//----------------------
// <auto-generated>
//     Generated using the NSwag toolchain v14.6.3.0 (NJsonSchema v11.5.2.0 (Newtonsoft.Json v13.0.0.0)) (http://NSwag.org)
// </auto-generated>
//----------------------

/* eslint-disable */
// ReSharper disable InconsistentNaming

import { mergeMap as _observableMergeMap, catchError as _observableCatch } from 'rxjs/operators';
import { Observable, throwError as _observableThrow, of as _observableOf } from 'rxjs';
import { Injectable, Inject, Optional, InjectionToken } from '@angular/core';
import { HttpClient, HttpHeaders, HttpResponse, HttpResponseBase } from '@angular/common/http';

import { DateTime, Duration } from "luxon";


export const API_BASE_URL = new InjectionToken<string>('API_BASE_URL');


@Injectable()

export class AccessEnterpriseProxy {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl ?? "https://api.doktar.dev";
    }

    /**
     * @param body (optional) 
     * @return OK
     */
    accessEnterprise_Create(body?: CreateAccessEnterpriseCommand | undefined): Observable<BooleanResponseResult> {
        let url_ = this.baseUrl + "/v4.0/access-enterprise";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processAccessEnterprise_Create(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processAccessEnterprise_Create(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<BooleanResponseResult>;
                }
            } else
                return _observableThrow(response_) as any as Observable<BooleanResponseResult>;
        }));
    }

    protected processAccessEnterprise_Create(response: HttpResponseBase): Observable<BooleanResponseResult> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = BooleanResponseResult.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param body (optional) 
     * @return OK
     */
    accessEnterprise_Update(body?: UpdateAccessEnterpriseCommand | undefined): Observable<BooleanResponseResult> {
        let url_ = this.baseUrl + "/v4.0/access-enterprise";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("put", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processAccessEnterprise_Update(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processAccessEnterprise_Update(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<BooleanResponseResult>;
                }
            } else
                return _observableThrow(response_) as any as Observable<BooleanResponseResult>;
        }));
    }

    protected processAccessEnterprise_Update(response: HttpResponseBase): Observable<BooleanResponseResult> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = BooleanResponseResult.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @return OK
     */
    accessEnterprise_Delete(id: string): Observable<BooleanResponseResult> {
        let url_ = this.baseUrl + "/v4.0/access-enterprise/{id}";
        if (id === undefined || id === null)
            throw new globalThis.Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("delete", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processAccessEnterprise_Delete(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processAccessEnterprise_Delete(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<BooleanResponseResult>;
                }
            } else
                return _observableThrow(response_) as any as Observable<BooleanResponseResult>;
        }));
    }

    protected processAccessEnterprise_Delete(response: HttpResponseBase): Observable<BooleanResponseResult> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = BooleanResponseResult.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @return OK
     */
    accessEnterprise_GetById(id: string): Observable<AccessEnterpriseViewModelResponseResult> {
        let url_ = this.baseUrl + "/v4.0/access-enterprise/{id}";
        if (id === undefined || id === null)
            throw new globalThis.Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processAccessEnterprise_GetById(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processAccessEnterprise_GetById(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<AccessEnterpriseViewModelResponseResult>;
                }
            } else
                return _observableThrow(response_) as any as Observable<AccessEnterpriseViewModelResponseResult>;
        }));
    }

    protected processAccessEnterprise_GetById(response: HttpResponseBase): Observable<AccessEnterpriseViewModelResponseResult> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = AccessEnterpriseViewModelResponseResult.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param body (optional) 
     * @return OK
     */
    accessEnterprise_GetPaginated(body?: PaginatedRequest | undefined): Observable<AccessEnterpriseViewModelPaginatedResponseResponseResult> {
        let url_ = this.baseUrl + "/v4.0/access-enterprise/paginated";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processAccessEnterprise_GetPaginated(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processAccessEnterprise_GetPaginated(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<AccessEnterpriseViewModelPaginatedResponseResponseResult>;
                }
            } else
                return _observableThrow(response_) as any as Observable<AccessEnterpriseViewModelPaginatedResponseResponseResult>;
        }));
    }

    protected processAccessEnterprise_GetPaginated(response: HttpResponseBase): Observable<AccessEnterpriseViewModelPaginatedResponseResponseResult> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = AccessEnterpriseViewModelPaginatedResponseResponseResult.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @return OK
     */
    accessEnterprise_GetByEnterpriseId(id: string): Observable<AccessEnterpriseViewModelListResponseResult> {
        let url_ = this.baseUrl + "/v4.0/access-enterprise/by-enterprise/{id}";
        if (id === undefined || id === null)
            throw new globalThis.Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processAccessEnterprise_GetByEnterpriseId(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processAccessEnterprise_GetByEnterpriseId(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<AccessEnterpriseViewModelListResponseResult>;
                }
            } else
                return _observableThrow(response_) as any as Observable<AccessEnterpriseViewModelListResponseResult>;
        }));
    }

    protected processAccessEnterprise_GetByEnterpriseId(response: HttpResponseBase): Observable<AccessEnterpriseViewModelListResponseResult> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = AccessEnterpriseViewModelListResponseResult.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }
}


@Injectable()

export class AccessRoleProxy {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl ?? "https://api.doktar.dev";
    }

    /**
     * @return OK
     */
    accessRole_GetByUserId(enterpriseId: string): Observable<AccessRoleViewModelListResponseResult> {
        let url_ = this.baseUrl + "/v4.0/access-role/by-user-and-enterprise?";
        if (enterpriseId === undefined || enterpriseId === null)
            throw new globalThis.Error("The parameter 'enterpriseId' must be defined and cannot be null.");
        else
            url_ += "enterpriseId=" + encodeURIComponent("" + enterpriseId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processAccessRole_GetByUserId(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processAccessRole_GetByUserId(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<AccessRoleViewModelListResponseResult>;
                }
            } else
                return _observableThrow(response_) as any as Observable<AccessRoleViewModelListResponseResult>;
        }));
    }

    protected processAccessRole_GetByUserId(response: HttpResponseBase): Observable<AccessRoleViewModelListResponseResult> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = AccessRoleViewModelListResponseResult.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @return OK
     */
    accessRole_GetByEnterpriseId(enterpriseId: string, roleId: string): Observable<AccessRoleViewModelListResponseResult> {
        let url_ = this.baseUrl + "/v4.0/access-role/by-enterprise-and-role/{enterpriseId}?";
        if (enterpriseId === undefined || enterpriseId === null)
            throw new globalThis.Error("The parameter 'enterpriseId' must be defined.");
        url_ = url_.replace("{enterpriseId}", encodeURIComponent("" + enterpriseId));
        if (roleId === undefined || roleId === null)
            throw new globalThis.Error("The parameter 'roleId' must be defined and cannot be null.");
        else
            url_ += "roleId=" + encodeURIComponent("" + roleId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processAccessRole_GetByEnterpriseId(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processAccessRole_GetByEnterpriseId(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<AccessRoleViewModelListResponseResult>;
                }
            } else
                return _observableThrow(response_) as any as Observable<AccessRoleViewModelListResponseResult>;
        }));
    }

    protected processAccessRole_GetByEnterpriseId(response: HttpResponseBase): Observable<AccessRoleViewModelListResponseResult> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = AccessRoleViewModelListResponseResult.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param body (optional) 
     * @return OK
     */
    accessRole_Create(body?: CreateAccessRoleCommand | undefined): Observable<GuidResponseResult> {
        let url_ = this.baseUrl + "/v4.0/access-role";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processAccessRole_Create(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processAccessRole_Create(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<GuidResponseResult>;
                }
            } else
                return _observableThrow(response_) as any as Observable<GuidResponseResult>;
        }));
    }

    protected processAccessRole_Create(response: HttpResponseBase): Observable<GuidResponseResult> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = GuidResponseResult.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param body (optional) 
     * @return OK
     */
    accessRole_Update(body?: UpdateAccessRoleCommand | undefined): Observable<BooleanResponseResult> {
        let url_ = this.baseUrl + "/v4.0/access-role";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("put", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processAccessRole_Update(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processAccessRole_Update(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<BooleanResponseResult>;
                }
            } else
                return _observableThrow(response_) as any as Observable<BooleanResponseResult>;
        }));
    }

    protected processAccessRole_Update(response: HttpResponseBase): Observable<BooleanResponseResult> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = BooleanResponseResult.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param roleId (optional) 
     * @param cropId (optional) 
     * @param seasonId (optional) 
     * @param year (optional) 
     * @return OK
     */
    accessRole_Delete(id: string, roleId?: string | undefined, cropId?: string | undefined, seasonId?: string | undefined, year?: number | undefined): Observable<BooleanResponseResult> {
        let url_ = this.baseUrl + "/v4.0/access-role/{id}?";
        if (id === undefined || id === null)
            throw new globalThis.Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        if (roleId === null)
            throw new globalThis.Error("The parameter 'roleId' cannot be null.");
        else if (roleId !== undefined)
            url_ += "roleId=" + encodeURIComponent("" + roleId) + "&";
        if (cropId === null)
            throw new globalThis.Error("The parameter 'cropId' cannot be null.");
        else if (cropId !== undefined)
            url_ += "cropId=" + encodeURIComponent("" + cropId) + "&";
        if (seasonId === null)
            throw new globalThis.Error("The parameter 'seasonId' cannot be null.");
        else if (seasonId !== undefined)
            url_ += "seasonId=" + encodeURIComponent("" + seasonId) + "&";
        if (year === null)
            throw new globalThis.Error("The parameter 'year' cannot be null.");
        else if (year !== undefined)
            url_ += "year=" + encodeURIComponent("" + year) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("delete", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processAccessRole_Delete(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processAccessRole_Delete(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<BooleanResponseResult>;
                }
            } else
                return _observableThrow(response_) as any as Observable<BooleanResponseResult>;
        }));
    }

    protected processAccessRole_Delete(response: HttpResponseBase): Observable<BooleanResponseResult> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = BooleanResponseResult.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }
}


@Injectable()

export class ContactUsProxy {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl ?? "https://api.doktar.dev";
    }

    /**
     * @param body (optional) 
     * @return OK
     */
    contactUs_Create(body?: ContactUsCommand | undefined): Observable<BooleanResponseResult> {
        let url_ = this.baseUrl + "/v4.0/contact-us";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processContactUs_Create(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processContactUs_Create(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<BooleanResponseResult>;
                }
            } else
                return _observableThrow(response_) as any as Observable<BooleanResponseResult>;
        }));
    }

    protected processContactUs_Create(response: HttpResponseBase): Observable<BooleanResponseResult> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = BooleanResponseResult.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }
}


@Injectable()

export class CropMapLayerProxy {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl ?? "https://api.doktar.dev";
    }

    /**
     * @return OK
     */
    cropMapLayer_GetAllLayer(): Observable<CropMapLayerViewModelListResponseResult> {
        let url_ = this.baseUrl + "/v4.0/crop-map-layer/all";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processCropMapLayer_GetAllLayer(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processCropMapLayer_GetAllLayer(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<CropMapLayerViewModelListResponseResult>;
                }
            } else
                return _observableThrow(response_) as any as Observable<CropMapLayerViewModelListResponseResult>;
        }));
    }

    protected processCropMapLayer_GetAllLayer(response: HttpResponseBase): Observable<CropMapLayerViewModelListResponseResult> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = CropMapLayerViewModelListResponseResult.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @return OK
     */
    cropMapLayer_GetLayerByCountryId(countryId: number): Observable<CropMapLayerViewModelListResponseResult> {
        let url_ = this.baseUrl + "/v4.0/crop-map-layer/{countryId}";
        if (countryId === undefined || countryId === null)
            throw new globalThis.Error("The parameter 'countryId' must be defined.");
        url_ = url_.replace("{countryId}", encodeURIComponent("" + countryId));
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processCropMapLayer_GetLayerByCountryId(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processCropMapLayer_GetLayerByCountryId(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<CropMapLayerViewModelListResponseResult>;
                }
            } else
                return _observableThrow(response_) as any as Observable<CropMapLayerViewModelListResponseResult>;
        }));
    }

    protected processCropMapLayer_GetLayerByCountryId(response: HttpResponseBase): Observable<CropMapLayerViewModelListResponseResult> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = CropMapLayerViewModelListResponseResult.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param body (optional) 
     * @return OK
     */
    cropMapLayer_CreateLayer(body?: CreateLayerCommand | undefined): Observable<BooleanResponseResult> {
        let url_ = this.baseUrl + "/v4.0/crop-map-layer";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processCropMapLayer_CreateLayer(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processCropMapLayer_CreateLayer(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<BooleanResponseResult>;
                }
            } else
                return _observableThrow(response_) as any as Observable<BooleanResponseResult>;
        }));
    }

    protected processCropMapLayer_CreateLayer(response: HttpResponseBase): Observable<BooleanResponseResult> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = BooleanResponseResult.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param body (optional) 
     * @return OK
     */
    cropMapLayer_UpdateLayer(body?: UpdateLayerCommand | undefined): Observable<BooleanResponseResult> {
        let url_ = this.baseUrl + "/v4.0/crop-map-layer";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("put", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processCropMapLayer_UpdateLayer(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processCropMapLayer_UpdateLayer(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<BooleanResponseResult>;
                }
            } else
                return _observableThrow(response_) as any as Observable<BooleanResponseResult>;
        }));
    }

    protected processCropMapLayer_UpdateLayer(response: HttpResponseBase): Observable<BooleanResponseResult> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = BooleanResponseResult.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @return OK
     */
    cropMapLayer_DeleteLayer(id: number): Observable<BooleanResponseResult> {
        let url_ = this.baseUrl + "/v4.0/crop-map-layer/{id}";
        if (id === undefined || id === null)
            throw new globalThis.Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("delete", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processCropMapLayer_DeleteLayer(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processCropMapLayer_DeleteLayer(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<BooleanResponseResult>;
                }
            } else
                return _observableThrow(response_) as any as Observable<BooleanResponseResult>;
        }));
    }

    protected processCropMapLayer_DeleteLayer(response: HttpResponseBase): Observable<BooleanResponseResult> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = BooleanResponseResult.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }
}


@Injectable()

export class CropMapOperationProxy {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl ?? "https://api.doktar.dev";
    }

    /**
     * @return OK
     */
    cropMapOperation_GetCropMapUserByEnterprise(enterpriseId: string): Observable<CropMapUserViewModelListResponseResult> {
        let url_ = this.baseUrl + "/v4.0/crop-map-operation/users/{enterpriseId}";
        if (enterpriseId === undefined || enterpriseId === null)
            throw new globalThis.Error("The parameter 'enterpriseId' must be defined.");
        url_ = url_.replace("{enterpriseId}", encodeURIComponent("" + enterpriseId));
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processCropMapOperation_GetCropMapUserByEnterprise(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processCropMapOperation_GetCropMapUserByEnterprise(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<CropMapUserViewModelListResponseResult>;
                }
            } else
                return _observableThrow(response_) as any as Observable<CropMapUserViewModelListResponseResult>;
        }));
    }

    protected processCropMapOperation_GetCropMapUserByEnterprise(response: HttpResponseBase): Observable<CropMapUserViewModelListResponseResult> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = CropMapUserViewModelListResponseResult.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @return OK
     */
    cropMapOperation_GetCropMapCropCrmQuestionList(groupId: number): Observable<ConstantViewModelListResponseResult> {
        let url_ = this.baseUrl + "/v4.0/crop-map-operation/crm-questions/{groupId}";
        if (groupId === undefined || groupId === null)
            throw new globalThis.Error("The parameter 'groupId' must be defined.");
        url_ = url_.replace("{groupId}", encodeURIComponent("" + groupId));
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processCropMapOperation_GetCropMapCropCrmQuestionList(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processCropMapOperation_GetCropMapCropCrmQuestionList(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<ConstantViewModelListResponseResult>;
                }
            } else
                return _observableThrow(response_) as any as Observable<ConstantViewModelListResponseResult>;
        }));
    }

    protected processCropMapOperation_GetCropMapCropCrmQuestionList(response: HttpResponseBase): Observable<ConstantViewModelListResponseResult> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = ConstantViewModelListResponseResult.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param body (optional) 
     * @return OK
     */
    cropMapOperation_CreateCropMapUser(body?: CreateCropMapUserCommand | undefined): Observable<GuidResponseResult> {
        let url_ = this.baseUrl + "/v4.0/crop-map-operation/user";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processCropMapOperation_CreateCropMapUser(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processCropMapOperation_CreateCropMapUser(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<GuidResponseResult>;
                }
            } else
                return _observableThrow(response_) as any as Observable<GuidResponseResult>;
        }));
    }

    protected processCropMapOperation_CreateCropMapUser(response: HttpResponseBase): Observable<GuidResponseResult> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = GuidResponseResult.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param body (optional) 
     * @return OK
     */
    cropMapOperation_UpdateCropMapUser(body?: UpdateCropMapUserCommand | undefined): Observable<BooleanResponseResult> {
        let url_ = this.baseUrl + "/v4.0/crop-map-operation/user";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("put", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processCropMapOperation_UpdateCropMapUser(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processCropMapOperation_UpdateCropMapUser(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<BooleanResponseResult>;
                }
            } else
                return _observableThrow(response_) as any as Observable<BooleanResponseResult>;
        }));
    }

    protected processCropMapOperation_UpdateCropMapUser(response: HttpResponseBase): Observable<BooleanResponseResult> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = BooleanResponseResult.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @return OK
     */
    cropMapOperation_GetCropMapUserEnterprise(): Observable<CropMapUserEnterpiseViewModelResponseResult> {
        let url_ = this.baseUrl + "/v4.0/crop-map-operation/user-enterprise";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processCropMapOperation_GetCropMapUserEnterprise(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processCropMapOperation_GetCropMapUserEnterprise(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<CropMapUserEnterpiseViewModelResponseResult>;
                }
            } else
                return _observableThrow(response_) as any as Observable<CropMapUserEnterpiseViewModelResponseResult>;
        }));
    }

    protected processCropMapOperation_GetCropMapUserEnterprise(response: HttpResponseBase): Observable<CropMapUserEnterpiseViewModelResponseResult> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = CropMapUserEnterpiseViewModelResponseResult.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @return OK
     */
    cropMapOperation_GetCropMapUserEnterprises(): Observable<CropMapUserEnterpiseListViewModelResponseResult> {
        let url_ = this.baseUrl + "/v4.0/crop-map-operation/user-enterprises";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processCropMapOperation_GetCropMapUserEnterprises(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processCropMapOperation_GetCropMapUserEnterprises(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<CropMapUserEnterpiseListViewModelResponseResult>;
                }
            } else
                return _observableThrow(response_) as any as Observable<CropMapUserEnterpiseListViewModelResponseResult>;
        }));
    }

    protected processCropMapOperation_GetCropMapUserEnterprises(response: HttpResponseBase): Observable<CropMapUserEnterpiseListViewModelResponseResult> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = CropMapUserEnterpiseListViewModelResponseResult.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @return OK
     */
    cropMapOperation_DeleteCropMapUser(id: string): Observable<BooleanResponseResult> {
        let url_ = this.baseUrl + "/v4.0/crop-map-operation/user/{id}";
        if (id === undefined || id === null)
            throw new globalThis.Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("delete", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processCropMapOperation_DeleteCropMapUser(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processCropMapOperation_DeleteCropMapUser(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<BooleanResponseResult>;
                }
            } else
                return _observableThrow(response_) as any as Observable<BooleanResponseResult>;
        }));
    }

    protected processCropMapOperation_DeleteCropMapUser(response: HttpResponseBase): Observable<BooleanResponseResult> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = BooleanResponseResult.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param id (optional) 
     * @param year (optional) 
     * @param geoJson (optional) 
     * @return OK
     */
    cropMapOperation_GetCropMapCrmsQuery(id?: number | undefined, year?: number | undefined, geoJson?: string | undefined): Observable<CrmViewModelListResponseResult> {
        let url_ = this.baseUrl + "/v4.0/crop-map-operation/crm?";
        if (id === null)
            throw new globalThis.Error("The parameter 'id' cannot be null.");
        else if (id !== undefined)
            url_ += "id=" + encodeURIComponent("" + id) + "&";
        if (year === null)
            throw new globalThis.Error("The parameter 'year' cannot be null.");
        else if (year !== undefined)
            url_ += "year=" + encodeURIComponent("" + year) + "&";
        if (geoJson === null)
            throw new globalThis.Error("The parameter 'geoJson' cannot be null.");
        else if (geoJson !== undefined)
            url_ += "geoJson=" + encodeURIComponent("" + geoJson) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processCropMapOperation_GetCropMapCrmsQuery(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processCropMapOperation_GetCropMapCrmsQuery(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<CrmViewModelListResponseResult>;
                }
            } else
                return _observableThrow(response_) as any as Observable<CrmViewModelListResponseResult>;
        }));
    }

    protected processCropMapOperation_GetCropMapCrmsQuery(response: HttpResponseBase): Observable<CrmViewModelListResponseResult> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = CrmViewModelListResponseResult.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param body (optional) 
     * @return OK
     */
    cropMapOperation_CreateCropMapCrm(body?: SaveCrmCommand | undefined): Observable<BooleanResponseResult> {
        let url_ = this.baseUrl + "/v4.0/crop-map-operation/crm";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processCropMapOperation_CreateCropMapCrm(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processCropMapOperation_CreateCropMapCrm(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<BooleanResponseResult>;
                }
            } else
                return _observableThrow(response_) as any as Observable<BooleanResponseResult>;
        }));
    }

    protected processCropMapOperation_CreateCropMapCrm(response: HttpResponseBase): Observable<BooleanResponseResult> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = BooleanResponseResult.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @return OK
     */
    cropMapOperation_GetCrmVisitingUserQuery(): Observable<BooleanResponseResult> {
        let url_ = this.baseUrl + "/v4.0/crop-map-operation/crm-visiting-user";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processCropMapOperation_GetCrmVisitingUserQuery(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processCropMapOperation_GetCrmVisitingUserQuery(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<BooleanResponseResult>;
                }
            } else
                return _observableThrow(response_) as any as Observable<BooleanResponseResult>;
        }));
    }

    protected processCropMapOperation_GetCrmVisitingUserQuery(response: HttpResponseBase): Observable<BooleanResponseResult> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = BooleanResponseResult.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param body (optional) 
     * @return OK
     */
    cropMapOperation_SaveCrmVisitingUser(body?: SaveCrmVisitingUserCommand | undefined): Observable<BooleanResponseResult> {
        let url_ = this.baseUrl + "/v4.0/crop-map-operation/crm-visiting-user";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processCropMapOperation_SaveCrmVisitingUser(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processCropMapOperation_SaveCrmVisitingUser(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<BooleanResponseResult>;
                }
            } else
                return _observableThrow(response_) as any as Observable<BooleanResponseResult>;
        }));
    }

    protected processCropMapOperation_SaveCrmVisitingUser(response: HttpResponseBase): Observable<BooleanResponseResult> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = BooleanResponseResult.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param year (optional) 
     * @return OK
     */
    cropMapOperation_GetCrmByEnterprise(enterpriseId: string, year?: number | undefined): Observable<CrmViewModelListResponseResult> {
        let url_ = this.baseUrl + "/v4.0/crop-map-operation/crm/by-enterprise/{enterpriseId}?";
        if (enterpriseId === undefined || enterpriseId === null)
            throw new globalThis.Error("The parameter 'enterpriseId' must be defined.");
        url_ = url_.replace("{enterpriseId}", encodeURIComponent("" + enterpriseId));
        if (year === null)
            throw new globalThis.Error("The parameter 'year' cannot be null.");
        else if (year !== undefined)
            url_ += "year=" + encodeURIComponent("" + year) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processCropMapOperation_GetCrmByEnterprise(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processCropMapOperation_GetCrmByEnterprise(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<CrmViewModelListResponseResult>;
                }
            } else
                return _observableThrow(response_) as any as Observable<CrmViewModelListResponseResult>;
        }));
    }

    protected processCropMapOperation_GetCrmByEnterprise(response: HttpResponseBase): Observable<CrmViewModelListResponseResult> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = CrmViewModelListResponseResult.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @return OK
     */
    cropMapOperation_DeleteCropMapCrm(id: number): Observable<BooleanResponseResult> {
        let url_ = this.baseUrl + "/v4.0/crop-map-operation/crm/{id}";
        if (id === undefined || id === null)
            throw new globalThis.Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("delete", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processCropMapOperation_DeleteCropMapCrm(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processCropMapOperation_DeleteCropMapCrm(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<BooleanResponseResult>;
                }
            } else
                return _observableThrow(response_) as any as Observable<BooleanResponseResult>;
        }));
    }

    protected processCropMapOperation_DeleteCropMapCrm(response: HttpResponseBase): Observable<BooleanResponseResult> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = BooleanResponseResult.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }
}


@Injectable()

export class CropMapPlantationProxy {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl ?? "https://api.doktar.dev";
    }

    /**
     * @param body (optional) 
     * @return OK
     */
    cropMapPlantation_CropMapPlantationReport(body?: GetCropAreaPlantationReportQuery | undefined): Observable<CropAreaPlantationReportRowViewModelListResponseResult> {
        let url_ = this.baseUrl + "/v4.0/crop-map-plantation/report";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processCropMapPlantation_CropMapPlantationReport(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processCropMapPlantation_CropMapPlantationReport(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<CropAreaPlantationReportRowViewModelListResponseResult>;
                }
            } else
                return _observableThrow(response_) as any as Observable<CropAreaPlantationReportRowViewModelListResponseResult>;
        }));
    }

    protected processCropMapPlantation_CropMapPlantationReport(response: HttpResponseBase): Observable<CropAreaPlantationReportRowViewModelListResponseResult> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = CropAreaPlantationReportRowViewModelListResponseResult.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }
}


@Injectable()

export class CropMapUserProxy {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl ?? "https://api.doktar.dev";
    }

    /**
     * @return OK
     */
    cropMapUser_GetCropMapUserByEnterpriseId(enterpriseId: string): Observable<CropMapUserV2ViewModelListResponseResult> {
        let url_ = this.baseUrl + "/v4.0/crop-map-user/enterprise/{enterpriseId}";
        if (enterpriseId === undefined || enterpriseId === null)
            throw new globalThis.Error("The parameter 'enterpriseId' must be defined.");
        url_ = url_.replace("{enterpriseId}", encodeURIComponent("" + enterpriseId));
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processCropMapUser_GetCropMapUserByEnterpriseId(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processCropMapUser_GetCropMapUserByEnterpriseId(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<CropMapUserV2ViewModelListResponseResult>;
                }
            } else
                return _observableThrow(response_) as any as Observable<CropMapUserV2ViewModelListResponseResult>;
        }));
    }

    protected processCropMapUser_GetCropMapUserByEnterpriseId(response: HttpResponseBase): Observable<CropMapUserV2ViewModelListResponseResult> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = CropMapUserV2ViewModelListResponseResult.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @return OK
     */
    cropMapUser_GetCropMapEnterpriseByUser(): Observable<EnterpriseUserAccessViewModelListResponseResult> {
        let url_ = this.baseUrl + "/v4.0/crop-map-user/enterprise";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processCropMapUser_GetCropMapEnterpriseByUser(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processCropMapUser_GetCropMapEnterpriseByUser(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<EnterpriseUserAccessViewModelListResponseResult>;
                }
            } else
                return _observableThrow(response_) as any as Observable<EnterpriseUserAccessViewModelListResponseResult>;
        }));
    }

    protected processCropMapUser_GetCropMapEnterpriseByUser(response: HttpResponseBase): Observable<EnterpriseUserAccessViewModelListResponseResult> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = EnterpriseUserAccessViewModelListResponseResult.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @return OK
     */
    cropMapUser_GetPermissionsByEnterpriseId(enterpriseId: string): Observable<EnterprisePermissionViewModelResponseResult> {
        let url_ = this.baseUrl + "/v4.0/crop-map-user/permissions/enterprise/{enterpriseId}";
        if (enterpriseId === undefined || enterpriseId === null)
            throw new globalThis.Error("The parameter 'enterpriseId' must be defined.");
        url_ = url_.replace("{enterpriseId}", encodeURIComponent("" + enterpriseId));
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processCropMapUser_GetPermissionsByEnterpriseId(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processCropMapUser_GetPermissionsByEnterpriseId(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<EnterprisePermissionViewModelResponseResult>;
                }
            } else
                return _observableThrow(response_) as any as Observable<EnterprisePermissionViewModelResponseResult>;
        }));
    }

    protected processCropMapUser_GetPermissionsByEnterpriseId(response: HttpResponseBase): Observable<EnterprisePermissionViewModelResponseResult> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = EnterprisePermissionViewModelResponseResult.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status === 404) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result404: any = null;
            let resultData404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result404 = ProblemDetails.fromJS(resultData404);
            return throwException("Not Found", status, _responseText, _headers, result404);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param body (optional) 
     * @return OK
     */
    cropMapUser_CreateCropMapUser(body?: CreateCropMapUserV2Command | undefined): Observable<GuidResponseResult> {
        let url_ = this.baseUrl + "/v4.0/crop-map-user";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processCropMapUser_CreateCropMapUser(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processCropMapUser_CreateCropMapUser(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<GuidResponseResult>;
                }
            } else
                return _observableThrow(response_) as any as Observable<GuidResponseResult>;
        }));
    }

    protected processCropMapUser_CreateCropMapUser(response: HttpResponseBase): Observable<GuidResponseResult> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = GuidResponseResult.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param body (optional) 
     * @return OK
     */
    cropMapUser_UpdateCropMapUser(body?: UpdateCropMapUserV2Command | undefined): Observable<BooleanResponseResult> {
        let url_ = this.baseUrl + "/v4.0/crop-map-user";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("put", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processCropMapUser_UpdateCropMapUser(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processCropMapUser_UpdateCropMapUser(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<BooleanResponseResult>;
                }
            } else
                return _observableThrow(response_) as any as Observable<BooleanResponseResult>;
        }));
    }

    protected processCropMapUser_UpdateCropMapUser(response: HttpResponseBase): Observable<BooleanResponseResult> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = BooleanResponseResult.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param body (optional) 
     * @return OK
     */
    cropMapUser_RemoveCropMapUser(body?: RemoveCropMapUserV2Command | undefined): Observable<void> {
        let url_ = this.baseUrl + "/v4.0/crop-map-user";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
            })
        };

        return this.http.request("delete", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processCropMapUser_RemoveCropMapUser(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processCropMapUser_RemoveCropMapUser(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processCropMapUser_RemoveCropMapUser(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return _observableOf(null as any);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }
}


@Injectable()

export class CropSeasonProxy {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl ?? "https://api.doktar.dev";
    }

    /**
     * @param cropId (optional) 
     * @param seasonId (optional) 
     * @return OK
     */
    cropSeason_Get(cropId?: string | undefined, seasonId?: string | undefined): Observable<CropSeasonViewModelResponseResult> {
        let url_ = this.baseUrl + "/v4.0/cropseason?";
        if (cropId === null)
            throw new globalThis.Error("The parameter 'cropId' cannot be null.");
        else if (cropId !== undefined)
            url_ += "cropId=" + encodeURIComponent("" + cropId) + "&";
        if (seasonId === null)
            throw new globalThis.Error("The parameter 'seasonId' cannot be null.");
        else if (seasonId !== undefined)
            url_ += "seasonId=" + encodeURIComponent("" + seasonId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processCropSeason_Get(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processCropSeason_Get(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<CropSeasonViewModelResponseResult>;
                }
            } else
                return _observableThrow(response_) as any as Observable<CropSeasonViewModelResponseResult>;
        }));
    }

    protected processCropSeason_Get(response: HttpResponseBase): Observable<CropSeasonViewModelResponseResult> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = CropSeasonViewModelResponseResult.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param body (optional) 
     * @return OK
     */
    cropSeason_Create(body?: CreateCropSeasonCommand | undefined): Observable<BooleanResponseResult> {
        let url_ = this.baseUrl + "/v4.0/cropseason";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processCropSeason_Create(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processCropSeason_Create(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<BooleanResponseResult>;
                }
            } else
                return _observableThrow(response_) as any as Observable<BooleanResponseResult>;
        }));
    }

    protected processCropSeason_Create(response: HttpResponseBase): Observable<BooleanResponseResult> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = BooleanResponseResult.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param cropId (optional) 
     * @param seasonId (optional) 
     * @return OK
     */
    cropSeason_Delete(cropId?: string | undefined, seasonId?: string | undefined): Observable<BooleanResponseResult> {
        let url_ = this.baseUrl + "/v4.0/cropseason?";
        if (cropId === null)
            throw new globalThis.Error("The parameter 'cropId' cannot be null.");
        else if (cropId !== undefined)
            url_ += "cropId=" + encodeURIComponent("" + cropId) + "&";
        if (seasonId === null)
            throw new globalThis.Error("The parameter 'seasonId' cannot be null.");
        else if (seasonId !== undefined)
            url_ += "seasonId=" + encodeURIComponent("" + seasonId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("delete", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processCropSeason_Delete(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processCropSeason_Delete(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<BooleanResponseResult>;
                }
            } else
                return _observableThrow(response_) as any as Observable<BooleanResponseResult>;
        }));
    }

    protected processCropSeason_Delete(response: HttpResponseBase): Observable<BooleanResponseResult> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = BooleanResponseResult.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @return OK
     */
    cropSeason_GetSeasonsByCropId(cropId: string): Observable<SeasonViewModelListResponseResult> {
        let url_ = this.baseUrl + "/v4.0/cropseason/crop/{cropId}/seasons";
        if (cropId === undefined || cropId === null)
            throw new globalThis.Error("The parameter 'cropId' must be defined.");
        url_ = url_.replace("{cropId}", encodeURIComponent("" + cropId));
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processCropSeason_GetSeasonsByCropId(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processCropSeason_GetSeasonsByCropId(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<SeasonViewModelListResponseResult>;
                }
            } else
                return _observableThrow(response_) as any as Observable<SeasonViewModelListResponseResult>;
        }));
    }

    protected processCropSeason_GetSeasonsByCropId(response: HttpResponseBase): Observable<SeasonViewModelListResponseResult> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = SeasonViewModelListResponseResult.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @return OK
     */
    cropSeason_GetCropsBySeasonId(seasonId: string): Observable<CropSeasonCropViewModelListResponseResult> {
        let url_ = this.baseUrl + "/v4.0/cropseason/season/{seasonId}/crops";
        if (seasonId === undefined || seasonId === null)
            throw new globalThis.Error("The parameter 'seasonId' must be defined.");
        url_ = url_.replace("{seasonId}", encodeURIComponent("" + seasonId));
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processCropSeason_GetCropsBySeasonId(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processCropSeason_GetCropsBySeasonId(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<CropSeasonCropViewModelListResponseResult>;
                }
            } else
                return _observableThrow(response_) as any as Observable<CropSeasonCropViewModelListResponseResult>;
        }));
    }

    protected processCropSeason_GetCropsBySeasonId(response: HttpResponseBase): Observable<CropSeasonCropViewModelListResponseResult> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = CropSeasonCropViewModelListResponseResult.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param body (optional) 
     * @return OK
     */
    cropSeason_GetPaginated(body?: PaginatedRequest | undefined): Observable<CropSeasonViewModelPaginatedResponseResponseResult> {
        let url_ = this.baseUrl + "/v4.0/cropseason/paginated";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processCropSeason_GetPaginated(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processCropSeason_GetPaginated(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<CropSeasonViewModelPaginatedResponseResponseResult>;
                }
            } else
                return _observableThrow(response_) as any as Observable<CropSeasonViewModelPaginatedResponseResponseResult>;
        }));
    }

    protected processCropSeason_GetPaginated(response: HttpResponseBase): Observable<CropSeasonViewModelPaginatedResponseResponseResult> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = CropSeasonViewModelPaginatedResponseResponseResult.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }
}


@Injectable()

export class FieldObservationProxy {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl ?? "https://api.doktar.dev";
    }

    /**
     * @return OK
     */
    fieldObservation_GetById(id: string): Observable<FieldObservationViewModelResponseResult> {
        let url_ = this.baseUrl + "/v4.0/fieldobservation/{id}";
        if (id === undefined || id === null)
            throw new globalThis.Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processFieldObservation_GetById(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processFieldObservation_GetById(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<FieldObservationViewModelResponseResult>;
                }
            } else
                return _observableThrow(response_) as any as Observable<FieldObservationViewModelResponseResult>;
        }));
    }

    protected processFieldObservation_GetById(response: HttpResponseBase): Observable<FieldObservationViewModelResponseResult> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = FieldObservationViewModelResponseResult.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @return OK
     */
    fieldObservation_Delete(id: string): Observable<BooleanResponseResult> {
        let url_ = this.baseUrl + "/v4.0/fieldobservation/{id}";
        if (id === undefined || id === null)
            throw new globalThis.Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("delete", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processFieldObservation_Delete(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processFieldObservation_Delete(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<BooleanResponseResult>;
                }
            } else
                return _observableThrow(response_) as any as Observable<BooleanResponseResult>;
        }));
    }

    protected processFieldObservation_Delete(response: HttpResponseBase): Observable<BooleanResponseResult> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = BooleanResponseResult.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @return OK
     */
    fieldObservation_GetByEnterprise(enterpriseId: string): Observable<FieldObservationViewModelListResponseResult> {
        let url_ = this.baseUrl + "/v4.0/fieldobservation/enterprise/{enterpriseId}";
        if (enterpriseId === undefined || enterpriseId === null)
            throw new globalThis.Error("The parameter 'enterpriseId' must be defined.");
        url_ = url_.replace("{enterpriseId}", encodeURIComponent("" + enterpriseId));
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processFieldObservation_GetByEnterprise(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processFieldObservation_GetByEnterprise(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<FieldObservationViewModelListResponseResult>;
                }
            } else
                return _observableThrow(response_) as any as Observable<FieldObservationViewModelListResponseResult>;
        }));
    }

    protected processFieldObservation_GetByEnterprise(response: HttpResponseBase): Observable<FieldObservationViewModelListResponseResult> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = FieldObservationViewModelListResponseResult.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param body (optional) 
     * @return OK
     */
    fieldObservation_Create(body?: CreateFieldObservationCommand | undefined): Observable<GuidResponseResult> {
        let url_ = this.baseUrl + "/v4.0/fieldobservation";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processFieldObservation_Create(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processFieldObservation_Create(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<GuidResponseResult>;
                }
            } else
                return _observableThrow(response_) as any as Observable<GuidResponseResult>;
        }));
    }

    protected processFieldObservation_Create(response: HttpResponseBase): Observable<GuidResponseResult> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = GuidResponseResult.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param body (optional) 
     * @return OK
     */
    fieldObservation_Update(body?: UpdateFieldObservationCommand | undefined): Observable<BooleanResponseResult> {
        let url_ = this.baseUrl + "/v4.0/fieldobservation";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("put", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processFieldObservation_Update(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processFieldObservation_Update(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<BooleanResponseResult>;
                }
            } else
                return _observableThrow(response_) as any as Observable<BooleanResponseResult>;
        }));
    }

    protected processFieldObservation_Update(response: HttpResponseBase): Observable<BooleanResponseResult> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = BooleanResponseResult.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }
}


@Injectable()

export class FieldObservationQuestionnaireProxy {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl ?? "https://api.doktar.dev";
    }

    /**
     * @return OK
     */
    fieldObservationQuestionnaire_GetById(id: string): Observable<FieldObservationQuestionnaireViewModelResponseResult> {
        let url_ = this.baseUrl + "/v4.0/fieldobservationquestionnaire/{id}";
        if (id === undefined || id === null)
            throw new globalThis.Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processFieldObservationQuestionnaire_GetById(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processFieldObservationQuestionnaire_GetById(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<FieldObservationQuestionnaireViewModelResponseResult>;
                }
            } else
                return _observableThrow(response_) as any as Observable<FieldObservationQuestionnaireViewModelResponseResult>;
        }));
    }

    protected processFieldObservationQuestionnaire_GetById(response: HttpResponseBase): Observable<FieldObservationQuestionnaireViewModelResponseResult> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = FieldObservationQuestionnaireViewModelResponseResult.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @return OK
     */
    fieldObservationQuestionnaire_Delete(id: string): Observable<BooleanResponseResult> {
        let url_ = this.baseUrl + "/v4.0/fieldobservationquestionnaire/{id}";
        if (id === undefined || id === null)
            throw new globalThis.Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("delete", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processFieldObservationQuestionnaire_Delete(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processFieldObservationQuestionnaire_Delete(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<BooleanResponseResult>;
                }
            } else
                return _observableThrow(response_) as any as Observable<BooleanResponseResult>;
        }));
    }

    protected processFieldObservationQuestionnaire_Delete(response: HttpResponseBase): Observable<BooleanResponseResult> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = BooleanResponseResult.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @return OK
     */
    fieldObservationQuestionnaire_GetByEnterprise(enterpriseId: string): Observable<FieldObservationQuestionnaireViewModelListResponseResult> {
        let url_ = this.baseUrl + "/v4.0/fieldobservationquestionnaire/enterprise/{enterpriseId}";
        if (enterpriseId === undefined || enterpriseId === null)
            throw new globalThis.Error("The parameter 'enterpriseId' must be defined.");
        url_ = url_.replace("{enterpriseId}", encodeURIComponent("" + enterpriseId));
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processFieldObservationQuestionnaire_GetByEnterprise(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processFieldObservationQuestionnaire_GetByEnterprise(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<FieldObservationQuestionnaireViewModelListResponseResult>;
                }
            } else
                return _observableThrow(response_) as any as Observable<FieldObservationQuestionnaireViewModelListResponseResult>;
        }));
    }

    protected processFieldObservationQuestionnaire_GetByEnterprise(response: HttpResponseBase): Observable<FieldObservationQuestionnaireViewModelListResponseResult> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = FieldObservationQuestionnaireViewModelListResponseResult.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param body (optional) 
     * @return OK
     */
    fieldObservationQuestionnaire_Create(body?: CreateFieldObservationQuestionnaireCommand | undefined): Observable<GuidResponseResult> {
        let url_ = this.baseUrl + "/v4.0/fieldobservationquestionnaire";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processFieldObservationQuestionnaire_Create(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processFieldObservationQuestionnaire_Create(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<GuidResponseResult>;
                }
            } else
                return _observableThrow(response_) as any as Observable<GuidResponseResult>;
        }));
    }

    protected processFieldObservationQuestionnaire_Create(response: HttpResponseBase): Observable<GuidResponseResult> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = GuidResponseResult.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param body (optional) 
     * @return OK
     */
    fieldObservationQuestionnaire_Update(body?: UpdateFieldObservationQuestionnaireCommand | undefined): Observable<BooleanResponseResult> {
        let url_ = this.baseUrl + "/v4.0/fieldobservationquestionnaire";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("put", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processFieldObservationQuestionnaire_Update(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processFieldObservationQuestionnaire_Update(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<BooleanResponseResult>;
                }
            } else
                return _observableThrow(response_) as any as Observable<BooleanResponseResult>;
        }));
    }

    protected processFieldObservationQuestionnaire_Update(response: HttpResponseBase): Observable<BooleanResponseResult> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = BooleanResponseResult.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }
}


@Injectable()

export class FieldObservationUserProxy {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl ?? "https://api.doktar.dev";
    }

    /**
     * @return OK
     */
    fieldObservationUser_GetByUser(): Observable<BooleanResponseResult> {
        let url_ = this.baseUrl + "/v4.0/field-observation-user/user";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processFieldObservationUser_GetByUser(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processFieldObservationUser_GetByUser(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<BooleanResponseResult>;
                }
            } else
                return _observableThrow(response_) as any as Observable<BooleanResponseResult>;
        }));
    }

    protected processFieldObservationUser_GetByUser(response: HttpResponseBase): Observable<BooleanResponseResult> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = BooleanResponseResult.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @return OK
     */
    fieldObservationUser_Create(): Observable<BooleanResponseResult> {
        let url_ = this.baseUrl + "/v4.0/field-observation-user";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processFieldObservationUser_Create(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processFieldObservationUser_Create(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<BooleanResponseResult>;
                }
            } else
                return _observableThrow(response_) as any as Observable<BooleanResponseResult>;
        }));
    }

    protected processFieldObservationUser_Create(response: HttpResponseBase): Observable<BooleanResponseResult> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = BooleanResponseResult.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }
}


@Injectable()

export class LandProxy {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl ?? "https://api.doktar.dev";
    }

    /**
     * @return OK
     */
    land_GetUserLandsQuery(): Observable<EnterpriseGroupViewModelListResponseResult> {
        let url_ = this.baseUrl + "/v4.0/land";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processLand_GetUserLandsQuery(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processLand_GetUserLandsQuery(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<EnterpriseGroupViewModelListResponseResult>;
                }
            } else
                return _observableThrow(response_) as any as Observable<EnterpriseGroupViewModelListResponseResult>;
        }));
    }

    protected processLand_GetUserLandsQuery(response: HttpResponseBase): Observable<EnterpriseGroupViewModelListResponseResult> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = EnterpriseGroupViewModelListResponseResult.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param body (optional) 
     * @return OK
     */
    land_CreateLand(body?: CreateLandCommand | undefined): Observable<GuidResponseResult> {
        let url_ = this.baseUrl + "/v4.0/land";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processLand_CreateLand(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processLand_CreateLand(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<GuidResponseResult>;
                }
            } else
                return _observableThrow(response_) as any as Observable<GuidResponseResult>;
        }));
    }

    protected processLand_CreateLand(response: HttpResponseBase): Observable<GuidResponseResult> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = GuidResponseResult.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param body (optional) 
     * @return OK
     */
    land_UpdateLand(body?: UpdateLandCommand | undefined): Observable<GuidResponseResult> {
        let url_ = this.baseUrl + "/v4.0/land";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("put", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processLand_UpdateLand(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processLand_UpdateLand(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<GuidResponseResult>;
                }
            } else
                return _observableThrow(response_) as any as Observable<GuidResponseResult>;
        }));
    }

    protected processLand_UpdateLand(response: HttpResponseBase): Observable<GuidResponseResult> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = GuidResponseResult.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @return OK
     */
    land_Get(landId: string): Observable<LandViewModelResponseResult> {
        let url_ = this.baseUrl + "/v4.0/land/{landId}";
        if (landId === undefined || landId === null)
            throw new globalThis.Error("The parameter 'landId' must be defined.");
        url_ = url_.replace("{landId}", encodeURIComponent("" + landId));
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processLand_Get(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processLand_Get(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<LandViewModelResponseResult>;
                }
            } else
                return _observableThrow(response_) as any as Observable<LandViewModelResponseResult>;
        }));
    }

    protected processLand_Get(response: HttpResponseBase): Observable<LandViewModelResponseResult> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = LandViewModelResponseResult.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param body (optional) 
     * @return OK
     */
    land_GetAllLandsQuery(body?: PaginatedRequest | undefined): Observable<GetAllLandsResultPaginatedResponseResponseResult> {
        let url_ = this.baseUrl + "/v4.0/land/all";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processLand_GetAllLandsQuery(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processLand_GetAllLandsQuery(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<GetAllLandsResultPaginatedResponseResponseResult>;
                }
            } else
                return _observableThrow(response_) as any as Observable<GetAllLandsResultPaginatedResponseResponseResult>;
        }));
    }

    protected processLand_GetAllLandsQuery(response: HttpResponseBase): Observable<GetAllLandsResultPaginatedResponseResponseResult> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = GetAllLandsResultPaginatedResponseResponseResult.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param body (optional) 
     * @return OK
     */
    land_GetPaginatedLand(body?: PaginatedRequest | undefined): Observable<LandPaginatedViewModelPaginatedResponseResponseResult> {
        let url_ = this.baseUrl + "/v4.0/land/paginated";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processLand_GetPaginatedLand(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processLand_GetPaginatedLand(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<LandPaginatedViewModelPaginatedResponseResponseResult>;
                }
            } else
                return _observableThrow(response_) as any as Observable<LandPaginatedViewModelPaginatedResponseResponseResult>;
        }));
    }

    protected processLand_GetPaginatedLand(response: HttpResponseBase): Observable<LandPaginatedViewModelPaginatedResponseResponseResult> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = LandPaginatedViewModelPaginatedResponseResponseResult.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param body (optional) 
     * @return OK
     */
    land_CreateLandWithPlantation(body?: CreateLandWithPlantationCommand | undefined): Observable<GuidResponseResult> {
        let url_ = this.baseUrl + "/v4.0/land/with-plantation";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processLand_CreateLandWithPlantation(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processLand_CreateLandWithPlantation(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<GuidResponseResult>;
                }
            } else
                return _observableThrow(response_) as any as Observable<GuidResponseResult>;
        }));
    }

    protected processLand_CreateLandWithPlantation(response: HttpResponseBase): Observable<GuidResponseResult> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = GuidResponseResult.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param body (optional) 
     * @return OK
     */
    land_UpdateLandWithPlantation(body?: UpdateLandWithPlantationCommand | undefined): Observable<GuidResponseResult> {
        let url_ = this.baseUrl + "/v4.0/land/with-plantation";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("put", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processLand_UpdateLandWithPlantation(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processLand_UpdateLandWithPlantation(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<GuidResponseResult>;
                }
            } else
                return _observableThrow(response_) as any as Observable<GuidResponseResult>;
        }));
    }

    protected processLand_UpdateLandWithPlantation(response: HttpResponseBase): Observable<GuidResponseResult> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = GuidResponseResult.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param kmlFile (optional) 
     * @return OK
     */
    land_ValidateKml(kmlFile?: FileParameter | undefined): Observable<KmlValidationResultResponseResult> {
        let url_ = this.baseUrl + "/v4.0/land/kml-validate";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = new FormData();
        if (kmlFile === null || kmlFile === undefined)
            throw new globalThis.Error("The parameter 'kmlFile' cannot be null.");
        else
            content_.append("kmlFile", kmlFile.data, kmlFile.fileName ? kmlFile.fileName : "kmlFile");

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processLand_ValidateKml(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processLand_ValidateKml(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<KmlValidationResultResponseResult>;
                }
            } else
                return _observableThrow(response_) as any as Observable<KmlValidationResultResponseResult>;
        }));
    }

    protected processLand_ValidateKml(response: HttpResponseBase): Observable<KmlValidationResultResponseResult> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = KmlValidationResultResponseResult.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param body (optional) 
     * @return OK
     */
    land_SubmitParcelInquiry(body?: ParcelInquiryCommand | undefined): Observable<StringDoubleDictionaryListResponseResult> {
        let url_ = this.baseUrl + "/v4.0/land/parcel-inquiry";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processLand_SubmitParcelInquiry(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processLand_SubmitParcelInquiry(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<StringDoubleDictionaryListResponseResult>;
                }
            } else
                return _observableThrow(response_) as any as Observable<StringDoubleDictionaryListResponseResult>;
        }));
    }

    protected processLand_SubmitParcelInquiry(response: HttpResponseBase): Observable<StringDoubleDictionaryListResponseResult> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = StringDoubleDictionaryListResponseResult.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param body (optional) 
     * @return OK
     */
    land_GetParcelInquiryConfiguration(body?: ParcelInquiryConfigurationCommand | undefined): Observable<ParcelInquiryConfigurationResponseResponseResult> {
        let url_ = this.baseUrl + "/v4.0/land/parcel-inquiry-configuration";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processLand_GetParcelInquiryConfiguration(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processLand_GetParcelInquiryConfiguration(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<ParcelInquiryConfigurationResponseResponseResult>;
                }
            } else
                return _observableThrow(response_) as any as Observable<ParcelInquiryConfigurationResponseResponseResult>;
        }));
    }

    protected processLand_GetParcelInquiryConfiguration(response: HttpResponseBase): Observable<ParcelInquiryConfigurationResponseResponseResult> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = ParcelInquiryConfigurationResponseResponseResult.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @return OK
     */
    land_DeleteLand(id: string): Observable<BooleanResponseResult> {
        let url_ = this.baseUrl + "/v4.0/land/{id}";
        if (id === undefined || id === null)
            throw new globalThis.Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("delete", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processLand_DeleteLand(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processLand_DeleteLand(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<BooleanResponseResult>;
                }
            } else
                return _observableThrow(response_) as any as Observable<BooleanResponseResult>;
        }));
    }

    protected processLand_DeleteLand(response: HttpResponseBase): Observable<BooleanResponseResult> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = BooleanResponseResult.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }
}


@Injectable()

export class LookupProxy {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl ?? "https://api.doktar.dev";
    }

    /**
     * @return OK
     */
    lookup_AppStartupLookups(): Observable<AppStartupModelResponseResult> {
        let url_ = this.baseUrl + "/v4.0/lookup/app-startup";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processLookup_AppStartupLookups(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processLookup_AppStartupLookups(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<AppStartupModelResponseResult>;
                }
            } else
                return _observableThrow(response_) as any as Observable<AppStartupModelResponseResult>;
        }));
    }

    protected processLookup_AppStartupLookups(response: HttpResponseBase): Observable<AppStartupModelResponseResult> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = AppStartupModelResponseResult.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @return OK
     */
    lookup_GetLocales(): Observable<KeyValueModelListResponseResult> {
        let url_ = this.baseUrl + "/v4.0/lookup/locales";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processLookup_GetLocales(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processLookup_GetLocales(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<KeyValueModelListResponseResult>;
                }
            } else
                return _observableThrow(response_) as any as Observable<KeyValueModelListResponseResult>;
        }));
    }

    protected processLookup_GetLocales(response: HttpResponseBase): Observable<KeyValueModelListResponseResult> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = KeyValueModelListResponseResult.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @return OK
     */
    lookup_GetLanguages(): Observable<LanguageViewModelListResponseResult> {
        let url_ = this.baseUrl + "/v4.0/lookup/languages";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processLookup_GetLanguages(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processLookup_GetLanguages(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<LanguageViewModelListResponseResult>;
                }
            } else
                return _observableThrow(response_) as any as Observable<LanguageViewModelListResponseResult>;
        }));
    }

    protected processLookup_GetLanguages(response: HttpResponseBase): Observable<LanguageViewModelListResponseResult> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = LanguageViewModelListResponseResult.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @return OK
     */
    lookup_GetInquiryTypes(): Observable<KeyValueModelListResponseResult> {
        let url_ = this.baseUrl + "/v4.0/lookup/inquiry-types";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processLookup_GetInquiryTypes(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processLookup_GetInquiryTypes(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<KeyValueModelListResponseResult>;
                }
            } else
                return _observableThrow(response_) as any as Observable<KeyValueModelListResponseResult>;
        }));
    }

    protected processLookup_GetInquiryTypes(response: HttpResponseBase): Observable<KeyValueModelListResponseResult> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = KeyValueModelListResponseResult.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @return OK
     */
    lookup_GetInventoryLookupsByEnterprise(enterpriseId: string): Observable<KeyValueModelListResponseResult> {
        let url_ = this.baseUrl + "/v4.0/lookup/inventories/{enterpriseId}";
        if (enterpriseId === undefined || enterpriseId === null)
            throw new globalThis.Error("The parameter 'enterpriseId' must be defined.");
        url_ = url_.replace("{enterpriseId}", encodeURIComponent("" + enterpriseId));
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processLookup_GetInventoryLookupsByEnterprise(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processLookup_GetInventoryLookupsByEnterprise(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<KeyValueModelListResponseResult>;
                }
            } else
                return _observableThrow(response_) as any as Observable<KeyValueModelListResponseResult>;
        }));
    }

    protected processLookup_GetInventoryLookupsByEnterprise(response: HttpResponseBase): Observable<KeyValueModelListResponseResult> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = KeyValueModelListResponseResult.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param search (optional) 
     * @return OK
     */
    lookup_GetInventoryLookups(search?: string | undefined): Observable<KeyValueModelListResponseResult> {
        let url_ = this.baseUrl + "/v4.0/lookup/inventories?";
        if (search === null)
            throw new globalThis.Error("The parameter 'search' cannot be null.");
        else if (search !== undefined)
            url_ += "search=" + encodeURIComponent("" + search) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processLookup_GetInventoryLookups(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processLookup_GetInventoryLookups(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<KeyValueModelListResponseResult>;
                }
            } else
                return _observableThrow(response_) as any as Observable<KeyValueModelListResponseResult>;
        }));
    }

    protected processLookup_GetInventoryLookups(response: HttpResponseBase): Observable<KeyValueModelListResponseResult> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = KeyValueModelListResponseResult.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @return OK
     */
    lookup_GetProfessions(): Observable<ProfessionLookupViewModelListResponseResult> {
        let url_ = this.baseUrl + "/v4.0/lookup/professions";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processLookup_GetProfessions(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processLookup_GetProfessions(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<ProfessionLookupViewModelListResponseResult>;
                }
            } else
                return _observableThrow(response_) as any as Observable<ProfessionLookupViewModelListResponseResult>;
        }));
    }

    protected processLookup_GetProfessions(response: HttpResponseBase): Observable<ProfessionLookupViewModelListResponseResult> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = ProfessionLookupViewModelListResponseResult.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @return OK
     */
    lookup_GetLandsLookup(enterpriseId: string): Observable<KeyValueModelListResponseResult> {
        let url_ = this.baseUrl + "/v4.0/lookup/lands/{enterpriseId}";
        if (enterpriseId === undefined || enterpriseId === null)
            throw new globalThis.Error("The parameter 'enterpriseId' must be defined.");
        url_ = url_.replace("{enterpriseId}", encodeURIComponent("" + enterpriseId));
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processLookup_GetLandsLookup(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processLookup_GetLandsLookup(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<KeyValueModelListResponseResult>;
                }
            } else
                return _observableThrow(response_) as any as Observable<KeyValueModelListResponseResult>;
        }));
    }

    protected processLookup_GetLandsLookup(response: HttpResponseBase): Observable<KeyValueModelListResponseResult> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = KeyValueModelListResponseResult.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @return OK
     */
    lookup_GetPlantationsLookup(enterpriseId: string): Observable<KeyValueModelListResponseResult> {
        let url_ = this.baseUrl + "/v4.0/lookup/plantations/{enterpriseId}";
        if (enterpriseId === undefined || enterpriseId === null)
            throw new globalThis.Error("The parameter 'enterpriseId' must be defined.");
        url_ = url_.replace("{enterpriseId}", encodeURIComponent("" + enterpriseId));
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processLookup_GetPlantationsLookup(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processLookup_GetPlantationsLookup(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<KeyValueModelListResponseResult>;
                }
            } else
                return _observableThrow(response_) as any as Observable<KeyValueModelListResponseResult>;
        }));
    }

    protected processLookup_GetPlantationsLookup(response: HttpResponseBase): Observable<KeyValueModelListResponseResult> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = KeyValueModelListResponseResult.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param search (optional) 
     * @return OK
     */
    lookup_GetPlantationsLookup2(search?: string | undefined): Observable<KeyValueModelListResponseResult> {
        let url_ = this.baseUrl + "/v4.0/lookup/plantations?";
        if (search === null)
            throw new globalThis.Error("The parameter 'search' cannot be null.");
        else if (search !== undefined)
            url_ += "search=" + encodeURIComponent("" + search) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processLookup_GetPlantationsLookup2(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processLookup_GetPlantationsLookup2(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<KeyValueModelListResponseResult>;
                }
            } else
                return _observableThrow(response_) as any as Observable<KeyValueModelListResponseResult>;
        }));
    }

    protected processLookup_GetPlantationsLookup2(response: HttpResponseBase): Observable<KeyValueModelListResponseResult> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = KeyValueModelListResponseResult.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @return OK
     */
    lookup_GetRotationsLookupByEnterprise(enterpriseId: string): Observable<KeyValueModelListResponseResult> {
        let url_ = this.baseUrl + "/v4.0/lookup/rotations/{enterpriseId}";
        if (enterpriseId === undefined || enterpriseId === null)
            throw new globalThis.Error("The parameter 'enterpriseId' must be defined.");
        url_ = url_.replace("{enterpriseId}", encodeURIComponent("" + enterpriseId));
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processLookup_GetRotationsLookupByEnterprise(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processLookup_GetRotationsLookupByEnterprise(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<KeyValueModelListResponseResult>;
                }
            } else
                return _observableThrow(response_) as any as Observable<KeyValueModelListResponseResult>;
        }));
    }

    protected processLookup_GetRotationsLookupByEnterprise(response: HttpResponseBase): Observable<KeyValueModelListResponseResult> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = KeyValueModelListResponseResult.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @return OK
     */
    lookup_GetRotationsLookup(): Observable<KeyValueModelListResponseResult> {
        let url_ = this.baseUrl + "/v4.0/lookup/rotations";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processLookup_GetRotationsLookup(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processLookup_GetRotationsLookup(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<KeyValueModelListResponseResult>;
                }
            } else
                return _observableThrow(response_) as any as Observable<KeyValueModelListResponseResult>;
        }));
    }

    protected processLookup_GetRotationsLookup(response: HttpResponseBase): Observable<KeyValueModelListResponseResult> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = KeyValueModelListResponseResult.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @return OK
     */
    lookup_GetTimeZones(): Observable<KeyValueModelListResponseResult> {
        let url_ = this.baseUrl + "/v4.0/lookup/time-zones";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processLookup_GetTimeZones(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processLookup_GetTimeZones(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<KeyValueModelListResponseResult>;
                }
            } else
                return _observableThrow(response_) as any as Observable<KeyValueModelListResponseResult>;
        }));
    }

    protected processLookup_GetTimeZones(response: HttpResponseBase): Observable<KeyValueModelListResponseResult> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = KeyValueModelListResponseResult.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @return OK
     */
    lookup_GetUnitTypes(): Observable<KeyValueModelListResponseResult> {
        let url_ = this.baseUrl + "/v4.0/lookup/unit-types";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processLookup_GetUnitTypes(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processLookup_GetUnitTypes(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<KeyValueModelListResponseResult>;
                }
            } else
                return _observableThrow(response_) as any as Observable<KeyValueModelListResponseResult>;
        }));
    }

    protected processLookup_GetUnitTypes(response: HttpResponseBase): Observable<KeyValueModelListResponseResult> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = KeyValueModelListResponseResult.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @return OK
     */
    lookup_GetUnits(): Observable<UnitTypeLookupViewModelListResponseResult> {
        let url_ = this.baseUrl + "/v4.0/lookup/units";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processLookup_GetUnits(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processLookup_GetUnits(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<UnitTypeLookupViewModelListResponseResult>;
                }
            } else
                return _observableThrow(response_) as any as Observable<UnitTypeLookupViewModelListResponseResult>;
        }));
    }

    protected processLookup_GetUnits(response: HttpResponseBase): Observable<UnitTypeLookupViewModelListResponseResult> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = UnitTypeLookupViewModelListResponseResult.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @return OK
     */
    lookup_GetUnits2(unitTypeId: string): Observable<KeyValueModelListResponseResult> {
        let url_ = this.baseUrl + "/v4.0/lookup/units/{unitTypeId}";
        if (unitTypeId === undefined || unitTypeId === null)
            throw new globalThis.Error("The parameter 'unitTypeId' must be defined.");
        url_ = url_.replace("{unitTypeId}", encodeURIComponent("" + unitTypeId));
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processLookup_GetUnits2(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processLookup_GetUnits2(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<KeyValueModelListResponseResult>;
                }
            } else
                return _observableThrow(response_) as any as Observable<KeyValueModelListResponseResult>;
        }));
    }

    protected processLookup_GetUnits2(response: HttpResponseBase): Observable<KeyValueModelListResponseResult> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = KeyValueModelListResponseResult.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @return OK
     */
    lookup_GetUnityByUserQuery(userId: string): Observable<KeyValueModelListResponseResult> {
        let url_ = this.baseUrl + "/v4.0/lookup/units/user/{userId}";
        if (userId === undefined || userId === null)
            throw new globalThis.Error("The parameter 'userId' must be defined.");
        url_ = url_.replace("{userId}", encodeURIComponent("" + userId));
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processLookup_GetUnityByUserQuery(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processLookup_GetUnityByUserQuery(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<KeyValueModelListResponseResult>;
                }
            } else
                return _observableThrow(response_) as any as Observable<KeyValueModelListResponseResult>;
        }));
    }

    protected processLookup_GetUnityByUserQuery(response: HttpResponseBase): Observable<KeyValueModelListResponseResult> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = KeyValueModelListResponseResult.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @return OK
     */
    lookup_GetUserTypes(): Observable<KeyValueModelListResponseResult> {
        let url_ = this.baseUrl + "/v4.0/lookup/user-types";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processLookup_GetUserTypes(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processLookup_GetUserTypes(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<KeyValueModelListResponseResult>;
                }
            } else
                return _observableThrow(response_) as any as Observable<KeyValueModelListResponseResult>;
        }));
    }

    protected processLookup_GetUserTypes(response: HttpResponseBase): Observable<KeyValueModelListResponseResult> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = KeyValueModelListResponseResult.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param customerAccessKey (optional) 
     * @return OK
     */
    lookup_GetApps(customerAccessKey?: string | undefined): Observable<KeyValueModelListResponseResult> {
        let url_ = this.baseUrl + "/v4.0/lookup/apps?";
        if (customerAccessKey === null)
            throw new globalThis.Error("The parameter 'customerAccessKey' cannot be null.");
        else if (customerAccessKey !== undefined)
            url_ += "customerAccessKey=" + encodeURIComponent("" + customerAccessKey) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processLookup_GetApps(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processLookup_GetApps(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<KeyValueModelListResponseResult>;
                }
            } else
                return _observableThrow(response_) as any as Observable<KeyValueModelListResponseResult>;
        }));
    }

    protected processLookup_GetApps(response: HttpResponseBase): Observable<KeyValueModelListResponseResult> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = KeyValueModelListResponseResult.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @return OK
     */
    lookup_GetCountries(): Observable<CountryLookupModelListResponseResult> {
        let url_ = this.baseUrl + "/v4.0/lookup/countries";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processLookup_GetCountries(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processLookup_GetCountries(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<CountryLookupModelListResponseResult>;
                }
            } else
                return _observableThrow(response_) as any as Observable<CountryLookupModelListResponseResult>;
        }));
    }

    protected processLookup_GetCountries(response: HttpResponseBase): Observable<CountryLookupModelListResponseResult> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = CountryLookupModelListResponseResult.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @return OK
     */
    lookup_GetCrops(): Observable<GetCropsQueryResultListResponseResult> {
        let url_ = this.baseUrl + "/v4.0/lookup/crops";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processLookup_GetCrops(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processLookup_GetCrops(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<GetCropsQueryResultListResponseResult>;
                }
            } else
                return _observableThrow(response_) as any as Observable<GetCropsQueryResultListResponseResult>;
        }));
    }

    protected processLookup_GetCrops(response: HttpResponseBase): Observable<GetCropsQueryResultListResponseResult> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = GetCropsQueryResultListResponseResult.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @return OK
     */
    lookup_GetCropClasses(cropId: string): Observable<GetCropClassesQueryResultListResponseResult> {
        let url_ = this.baseUrl + "/v4.0/lookup/crop-classes/{cropId}";
        if (cropId === undefined || cropId === null)
            throw new globalThis.Error("The parameter 'cropId' must be defined.");
        url_ = url_.replace("{cropId}", encodeURIComponent("" + cropId));
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processLookup_GetCropClasses(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processLookup_GetCropClasses(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<GetCropClassesQueryResultListResponseResult>;
                }
            } else
                return _observableThrow(response_) as any as Observable<GetCropClassesQueryResultListResponseResult>;
        }));
    }

    protected processLookup_GetCropClasses(response: HttpResponseBase): Observable<GetCropClassesQueryResultListResponseResult> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = GetCropClassesQueryResultListResponseResult.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @return OK
     */
    lookup_GetCropClasses2(): Observable<GetCropClassesQueryResultListResponseResult> {
        let url_ = this.baseUrl + "/v4.0/lookup/crop-classes";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processLookup_GetCropClasses2(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processLookup_GetCropClasses2(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<GetCropClassesQueryResultListResponseResult>;
                }
            } else
                return _observableThrow(response_) as any as Observable<GetCropClassesQueryResultListResponseResult>;
        }));
    }

    protected processLookup_GetCropClasses2(response: HttpResponseBase): Observable<GetCropClassesQueryResultListResponseResult> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = GetCropClassesQueryResultListResponseResult.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @return OK
     */
    lookup_GetCropTypes(): Observable<GetCropTypesQueryResultListResponseResult> {
        let url_ = this.baseUrl + "/v4.0/lookup/crop-types";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processLookup_GetCropTypes(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processLookup_GetCropTypes(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<GetCropTypesQueryResultListResponseResult>;
                }
            } else
                return _observableThrow(response_) as any as Observable<GetCropTypesQueryResultListResponseResult>;
        }));
    }

    protected processLookup_GetCropTypes(response: HttpResponseBase): Observable<GetCropTypesQueryResultListResponseResult> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = GetCropTypesQueryResultListResponseResult.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @return OK
     */
    lookup_GetAnimalSpecies(): Observable<KeyValueModelListResponseResult> {
        let url_ = this.baseUrl + "/v4.0/lookup/animal-species";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processLookup_GetAnimalSpecies(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processLookup_GetAnimalSpecies(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<KeyValueModelListResponseResult>;
                }
            } else
                return _observableThrow(response_) as any as Observable<KeyValueModelListResponseResult>;
        }));
    }

    protected processLookup_GetAnimalSpecies(response: HttpResponseBase): Observable<KeyValueModelListResponseResult> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = KeyValueModelListResponseResult.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @return OK
     */
    lookup_GetAnimalBreeds(animalSpeciesId: string): Observable<KeyValueModelListResponseResult> {
        let url_ = this.baseUrl + "/v4.0/lookup/animal-breeds/{animalSpeciesId}";
        if (animalSpeciesId === undefined || animalSpeciesId === null)
            throw new globalThis.Error("The parameter 'animalSpeciesId' must be defined.");
        url_ = url_.replace("{animalSpeciesId}", encodeURIComponent("" + animalSpeciesId));
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processLookup_GetAnimalBreeds(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processLookup_GetAnimalBreeds(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<KeyValueModelListResponseResult>;
                }
            } else
                return _observableThrow(response_) as any as Observable<KeyValueModelListResponseResult>;
        }));
    }

    protected processLookup_GetAnimalBreeds(response: HttpResponseBase): Observable<KeyValueModelListResponseResult> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = KeyValueModelListResponseResult.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @return OK
     */
    lookup_GetAnimalBreeds2(): Observable<KeyValueModelListResponseResult> {
        let url_ = this.baseUrl + "/v4.0/lookup/animal-breeds";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processLookup_GetAnimalBreeds2(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processLookup_GetAnimalBreeds2(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<KeyValueModelListResponseResult>;
                }
            } else
                return _observableThrow(response_) as any as Observable<KeyValueModelListResponseResult>;
        }));
    }

    protected processLookup_GetAnimalBreeds2(response: HttpResponseBase): Observable<KeyValueModelListResponseResult> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = KeyValueModelListResponseResult.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @return OK
     */
    lookup_GetAnimalGenders(): Observable<KeyValueModelListResponseResult> {
        let url_ = this.baseUrl + "/v4.0/lookup/animal-genders";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processLookup_GetAnimalGenders(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processLookup_GetAnimalGenders(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<KeyValueModelListResponseResult>;
                }
            } else
                return _observableThrow(response_) as any as Observable<KeyValueModelListResponseResult>;
        }));
    }

    protected processLookup_GetAnimalGenders(response: HttpResponseBase): Observable<KeyValueModelListResponseResult> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = KeyValueModelListResponseResult.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @return OK
     */
    lookup_GetAnimalStatuses(): Observable<KeyValueModelListResponseResult> {
        let url_ = this.baseUrl + "/v4.0/lookup/animal-statuses";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processLookup_GetAnimalStatuses(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processLookup_GetAnimalStatuses(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<KeyValueModelListResponseResult>;
                }
            } else
                return _observableThrow(response_) as any as Observable<KeyValueModelListResponseResult>;
        }));
    }

    protected processLookup_GetAnimalStatuses(response: HttpResponseBase): Observable<KeyValueModelListResponseResult> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = KeyValueModelListResponseResult.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @return OK
     */
    lookup_GetBreedingTypes(): Observable<KeyValueModelListResponseResult> {
        let url_ = this.baseUrl + "/v4.0/lookup/breeding-types";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processLookup_GetBreedingTypes(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processLookup_GetBreedingTypes(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<KeyValueModelListResponseResult>;
                }
            } else
                return _observableThrow(response_) as any as Observable<KeyValueModelListResponseResult>;
        }));
    }

    protected processLookup_GetBreedingTypes(response: HttpResponseBase): Observable<KeyValueModelListResponseResult> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = KeyValueModelListResponseResult.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @return OK
     */
    lookup_GetCropVarieties(cropClassId: string): Observable<KeyValueModelListResponseResult> {
        let url_ = this.baseUrl + "/v4.0/lookup/crop-varieties/{cropClassId}";
        if (cropClassId === undefined || cropClassId === null)
            throw new globalThis.Error("The parameter 'cropClassId' must be defined.");
        url_ = url_.replace("{cropClassId}", encodeURIComponent("" + cropClassId));
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processLookup_GetCropVarieties(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processLookup_GetCropVarieties(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<KeyValueModelListResponseResult>;
                }
            } else
                return _observableThrow(response_) as any as Observable<KeyValueModelListResponseResult>;
        }));
    }

    protected processLookup_GetCropVarieties(response: HttpResponseBase): Observable<KeyValueModelListResponseResult> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = KeyValueModelListResponseResult.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @return OK
     */
    lookup_GetCropProduces(cropClassId: string): Observable<KeyValueModelListResponseResult> {
        let url_ = this.baseUrl + "/v4.0/lookup/crop-produces/{cropClassId}";
        if (cropClassId === undefined || cropClassId === null)
            throw new globalThis.Error("The parameter 'cropClassId' must be defined.");
        url_ = url_.replace("{cropClassId}", encodeURIComponent("" + cropClassId));
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processLookup_GetCropProduces(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processLookup_GetCropProduces(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<KeyValueModelListResponseResult>;
                }
            } else
                return _observableThrow(response_) as any as Observable<KeyValueModelListResponseResult>;
        }));
    }

    protected processLookup_GetCropProduces(response: HttpResponseBase): Observable<KeyValueModelListResponseResult> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = KeyValueModelListResponseResult.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @return OK
     */
    lookup_GetCropHarvestableStages(cropId: string): Observable<KeyValueModelListResponseResult> {
        let url_ = this.baseUrl + "/v4.0/lookup/crop-harvestable-stages/{cropId}";
        if (cropId === undefined || cropId === null)
            throw new globalThis.Error("The parameter 'cropId' must be defined.");
        url_ = url_.replace("{cropId}", encodeURIComponent("" + cropId));
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processLookup_GetCropHarvestableStages(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processLookup_GetCropHarvestableStages(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<KeyValueModelListResponseResult>;
                }
            } else
                return _observableThrow(response_) as any as Observable<KeyValueModelListResponseResult>;
        }));
    }

    protected processLookup_GetCropHarvestableStages(response: HttpResponseBase): Observable<KeyValueModelListResponseResult> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = KeyValueModelListResponseResult.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @return OK
     */
    lookup_GetCropPhenologicalStages(cropId: string): Observable<KeyValueModelListResponseResult> {
        let url_ = this.baseUrl + "/v4.0/lookup/crop-phenological-stages/{cropId}";
        if (cropId === undefined || cropId === null)
            throw new globalThis.Error("The parameter 'cropId' must be defined.");
        url_ = url_.replace("{cropId}", encodeURIComponent("" + cropId));
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processLookup_GetCropPhenologicalStages(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processLookup_GetCropPhenologicalStages(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<KeyValueModelListResponseResult>;
                }
            } else
                return _observableThrow(response_) as any as Observable<KeyValueModelListResponseResult>;
        }));
    }

    protected processLookup_GetCropPhenologicalStages(response: HttpResponseBase): Observable<KeyValueModelListResponseResult> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = KeyValueModelListResponseResult.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @return OK
     */
    lookup_GetCustomersQuery(): Observable<KeyValueModelListResponseResult> {
        let url_ = this.baseUrl + "/v4.0/lookup/customers";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processLookup_GetCustomersQuery(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processLookup_GetCustomersQuery(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<KeyValueModelListResponseResult>;
                }
            } else
                return _observableThrow(response_) as any as Observable<KeyValueModelListResponseResult>;
        }));
    }

    protected processLookup_GetCustomersQuery(response: HttpResponseBase): Observable<KeyValueModelListResponseResult> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = KeyValueModelListResponseResult.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @return OK
     */
    lookup_GetEnterprisesQuery(): Observable<KeyValueModelListResponseResult> {
        let url_ = this.baseUrl + "/v4.0/lookup/enterprises";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processLookup_GetEnterprisesQuery(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processLookup_GetEnterprisesQuery(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<KeyValueModelListResponseResult>;
                }
            } else
                return _observableThrow(response_) as any as Observable<KeyValueModelListResponseResult>;
        }));
    }

    protected processLookup_GetEnterprisesQuery(response: HttpResponseBase): Observable<KeyValueModelListResponseResult> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = KeyValueModelListResponseResult.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param roleKind (optional) 
     * @return OK
     */
    lookup_GetRolesQuery(roleKind?: string | undefined): Observable<KeyValueModelListResponseResult> {
        let url_ = this.baseUrl + "/v4.0/lookup/roles?";
        if (roleKind === null)
            throw new globalThis.Error("The parameter 'roleKind' cannot be null.");
        else if (roleKind !== undefined)
            url_ += "roleKind=" + encodeURIComponent("" + roleKind) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processLookup_GetRolesQuery(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processLookup_GetRolesQuery(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<KeyValueModelListResponseResult>;
                }
            } else
                return _observableThrow(response_) as any as Observable<KeyValueModelListResponseResult>;
        }));
    }

    protected processLookup_GetRolesQuery(response: HttpResponseBase): Observable<KeyValueModelListResponseResult> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = KeyValueModelListResponseResult.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @return OK
     */
    lookup_GetEngagementCategories(): Observable<ExtentedKeyValueModelListResponseResult> {
        let url_ = this.baseUrl + "/v4.0/lookup/engagement-categories";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processLookup_GetEngagementCategories(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processLookup_GetEngagementCategories(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<ExtentedKeyValueModelListResponseResult>;
                }
            } else
                return _observableThrow(response_) as any as Observable<ExtentedKeyValueModelListResponseResult>;
        }));
    }

    protected processLookup_GetEngagementCategories(response: HttpResponseBase): Observable<ExtentedKeyValueModelListResponseResult> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = ExtentedKeyValueModelListResponseResult.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @return OK
     */
    lookup_GetNotificationChannels(): Observable<ExtentedKeyValueModelListResponseResult> {
        let url_ = this.baseUrl + "/v4.0/lookup/notification-channels";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processLookup_GetNotificationChannels(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processLookup_GetNotificationChannels(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<ExtentedKeyValueModelListResponseResult>;
                }
            } else
                return _observableThrow(response_) as any as Observable<ExtentedKeyValueModelListResponseResult>;
        }));
    }

    protected processLookup_GetNotificationChannels(response: HttpResponseBase): Observable<ExtentedKeyValueModelListResponseResult> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = ExtentedKeyValueModelListResponseResult.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @return OK
     */
    lookup_GetProductList(): Observable<KeyValueModelListResponseResult> {
        let url_ = this.baseUrl + "/v4.0/lookup/product-list";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processLookup_GetProductList(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processLookup_GetProductList(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<KeyValueModelListResponseResult>;
                }
            } else
                return _observableThrow(response_) as any as Observable<KeyValueModelListResponseResult>;
        }));
    }

    protected processLookup_GetProductList(response: HttpResponseBase): Observable<KeyValueModelListResponseResult> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = KeyValueModelListResponseResult.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @return OK
     */
    lookup_GetDataRequestTypes(): Observable<KeyValueModelListResponseResult> {
        let url_ = this.baseUrl + "/v4.0/lookup/data-request-types";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processLookup_GetDataRequestTypes(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processLookup_GetDataRequestTypes(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<KeyValueModelListResponseResult>;
                }
            } else
                return _observableThrow(response_) as any as Observable<KeyValueModelListResponseResult>;
        }));
    }

    protected processLookup_GetDataRequestTypes(response: HttpResponseBase): Observable<KeyValueModelListResponseResult> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = KeyValueModelListResponseResult.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param appId (optional) 
     * @param processingStatus (optional) 
     * @return OK
     */
    lookup_GetDataRequests(appId?: string | undefined, processingStatus?: boolean | undefined): Observable<KeyValueModelListResponseResult> {
        let url_ = this.baseUrl + "/v4.0/lookup/data-requests?";
        if (appId === null)
            throw new globalThis.Error("The parameter 'appId' cannot be null.");
        else if (appId !== undefined)
            url_ += "appId=" + encodeURIComponent("" + appId) + "&";
        if (processingStatus === null)
            throw new globalThis.Error("The parameter 'processingStatus' cannot be null.");
        else if (processingStatus !== undefined)
            url_ += "processingStatus=" + encodeURIComponent("" + processingStatus) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processLookup_GetDataRequests(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processLookup_GetDataRequests(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<KeyValueModelListResponseResult>;
                }
            } else
                return _observableThrow(response_) as any as Observable<KeyValueModelListResponseResult>;
        }));
    }

    protected processLookup_GetDataRequests(response: HttpResponseBase): Observable<KeyValueModelListResponseResult> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = KeyValueModelListResponseResult.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @return OK
     */
    lookup_GetInvitationStatuses(): Observable<KeyValueModelListResponseResult> {
        let url_ = this.baseUrl + "/v4.0/lookup/invitation-statuses";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processLookup_GetInvitationStatuses(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processLookup_GetInvitationStatuses(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<KeyValueModelListResponseResult>;
                }
            } else
                return _observableThrow(response_) as any as Observable<KeyValueModelListResponseResult>;
        }));
    }

    protected processLookup_GetInvitationStatuses(response: HttpResponseBase): Observable<KeyValueModelListResponseResult> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = KeyValueModelListResponseResult.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @return OK
     */
    lookup_GetContractTypes(): Observable<KeyValueModelListResponseResult> {
        let url_ = this.baseUrl + "/v4.0/lookup/contract-types";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processLookup_GetContractTypes(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processLookup_GetContractTypes(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<KeyValueModelListResponseResult>;
                }
            } else
                return _observableThrow(response_) as any as Observable<KeyValueModelListResponseResult>;
        }));
    }

    protected processLookup_GetContractTypes(response: HttpResponseBase): Observable<KeyValueModelListResponseResult> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = KeyValueModelListResponseResult.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @return OK
     */
    lookup_GetContractSeasons(): Observable<KeyValueModelListResponseResult> {
        let url_ = this.baseUrl + "/v4.0/lookup/contract-seasons";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processLookup_GetContractSeasons(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processLookup_GetContractSeasons(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<KeyValueModelListResponseResult>;
                }
            } else
                return _observableThrow(response_) as any as Observable<KeyValueModelListResponseResult>;
        }));
    }

    protected processLookup_GetContractSeasons(response: HttpResponseBase): Observable<KeyValueModelListResponseResult> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = KeyValueModelListResponseResult.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @return OK
     */
    lookup_GetDeviceLines(): Observable<KeyValueModelListResponseResult> {
        let url_ = this.baseUrl + "/v4.0/lookup/device-lines";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processLookup_GetDeviceLines(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processLookup_GetDeviceLines(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<KeyValueModelListResponseResult>;
                }
            } else
                return _observableThrow(response_) as any as Observable<KeyValueModelListResponseResult>;
        }));
    }

    protected processLookup_GetDeviceLines(response: HttpResponseBase): Observable<KeyValueModelListResponseResult> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = KeyValueModelListResponseResult.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @return OK
     */
    lookup_GetDeviceModels(): Observable<KeyValueModelListResponseResult> {
        let url_ = this.baseUrl + "/v4.0/lookup/device-models";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processLookup_GetDeviceModels(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processLookup_GetDeviceModels(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<KeyValueModelListResponseResult>;
                }
            } else
                return _observableThrow(response_) as any as Observable<KeyValueModelListResponseResult>;
        }));
    }

    protected processLookup_GetDeviceModels(response: HttpResponseBase): Observable<KeyValueModelListResponseResult> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = KeyValueModelListResponseResult.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @return OK
     */
    lookup_GetDeviceModelsByDeviceLine(deviceLineId: string): Observable<KeyValueModelListResponseResult> {
        let url_ = this.baseUrl + "/v4.0/lookup/device-models/{deviceLineId}";
        if (deviceLineId === undefined || deviceLineId === null)
            throw new globalThis.Error("The parameter 'deviceLineId' must be defined.");
        url_ = url_.replace("{deviceLineId}", encodeURIComponent("" + deviceLineId));
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processLookup_GetDeviceModelsByDeviceLine(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processLookup_GetDeviceModelsByDeviceLine(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<KeyValueModelListResponseResult>;
                }
            } else
                return _observableThrow(response_) as any as Observable<KeyValueModelListResponseResult>;
        }));
    }

    protected processLookup_GetDeviceModelsByDeviceLine(response: HttpResponseBase): Observable<KeyValueModelListResponseResult> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = KeyValueModelListResponseResult.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @return OK
     */
    lookup_GetDeviceGenerations(): Observable<KeyValueModelListResponseResult> {
        let url_ = this.baseUrl + "/v4.0/lookup/device-generations";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processLookup_GetDeviceGenerations(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processLookup_GetDeviceGenerations(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<KeyValueModelListResponseResult>;
                }
            } else
                return _observableThrow(response_) as any as Observable<KeyValueModelListResponseResult>;
        }));
    }

    protected processLookup_GetDeviceGenerations(response: HttpResponseBase): Observable<KeyValueModelListResponseResult> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = KeyValueModelListResponseResult.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @return OK
     */
    lookup_GetSIMInventory(): Observable<KeyValueModelListResponseResult> {
        let url_ = this.baseUrl + "/v4.0/lookup/sim-inventory";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processLookup_GetSIMInventory(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processLookup_GetSIMInventory(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<KeyValueModelListResponseResult>;
                }
            } else
                return _observableThrow(response_) as any as Observable<KeyValueModelListResponseResult>;
        }));
    }

    protected processLookup_GetSIMInventory(response: HttpResponseBase): Observable<KeyValueModelListResponseResult> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = KeyValueModelListResponseResult.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @return OK
     */
    lookup_GetDeviceOperationModels(): Observable<KeyValueModelListResponseResult> {
        let url_ = this.baseUrl + "/v4.0/lookup/device-operation-models";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processLookup_GetDeviceOperationModels(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processLookup_GetDeviceOperationModels(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<KeyValueModelListResponseResult>;
                }
            } else
                return _observableThrow(response_) as any as Observable<KeyValueModelListResponseResult>;
        }));
    }

    protected processLookup_GetDeviceOperationModels(response: HttpResponseBase): Observable<KeyValueModelListResponseResult> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = KeyValueModelListResponseResult.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @return OK
     */
    lookup_GetDeviceOwnerships(): Observable<KeyValueModelListResponseResult> {
        let url_ = this.baseUrl + "/v4.0/lookup/device-ownerships";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processLookup_GetDeviceOwnerships(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processLookup_GetDeviceOwnerships(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<KeyValueModelListResponseResult>;
                }
            } else
                return _observableThrow(response_) as any as Observable<KeyValueModelListResponseResult>;
        }));
    }

    protected processLookup_GetDeviceOwnerships(response: HttpResponseBase): Observable<KeyValueModelListResponseResult> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = KeyValueModelListResponseResult.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @return OK
     */
    lookup_GetInventoryStatuses(): Observable<KeyValueModelListResponseResult> {
        let url_ = this.baseUrl + "/v4.0/lookup/inventory-statuses";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processLookup_GetInventoryStatuses(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processLookup_GetInventoryStatuses(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<KeyValueModelListResponseResult>;
                }
            } else
                return _observableThrow(response_) as any as Observable<KeyValueModelListResponseResult>;
        }));
    }

    protected processLookup_GetInventoryStatuses(response: HttpResponseBase): Observable<KeyValueModelListResponseResult> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = KeyValueModelListResponseResult.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @return OK
     */
    lookup_GetDeviceConfigurations(): Observable<KeyValueModelListResponseResult> {
        let url_ = this.baseUrl + "/v4.0/lookup/device-configurations";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processLookup_GetDeviceConfigurations(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processLookup_GetDeviceConfigurations(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<KeyValueModelListResponseResult>;
                }
            } else
                return _observableThrow(response_) as any as Observable<KeyValueModelListResponseResult>;
        }));
    }

    protected processLookup_GetDeviceConfigurations(response: HttpResponseBase): Observable<KeyValueModelListResponseResult> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = KeyValueModelListResponseResult.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @return OK
     */
    lookup_GetUsersByEnterprise(enterpriseId: string): Observable<KeyValueModelListResponseResult> {
        let url_ = this.baseUrl + "/v4.0/lookup/users/{enterpriseId}";
        if (enterpriseId === undefined || enterpriseId === null)
            throw new globalThis.Error("The parameter 'enterpriseId' must be defined.");
        url_ = url_.replace("{enterpriseId}", encodeURIComponent("" + enterpriseId));
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processLookup_GetUsersByEnterprise(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processLookup_GetUsersByEnterprise(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<KeyValueModelListResponseResult>;
                }
            } else
                return _observableThrow(response_) as any as Observable<KeyValueModelListResponseResult>;
        }));
    }

    protected processLookup_GetUsersByEnterprise(response: HttpResponseBase): Observable<KeyValueModelListResponseResult> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = KeyValueModelListResponseResult.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param regionId (optional) 
     * @param stateId (optional) 
     * @param countryId (optional) 
     * @return OK
     */
    lookup_GetCities(regionId?: string | undefined, stateId?: string | undefined, countryId?: string | undefined): Observable<KeyValueModelListResponseResult> {
        let url_ = this.baseUrl + "/v4.0/lookup/cities?";
        if (regionId === null)
            throw new globalThis.Error("The parameter 'regionId' cannot be null.");
        else if (regionId !== undefined)
            url_ += "regionId=" + encodeURIComponent("" + regionId) + "&";
        if (stateId === null)
            throw new globalThis.Error("The parameter 'stateId' cannot be null.");
        else if (stateId !== undefined)
            url_ += "stateId=" + encodeURIComponent("" + stateId) + "&";
        if (countryId === null)
            throw new globalThis.Error("The parameter 'countryId' cannot be null.");
        else if (countryId !== undefined)
            url_ += "countryId=" + encodeURIComponent("" + countryId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processLookup_GetCities(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processLookup_GetCities(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<KeyValueModelListResponseResult>;
                }
            } else
                return _observableThrow(response_) as any as Observable<KeyValueModelListResponseResult>;
        }));
    }

    protected processLookup_GetCities(response: HttpResponseBase): Observable<KeyValueModelListResponseResult> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = KeyValueModelListResponseResult.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param countryId (optional) 
     * @param regionId (optional) 
     * @return OK
     */
    lookup_GetStates(countryId?: string | undefined, regionId?: string | undefined): Observable<KeyValueModelListResponseResult> {
        let url_ = this.baseUrl + "/v4.0/lookup/states?";
        if (countryId === null)
            throw new globalThis.Error("The parameter 'countryId' cannot be null.");
        else if (countryId !== undefined)
            url_ += "countryId=" + encodeURIComponent("" + countryId) + "&";
        if (regionId === null)
            throw new globalThis.Error("The parameter 'regionId' cannot be null.");
        else if (regionId !== undefined)
            url_ += "regionId=" + encodeURIComponent("" + regionId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processLookup_GetStates(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processLookup_GetStates(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<KeyValueModelListResponseResult>;
                }
            } else
                return _observableThrow(response_) as any as Observable<KeyValueModelListResponseResult>;
        }));
    }

    protected processLookup_GetStates(response: HttpResponseBase): Observable<KeyValueModelListResponseResult> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = KeyValueModelListResponseResult.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @return OK
     */
    lookup_GetDistrictsByCity(cityId: string): Observable<KeyValueModelListResponseResult> {
        let url_ = this.baseUrl + "/v4.0/lookup/districts/{cityId}";
        if (cityId === undefined || cityId === null)
            throw new globalThis.Error("The parameter 'cityId' must be defined.");
        url_ = url_.replace("{cityId}", encodeURIComponent("" + cityId));
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processLookup_GetDistrictsByCity(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processLookup_GetDistrictsByCity(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<KeyValueModelListResponseResult>;
                }
            } else
                return _observableThrow(response_) as any as Observable<KeyValueModelListResponseResult>;
        }));
    }

    protected processLookup_GetDistrictsByCity(response: HttpResponseBase): Observable<KeyValueModelListResponseResult> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = KeyValueModelListResponseResult.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @return OK
     */
    lookup_GetCountryAddressHierarchy(countryId: string): Observable<CountryAddressHierarchyViewModelResponseResult> {
        let url_ = this.baseUrl + "/v4.0/lookup/countries/{countryId}/address-hierarchy";
        if (countryId === undefined || countryId === null)
            throw new globalThis.Error("The parameter 'countryId' must be defined.");
        url_ = url_.replace("{countryId}", encodeURIComponent("" + countryId));
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processLookup_GetCountryAddressHierarchy(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processLookup_GetCountryAddressHierarchy(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<CountryAddressHierarchyViewModelResponseResult>;
                }
            } else
                return _observableThrow(response_) as any as Observable<CountryAddressHierarchyViewModelResponseResult>;
        }));
    }

    protected processLookup_GetCountryAddressHierarchy(response: HttpResponseBase): Observable<CountryAddressHierarchyViewModelResponseResult> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = CountryAddressHierarchyViewModelResponseResult.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @return OK
     */
    lookup_GetCountryAddressHierarchyWithBoundaries(countryId: string): Observable<CountryAddressHierarchyWithBoundariesViewModelResponseResult> {
        let url_ = this.baseUrl + "/v4.0/lookup/countries/{countryId}/address-hierarchy-with-boundaries";
        if (countryId === undefined || countryId === null)
            throw new globalThis.Error("The parameter 'countryId' must be defined.");
        url_ = url_.replace("{countryId}", encodeURIComponent("" + countryId));
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processLookup_GetCountryAddressHierarchyWithBoundaries(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processLookup_GetCountryAddressHierarchyWithBoundaries(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<CountryAddressHierarchyWithBoundariesViewModelResponseResult>;
                }
            } else
                return _observableThrow(response_) as any as Observable<CountryAddressHierarchyWithBoundariesViewModelResponseResult>;
        }));
    }

    protected processLookup_GetCountryAddressHierarchyWithBoundaries(response: HttpResponseBase): Observable<CountryAddressHierarchyWithBoundariesViewModelResponseResult> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = CountryAddressHierarchyWithBoundariesViewModelResponseResult.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @return OK
     */
    lookup_GetVillagesByDistrict(districtId: string): Observable<VillageLookupViewModelListResponseResult> {
        let url_ = this.baseUrl + "/v4.0/lookup/villages/{districtId}";
        if (districtId === undefined || districtId === null)
            throw new globalThis.Error("The parameter 'districtId' must be defined.");
        url_ = url_.replace("{districtId}", encodeURIComponent("" + districtId));
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processLookup_GetVillagesByDistrict(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processLookup_GetVillagesByDistrict(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<VillageLookupViewModelListResponseResult>;
                }
            } else
                return _observableThrow(response_) as any as Observable<VillageLookupViewModelListResponseResult>;
        }));
    }

    protected processLookup_GetVillagesByDistrict(response: HttpResponseBase): Observable<VillageLookupViewModelListResponseResult> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = VillageLookupViewModelListResponseResult.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @return OK
     */
    lookup_GetCurrencies(): Observable<CurrencyLookupViewModelListResponseResult> {
        let url_ = this.baseUrl + "/v4.0/lookup/currencies";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processLookup_GetCurrencies(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processLookup_GetCurrencies(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<CurrencyLookupViewModelListResponseResult>;
                }
            } else
                return _observableThrow(response_) as any as Observable<CurrencyLookupViewModelListResponseResult>;
        }));
    }

    protected processLookup_GetCurrencies(response: HttpResponseBase): Observable<CurrencyLookupViewModelListResponseResult> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = CurrencyLookupViewModelListResponseResult.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @return OK
     */
    lookup_GetAssetOwnerShips(): Observable<KeyValueModelListResponseResult> {
        let url_ = this.baseUrl + "/v4.0/lookup/asset-ownerships";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processLookup_GetAssetOwnerShips(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processLookup_GetAssetOwnerShips(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<KeyValueModelListResponseResult>;
                }
            } else
                return _observableThrow(response_) as any as Observable<KeyValueModelListResponseResult>;
        }));
    }

    protected processLookup_GetAssetOwnerShips(response: HttpResponseBase): Observable<KeyValueModelListResponseResult> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = KeyValueModelListResponseResult.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @return OK
     */
    lookup_GetSoilTypes(): Observable<KeyValueModelListResponseResult> {
        let url_ = this.baseUrl + "/v4.0/lookup/soil-types";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processLookup_GetSoilTypes(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processLookup_GetSoilTypes(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<KeyValueModelListResponseResult>;
                }
            } else
                return _observableThrow(response_) as any as Observable<KeyValueModelListResponseResult>;
        }));
    }

    protected processLookup_GetSoilTypes(response: HttpResponseBase): Observable<KeyValueModelListResponseResult> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = KeyValueModelListResponseResult.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @return OK
     */
    lookup_GetSeedTypes(): Observable<KeyValueModelListResponseResult> {
        let url_ = this.baseUrl + "/v4.0/lookup/seed-types";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processLookup_GetSeedTypes(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processLookup_GetSeedTypes(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<KeyValueModelListResponseResult>;
                }
            } else
                return _observableThrow(response_) as any as Observable<KeyValueModelListResponseResult>;
        }));
    }

    protected processLookup_GetSeedTypes(response: HttpResponseBase): Observable<KeyValueModelListResponseResult> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = KeyValueModelListResponseResult.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @return OK
     */
    lookup_GetRegenerativePractices(): Observable<KeyValueModelListResponseResult> {
        let url_ = this.baseUrl + "/v4.0/lookup/regenerative-practices";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processLookup_GetRegenerativePractices(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processLookup_GetRegenerativePractices(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<KeyValueModelListResponseResult>;
                }
            } else
                return _observableThrow(response_) as any as Observable<KeyValueModelListResponseResult>;
        }));
    }

    protected processLookup_GetRegenerativePractices(response: HttpResponseBase): Observable<KeyValueModelListResponseResult> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = KeyValueModelListResponseResult.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @return OK
     */
    lookup_GetSubcontractPractices(): Observable<SubcontractPracticeKeyValueModelListResponseResult> {
        let url_ = this.baseUrl + "/v4.0/lookup/subcontract-practices";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processLookup_GetSubcontractPractices(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processLookup_GetSubcontractPractices(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<SubcontractPracticeKeyValueModelListResponseResult>;
                }
            } else
                return _observableThrow(response_) as any as Observable<SubcontractPracticeKeyValueModelListResponseResult>;
        }));
    }

    protected processLookup_GetSubcontractPractices(response: HttpResponseBase): Observable<SubcontractPracticeKeyValueModelListResponseResult> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = SubcontractPracticeKeyValueModelListResponseResult.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param climateZoneClassId (optional) 
     * @return OK
     */
    lookup_GetClimateZoneClasses(climateZoneClassId?: string | undefined): Observable<KeyValueModelListResponseResult> {
        let url_ = this.baseUrl + "/v4.0/lookup/climate-zone-classes?";
        if (climateZoneClassId === null)
            throw new globalThis.Error("The parameter 'climateZoneClassId' cannot be null.");
        else if (climateZoneClassId !== undefined)
            url_ += "climateZoneClassId=" + encodeURIComponent("" + climateZoneClassId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processLookup_GetClimateZoneClasses(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processLookup_GetClimateZoneClasses(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<KeyValueModelListResponseResult>;
                }
            } else
                return _observableThrow(response_) as any as Observable<KeyValueModelListResponseResult>;
        }));
    }

    protected processLookup_GetClimateZoneClasses(response: HttpResponseBase): Observable<KeyValueModelListResponseResult> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = KeyValueModelListResponseResult.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param climateZonaAgriculturalClassId (optional) 
     * @return OK
     */
    lookup_GetClimateZoneAgriculturalClasses(climateZonaAgriculturalClassId?: string | undefined): Observable<KeyValueModelListResponseResult> {
        let url_ = this.baseUrl + "/v4.0/lookup/climate-zones-agricultural-classes?";
        if (climateZonaAgriculturalClassId === null)
            throw new globalThis.Error("The parameter 'climateZonaAgriculturalClassId' cannot be null.");
        else if (climateZonaAgriculturalClassId !== undefined)
            url_ += "climateZonaAgriculturalClassId=" + encodeURIComponent("" + climateZonaAgriculturalClassId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processLookup_GetClimateZoneAgriculturalClasses(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processLookup_GetClimateZoneAgriculturalClasses(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<KeyValueModelListResponseResult>;
                }
            } else
                return _observableThrow(response_) as any as Observable<KeyValueModelListResponseResult>;
        }));
    }

    protected processLookup_GetClimateZoneAgriculturalClasses(response: HttpResponseBase): Observable<KeyValueModelListResponseResult> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = KeyValueModelListResponseResult.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @return OK
     */
    lookup_GetVraImplementationStrategies(): Observable<KeyValueModelListResponseResult> {
        let url_ = this.baseUrl + "/v4.0/lookup/vra-implementation-strategies";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processLookup_GetVraImplementationStrategies(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processLookup_GetVraImplementationStrategies(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<KeyValueModelListResponseResult>;
                }
            } else
                return _observableThrow(response_) as any as Observable<KeyValueModelListResponseResult>;
        }));
    }

    protected processLookup_GetVraImplementationStrategies(response: HttpResponseBase): Observable<KeyValueModelListResponseResult> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = KeyValueModelListResponseResult.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @return OK
     */
    lookup_GetFertilizerTypes(): Observable<KeyValueModelListResponseResult> {
        let url_ = this.baseUrl + "/v4.0/lookup/fertilizer-types";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processLookup_GetFertilizerTypes(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processLookup_GetFertilizerTypes(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<KeyValueModelListResponseResult>;
                }
            } else
                return _observableThrow(response_) as any as Observable<KeyValueModelListResponseResult>;
        }));
    }

    protected processLookup_GetFertilizerTypes(response: HttpResponseBase): Observable<KeyValueModelListResponseResult> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = KeyValueModelListResponseResult.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @return OK
     */
    lookup_GetVraUnitsQuery(): Observable<KeyValueModelListResponseResult> {
        let url_ = this.baseUrl + "/v4.0/lookup/vra-units";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processLookup_GetVraUnitsQuery(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processLookup_GetVraUnitsQuery(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<KeyValueModelListResponseResult>;
                }
            } else
                return _observableThrow(response_) as any as Observable<KeyValueModelListResponseResult>;
        }));
    }

    protected processLookup_GetVraUnitsQuery(response: HttpResponseBase): Observable<KeyValueModelListResponseResult> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = KeyValueModelListResponseResult.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @return OK
     */
    lookup_GetVraStatusesQuery(): Observable<KeyValueModelListResponseResult> {
        let url_ = this.baseUrl + "/v4.0/lookup/vra-statuses";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processLookup_GetVraStatusesQuery(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processLookup_GetVraStatusesQuery(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<KeyValueModelListResponseResult>;
                }
            } else
                return _observableThrow(response_) as any as Observable<KeyValueModelListResponseResult>;
        }));
    }

    protected processLookup_GetVraStatusesQuery(response: HttpResponseBase): Observable<KeyValueModelListResponseResult> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = KeyValueModelListResponseResult.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @return OK
     */
    lookup_GetPests(): Observable<KeyValueModelListResponseResult> {
        let url_ = this.baseUrl + "/v4.0/lookup/pests";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processLookup_GetPests(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processLookup_GetPests(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<KeyValueModelListResponseResult>;
                }
            } else
                return _observableThrow(response_) as any as Observable<KeyValueModelListResponseResult>;
        }));
    }

    protected processLookup_GetPests(response: HttpResponseBase): Observable<KeyValueModelListResponseResult> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = KeyValueModelListResponseResult.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @return OK
     */
    lookup_GetNoteTypes(): Observable<KeyValueModelListResponseResult> {
        let url_ = this.baseUrl + "/v4.0/lookup/note-types";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processLookup_GetNoteTypes(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processLookup_GetNoteTypes(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<KeyValueModelListResponseResult>;
                }
            } else
                return _observableThrow(response_) as any as Observable<KeyValueModelListResponseResult>;
        }));
    }

    protected processLookup_GetNoteTypes(response: HttpResponseBase): Observable<KeyValueModelListResponseResult> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = KeyValueModelListResponseResult.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @return OK
     */
    lookup_GetProblematicSpotStatuses(): Observable<KeyValueModelListResponseResult> {
        let url_ = this.baseUrl + "/v4.0/lookup/problematic-spot-statuses";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processLookup_GetProblematicSpotStatuses(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processLookup_GetProblematicSpotStatuses(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<KeyValueModelListResponseResult>;
                }
            } else
                return _observableThrow(response_) as any as Observable<KeyValueModelListResponseResult>;
        }));
    }

    protected processLookup_GetProblematicSpotStatuses(response: HttpResponseBase): Observable<KeyValueModelListResponseResult> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = KeyValueModelListResponseResult.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @return OK
     */
    lookup_GetNoteTags(): Observable<NoteTagsLookupModelListResponseResult> {
        let url_ = this.baseUrl + "/v4.0/lookup/note-tags";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processLookup_GetNoteTags(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processLookup_GetNoteTags(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<NoteTagsLookupModelListResponseResult>;
                }
            } else
                return _observableThrow(response_) as any as Observable<NoteTagsLookupModelListResponseResult>;
        }));
    }

    protected processLookup_GetNoteTags(response: HttpResponseBase): Observable<NoteTagsLookupModelListResponseResult> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = NoteTagsLookupModelListResponseResult.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @return OK
     */
    lookup_GetIrrigationType(): Observable<KeyValueModelListResponseResult> {
        let url_ = this.baseUrl + "/v4.0/lookup/irrigation-type";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processLookup_GetIrrigationType(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processLookup_GetIrrigationType(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<KeyValueModelListResponseResult>;
                }
            } else
                return _observableThrow(response_) as any as Observable<KeyValueModelListResponseResult>;
        }));
    }

    protected processLookup_GetIrrigationType(response: HttpResponseBase): Observable<KeyValueModelListResponseResult> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = KeyValueModelListResponseResult.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @return OK
     */
    lookup_GetIrrigationProgramStatus(): Observable<KeyValueModelListResponseResult> {
        let url_ = this.baseUrl + "/v4.0/lookup/irrigation-program-status";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processLookup_GetIrrigationProgramStatus(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processLookup_GetIrrigationProgramStatus(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<KeyValueModelListResponseResult>;
                }
            } else
                return _observableThrow(response_) as any as Observable<KeyValueModelListResponseResult>;
        }));
    }

    protected processLookup_GetIrrigationProgramStatus(response: HttpResponseBase): Observable<KeyValueModelListResponseResult> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = KeyValueModelListResponseResult.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @return OK
     */
    lookup_GetIrrigationRecommendationStatus(): Observable<KeyValueModelListResponseResult> {
        let url_ = this.baseUrl + "/v4.0/lookup/irrigation-recommendation-status";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processLookup_GetIrrigationRecommendationStatus(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processLookup_GetIrrigationRecommendationStatus(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<KeyValueModelListResponseResult>;
                }
            } else
                return _observableThrow(response_) as any as Observable<KeyValueModelListResponseResult>;
        }));
    }

    protected processLookup_GetIrrigationRecommendationStatus(response: HttpResponseBase): Observable<KeyValueModelListResponseResult> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = KeyValueModelListResponseResult.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @return OK
     */
    lookup_GetSoilType(): Observable<KeyValueModelListResponseResult> {
        let url_ = this.baseUrl + "/v4.0/lookup/soil-type";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processLookup_GetSoilType(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processLookup_GetSoilType(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<KeyValueModelListResponseResult>;
                }
            } else
                return _observableThrow(response_) as any as Observable<KeyValueModelListResponseResult>;
        }));
    }

    protected processLookup_GetSoilType(response: HttpResponseBase): Observable<KeyValueModelListResponseResult> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = KeyValueModelListResponseResult.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @return OK
     */
    lookup_GetWaterConveyanceLine(): Observable<KeyValueModelListResponseResult> {
        let url_ = this.baseUrl + "/v4.0/lookup/water-conveyance-line";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processLookup_GetWaterConveyanceLine(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processLookup_GetWaterConveyanceLine(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<KeyValueModelListResponseResult>;
                }
            } else
                return _observableThrow(response_) as any as Observable<KeyValueModelListResponseResult>;
        }));
    }

    protected processLookup_GetWaterConveyanceLine(response: HttpResponseBase): Observable<KeyValueModelListResponseResult> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = KeyValueModelListResponseResult.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @return OK
     */
    lookup_GetPermissions(): Observable<KeyValueModelListResponseResult> {
        let url_ = this.baseUrl + "/v4.0/lookup/permissions";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processLookup_GetPermissions(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processLookup_GetPermissions(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<KeyValueModelListResponseResult>;
                }
            } else
                return _observableThrow(response_) as any as Observable<KeyValueModelListResponseResult>;
        }));
    }

    protected processLookup_GetPermissions(response: HttpResponseBase): Observable<KeyValueModelListResponseResult> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = KeyValueModelListResponseResult.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @return OK
     */
    lookup_GetFileTypes(): Observable<KeyValueModelListResponseResult> {
        let url_ = this.baseUrl + "/v4.0/lookup/file-types";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processLookup_GetFileTypes(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processLookup_GetFileTypes(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<KeyValueModelListResponseResult>;
                }
            } else
                return _observableThrow(response_) as any as Observable<KeyValueModelListResponseResult>;
        }));
    }

    protected processLookup_GetFileTypes(response: HttpResponseBase): Observable<KeyValueModelListResponseResult> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = KeyValueModelListResponseResult.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @return OK
     */
    lookup_GetHarvestableStages(): Observable<KeyValueModelListResponseResult> {
        let url_ = this.baseUrl + "/v4.0/lookup/harvestable-stages";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processLookup_GetHarvestableStages(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processLookup_GetHarvestableStages(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<KeyValueModelListResponseResult>;
                }
            } else
                return _observableThrow(response_) as any as Observable<KeyValueModelListResponseResult>;
        }));
    }

    protected processLookup_GetHarvestableStages(response: HttpResponseBase): Observable<KeyValueModelListResponseResult> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = KeyValueModelListResponseResult.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @return OK
     */
    lookup_GetNewsTypes(): Observable<KeyValueModelListResponseResult> {
        let url_ = this.baseUrl + "/v4.0/lookup/news-types";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processLookup_GetNewsTypes(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processLookup_GetNewsTypes(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<KeyValueModelListResponseResult>;
                }
            } else
                return _observableThrow(response_) as any as Observable<KeyValueModelListResponseResult>;
        }));
    }

    protected processLookup_GetNewsTypes(response: HttpResponseBase): Observable<KeyValueModelListResponseResult> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = KeyValueModelListResponseResult.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @return OK
     */
    lookup_GetNotificationGroups(): Observable<KeyValueModelListResponseResult> {
        let url_ = this.baseUrl + "/v4.0/lookup/notification-groups";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processLookup_GetNotificationGroups(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processLookup_GetNotificationGroups(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<KeyValueModelListResponseResult>;
                }
            } else
                return _observableThrow(response_) as any as Observable<KeyValueModelListResponseResult>;
        }));
    }

    protected processLookup_GetNotificationGroups(response: HttpResponseBase): Observable<KeyValueModelListResponseResult> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = KeyValueModelListResponseResult.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @return OK
     */
    lookup_GetNotificationRecipientTypes(): Observable<KeyValueModelListResponseResult> {
        let url_ = this.baseUrl + "/v4.0/lookup/notification-recipient-types";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processLookup_GetNotificationRecipientTypes(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processLookup_GetNotificationRecipientTypes(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<KeyValueModelListResponseResult>;
                }
            } else
                return _observableThrow(response_) as any as Observable<KeyValueModelListResponseResult>;
        }));
    }

    protected processLookup_GetNotificationRecipientTypes(response: HttpResponseBase): Observable<KeyValueModelListResponseResult> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = KeyValueModelListResponseResult.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @return OK
     */
    lookup_GetNotificationSeverities(): Observable<KeyValueModelListResponseResult> {
        let url_ = this.baseUrl + "/v4.0/lookup/notification-severities";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processLookup_GetNotificationSeverities(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processLookup_GetNotificationSeverities(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<KeyValueModelListResponseResult>;
                }
            } else
                return _observableThrow(response_) as any as Observable<KeyValueModelListResponseResult>;
        }));
    }

    protected processLookup_GetNotificationSeverities(response: HttpResponseBase): Observable<KeyValueModelListResponseResult> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = KeyValueModelListResponseResult.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @return OK
     */
    lookup_GetPermissionTypes(): Observable<KeyValueModelListResponseResult> {
        let url_ = this.baseUrl + "/v4.0/lookup/permission-types";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processLookup_GetPermissionTypes(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processLookup_GetPermissionTypes(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<KeyValueModelListResponseResult>;
                }
            } else
                return _observableThrow(response_) as any as Observable<KeyValueModelListResponseResult>;
        }));
    }

    protected processLookup_GetPermissionTypes(response: HttpResponseBase): Observable<KeyValueModelListResponseResult> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = KeyValueModelListResponseResult.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @return OK
     */
    lookup_GetPhenologicalStages(): Observable<KeyValueModelListResponseResult> {
        let url_ = this.baseUrl + "/v4.0/lookup/phenological-stages";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processLookup_GetPhenologicalStages(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processLookup_GetPhenologicalStages(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<KeyValueModelListResponseResult>;
                }
            } else
                return _observableThrow(response_) as any as Observable<KeyValueModelListResponseResult>;
        }));
    }

    protected processLookup_GetPhenologicalStages(response: HttpResponseBase): Observable<KeyValueModelListResponseResult> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = KeyValueModelListResponseResult.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @return OK
     */
    lookup_GetRegionsByCountry(countryId: string): Observable<KeyValueModelListResponseResult> {
        let url_ = this.baseUrl + "/v4.0/lookup/regions/{countryId}";
        if (countryId === undefined || countryId === null)
            throw new globalThis.Error("The parameter 'countryId' must be defined.");
        url_ = url_.replace("{countryId}", encodeURIComponent("" + countryId));
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processLookup_GetRegionsByCountry(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processLookup_GetRegionsByCountry(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<KeyValueModelListResponseResult>;
                }
            } else
                return _observableThrow(response_) as any as Observable<KeyValueModelListResponseResult>;
        }));
    }

    protected processLookup_GetRegionsByCountry(response: HttpResponseBase): Observable<KeyValueModelListResponseResult> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = KeyValueModelListResponseResult.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @return OK
     */
    lookup_GetSatelliteTypes(): Observable<KeyValueModelListResponseResult> {
        let url_ = this.baseUrl + "/v4.0/lookup/satellite-types";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processLookup_GetSatelliteTypes(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processLookup_GetSatelliteTypes(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<KeyValueModelListResponseResult>;
                }
            } else
                return _observableThrow(response_) as any as Observable<KeyValueModelListResponseResult>;
        }));
    }

    protected processLookup_GetSatelliteTypes(response: HttpResponseBase): Observable<KeyValueModelListResponseResult> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = KeyValueModelListResponseResult.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @return OK
     */
    lookup_GetSIMProviders(): Observable<KeyValueModelListResponseResult> {
        let url_ = this.baseUrl + "/v4.0/lookup/sim-providers";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processLookup_GetSIMProviders(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processLookup_GetSIMProviders(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<KeyValueModelListResponseResult>;
                }
            } else
                return _observableThrow(response_) as any as Observable<KeyValueModelListResponseResult>;
        }));
    }

    protected processLookup_GetSIMProviders(response: HttpResponseBase): Observable<KeyValueModelListResponseResult> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = KeyValueModelListResponseResult.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @return OK
     */
    lookup_GetSubcontractPropertyTypes(): Observable<KeyValueModelListResponseResult> {
        let url_ = this.baseUrl + "/v4.0/lookup/subcontract-property-types";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processLookup_GetSubcontractPropertyTypes(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processLookup_GetSubcontractPropertyTypes(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<KeyValueModelListResponseResult>;
                }
            } else
                return _observableThrow(response_) as any as Observable<KeyValueModelListResponseResult>;
        }));
    }

    protected processLookup_GetSubcontractPropertyTypes(response: HttpResponseBase): Observable<KeyValueModelListResponseResult> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = KeyValueModelListResponseResult.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param enterpriseId (optional) 
     * @return OK
     */
    lookup_GetCSIContracts(enterpriseId?: string | undefined): Observable<KeyValueModelListResponseResult> {
        let url_ = this.baseUrl + "/v4.0/lookup/csi-contracts?";
        if (enterpriseId === null)
            throw new globalThis.Error("The parameter 'enterpriseId' cannot be null.");
        else if (enterpriseId !== undefined)
            url_ += "enterpriseId=" + encodeURIComponent("" + enterpriseId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processLookup_GetCSIContracts(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processLookup_GetCSIContracts(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<KeyValueModelListResponseResult>;
                }
            } else
                return _observableThrow(response_) as any as Observable<KeyValueModelListResponseResult>;
        }));
    }

    protected processLookup_GetCSIContracts(response: HttpResponseBase): Observable<KeyValueModelListResponseResult> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = KeyValueModelListResponseResult.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param contractId (optional) 
     * @return OK
     */
    lookup_GetSubcontractsByContract(contractId?: string | undefined): Observable<KeyValueModelListResponseResult> {
        let url_ = this.baseUrl + "/v4.0/lookup/subcontracts?";
        if (contractId === null)
            throw new globalThis.Error("The parameter 'contractId' cannot be null.");
        else if (contractId !== undefined)
            url_ += "contractId=" + encodeURIComponent("" + contractId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processLookup_GetSubcontractsByContract(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processLookup_GetSubcontractsByContract(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<KeyValueModelListResponseResult>;
                }
            } else
                return _observableThrow(response_) as any as Observable<KeyValueModelListResponseResult>;
        }));
    }

    protected processLookup_GetSubcontractsByContract(response: HttpResponseBase): Observable<KeyValueModelListResponseResult> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = KeyValueModelListResponseResult.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param subcontractId (optional) 
     * @return OK
     */
    lookup_GetMilestonesBySubcontract(subcontractId?: string | undefined): Observable<KeyValueModelListResponseResult> {
        let url_ = this.baseUrl + "/v4.0/lookup/milestones?";
        if (subcontractId === null)
            throw new globalThis.Error("The parameter 'subcontractId' cannot be null.");
        else if (subcontractId !== undefined)
            url_ += "subcontractId=" + encodeURIComponent("" + subcontractId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processLookup_GetMilestonesBySubcontract(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processLookup_GetMilestonesBySubcontract(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<KeyValueModelListResponseResult>;
                }
            } else
                return _observableThrow(response_) as any as Observable<KeyValueModelListResponseResult>;
        }));
    }

    protected processLookup_GetMilestonesBySubcontract(response: HttpResponseBase): Observable<KeyValueModelListResponseResult> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = KeyValueModelListResponseResult.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @return OK
     */
    lookup_GetSubscriptionPlans(): Observable<KeyValueModelListResponseResult> {
        let url_ = this.baseUrl + "/v4.0/lookup/subscription-plans";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processLookup_GetSubscriptionPlans(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processLookup_GetSubscriptionPlans(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<KeyValueModelListResponseResult>;
                }
            } else
                return _observableThrow(response_) as any as Observable<KeyValueModelListResponseResult>;
        }));
    }

    protected processLookup_GetSubscriptionPlans(response: HttpResponseBase): Observable<KeyValueModelListResponseResult> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = KeyValueModelListResponseResult.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @return OK
     */
    lookup_GetSubscriptionStatuses(): Observable<KeyValueModelListResponseResult> {
        let url_ = this.baseUrl + "/v4.0/lookup/subscription-statuses";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processLookup_GetSubscriptionStatuses(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processLookup_GetSubscriptionStatuses(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<KeyValueModelListResponseResult>;
                }
            } else
                return _observableThrow(response_) as any as Observable<KeyValueModelListResponseResult>;
        }));
    }

    protected processLookup_GetSubscriptionStatuses(response: HttpResponseBase): Observable<KeyValueModelListResponseResult> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = KeyValueModelListResponseResult.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @return OK
     */
    lookup_GetTransactionStatuses(): Observable<KeyValueModelListResponseResult> {
        let url_ = this.baseUrl + "/v4.0/lookup/transaction-statuses";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processLookup_GetTransactionStatuses(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processLookup_GetTransactionStatuses(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<KeyValueModelListResponseResult>;
                }
            } else
                return _observableThrow(response_) as any as Observable<KeyValueModelListResponseResult>;
        }));
    }

    protected processLookup_GetTransactionStatuses(response: HttpResponseBase): Observable<KeyValueModelListResponseResult> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = KeyValueModelListResponseResult.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @return OK
     */
    lookup_GetTransactionTypes(): Observable<KeyValueModelListResponseResult> {
        let url_ = this.baseUrl + "/v4.0/lookup/transaction-types";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processLookup_GetTransactionTypes(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processLookup_GetTransactionTypes(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<KeyValueModelListResponseResult>;
                }
            } else
                return _observableThrow(response_) as any as Observable<KeyValueModelListResponseResult>;
        }));
    }

    protected processLookup_GetTransactionTypes(response: HttpResponseBase): Observable<KeyValueModelListResponseResult> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = KeyValueModelListResponseResult.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @return OK
     */
    lookup_GetVraProductivityZones(): Observable<KeyValueModelListResponseResult> {
        let url_ = this.baseUrl + "/v4.0/lookup/vra-productivity-zones";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processLookup_GetVraProductivityZones(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processLookup_GetVraProductivityZones(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<KeyValueModelListResponseResult>;
                }
            } else
                return _observableThrow(response_) as any as Observable<KeyValueModelListResponseResult>;
        }));
    }

    protected processLookup_GetVraProductivityZones(response: HttpResponseBase): Observable<KeyValueModelListResponseResult> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = KeyValueModelListResponseResult.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @return OK
     */
    lookup_GetPestDetectionStatuses(): Observable<KeyValueModelListResponseResult> {
        let url_ = this.baseUrl + "/v4.0/lookup/pest-detection-statuses";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processLookup_GetPestDetectionStatuses(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processLookup_GetPestDetectionStatuses(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<KeyValueModelListResponseResult>;
                }
            } else
                return _observableThrow(response_) as any as Observable<KeyValueModelListResponseResult>;
        }));
    }

    protected processLookup_GetPestDetectionStatuses(response: HttpResponseBase): Observable<KeyValueModelListResponseResult> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = KeyValueModelListResponseResult.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @return OK
     */
    lookup_GetGrantAndSupportTypes(): Observable<KeyValueModelListResponseResult> {
        let url_ = this.baseUrl + "/v4.0/lookup/grant-and-support-types";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processLookup_GetGrantAndSupportTypes(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processLookup_GetGrantAndSupportTypes(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<KeyValueModelListResponseResult>;
                }
            } else
                return _observableThrow(response_) as any as Observable<KeyValueModelListResponseResult>;
        }));
    }

    protected processLookup_GetGrantAndSupportTypes(response: HttpResponseBase): Observable<KeyValueModelListResponseResult> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = KeyValueModelListResponseResult.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @return OK
     */
    lookup_GetGrantAndSupportCalculationTypes(): Observable<KeyValueModelListResponseResult> {
        let url_ = this.baseUrl + "/v4.0/lookup/grant-and-support-calculation-types";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processLookup_GetGrantAndSupportCalculationTypes(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processLookup_GetGrantAndSupportCalculationTypes(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<KeyValueModelListResponseResult>;
                }
            } else
                return _observableThrow(response_) as any as Observable<KeyValueModelListResponseResult>;
        }));
    }

    protected processLookup_GetGrantAndSupportCalculationTypes(response: HttpResponseBase): Observable<KeyValueModelListResponseResult> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = KeyValueModelListResponseResult.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @return OK
     */
    lookup_GetGrantAndSupports(): Observable<KeyValueModelListResponseResult> {
        let url_ = this.baseUrl + "/v4.0/lookup/grant-and-supports";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processLookup_GetGrantAndSupports(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processLookup_GetGrantAndSupports(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<KeyValueModelListResponseResult>;
                }
            } else
                return _observableThrow(response_) as any as Observable<KeyValueModelListResponseResult>;
        }));
    }

    protected processLookup_GetGrantAndSupports(response: HttpResponseBase): Observable<KeyValueModelListResponseResult> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = KeyValueModelListResponseResult.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @return OK
     */
    lookup_GetCropLifespanClassifications(): Observable<KeyValueModelListResponseResult> {
        let url_ = this.baseUrl + "/v4.0/lookup/crop-lifespan-classifications";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processLookup_GetCropLifespanClassifications(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processLookup_GetCropLifespanClassifications(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<KeyValueModelListResponseResult>;
                }
            } else
                return _observableThrow(response_) as any as Observable<KeyValueModelListResponseResult>;
        }));
    }

    protected processLookup_GetCropLifespanClassifications(response: HttpResponseBase): Observable<KeyValueModelListResponseResult> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = KeyValueModelListResponseResult.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @return OK
     */
    lookup_GetCropHarvestTypes(): Observable<KeyValueModelListResponseResult> {
        let url_ = this.baseUrl + "/v4.0/lookup/crop-harvest-types";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processLookup_GetCropHarvestTypes(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processLookup_GetCropHarvestTypes(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<KeyValueModelListResponseResult>;
                }
            } else
                return _observableThrow(response_) as any as Observable<KeyValueModelListResponseResult>;
        }));
    }

    protected processLookup_GetCropHarvestTypes(response: HttpResponseBase): Observable<KeyValueModelListResponseResult> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = KeyValueModelListResponseResult.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @return OK
     */
    lookup_GetCropRootDepthClassifications(): Observable<KeyValueModelListResponseResult> {
        let url_ = this.baseUrl + "/v4.0/lookup/crop-root-depth-classifications";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processLookup_GetCropRootDepthClassifications(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processLookup_GetCropRootDepthClassifications(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<KeyValueModelListResponseResult>;
                }
            } else
                return _observableThrow(response_) as any as Observable<KeyValueModelListResponseResult>;
        }));
    }

    protected processLookup_GetCropRootDepthClassifications(response: HttpResponseBase): Observable<KeyValueModelListResponseResult> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = KeyValueModelListResponseResult.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @return OK
     */
    lookup_GetCSIOperatorTypes(): Observable<CSIOperatorTypeListResponseResult> {
        let url_ = this.baseUrl + "/v4.0/lookup/csi-operator-types";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processLookup_GetCSIOperatorTypes(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processLookup_GetCSIOperatorTypes(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<CSIOperatorTypeListResponseResult>;
                }
            } else
                return _observableThrow(response_) as any as Observable<CSIOperatorTypeListResponseResult>;
        }));
    }

    protected processLookup_GetCSIOperatorTypes(response: HttpResponseBase): Observable<CSIOperatorTypeListResponseResult> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = CSIOperatorTypeListResponseResult.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @return OK
     */
    lookup_GetSubcontractAssetTypes(): Observable<KeyValueModelListResponseResult> {
        let url_ = this.baseUrl + "/v4.0/lookup/subcontract-asset-types";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processLookup_GetSubcontractAssetTypes(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processLookup_GetSubcontractAssetTypes(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<KeyValueModelListResponseResult>;
                }
            } else
                return _observableThrow(response_) as any as Observable<KeyValueModelListResponseResult>;
        }));
    }

    protected processLookup_GetSubcontractAssetTypes(response: HttpResponseBase): Observable<KeyValueModelListResponseResult> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = KeyValueModelListResponseResult.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @return OK
     */
    lookup_GetSubcontractPropertyUnits(): Observable<KeyValueModelListResponseResult> {
        let url_ = this.baseUrl + "/v4.0/lookup/subcontract-property-units";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processLookup_GetSubcontractPropertyUnits(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processLookup_GetSubcontractPropertyUnits(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<KeyValueModelListResponseResult>;
                }
            } else
                return _observableThrow(response_) as any as Observable<KeyValueModelListResponseResult>;
        }));
    }

    protected processLookup_GetSubcontractPropertyUnits(response: HttpResponseBase): Observable<KeyValueModelListResponseResult> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = KeyValueModelListResponseResult.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @return OK
     */
    lookup_GetActivityTypes(): Observable<KeyValueModelListResponseResult> {
        let url_ = this.baseUrl + "/v4.0/lookup/activity-types";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processLookup_GetActivityTypes(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processLookup_GetActivityTypes(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<KeyValueModelListResponseResult>;
                }
            } else
                return _observableThrow(response_) as any as Observable<KeyValueModelListResponseResult>;
        }));
    }

    protected processLookup_GetActivityTypes(response: HttpResponseBase): Observable<KeyValueModelListResponseResult> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = KeyValueModelListResponseResult.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @return OK
     */
    lookup_GEtWeatherStatuses(): Observable<KeyValueModelListResponseResult> {
        let url_ = this.baseUrl + "/v4.0/lookup/weather-status";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processLookup_GEtWeatherStatuses(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processLookup_GEtWeatherStatuses(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<KeyValueModelListResponseResult>;
                }
            } else
                return _observableThrow(response_) as any as Observable<KeyValueModelListResponseResult>;
        }));
    }

    protected processLookup_GEtWeatherStatuses(response: HttpResponseBase): Observable<KeyValueModelListResponseResult> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = KeyValueModelListResponseResult.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @return OK
     */
    lookup_GetInquiryCorrespondenceTypes(): Observable<KeyValueModelListResponseResult> {
        let url_ = this.baseUrl + "/v4.0/lookup/inquiry-correspondence-type";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processLookup_GetInquiryCorrespondenceTypes(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processLookup_GetInquiryCorrespondenceTypes(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<KeyValueModelListResponseResult>;
                }
            } else
                return _observableThrow(response_) as any as Observable<KeyValueModelListResponseResult>;
        }));
    }

    protected processLookup_GetInquiryCorrespondenceTypes(response: HttpResponseBase): Observable<KeyValueModelListResponseResult> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = KeyValueModelListResponseResult.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @return OK
     */
    lookup_GetUserCSIEnterprises(): Observable<KeyValueModelListResponseResult> {
        let url_ = this.baseUrl + "/v4.0/lookup/csi-enterprises";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processLookup_GetUserCSIEnterprises(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processLookup_GetUserCSIEnterprises(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<KeyValueModelListResponseResult>;
                }
            } else
                return _observableThrow(response_) as any as Observable<KeyValueModelListResponseResult>;
        }));
    }

    protected processLookup_GetUserCSIEnterprises(response: HttpResponseBase): Observable<KeyValueModelListResponseResult> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = KeyValueModelListResponseResult.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @return OK
     */
    lookup_GetSeason(): Observable<KeyValueModelListResponseResult> {
        let url_ = this.baseUrl + "/v4.0/lookup/season";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processLookup_GetSeason(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processLookup_GetSeason(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<KeyValueModelListResponseResult>;
                }
            } else
                return _observableThrow(response_) as any as Observable<KeyValueModelListResponseResult>;
        }));
    }

    protected processLookup_GetSeason(response: HttpResponseBase): Observable<KeyValueModelListResponseResult> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = KeyValueModelListResponseResult.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }
}


@Injectable()

export class RolesProxy {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl ?? "https://api.doktar.dev";
    }

    /**
     * @return OK
     */
    roles_GetRoles(): Observable<RoleDtoListResponseResult> {
        let url_ = this.baseUrl + "/v4.0/roles";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processRoles_GetRoles(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processRoles_GetRoles(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<RoleDtoListResponseResult>;
                }
            } else
                return _observableThrow(response_) as any as Observable<RoleDtoListResponseResult>;
        }));
    }

    protected processRoles_GetRoles(response: HttpResponseBase): Observable<RoleDtoListResponseResult> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = RoleDtoListResponseResult.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param body (optional) 
     * @return OK
     */
    roles_CreateRole(body?: CreateRoleCommand | undefined): Observable<GuidResponseResult> {
        let url_ = this.baseUrl + "/v4.0/roles";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processRoles_CreateRole(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processRoles_CreateRole(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<GuidResponseResult>;
                }
            } else
                return _observableThrow(response_) as any as Observable<GuidResponseResult>;
        }));
    }

    protected processRoles_CreateRole(response: HttpResponseBase): Observable<GuidResponseResult> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = GuidResponseResult.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param body (optional) 
     * @return OK
     */
    roles_UpdateRole(body?: UpdateRoleCommand | undefined): Observable<BooleanResponseResult> {
        let url_ = this.baseUrl + "/v4.0/roles";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("put", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processRoles_UpdateRole(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processRoles_UpdateRole(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<BooleanResponseResult>;
                }
            } else
                return _observableThrow(response_) as any as Observable<BooleanResponseResult>;
        }));
    }

    protected processRoles_UpdateRole(response: HttpResponseBase): Observable<BooleanResponseResult> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = BooleanResponseResult.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @return OK
     */
    roles_GetRolesById(id: string): Observable<RoleDtoResponseResult> {
        let url_ = this.baseUrl + "/v4.0/roles/{id}";
        if (id === undefined || id === null)
            throw new globalThis.Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processRoles_GetRolesById(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processRoles_GetRolesById(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<RoleDtoResponseResult>;
                }
            } else
                return _observableThrow(response_) as any as Observable<RoleDtoResponseResult>;
        }));
    }

    protected processRoles_GetRolesById(response: HttpResponseBase): Observable<RoleDtoResponseResult> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = RoleDtoResponseResult.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @return OK
     */
    roles_DeleteRole(id: string): Observable<BooleanResponseResult> {
        let url_ = this.baseUrl + "/v4.0/roles/{id}";
        if (id === undefined || id === null)
            throw new globalThis.Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("delete", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processRoles_DeleteRole(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processRoles_DeleteRole(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<BooleanResponseResult>;
                }
            } else
                return _observableThrow(response_) as any as Observable<BooleanResponseResult>;
        }));
    }

    protected processRoles_DeleteRole(response: HttpResponseBase): Observable<BooleanResponseResult> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = BooleanResponseResult.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param roleKind (optional) 
     * @return OK
     */
    roles_GetRolesByEnterprise(enterpriseId: string, roleKind?: string | undefined): Observable<RoleDtoListResponseResult> {
        let url_ = this.baseUrl + "/v4.0/roles/by-enterprise/{enterpriseId}?";
        if (enterpriseId === undefined || enterpriseId === null)
            throw new globalThis.Error("The parameter 'enterpriseId' must be defined.");
        url_ = url_.replace("{enterpriseId}", encodeURIComponent("" + enterpriseId));
        if (roleKind === null)
            throw new globalThis.Error("The parameter 'roleKind' cannot be null.");
        else if (roleKind !== undefined)
            url_ += "roleKind=" + encodeURIComponent("" + roleKind) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processRoles_GetRolesByEnterprise(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processRoles_GetRolesByEnterprise(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<RoleDtoListResponseResult>;
                }
            } else
                return _observableThrow(response_) as any as Observable<RoleDtoListResponseResult>;
        }));
    }

    protected processRoles_GetRolesByEnterprise(response: HttpResponseBase): Observable<RoleDtoListResponseResult> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = RoleDtoListResponseResult.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }
}


@Injectable()

export class UserProxy {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl ?? "https://api.doktar.dev";
    }

    /**
     * @return OK
     */
    user_GetAll(): Observable<UserViewModelListResponseResult> {
        let url_ = this.baseUrl + "/v4.0/user";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processUser_GetAll(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processUser_GetAll(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<UserViewModelListResponseResult>;
                }
            } else
                return _observableThrow(response_) as any as Observable<UserViewModelListResponseResult>;
        }));
    }

    protected processUser_GetAll(response: HttpResponseBase): Observable<UserViewModelListResponseResult> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = UserViewModelListResponseResult.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param body (optional) 
     * @return OK
     */
    user_CreateUser(body?: CreateUserCommand | undefined): Observable<GuidResponseResult> {
        let url_ = this.baseUrl + "/v4.0/user";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processUser_CreateUser(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processUser_CreateUser(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<GuidResponseResult>;
                }
            } else
                return _observableThrow(response_) as any as Observable<GuidResponseResult>;
        }));
    }

    protected processUser_CreateUser(response: HttpResponseBase): Observable<GuidResponseResult> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = GuidResponseResult.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param body (optional) 
     * @return OK
     */
    user_GetPaginatedUsers(body?: PaginatedRequest | undefined): Observable<UserViewModelPaginatedResponseResponseResult> {
        let url_ = this.baseUrl + "/v4.0/user/paginated";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processUser_GetPaginatedUsers(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processUser_GetPaginatedUsers(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<UserViewModelPaginatedResponseResponseResult>;
                }
            } else
                return _observableThrow(response_) as any as Observable<UserViewModelPaginatedResponseResponseResult>;
        }));
    }

    protected processUser_GetPaginatedUsers(response: HttpResponseBase): Observable<UserViewModelPaginatedResponseResponseResult> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = UserViewModelPaginatedResponseResponseResult.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param body (optional) 
     * @return OK
     */
    user_UpdateUserSensitive(userId: string, body?: UpdateUserSensitiveCommand | undefined): Observable<BooleanResponseResult> {
        let url_ = this.baseUrl + "/v4.0/user/sensitive/{userId}";
        if (userId === undefined || userId === null)
            throw new globalThis.Error("The parameter 'userId' must be defined.");
        url_ = url_.replace("{userId}", encodeURIComponent("" + userId));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("put", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processUser_UpdateUserSensitive(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processUser_UpdateUserSensitive(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<BooleanResponseResult>;
                }
            } else
                return _observableThrow(response_) as any as Observable<BooleanResponseResult>;
        }));
    }

    protected processUser_UpdateUserSensitive(response: HttpResponseBase): Observable<BooleanResponseResult> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = BooleanResponseResult.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param totp (optional) 
     * @return OK
     */
    user_DeleteUser(id: string, totp?: number | undefined): Observable<KeyValueModelListResponseResult> {
        let url_ = this.baseUrl + "/v4.0/user/{id}?";
        if (id === undefined || id === null)
            throw new globalThis.Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        if (totp === null)
            throw new globalThis.Error("The parameter 'totp' cannot be null.");
        else if (totp !== undefined)
            url_ += "totp=" + encodeURIComponent("" + totp) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("delete", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processUser_DeleteUser(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processUser_DeleteUser(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<KeyValueModelListResponseResult>;
                }
            } else
                return _observableThrow(response_) as any as Observable<KeyValueModelListResponseResult>;
        }));
    }

    protected processUser_DeleteUser(response: HttpResponseBase): Observable<KeyValueModelListResponseResult> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = KeyValueModelListResponseResult.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @return OK
     */
    user_GetUserProfile(id: string): Observable<UserProfileViewModelResponseResult> {
        let url_ = this.baseUrl + "/v4.0/user/profile/{id}";
        if (id === undefined || id === null)
            throw new globalThis.Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processUser_GetUserProfile(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processUser_GetUserProfile(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<UserProfileViewModelResponseResult>;
                }
            } else
                return _observableThrow(response_) as any as Observable<UserProfileViewModelResponseResult>;
        }));
    }

    protected processUser_GetUserProfile(response: HttpResponseBase): Observable<UserProfileViewModelResponseResult> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = UserProfileViewModelResponseResult.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param body (optional) 
     * @return OK
     */
    user_UpdateUserProfile(userId: string, body?: UpdateUserProfileCommand | undefined): Observable<BooleanResponseResult> {
        let url_ = this.baseUrl + "/v4.0/user/profile/{userId}";
        if (userId === undefined || userId === null)
            throw new globalThis.Error("The parameter 'userId' must be defined.");
        url_ = url_.replace("{userId}", encodeURIComponent("" + userId));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("put", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processUser_UpdateUserProfile(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processUser_UpdateUserProfile(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<BooleanResponseResult>;
                }
            } else
                return _observableThrow(response_) as any as Observable<BooleanResponseResult>;
        }));
    }

    protected processUser_UpdateUserProfile(response: HttpResponseBase): Observable<BooleanResponseResult> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = BooleanResponseResult.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @return OK
     */
    user_GetMyPermissions(): Observable<MyPermissionViewModelListResponseResult> {
        let url_ = this.baseUrl + "/v4.0/user/my-permissions";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processUser_GetMyPermissions(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processUser_GetMyPermissions(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<MyPermissionViewModelListResponseResult>;
                }
            } else
                return _observableThrow(response_) as any as Observable<MyPermissionViewModelListResponseResult>;
        }));
    }

    protected processUser_GetMyPermissions(response: HttpResponseBase): Observable<MyPermissionViewModelListResponseResult> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = MyPermissionViewModelListResponseResult.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param body (optional) 
     * @return OK
     * @deprecated
     */
    user_UpdateEmail(body?: UpdateUserEmailCommand | undefined): Observable<BooleanResponseResult> {
        let url_ = this.baseUrl + "/v4.0/user/email";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("put", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processUser_UpdateEmail(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processUser_UpdateEmail(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<BooleanResponseResult>;
                }
            } else
                return _observableThrow(response_) as any as Observable<BooleanResponseResult>;
        }));
    }

    protected processUser_UpdateEmail(response: HttpResponseBase): Observable<BooleanResponseResult> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = BooleanResponseResult.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param body (optional) 
     * @return OK
     */
    user_UpdateEmailV2(body?: UpdateUserEmailCommandV2 | undefined): Observable<BooleanResponseResult> {
        let url_ = this.baseUrl + "/v4.0/user/email/update";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processUser_UpdateEmailV2(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processUser_UpdateEmailV2(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<BooleanResponseResult>;
                }
            } else
                return _observableThrow(response_) as any as Observable<BooleanResponseResult>;
        }));
    }

    protected processUser_UpdateEmailV2(response: HttpResponseBase): Observable<BooleanResponseResult> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = BooleanResponseResult.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param body (optional) 
     * @return OK
     * @deprecated
     */
    user_UpdatePhone(body?: UpdateUserPhoneCommand | undefined): Observable<BooleanResponseResult> {
        let url_ = this.baseUrl + "/v4.0/user/phone";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("put", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processUser_UpdatePhone(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processUser_UpdatePhone(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<BooleanResponseResult>;
                }
            } else
                return _observableThrow(response_) as any as Observable<BooleanResponseResult>;
        }));
    }

    protected processUser_UpdatePhone(response: HttpResponseBase): Observable<BooleanResponseResult> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = BooleanResponseResult.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param body (optional) 
     * @return OK
     */
    user_UpdatePhoneV2(body?: UpdateUserPhoneCommandV2 | undefined): Observable<BooleanResponseResult> {
        let url_ = this.baseUrl + "/v4.0/user/phone/update";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processUser_UpdatePhoneV2(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processUser_UpdatePhoneV2(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<BooleanResponseResult>;
                }
            } else
                return _observableThrow(response_) as any as Observable<BooleanResponseResult>;
        }));
    }

    protected processUser_UpdatePhoneV2(response: HttpResponseBase): Observable<BooleanResponseResult> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = BooleanResponseResult.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param body (optional) 
     * @return OK
     * @deprecated
     */
    user_Signup(body?: RegisterUserCommand | undefined): Observable<RegisterUserResponseResponseResult> {
        let url_ = this.baseUrl + "/v4.0/user/signup";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processUser_Signup(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processUser_Signup(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<RegisterUserResponseResponseResult>;
                }
            } else
                return _observableThrow(response_) as any as Observable<RegisterUserResponseResponseResult>;
        }));
    }

    protected processUser_Signup(response: HttpResponseBase): Observable<RegisterUserResponseResponseResult> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = RegisterUserResponseResponseResult.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param body (optional) 
     * @return OK
     */
    user_RequestEmailOtp(body?: RequestEmailOtpModel | undefined): Observable<CreateOTPResultResponseResult> {
        let url_ = this.baseUrl + "/v4.0/user/register/request-email-otp";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processUser_RequestEmailOtp(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processUser_RequestEmailOtp(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<CreateOTPResultResponseResult>;
                }
            } else
                return _observableThrow(response_) as any as Observable<CreateOTPResultResponseResult>;
        }));
    }

    protected processUser_RequestEmailOtp(response: HttpResponseBase): Observable<CreateOTPResultResponseResult> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = CreateOTPResultResponseResult.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param body (optional) 
     * @return OK
     */
    user_RequestPhoneOtp(body?: RequestPhoneOtpModel | undefined): Observable<CreateOTPResultResponseResult> {
        let url_ = this.baseUrl + "/v4.0/user/register/request-phone-otp";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processUser_RequestPhoneOtp(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processUser_RequestPhoneOtp(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<CreateOTPResultResponseResult>;
                }
            } else
                return _observableThrow(response_) as any as Observable<CreateOTPResultResponseResult>;
        }));
    }

    protected processUser_RequestPhoneOtp(response: HttpResponseBase): Observable<CreateOTPResultResponseResult> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = CreateOTPResultResponseResult.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param body (optional) 
     * @return OK
     */
    user_ValidateEmail(body?: ValidateEmailModel | undefined): Observable<CheckOTPResultResponseResult> {
        let url_ = this.baseUrl + "/v4.0/user/register/validate-email";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processUser_ValidateEmail(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processUser_ValidateEmail(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<CheckOTPResultResponseResult>;
                }
            } else
                return _observableThrow(response_) as any as Observable<CheckOTPResultResponseResult>;
        }));
    }

    protected processUser_ValidateEmail(response: HttpResponseBase): Observable<CheckOTPResultResponseResult> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = CheckOTPResultResponseResult.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param body (optional) 
     * @return OK
     */
    user_ValidatePhone(body?: ValidatePhoneModel | undefined): Observable<CheckOTPResultResponseResult> {
        let url_ = this.baseUrl + "/v4.0/user/register/validate-phone";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processUser_ValidatePhone(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processUser_ValidatePhone(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<CheckOTPResultResponseResult>;
                }
            } else
                return _observableThrow(response_) as any as Observable<CheckOTPResultResponseResult>;
        }));
    }

    protected processUser_ValidatePhone(response: HttpResponseBase): Observable<CheckOTPResultResponseResult> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = CheckOTPResultResponseResult.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param body (optional) 
     * @return OK
     */
    user_Register(body?: RegisterUserCompleteCommand | undefined): Observable<RegisterUserResponseResponseResult> {
        let url_ = this.baseUrl + "/v4.0/user/register";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processUser_Register(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processUser_Register(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<RegisterUserResponseResponseResult>;
                }
            } else
                return _observableThrow(response_) as any as Observable<RegisterUserResponseResponseResult>;
        }));
    }

    protected processUser_Register(response: HttpResponseBase): Observable<RegisterUserResponseResponseResult> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = RegisterUserResponseResponseResult.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param body (optional) 
     * @return OK
     */
    user_CheckEmailExist(body?: CheckEmailExistCommand | undefined): Observable<BooleanResponseResult> {
        let url_ = this.baseUrl + "/v4.0/user/check-email-exist";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processUser_CheckEmailExist(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processUser_CheckEmailExist(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<BooleanResponseResult>;
                }
            } else
                return _observableThrow(response_) as any as Observable<BooleanResponseResult>;
        }));
    }

    protected processUser_CheckEmailExist(response: HttpResponseBase): Observable<BooleanResponseResult> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = BooleanResponseResult.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param body (optional) 
     * @return OK
     */
    user_CheckPhoneExist(body?: CheckPhoneExistCommand | undefined): Observable<BooleanResponseResult> {
        let url_ = this.baseUrl + "/v4.0/user/check-phone-exist";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processUser_CheckPhoneExist(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processUser_CheckPhoneExist(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<BooleanResponseResult>;
                }
            } else
                return _observableThrow(response_) as any as Observable<BooleanResponseResult>;
        }));
    }

    protected processUser_CheckPhoneExist(response: HttpResponseBase): Observable<BooleanResponseResult> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = BooleanResponseResult.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param body (optional) 
     * @return OK
     */
    user_Signin(body?: SigninUserCommand | undefined): Observable<SigninUserResponseResponseResult> {
        let url_ = this.baseUrl + "/v4.0/user/signin";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processUser_Signin(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processUser_Signin(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<SigninUserResponseResponseResult>;
                }
            } else
                return _observableThrow(response_) as any as Observable<SigninUserResponseResponseResult>;
        }));
    }

    protected processUser_Signin(response: HttpResponseBase): Observable<SigninUserResponseResponseResult> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = SigninUserResponseResponseResult.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param body (optional) 
     * @return OK
     */
    user_Signout(body?: SignoutUserCommand | undefined): Observable<BooleanResponseResult> {
        let url_ = this.baseUrl + "/v4.0/user/signout";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processUser_Signout(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processUser_Signout(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<BooleanResponseResult>;
                }
            } else
                return _observableThrow(response_) as any as Observable<BooleanResponseResult>;
        }));
    }

    protected processUser_Signout(response: HttpResponseBase): Observable<BooleanResponseResult> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = BooleanResponseResult.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @return OK
     */
    user_Logout(): Observable<BooleanResponseResult> {
        let url_ = this.baseUrl + "/v4.0/user/logout";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processUser_Logout(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processUser_Logout(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<BooleanResponseResult>;
                }
            } else
                return _observableThrow(response_) as any as Observable<BooleanResponseResult>;
        }));
    }

    protected processUser_Logout(response: HttpResponseBase): Observable<BooleanResponseResult> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = BooleanResponseResult.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param body (optional) 
     * @return OK
     */
    user_Lock(body?: LockUserCommand | undefined): Observable<BooleanResponseResult> {
        let url_ = this.baseUrl + "/v4.0/user/lock";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processUser_Lock(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processUser_Lock(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<BooleanResponseResult>;
                }
            } else
                return _observableThrow(response_) as any as Observable<BooleanResponseResult>;
        }));
    }

    protected processUser_Lock(response: HttpResponseBase): Observable<BooleanResponseResult> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = BooleanResponseResult.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param body (optional) 
     * @return OK
     */
    user_Deactivate(body?: DeactivateUserCommand | undefined): Observable<BooleanResponseResult> {
        let url_ = this.baseUrl + "/v4.0/user/deactivate";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processUser_Deactivate(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processUser_Deactivate(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<BooleanResponseResult>;
                }
            } else
                return _observableThrow(response_) as any as Observable<BooleanResponseResult>;
        }));
    }

    protected processUser_Deactivate(response: HttpResponseBase): Observable<BooleanResponseResult> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = BooleanResponseResult.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param body (optional) 
     * @return OK
     */
    user_Anonymize(body?: AnonymizeUserCommand | undefined): Observable<BooleanResponseResult> {
        let url_ = this.baseUrl + "/v4.0/user/anonymize";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processUser_Anonymize(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processUser_Anonymize(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<BooleanResponseResult>;
                }
            } else
                return _observableThrow(response_) as any as Observable<BooleanResponseResult>;
        }));
    }

    protected processUser_Anonymize(response: HttpResponseBase): Observable<BooleanResponseResult> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = BooleanResponseResult.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param body (optional) 
     * @return OK
     */
    user_TerminateToken(body?: TerminateUserTokenCommand | undefined): Observable<BooleanResponseResult> {
        let url_ = this.baseUrl + "/v4.0/user/terminate-token";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processUser_TerminateToken(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processUser_TerminateToken(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<BooleanResponseResult>;
                }
            } else
                return _observableThrow(response_) as any as Observable<BooleanResponseResult>;
        }));
    }

    protected processUser_TerminateToken(response: HttpResponseBase): Observable<BooleanResponseResult> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = BooleanResponseResult.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param body (optional) 
     * @return OK
     */
    user_DeleteMyAccount(body?: DeleteMyAccountCommand | undefined): Observable<BooleanResponseResult> {
        let url_ = this.baseUrl + "/v4.0/user/delete-my-account";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processUser_DeleteMyAccount(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processUser_DeleteMyAccount(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<BooleanResponseResult>;
                }
            } else
                return _observableThrow(response_) as any as Observable<BooleanResponseResult>;
        }));
    }

    protected processUser_DeleteMyAccount(response: HttpResponseBase): Observable<BooleanResponseResult> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = BooleanResponseResult.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param body (optional) 
     * @return OK
     */
    user_VerifyPassword(body?: VerifyPasswordCommand | undefined): Observable<BooleanResponseResult> {
        let url_ = this.baseUrl + "/v4.0/user/verify-password";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processUser_VerifyPassword(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processUser_VerifyPassword(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<BooleanResponseResult>;
                }
            } else
                return _observableThrow(response_) as any as Observable<BooleanResponseResult>;
        }));
    }

    protected processUser_VerifyPassword(response: HttpResponseBase): Observable<BooleanResponseResult> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = BooleanResponseResult.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param body (optional) 
     * @return OK
     */
    user_ChangePassword(body?: ChangeMyPasswordCommand | undefined): Observable<BooleanResponseResult> {
        let url_ = this.baseUrl + "/v4.0/user/change-password";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processUser_ChangePassword(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processUser_ChangePassword(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<BooleanResponseResult>;
                }
            } else
                return _observableThrow(response_) as any as Observable<BooleanResponseResult>;
        }));
    }

    protected processUser_ChangePassword(response: HttpResponseBase): Observable<BooleanResponseResult> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = BooleanResponseResult.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param body (optional) 
     * @return OK
     */
    user_ChangeUserPassword(body?: ChangeUserPasswordByAdminCommand | undefined): Observable<BooleanResponseResult> {
        let url_ = this.baseUrl + "/v4.0/user/change-user-password";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processUser_ChangeUserPassword(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processUser_ChangeUserPassword(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<BooleanResponseResult>;
                }
            } else
                return _observableThrow(response_) as any as Observable<BooleanResponseResult>;
        }));
    }

    protected processUser_ChangeUserPassword(response: HttpResponseBase): Observable<BooleanResponseResult> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = BooleanResponseResult.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param body (optional) 
     * @return OK
     * @deprecated
     */
    user_RequestResetPassword(body?: RequestPasswordResetCodeCommand | undefined): Observable<BooleanResponseResult> {
        let url_ = this.baseUrl + "/v4.0/user/request-reset-password";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processUser_RequestResetPassword(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processUser_RequestResetPassword(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<BooleanResponseResult>;
                }
            } else
                return _observableThrow(response_) as any as Observable<BooleanResponseResult>;
        }));
    }

    protected processUser_RequestResetPassword(response: HttpResponseBase): Observable<BooleanResponseResult> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = BooleanResponseResult.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param body (optional) 
     * @return OK
     * @deprecated
     */
    user_ResetPassword(body?: ResetPasswordCommand | undefined): Observable<BooleanResponseResult> {
        let url_ = this.baseUrl + "/v4.0/user/reset-password";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processUser_ResetPassword(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processUser_ResetPassword(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<BooleanResponseResult>;
                }
            } else
                return _observableThrow(response_) as any as Observable<BooleanResponseResult>;
        }));
    }

    protected processUser_ResetPassword(response: HttpResponseBase): Observable<BooleanResponseResult> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = BooleanResponseResult.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param body (optional) 
     * @return OK
     */
    user_ResetPasswordV2(body?: ResetPasswordCommandV2 | undefined): Observable<BooleanResponseResult> {
        let url_ = this.baseUrl + "/v4.0/user/password/reset";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processUser_ResetPasswordV2(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processUser_ResetPasswordV2(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<BooleanResponseResult>;
                }
            } else
                return _observableThrow(response_) as any as Observable<BooleanResponseResult>;
        }));
    }

    protected processUser_ResetPasswordV2(response: HttpResponseBase): Observable<BooleanResponseResult> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = BooleanResponseResult.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @return OK
     */
    user_GetPasswordPolicy(appId: string): Observable<IAMPolicyPasswordComplexityResponseResult> {
        let url_ = this.baseUrl + "/v4.0/user/password-policy/{appId}";
        if (appId === undefined || appId === null)
            throw new globalThis.Error("The parameter 'appId' must be defined.");
        url_ = url_.replace("{appId}", encodeURIComponent("" + appId));
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processUser_GetPasswordPolicy(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processUser_GetPasswordPolicy(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<IAMPolicyPasswordComplexityResponseResult>;
                }
            } else
                return _observableThrow(response_) as any as Observable<IAMPolicyPasswordComplexityResponseResult>;
        }));
    }

    protected processUser_GetPasswordPolicy(response: HttpResponseBase): Observable<IAMPolicyPasswordComplexityResponseResult> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = IAMPolicyPasswordComplexityResponseResult.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param body (optional) 
     * @return OK
     */
    user_RequestOTP(body?: RequestUserOTPCommand | undefined): Observable<RequestUserOTPResultResponseResult> {
        let url_ = this.baseUrl + "/v4.0/user/request-otp";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processUser_RequestOTP(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processUser_RequestOTP(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<RequestUserOTPResultResponseResult>;
                }
            } else
                return _observableThrow(response_) as any as Observable<RequestUserOTPResultResponseResult>;
        }));
    }

    protected processUser_RequestOTP(response: HttpResponseBase): Observable<RequestUserOTPResultResponseResult> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = RequestUserOTPResultResponseResult.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param body (optional) 
     * @return OK
     */
    user_ValidateOTP(body?: ValidateUserOTPCommand | undefined): Observable<BooleanResponseResult> {
        let url_ = this.baseUrl + "/v4.0/user/validate-otp";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processUser_ValidateOTP(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processUser_ValidateOTP(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<BooleanResponseResult>;
                }
            } else
                return _observableThrow(response_) as any as Observable<BooleanResponseResult>;
        }));
    }

    protected processUser_ValidateOTP(response: HttpResponseBase): Observable<BooleanResponseResult> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = BooleanResponseResult.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param body (optional) 
     * @return OK
     */
    user_RequestOtpGeneral(body?: RequestOtpModel | undefined): Observable<CreateOTPResultResponseResult> {
        let url_ = this.baseUrl + "/v4.0/user/otp/request";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processUser_RequestOtpGeneral(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processUser_RequestOtpGeneral(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<CreateOTPResultResponseResult>;
                }
            } else
                return _observableThrow(response_) as any as Observable<CreateOTPResultResponseResult>;
        }));
    }

    protected processUser_RequestOtpGeneral(response: HttpResponseBase): Observable<CreateOTPResultResponseResult> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = CreateOTPResultResponseResult.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @return OK
     */
    user_RequestPrincipalOTP(id: string): Observable<Int32ResponseResult> {
        let url_ = this.baseUrl + "/v4.0/user/request-principal-otp/{id}";
        if (id === undefined || id === null)
            throw new globalThis.Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processUser_RequestPrincipalOTP(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processUser_RequestPrincipalOTP(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<Int32ResponseResult>;
                }
            } else
                return _observableThrow(response_) as any as Observable<Int32ResponseResult>;
        }));
    }

    protected processUser_RequestPrincipalOTP(response: HttpResponseBase): Observable<Int32ResponseResult> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = Int32ResponseResult.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param body (optional) 
     * @return OK
     */
    user_ValidatePrincipalOTP(body?: ValidatePrincipalOTPCommand | undefined): Observable<BooleanResponseResult> {
        let url_ = this.baseUrl + "/v4.0/user/validate-principal-otp";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processUser_ValidatePrincipalOTP(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processUser_ValidatePrincipalOTP(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<BooleanResponseResult>;
                }
            } else
                return _observableThrow(response_) as any as Observable<BooleanResponseResult>;
        }));
    }

    protected processUser_ValidatePrincipalOTP(response: HttpResponseBase): Observable<BooleanResponseResult> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = BooleanResponseResult.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param body (optional) 
     * @return OK
     */
    user_CheckPin(body?: CheckPinCommand | undefined): Observable<BooleanResponseResult> {
        let url_ = this.baseUrl + "/v4.0/user/check-pin";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processUser_CheckPin(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processUser_CheckPin(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<BooleanResponseResult>;
                }
            } else
                return _observableThrow(response_) as any as Observable<BooleanResponseResult>;
        }));
    }

    protected processUser_CheckPin(response: HttpResponseBase): Observable<BooleanResponseResult> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = BooleanResponseResult.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param body (optional) 
     * @return OK
     */
    user_ChangePin(body?: ChangeUserPINCommand | undefined): Observable<BooleanResponseResult> {
        let url_ = this.baseUrl + "/v4.0/user/change-pin";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processUser_ChangePin(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processUser_ChangePin(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<BooleanResponseResult>;
                }
            } else
                return _observableThrow(response_) as any as Observable<BooleanResponseResult>;
        }));
    }

    protected processUser_ChangePin(response: HttpResponseBase): Observable<BooleanResponseResult> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = BooleanResponseResult.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param body (optional) 
     * @return OK
     */
    user_ResetPin(body?: ResetUserPINCommand | undefined): Observable<BooleanResponseResult> {
        let url_ = this.baseUrl + "/v4.0/user/reset-pin";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processUser_ResetPin(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processUser_ResetPin(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<BooleanResponseResult>;
                }
            } else
                return _observableThrow(response_) as any as Observable<BooleanResponseResult>;
        }));
    }

    protected processUser_ResetPin(response: HttpResponseBase): Observable<BooleanResponseResult> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = BooleanResponseResult.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param body (optional) 
     * @return OK
     */
    user_GetUserLoginLog(body?: GetUserLoginLogQuery | undefined): Observable<BooleanResponseResult> {
        let url_ = this.baseUrl + "/v4.0/user/login-log";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processUser_GetUserLoginLog(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processUser_GetUserLoginLog(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<BooleanResponseResult>;
                }
            } else
                return _observableThrow(response_) as any as Observable<BooleanResponseResult>;
        }));
    }

    protected processUser_GetUserLoginLog(response: HttpResponseBase): Observable<BooleanResponseResult> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = BooleanResponseResult.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }
}


export class AccessEnterpriseViewModel implements IAccessEnterpriseViewModel {
    accessKey!: string;
    enterpriseId!: string;
    enterpriseName!: string | undefined;
    cropId!: string;
    cropName!: string | undefined;
    cropColor!: string | undefined;
    seasonId!: string;
    season!: string | undefined;
    year!: number;
    countryId!: string;
    countryName!: string | undefined;

    constructor(data?: IAccessEnterpriseViewModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.accessKey = _data["accessKey"];
            this.enterpriseId = _data["enterpriseId"];
            this.enterpriseName = _data["enterpriseName"];
            this.cropId = _data["cropId"];
            this.cropName = _data["cropName"];
            this.cropColor = _data["cropColor"];
            this.seasonId = _data["seasonId"];
            this.season = _data["season"];
            this.year = _data["year"];
            this.countryId = _data["countryId"];
            this.countryName = _data["countryName"];
        }
    }

    static fromJS(data: any): AccessEnterpriseViewModel {
        data = typeof data === 'object' ? data : {};
        let result = new AccessEnterpriseViewModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["accessKey"] = this.accessKey;
        data["enterpriseId"] = this.enterpriseId;
        data["enterpriseName"] = this.enterpriseName;
        data["cropId"] = this.cropId;
        data["cropName"] = this.cropName;
        data["cropColor"] = this.cropColor;
        data["seasonId"] = this.seasonId;
        data["season"] = this.season;
        data["year"] = this.year;
        data["countryId"] = this.countryId;
        data["countryName"] = this.countryName;
        return data;
    }
}


export interface IAccessEnterpriseViewModel {
    accessKey: string;
    enterpriseId: string;
    enterpriseName: string | undefined;
    cropId: string;
    cropName: string | undefined;
    cropColor: string | undefined;
    seasonId: string;
    season: string | undefined;
    year: number;
    countryId: string;
    countryName: string | undefined;
}


export class AccessEnterpriseViewModelListResponseResult implements IAccessEnterpriseViewModelListResponseResult {
    isSuccess!: boolean;
    statusCode!: number;
    result!: AccessEnterpriseViewModel[] | undefined;
    errors!: ErrorMessage[] | undefined;
    version!: string | undefined;
    environment!: string | undefined;

    constructor(data?: IAccessEnterpriseViewModelListResponseResult) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.isSuccess = _data["isSuccess"];
            this.statusCode = _data["statusCode"];
            if (Array.isArray(_data["result"])) {
                this.result = [] as any;
                for (let item of _data["result"])
                    this.result!.push(AccessEnterpriseViewModel.fromJS(item));
            }
            if (Array.isArray(_data["errors"])) {
                this.errors = [] as any;
                for (let item of _data["errors"])
                    this.errors!.push(ErrorMessage.fromJS(item));
            }
            this.version = _data["version"];
            this.environment = _data["environment"];
        }
    }

    static fromJS(data: any): AccessEnterpriseViewModelListResponseResult {
        data = typeof data === 'object' ? data : {};
        let result = new AccessEnterpriseViewModelListResponseResult();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["isSuccess"] = this.isSuccess;
        data["statusCode"] = this.statusCode;
        if (Array.isArray(this.result)) {
            data["result"] = [];
            for (let item of this.result)
                data["result"].push(item ? item.toJSON() : undefined as any);
        }
        if (Array.isArray(this.errors)) {
            data["errors"] = [];
            for (let item of this.errors)
                data["errors"].push(item ? item.toJSON() : undefined as any);
        }
        data["version"] = this.version;
        data["environment"] = this.environment;
        return data;
    }
}


export interface IAccessEnterpriseViewModelListResponseResult {
    isSuccess: boolean;
    statusCode: number;
    result: AccessEnterpriseViewModel[] | undefined;
    errors: ErrorMessage[] | undefined;
    version: string | undefined;
    environment: string | undefined;
}


export class AccessEnterpriseViewModelPaginatedResponse implements IAccessEnterpriseViewModelPaginatedResponse {
    items!: AccessEnterpriseViewModel[] | undefined;
    pageNumber!: number;
    pageSize!: number;
    totalCount!: number;
    totalPages!: number;
    hasPreviousPage!: boolean;
    hasNextPage!: boolean;
    appliedSorts!: SortCriteria[] | undefined;
    appliedFilters!: FilterCriteria[] | undefined;

    constructor(data?: IAccessEnterpriseViewModelPaginatedResponse) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["items"])) {
                this.items = [] as any;
                for (let item of _data["items"])
                    this.items!.push(AccessEnterpriseViewModel.fromJS(item));
            }
            this.pageNumber = _data["pageNumber"];
            this.pageSize = _data["pageSize"];
            this.totalCount = _data["totalCount"];
            this.totalPages = _data["totalPages"];
            this.hasPreviousPage = _data["hasPreviousPage"];
            this.hasNextPage = _data["hasNextPage"];
            if (Array.isArray(_data["appliedSorts"])) {
                this.appliedSorts = [] as any;
                for (let item of _data["appliedSorts"])
                    this.appliedSorts!.push(SortCriteria.fromJS(item));
            }
            if (Array.isArray(_data["appliedFilters"])) {
                this.appliedFilters = [] as any;
                for (let item of _data["appliedFilters"])
                    this.appliedFilters!.push(FilterCriteria.fromJS(item));
            }
        }
    }

    static fromJS(data: any): AccessEnterpriseViewModelPaginatedResponse {
        data = typeof data === 'object' ? data : {};
        let result = new AccessEnterpriseViewModelPaginatedResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.items)) {
            data["items"] = [];
            for (let item of this.items)
                data["items"].push(item ? item.toJSON() : undefined as any);
        }
        data["pageNumber"] = this.pageNumber;
        data["pageSize"] = this.pageSize;
        data["totalCount"] = this.totalCount;
        data["totalPages"] = this.totalPages;
        data["hasPreviousPage"] = this.hasPreviousPage;
        data["hasNextPage"] = this.hasNextPage;
        if (Array.isArray(this.appliedSorts)) {
            data["appliedSorts"] = [];
            for (let item of this.appliedSorts)
                data["appliedSorts"].push(item ? item.toJSON() : undefined as any);
        }
        if (Array.isArray(this.appliedFilters)) {
            data["appliedFilters"] = [];
            for (let item of this.appliedFilters)
                data["appliedFilters"].push(item ? item.toJSON() : undefined as any);
        }
        return data;
    }
}


export interface IAccessEnterpriseViewModelPaginatedResponse {
    items: AccessEnterpriseViewModel[] | undefined;
    pageNumber: number;
    pageSize: number;
    totalCount: number;
    totalPages: number;
    hasPreviousPage: boolean;
    hasNextPage: boolean;
    appliedSorts: SortCriteria[] | undefined;
    appliedFilters: FilterCriteria[] | undefined;
}


export class AccessEnterpriseViewModelPaginatedResponseResponseResult implements IAccessEnterpriseViewModelPaginatedResponseResponseResult {
    isSuccess!: boolean;
    statusCode!: number;
    result!: AccessEnterpriseViewModelPaginatedResponse;
    errors!: ErrorMessage[] | undefined;
    version!: string | undefined;
    environment!: string | undefined;

    constructor(data?: IAccessEnterpriseViewModelPaginatedResponseResponseResult) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.isSuccess = _data["isSuccess"];
            this.statusCode = _data["statusCode"];
            this.result = _data["result"] ? AccessEnterpriseViewModelPaginatedResponse.fromJS(_data["result"]) : undefined as any;
            if (Array.isArray(_data["errors"])) {
                this.errors = [] as any;
                for (let item of _data["errors"])
                    this.errors!.push(ErrorMessage.fromJS(item));
            }
            this.version = _data["version"];
            this.environment = _data["environment"];
        }
    }

    static fromJS(data: any): AccessEnterpriseViewModelPaginatedResponseResponseResult {
        data = typeof data === 'object' ? data : {};
        let result = new AccessEnterpriseViewModelPaginatedResponseResponseResult();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["isSuccess"] = this.isSuccess;
        data["statusCode"] = this.statusCode;
        data["result"] = this.result ? this.result.toJSON() : undefined as any;
        if (Array.isArray(this.errors)) {
            data["errors"] = [];
            for (let item of this.errors)
                data["errors"].push(item ? item.toJSON() : undefined as any);
        }
        data["version"] = this.version;
        data["environment"] = this.environment;
        return data;
    }
}


export interface IAccessEnterpriseViewModelPaginatedResponseResponseResult {
    isSuccess: boolean;
    statusCode: number;
    result: AccessEnterpriseViewModelPaginatedResponse;
    errors: ErrorMessage[] | undefined;
    version: string | undefined;
    environment: string | undefined;
}


export class AccessEnterpriseViewModelResponseResult implements IAccessEnterpriseViewModelResponseResult {
    isSuccess!: boolean;
    statusCode!: number;
    result!: AccessEnterpriseViewModel;
    errors!: ErrorMessage[] | undefined;
    version!: string | undefined;
    environment!: string | undefined;

    constructor(data?: IAccessEnterpriseViewModelResponseResult) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.isSuccess = _data["isSuccess"];
            this.statusCode = _data["statusCode"];
            this.result = _data["result"] ? AccessEnterpriseViewModel.fromJS(_data["result"]) : undefined as any;
            if (Array.isArray(_data["errors"])) {
                this.errors = [] as any;
                for (let item of _data["errors"])
                    this.errors!.push(ErrorMessage.fromJS(item));
            }
            this.version = _data["version"];
            this.environment = _data["environment"];
        }
    }

    static fromJS(data: any): AccessEnterpriseViewModelResponseResult {
        data = typeof data === 'object' ? data : {};
        let result = new AccessEnterpriseViewModelResponseResult();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["isSuccess"] = this.isSuccess;
        data["statusCode"] = this.statusCode;
        data["result"] = this.result ? this.result.toJSON() : undefined as any;
        if (Array.isArray(this.errors)) {
            data["errors"] = [];
            for (let item of this.errors)
                data["errors"].push(item ? item.toJSON() : undefined as any);
        }
        data["version"] = this.version;
        data["environment"] = this.environment;
        return data;
    }
}


export interface IAccessEnterpriseViewModelResponseResult {
    isSuccess: boolean;
    statusCode: number;
    result: AccessEnterpriseViewModel;
    errors: ErrorMessage[] | undefined;
    version: string | undefined;
    environment: string | undefined;
}


export class AccessRoleCityLocation implements IAccessRoleCityLocation {
    city!: string;
    districtIds!: string[] | undefined;

    constructor(data?: IAccessRoleCityLocation) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.city = _data["city"];
            if (Array.isArray(_data["districtIds"])) {
                this.districtIds = [] as any;
                for (let item of _data["districtIds"])
                    this.districtIds!.push(item);
            }
        }
    }

    static fromJS(data: any): AccessRoleCityLocation {
        data = typeof data === 'object' ? data : {};
        let result = new AccessRoleCityLocation();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["city"] = this.city;
        if (Array.isArray(this.districtIds)) {
            data["districtIds"] = [];
            for (let item of this.districtIds)
                data["districtIds"].push(item);
        }
        return data;
    }
}


export interface IAccessRoleCityLocation {
    city: string;
    districtIds: string[] | undefined;
}


export class AccessRoleLocation implements IAccessRoleLocation {
    countryId!: string;
    stateIds!: AccessRoleStateLocation[] | undefined;
    regionIds!: AccessRoleRegionLocation[] | undefined;

    constructor(data?: IAccessRoleLocation) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.countryId = _data["countryId"];
            if (Array.isArray(_data["stateIds"])) {
                this.stateIds = [] as any;
                for (let item of _data["stateIds"])
                    this.stateIds!.push(AccessRoleStateLocation.fromJS(item));
            }
            if (Array.isArray(_data["regionIds"])) {
                this.regionIds = [] as any;
                for (let item of _data["regionIds"])
                    this.regionIds!.push(AccessRoleRegionLocation.fromJS(item));
            }
        }
    }

    static fromJS(data: any): AccessRoleLocation {
        data = typeof data === 'object' ? data : {};
        let result = new AccessRoleLocation();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["countryId"] = this.countryId;
        if (Array.isArray(this.stateIds)) {
            data["stateIds"] = [];
            for (let item of this.stateIds)
                data["stateIds"].push(item ? item.toJSON() : undefined as any);
        }
        if (Array.isArray(this.regionIds)) {
            data["regionIds"] = [];
            for (let item of this.regionIds)
                data["regionIds"].push(item ? item.toJSON() : undefined as any);
        }
        return data;
    }
}


export interface IAccessRoleLocation {
    countryId: string;
    stateIds: AccessRoleStateLocation[] | undefined;
    regionIds: AccessRoleRegionLocation[] | undefined;
}


export class AccessRoleRegionLocation implements IAccessRoleRegionLocation {
    region!: string;
    cityLocations!: AccessRoleCityLocation[] | undefined;

    constructor(data?: IAccessRoleRegionLocation) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.region = _data["region"];
            if (Array.isArray(_data["cityLocations"])) {
                this.cityLocations = [] as any;
                for (let item of _data["cityLocations"])
                    this.cityLocations!.push(AccessRoleCityLocation.fromJS(item));
            }
        }
    }

    static fromJS(data: any): AccessRoleRegionLocation {
        data = typeof data === 'object' ? data : {};
        let result = new AccessRoleRegionLocation();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["region"] = this.region;
        if (Array.isArray(this.cityLocations)) {
            data["cityLocations"] = [];
            for (let item of this.cityLocations)
                data["cityLocations"].push(item ? item.toJSON() : undefined as any);
        }
        return data;
    }
}


export interface IAccessRoleRegionLocation {
    region: string;
    cityLocations: AccessRoleCityLocation[] | undefined;
}


export class AccessRoleStateLocation implements IAccessRoleStateLocation {
    state!: string;
    cityLocations!: AccessRoleCityLocation[] | undefined;

    constructor(data?: IAccessRoleStateLocation) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.state = _data["state"];
            if (Array.isArray(_data["cityLocations"])) {
                this.cityLocations = [] as any;
                for (let item of _data["cityLocations"])
                    this.cityLocations!.push(AccessRoleCityLocation.fromJS(item));
            }
        }
    }

    static fromJS(data: any): AccessRoleStateLocation {
        data = typeof data === 'object' ? data : {};
        let result = new AccessRoleStateLocation();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["state"] = this.state;
        if (Array.isArray(this.cityLocations)) {
            data["cityLocations"] = [];
            for (let item of this.cityLocations)
                data["cityLocations"].push(item ? item.toJSON() : undefined as any);
        }
        return data;
    }
}


export interface IAccessRoleStateLocation {
    state: string;
    cityLocations: AccessRoleCityLocation[] | undefined;
}


export class AccessRoleViewModel implements IAccessRoleViewModel {
    id!: string;
    enterpriseId!: string;
    year!: number;
    roleId!: string;
    roleName!: string | undefined;
    cropId!: string;
    cropName!: string | undefined;
    cropColor!: string | undefined;
    seasonId!: string;
    seasonName!: string | undefined;
    countriesHierarchy!: CountryHierarchyViewModel[] | undefined;

    constructor(data?: IAccessRoleViewModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.enterpriseId = _data["enterpriseId"];
            this.year = _data["year"];
            this.roleId = _data["roleId"];
            this.roleName = _data["roleName"];
            this.cropId = _data["cropId"];
            this.cropName = _data["cropName"];
            this.cropColor = _data["cropColor"];
            this.seasonId = _data["seasonId"];
            this.seasonName = _data["seasonName"];
            if (Array.isArray(_data["countriesHierarchy"])) {
                this.countriesHierarchy = [] as any;
                for (let item of _data["countriesHierarchy"])
                    this.countriesHierarchy!.push(CountryHierarchyViewModel.fromJS(item));
            }
        }
    }

    static fromJS(data: any): AccessRoleViewModel {
        data = typeof data === 'object' ? data : {};
        let result = new AccessRoleViewModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["enterpriseId"] = this.enterpriseId;
        data["year"] = this.year;
        data["roleId"] = this.roleId;
        data["roleName"] = this.roleName;
        data["cropId"] = this.cropId;
        data["cropName"] = this.cropName;
        data["cropColor"] = this.cropColor;
        data["seasonId"] = this.seasonId;
        data["seasonName"] = this.seasonName;
        if (Array.isArray(this.countriesHierarchy)) {
            data["countriesHierarchy"] = [];
            for (let item of this.countriesHierarchy)
                data["countriesHierarchy"].push(item ? item.toJSON() : undefined as any);
        }
        return data;
    }
}


export interface IAccessRoleViewModel {
    id: string;
    enterpriseId: string;
    year: number;
    roleId: string;
    roleName: string | undefined;
    cropId: string;
    cropName: string | undefined;
    cropColor: string | undefined;
    seasonId: string;
    seasonName: string | undefined;
    countriesHierarchy: CountryHierarchyViewModel[] | undefined;
}


export class AccessRoleViewModelListResponseResult implements IAccessRoleViewModelListResponseResult {
    isSuccess!: boolean;
    statusCode!: number;
    result!: AccessRoleViewModel[] | undefined;
    errors!: ErrorMessage[] | undefined;
    version!: string | undefined;
    environment!: string | undefined;

    constructor(data?: IAccessRoleViewModelListResponseResult) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.isSuccess = _data["isSuccess"];
            this.statusCode = _data["statusCode"];
            if (Array.isArray(_data["result"])) {
                this.result = [] as any;
                for (let item of _data["result"])
                    this.result!.push(AccessRoleViewModel.fromJS(item));
            }
            if (Array.isArray(_data["errors"])) {
                this.errors = [] as any;
                for (let item of _data["errors"])
                    this.errors!.push(ErrorMessage.fromJS(item));
            }
            this.version = _data["version"];
            this.environment = _data["environment"];
        }
    }

    static fromJS(data: any): AccessRoleViewModelListResponseResult {
        data = typeof data === 'object' ? data : {};
        let result = new AccessRoleViewModelListResponseResult();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["isSuccess"] = this.isSuccess;
        data["statusCode"] = this.statusCode;
        if (Array.isArray(this.result)) {
            data["result"] = [];
            for (let item of this.result)
                data["result"].push(item ? item.toJSON() : undefined as any);
        }
        if (Array.isArray(this.errors)) {
            data["errors"] = [];
            for (let item of this.errors)
                data["errors"].push(item ? item.toJSON() : undefined as any);
        }
        data["version"] = this.version;
        data["environment"] = this.environment;
        return data;
    }
}


export interface IAccessRoleViewModelListResponseResult {
    isSuccess: boolean;
    statusCode: number;
    result: AccessRoleViewModel[] | undefined;
    errors: ErrorMessage[] | undefined;
    version: string | undefined;
    environment: string | undefined;
}


export class ActiveCropModel implements IActiveCropModel {
    accessKey!: string | undefined;
    name!: string | undefined;
    color!: string | undefined;

    constructor(data?: IActiveCropModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.accessKey = _data["accessKey"];
            this.name = _data["name"];
            this.color = _data["color"];
        }
    }

    static fromJS(data: any): ActiveCropModel {
        data = typeof data === 'object' ? data : {};
        let result = new ActiveCropModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["accessKey"] = this.accessKey;
        data["name"] = this.name;
        data["color"] = this.color;
        return data;
    }
}


export interface IActiveCropModel {
    accessKey: string | undefined;
    name: string | undefined;
    color: string | undefined;
}


export class AnonymizeUserCommand implements IAnonymizeUserCommand {
    id!: string;
    reason!: string | undefined;
    totp!: number;

    constructor(data?: IAnonymizeUserCommand) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.reason = _data["reason"];
            this.totp = _data["totp"];
        }
    }

    static fromJS(data: any): AnonymizeUserCommand {
        data = typeof data === 'object' ? data : {};
        let result = new AnonymizeUserCommand();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["reason"] = this.reason;
        data["totp"] = this.totp;
        return data;
    }
}


export interface IAnonymizeUserCommand {
    id: string;
    reason: string | undefined;
    totp: number;
}


export class AppStartupModel implements IAppStartupModel {
    languages!: LanguageViewModel[] | undefined;
    professions!: ProfessionLookupViewModel[] | undefined;
    countries!: CountryViewModel[] | undefined;
    passwordPolicy!: IAMPolicyPasswordComplexity;
    versionDetails!: MobileAppVersionViewModel;
    minimumVersion!: number;

    constructor(data?: IAppStartupModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["languages"])) {
                this.languages = [] as any;
                for (let item of _data["languages"])
                    this.languages!.push(LanguageViewModel.fromJS(item));
            }
            if (Array.isArray(_data["professions"])) {
                this.professions = [] as any;
                for (let item of _data["professions"])
                    this.professions!.push(ProfessionLookupViewModel.fromJS(item));
            }
            if (Array.isArray(_data["countries"])) {
                this.countries = [] as any;
                for (let item of _data["countries"])
                    this.countries!.push(CountryViewModel.fromJS(item));
            }
            this.passwordPolicy = _data["passwordPolicy"] ? IAMPolicyPasswordComplexity.fromJS(_data["passwordPolicy"]) : undefined as any;
            this.versionDetails = _data["versionDetails"] ? MobileAppVersionViewModel.fromJS(_data["versionDetails"]) : undefined as any;
            this.minimumVersion = _data["minimumVersion"];
        }
    }

    static fromJS(data: any): AppStartupModel {
        data = typeof data === 'object' ? data : {};
        let result = new AppStartupModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.languages)) {
            data["languages"] = [];
            for (let item of this.languages)
                data["languages"].push(item ? item.toJSON() : undefined as any);
        }
        if (Array.isArray(this.professions)) {
            data["professions"] = [];
            for (let item of this.professions)
                data["professions"].push(item ? item.toJSON() : undefined as any);
        }
        if (Array.isArray(this.countries)) {
            data["countries"] = [];
            for (let item of this.countries)
                data["countries"].push(item ? item.toJSON() : undefined as any);
        }
        data["passwordPolicy"] = this.passwordPolicy ? this.passwordPolicy.toJSON() : undefined as any;
        data["versionDetails"] = this.versionDetails ? this.versionDetails.toJSON() : undefined as any;
        data["minimumVersion"] = this.minimumVersion;
        return data;
    }
}


export interface IAppStartupModel {
    languages: LanguageViewModel[] | undefined;
    professions: ProfessionLookupViewModel[] | undefined;
    countries: CountryViewModel[] | undefined;
    passwordPolicy: IAMPolicyPasswordComplexity;
    versionDetails: MobileAppVersionViewModel;
    minimumVersion: number;
}


export class AppStartupModelResponseResult implements IAppStartupModelResponseResult {
    isSuccess!: boolean;
    statusCode!: number;
    result!: AppStartupModel;
    errors!: ErrorMessage[] | undefined;
    version!: string | undefined;
    environment!: string | undefined;

    constructor(data?: IAppStartupModelResponseResult) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.isSuccess = _data["isSuccess"];
            this.statusCode = _data["statusCode"];
            this.result = _data["result"] ? AppStartupModel.fromJS(_data["result"]) : undefined as any;
            if (Array.isArray(_data["errors"])) {
                this.errors = [] as any;
                for (let item of _data["errors"])
                    this.errors!.push(ErrorMessage.fromJS(item));
            }
            this.version = _data["version"];
            this.environment = _data["environment"];
        }
    }

    static fromJS(data: any): AppStartupModelResponseResult {
        data = typeof data === 'object' ? data : {};
        let result = new AppStartupModelResponseResult();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["isSuccess"] = this.isSuccess;
        data["statusCode"] = this.statusCode;
        data["result"] = this.result ? this.result.toJSON() : undefined as any;
        if (Array.isArray(this.errors)) {
            data["errors"] = [];
            for (let item of this.errors)
                data["errors"].push(item ? item.toJSON() : undefined as any);
        }
        data["version"] = this.version;
        data["environment"] = this.environment;
        return data;
    }
}


export interface IAppStartupModelResponseResult {
    isSuccess: boolean;
    statusCode: number;
    result: AppStartupModel;
    errors: ErrorMessage[] | undefined;
    version: string | undefined;
    environment: string | undefined;
}


export class BooleanResponseResult implements IBooleanResponseResult {
    isSuccess!: boolean;
    statusCode!: number;
    result!: boolean;
    errors!: ErrorMessage[] | undefined;
    version!: string | undefined;
    environment!: string | undefined;

    constructor(data?: IBooleanResponseResult) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.isSuccess = _data["isSuccess"];
            this.statusCode = _data["statusCode"];
            this.result = _data["result"];
            if (Array.isArray(_data["errors"])) {
                this.errors = [] as any;
                for (let item of _data["errors"])
                    this.errors!.push(ErrorMessage.fromJS(item));
            }
            this.version = _data["version"];
            this.environment = _data["environment"];
        }
    }

    static fromJS(data: any): BooleanResponseResult {
        data = typeof data === 'object' ? data : {};
        let result = new BooleanResponseResult();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["isSuccess"] = this.isSuccess;
        data["statusCode"] = this.statusCode;
        data["result"] = this.result;
        if (Array.isArray(this.errors)) {
            data["errors"] = [];
            for (let item of this.errors)
                data["errors"].push(item ? item.toJSON() : undefined as any);
        }
        data["version"] = this.version;
        data["environment"] = this.environment;
        return data;
    }
}


export interface IBooleanResponseResult {
    isSuccess: boolean;
    statusCode: number;
    result: boolean;
    errors: ErrorMessage[] | undefined;
    version: string | undefined;
    environment: string | undefined;
}


export class CSIOperatorType implements ICSIOperatorType {
    propertyTypeId!: number;
    propertyTypeName!: string | undefined;
    name!: string | undefined;
    operator!: string | undefined;
    description!: string | undefined;

    constructor(data?: ICSIOperatorType) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.propertyTypeId = _data["propertyTypeId"];
            this.propertyTypeName = _data["propertyTypeName"];
            this.name = _data["name"];
            this.operator = _data["operator"];
            this.description = _data["description"];
        }
    }

    static fromJS(data: any): CSIOperatorType {
        data = typeof data === 'object' ? data : {};
        let result = new CSIOperatorType();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["propertyTypeId"] = this.propertyTypeId;
        data["propertyTypeName"] = this.propertyTypeName;
        data["name"] = this.name;
        data["operator"] = this.operator;
        data["description"] = this.description;
        return data;
    }
}


export interface ICSIOperatorType {
    propertyTypeId: number;
    propertyTypeName: string | undefined;
    name: string | undefined;
    operator: string | undefined;
    description: string | undefined;
}


export class CSIOperatorTypeListResponseResult implements ICSIOperatorTypeListResponseResult {
    isSuccess!: boolean;
    statusCode!: number;
    result!: CSIOperatorType[] | undefined;
    errors!: ErrorMessage[] | undefined;
    version!: string | undefined;
    environment!: string | undefined;

    constructor(data?: ICSIOperatorTypeListResponseResult) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.isSuccess = _data["isSuccess"];
            this.statusCode = _data["statusCode"];
            if (Array.isArray(_data["result"])) {
                this.result = [] as any;
                for (let item of _data["result"])
                    this.result!.push(CSIOperatorType.fromJS(item));
            }
            if (Array.isArray(_data["errors"])) {
                this.errors = [] as any;
                for (let item of _data["errors"])
                    this.errors!.push(ErrorMessage.fromJS(item));
            }
            this.version = _data["version"];
            this.environment = _data["environment"];
        }
    }

    static fromJS(data: any): CSIOperatorTypeListResponseResult {
        data = typeof data === 'object' ? data : {};
        let result = new CSIOperatorTypeListResponseResult();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["isSuccess"] = this.isSuccess;
        data["statusCode"] = this.statusCode;
        if (Array.isArray(this.result)) {
            data["result"] = [];
            for (let item of this.result)
                data["result"].push(item ? item.toJSON() : undefined as any);
        }
        if (Array.isArray(this.errors)) {
            data["errors"] = [];
            for (let item of this.errors)
                data["errors"].push(item ? item.toJSON() : undefined as any);
        }
        data["version"] = this.version;
        data["environment"] = this.environment;
        return data;
    }
}


export interface ICSIOperatorTypeListResponseResult {
    isSuccess: boolean;
    statusCode: number;
    result: CSIOperatorType[] | undefined;
    errors: ErrorMessage[] | undefined;
    version: string | undefined;
    environment: string | undefined;
}


export class ChangeMyPasswordCommand implements IChangeMyPasswordCommand {
    id!: string;
    oldPassword!: string | undefined;
    newPassword!: string | undefined;

    constructor(data?: IChangeMyPasswordCommand) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.oldPassword = _data["oldPassword"];
            this.newPassword = _data["newPassword"];
        }
    }

    static fromJS(data: any): ChangeMyPasswordCommand {
        data = typeof data === 'object' ? data : {};
        let result = new ChangeMyPasswordCommand();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["oldPassword"] = this.oldPassword;
        data["newPassword"] = this.newPassword;
        return data;
    }
}


export interface IChangeMyPasswordCommand {
    id: string;
    oldPassword: string | undefined;
    newPassword: string | undefined;
}


export class ChangeUserPINCommand implements IChangeUserPINCommand {
    userId!: string;
    currentPin!: number;
    newPin!: number;

    constructor(data?: IChangeUserPINCommand) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.userId = _data["userId"];
            this.currentPin = _data["currentPin"];
            this.newPin = _data["newPin"];
        }
    }

    static fromJS(data: any): ChangeUserPINCommand {
        data = typeof data === 'object' ? data : {};
        let result = new ChangeUserPINCommand();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["userId"] = this.userId;
        data["currentPin"] = this.currentPin;
        data["newPin"] = this.newPin;
        return data;
    }
}


export interface IChangeUserPINCommand {
    userId: string;
    currentPin: number;
    newPin: number;
}


export class ChangeUserPasswordByAdminCommand implements IChangeUserPasswordByAdminCommand {
    userId!: string;
    newPassword!: string | undefined;

    constructor(data?: IChangeUserPasswordByAdminCommand) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.userId = _data["userId"];
            this.newPassword = _data["newPassword"];
        }
    }

    static fromJS(data: any): ChangeUserPasswordByAdminCommand {
        data = typeof data === 'object' ? data : {};
        let result = new ChangeUserPasswordByAdminCommand();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["userId"] = this.userId;
        data["newPassword"] = this.newPassword;
        return data;
    }
}


export interface IChangeUserPasswordByAdminCommand {
    userId: string;
    newPassword: string | undefined;
}


export class CheckEmailExistCommand implements ICheckEmailExistCommand {
    email!: string | undefined;

    constructor(data?: ICheckEmailExistCommand) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.email = _data["email"];
        }
    }

    static fromJS(data: any): CheckEmailExistCommand {
        data = typeof data === 'object' ? data : {};
        let result = new CheckEmailExistCommand();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["email"] = this.email;
        return data;
    }
}


export interface ICheckEmailExistCommand {
    email: string | undefined;
}


export class CheckOTPResult implements ICheckOTPResult {
    isValid!: boolean;
    otpId!: number;
    actionPerformed!: boolean;
    userId!: number | undefined;
    method!: string | undefined;
    reason!: string | undefined;

    constructor(data?: ICheckOTPResult) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.isValid = _data["isValid"];
            this.otpId = _data["otpId"];
            this.actionPerformed = _data["actionPerformed"];
            this.userId = _data["userId"];
            this.method = _data["method"];
            this.reason = _data["reason"];
        }
    }

    static fromJS(data: any): CheckOTPResult {
        data = typeof data === 'object' ? data : {};
        let result = new CheckOTPResult();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["isValid"] = this.isValid;
        data["otpId"] = this.otpId;
        data["actionPerformed"] = this.actionPerformed;
        data["userId"] = this.userId;
        data["method"] = this.method;
        data["reason"] = this.reason;
        return data;
    }
}


export interface ICheckOTPResult {
    isValid: boolean;
    otpId: number;
    actionPerformed: boolean;
    userId: number | undefined;
    method: string | undefined;
    reason: string | undefined;
}


export class CheckOTPResultResponseResult implements ICheckOTPResultResponseResult {
    isSuccess!: boolean;
    statusCode!: number;
    result!: CheckOTPResult;
    errors!: ErrorMessage[] | undefined;
    version!: string | undefined;
    environment!: string | undefined;

    constructor(data?: ICheckOTPResultResponseResult) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.isSuccess = _data["isSuccess"];
            this.statusCode = _data["statusCode"];
            this.result = _data["result"] ? CheckOTPResult.fromJS(_data["result"]) : undefined as any;
            if (Array.isArray(_data["errors"])) {
                this.errors = [] as any;
                for (let item of _data["errors"])
                    this.errors!.push(ErrorMessage.fromJS(item));
            }
            this.version = _data["version"];
            this.environment = _data["environment"];
        }
    }

    static fromJS(data: any): CheckOTPResultResponseResult {
        data = typeof data === 'object' ? data : {};
        let result = new CheckOTPResultResponseResult();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["isSuccess"] = this.isSuccess;
        data["statusCode"] = this.statusCode;
        data["result"] = this.result ? this.result.toJSON() : undefined as any;
        if (Array.isArray(this.errors)) {
            data["errors"] = [];
            for (let item of this.errors)
                data["errors"].push(item ? item.toJSON() : undefined as any);
        }
        data["version"] = this.version;
        data["environment"] = this.environment;
        return data;
    }
}


export interface ICheckOTPResultResponseResult {
    isSuccess: boolean;
    statusCode: number;
    result: CheckOTPResult;
    errors: ErrorMessage[] | undefined;
    version: string | undefined;
    environment: string | undefined;
}


export class CheckPhoneExistCommand implements ICheckPhoneExistCommand {
    phone!: string | undefined;
    phoneCode!: string | undefined;

    constructor(data?: ICheckPhoneExistCommand) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.phone = _data["phone"];
            this.phoneCode = _data["phoneCode"];
        }
    }

    static fromJS(data: any): CheckPhoneExistCommand {
        data = typeof data === 'object' ? data : {};
        let result = new CheckPhoneExistCommand();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["phone"] = this.phone;
        data["phoneCode"] = this.phoneCode;
        return data;
    }
}


export interface ICheckPhoneExistCommand {
    phone: string | undefined;
    phoneCode: string | undefined;
}


export class CheckPinCommand implements ICheckPinCommand {
    pin!: number;

    constructor(data?: ICheckPinCommand) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.pin = _data["pin"];
        }
    }

    static fromJS(data: any): CheckPinCommand {
        data = typeof data === 'object' ? data : {};
        let result = new CheckPinCommand();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["pin"] = this.pin;
        return data;
    }
}


export interface ICheckPinCommand {
    pin: number;
}


export class CityBoundaryNode implements ICityBoundaryNode {
    key!: string;
    value!: string | undefined;
    boundaries!: CoordinateViewModel[] | undefined;
    districts!: DistrictBoundaryNode[] | undefined;

    constructor(data?: ICityBoundaryNode) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.key = _data["key"];
            this.value = _data["value"];
            if (Array.isArray(_data["boundaries"])) {
                this.boundaries = [] as any;
                for (let item of _data["boundaries"])
                    this.boundaries!.push(CoordinateViewModel.fromJS(item));
            }
            if (Array.isArray(_data["districts"])) {
                this.districts = [] as any;
                for (let item of _data["districts"])
                    this.districts!.push(DistrictBoundaryNode.fromJS(item));
            }
        }
    }

    static fromJS(data: any): CityBoundaryNode {
        data = typeof data === 'object' ? data : {};
        let result = new CityBoundaryNode();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["key"] = this.key;
        data["value"] = this.value;
        if (Array.isArray(this.boundaries)) {
            data["boundaries"] = [];
            for (let item of this.boundaries)
                data["boundaries"].push(item ? item.toJSON() : undefined as any);
        }
        if (Array.isArray(this.districts)) {
            data["districts"] = [];
            for (let item of this.districts)
                data["districts"].push(item ? item.toJSON() : undefined as any);
        }
        return data;
    }
}


export interface ICityBoundaryNode {
    key: string;
    value: string | undefined;
    boundaries: CoordinateViewModel[] | undefined;
    districts: DistrictBoundaryNode[] | undefined;
}


export class CityDistrictNode implements ICityDistrictNode {
    key!: string;
    value!: string | undefined;
    districts!: KeyValueModel[] | undefined;

    constructor(data?: ICityDistrictNode) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.key = _data["key"];
            this.value = _data["value"];
            if (Array.isArray(_data["districts"])) {
                this.districts = [] as any;
                for (let item of _data["districts"])
                    this.districts!.push(KeyValueModel.fromJS(item));
            }
        }
    }

    static fromJS(data: any): CityDistrictNode {
        data = typeof data === 'object' ? data : {};
        let result = new CityDistrictNode();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["key"] = this.key;
        data["value"] = this.value;
        if (Array.isArray(this.districts)) {
            data["districts"] = [];
            for (let item of this.districts)
                data["districts"].push(item ? item.toJSON() : undefined as any);
        }
        return data;
    }
}


export interface ICityDistrictNode {
    key: string;
    value: string | undefined;
    districts: KeyValueModel[] | undefined;
}


export class CityHierarchyViewModel implements ICityHierarchyViewModel {
    cityId!: string;
    name!: string | undefined;
    districts!: DistrictHierarchyViewModel[] | undefined;

    constructor(data?: ICityHierarchyViewModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.cityId = _data["cityId"];
            this.name = _data["name"];
            if (Array.isArray(_data["districts"])) {
                this.districts = [] as any;
                for (let item of _data["districts"])
                    this.districts!.push(DistrictHierarchyViewModel.fromJS(item));
            }
        }
    }

    static fromJS(data: any): CityHierarchyViewModel {
        data = typeof data === 'object' ? data : {};
        let result = new CityHierarchyViewModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["cityId"] = this.cityId;
        data["name"] = this.name;
        if (Array.isArray(this.districts)) {
            data["districts"] = [];
            for (let item of this.districts)
                data["districts"].push(item ? item.toJSON() : undefined as any);
        }
        return data;
    }
}


export interface ICityHierarchyViewModel {
    cityId: string;
    name: string | undefined;
    districts: DistrictHierarchyViewModel[] | undefined;
}


export class ConstantViewModel implements IConstantViewModel {
    constantId!: number;
    constantValue!: string | undefined;

    constructor(data?: IConstantViewModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.constantId = _data["constantId"];
            this.constantValue = _data["constantValue"];
        }
    }

    static fromJS(data: any): ConstantViewModel {
        data = typeof data === 'object' ? data : {};
        let result = new ConstantViewModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["constantId"] = this.constantId;
        data["constantValue"] = this.constantValue;
        return data;
    }
}


export interface IConstantViewModel {
    constantId: number;
    constantValue: string | undefined;
}


export class ConstantViewModelListResponseResult implements IConstantViewModelListResponseResult {
    isSuccess!: boolean;
    statusCode!: number;
    result!: ConstantViewModel[] | undefined;
    errors!: ErrorMessage[] | undefined;
    version!: string | undefined;
    environment!: string | undefined;

    constructor(data?: IConstantViewModelListResponseResult) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.isSuccess = _data["isSuccess"];
            this.statusCode = _data["statusCode"];
            if (Array.isArray(_data["result"])) {
                this.result = [] as any;
                for (let item of _data["result"])
                    this.result!.push(ConstantViewModel.fromJS(item));
            }
            if (Array.isArray(_data["errors"])) {
                this.errors = [] as any;
                for (let item of _data["errors"])
                    this.errors!.push(ErrorMessage.fromJS(item));
            }
            this.version = _data["version"];
            this.environment = _data["environment"];
        }
    }

    static fromJS(data: any): ConstantViewModelListResponseResult {
        data = typeof data === 'object' ? data : {};
        let result = new ConstantViewModelListResponseResult();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["isSuccess"] = this.isSuccess;
        data["statusCode"] = this.statusCode;
        if (Array.isArray(this.result)) {
            data["result"] = [];
            for (let item of this.result)
                data["result"].push(item ? item.toJSON() : undefined as any);
        }
        if (Array.isArray(this.errors)) {
            data["errors"] = [];
            for (let item of this.errors)
                data["errors"].push(item ? item.toJSON() : undefined as any);
        }
        data["version"] = this.version;
        data["environment"] = this.environment;
        return data;
    }
}


export interface IConstantViewModelListResponseResult {
    isSuccess: boolean;
    statusCode: number;
    result: ConstantViewModel[] | undefined;
    errors: ErrorMessage[] | undefined;
    version: string | undefined;
    environment: string | undefined;
}


export class ContactUsCommand implements IContactUsCommand {
    nameSurname!: string | undefined;
    email!: string | undefined;
    phone!: string | undefined;
    message!: string | undefined;

    constructor(data?: IContactUsCommand) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.nameSurname = _data["nameSurname"];
            this.email = _data["email"];
            this.phone = _data["phone"];
            this.message = _data["message"];
        }
    }

    static fromJS(data: any): ContactUsCommand {
        data = typeof data === 'object' ? data : {};
        let result = new ContactUsCommand();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["nameSurname"] = this.nameSurname;
        data["email"] = this.email;
        data["phone"] = this.phone;
        data["message"] = this.message;
        return data;
    }
}


export interface IContactUsCommand {
    nameSurname: string | undefined;
    email: string | undefined;
    phone: string | undefined;
    message: string | undefined;
}


export class CoordinateViewModel implements ICoordinateViewModel {
    latitude!: number;
    longitude!: number;

    constructor(data?: ICoordinateViewModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.latitude = _data["latitude"];
            this.longitude = _data["longitude"];
        }
    }

    static fromJS(data: any): CoordinateViewModel {
        data = typeof data === 'object' ? data : {};
        let result = new CoordinateViewModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["latitude"] = this.latitude;
        data["longitude"] = this.longitude;
        return data;
    }
}


export interface ICoordinateViewModel {
    latitude: number;
    longitude: number;
}


export class CountryAddressHierarchyViewModel implements ICountryAddressHierarchyViewModel {
    hasStates!: boolean;
    states!: StateOrRegionNode[] | undefined;
    regions!: StateOrRegionNode[] | undefined;

    constructor(data?: ICountryAddressHierarchyViewModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.hasStates = _data["hasStates"];
            if (Array.isArray(_data["states"])) {
                this.states = [] as any;
                for (let item of _data["states"])
                    this.states!.push(StateOrRegionNode.fromJS(item));
            }
            if (Array.isArray(_data["regions"])) {
                this.regions = [] as any;
                for (let item of _data["regions"])
                    this.regions!.push(StateOrRegionNode.fromJS(item));
            }
        }
    }

    static fromJS(data: any): CountryAddressHierarchyViewModel {
        data = typeof data === 'object' ? data : {};
        let result = new CountryAddressHierarchyViewModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["hasStates"] = this.hasStates;
        if (Array.isArray(this.states)) {
            data["states"] = [];
            for (let item of this.states)
                data["states"].push(item ? item.toJSON() : undefined as any);
        }
        if (Array.isArray(this.regions)) {
            data["regions"] = [];
            for (let item of this.regions)
                data["regions"].push(item ? item.toJSON() : undefined as any);
        }
        return data;
    }
}


export interface ICountryAddressHierarchyViewModel {
    hasStates: boolean;
    states: StateOrRegionNode[] | undefined;
    regions: StateOrRegionNode[] | undefined;
}


export class CountryAddressHierarchyViewModelResponseResult implements ICountryAddressHierarchyViewModelResponseResult {
    isSuccess!: boolean;
    statusCode!: number;
    result!: CountryAddressHierarchyViewModel;
    errors!: ErrorMessage[] | undefined;
    version!: string | undefined;
    environment!: string | undefined;

    constructor(data?: ICountryAddressHierarchyViewModelResponseResult) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.isSuccess = _data["isSuccess"];
            this.statusCode = _data["statusCode"];
            this.result = _data["result"] ? CountryAddressHierarchyViewModel.fromJS(_data["result"]) : undefined as any;
            if (Array.isArray(_data["errors"])) {
                this.errors = [] as any;
                for (let item of _data["errors"])
                    this.errors!.push(ErrorMessage.fromJS(item));
            }
            this.version = _data["version"];
            this.environment = _data["environment"];
        }
    }

    static fromJS(data: any): CountryAddressHierarchyViewModelResponseResult {
        data = typeof data === 'object' ? data : {};
        let result = new CountryAddressHierarchyViewModelResponseResult();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["isSuccess"] = this.isSuccess;
        data["statusCode"] = this.statusCode;
        data["result"] = this.result ? this.result.toJSON() : undefined as any;
        if (Array.isArray(this.errors)) {
            data["errors"] = [];
            for (let item of this.errors)
                data["errors"].push(item ? item.toJSON() : undefined as any);
        }
        data["version"] = this.version;
        data["environment"] = this.environment;
        return data;
    }
}


export interface ICountryAddressHierarchyViewModelResponseResult {
    isSuccess: boolean;
    statusCode: number;
    result: CountryAddressHierarchyViewModel;
    errors: ErrorMessage[] | undefined;
    version: string | undefined;
    environment: string | undefined;
}


export class CountryAddressHierarchyWithBoundariesViewModel implements ICountryAddressHierarchyWithBoundariesViewModel {
    hasStates!: boolean;
    states!: StateOrRegionBoundaryNode[] | undefined;
    regions!: StateOrRegionBoundaryNode[] | undefined;

    constructor(data?: ICountryAddressHierarchyWithBoundariesViewModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.hasStates = _data["hasStates"];
            if (Array.isArray(_data["states"])) {
                this.states = [] as any;
                for (let item of _data["states"])
                    this.states!.push(StateOrRegionBoundaryNode.fromJS(item));
            }
            if (Array.isArray(_data["regions"])) {
                this.regions = [] as any;
                for (let item of _data["regions"])
                    this.regions!.push(StateOrRegionBoundaryNode.fromJS(item));
            }
        }
    }

    static fromJS(data: any): CountryAddressHierarchyWithBoundariesViewModel {
        data = typeof data === 'object' ? data : {};
        let result = new CountryAddressHierarchyWithBoundariesViewModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["hasStates"] = this.hasStates;
        if (Array.isArray(this.states)) {
            data["states"] = [];
            for (let item of this.states)
                data["states"].push(item ? item.toJSON() : undefined as any);
        }
        if (Array.isArray(this.regions)) {
            data["regions"] = [];
            for (let item of this.regions)
                data["regions"].push(item ? item.toJSON() : undefined as any);
        }
        return data;
    }
}


export interface ICountryAddressHierarchyWithBoundariesViewModel {
    hasStates: boolean;
    states: StateOrRegionBoundaryNode[] | undefined;
    regions: StateOrRegionBoundaryNode[] | undefined;
}


export class CountryAddressHierarchyWithBoundariesViewModelResponseResult implements ICountryAddressHierarchyWithBoundariesViewModelResponseResult {
    isSuccess!: boolean;
    statusCode!: number;
    result!: CountryAddressHierarchyWithBoundariesViewModel;
    errors!: ErrorMessage[] | undefined;
    version!: string | undefined;
    environment!: string | undefined;

    constructor(data?: ICountryAddressHierarchyWithBoundariesViewModelResponseResult) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.isSuccess = _data["isSuccess"];
            this.statusCode = _data["statusCode"];
            this.result = _data["result"] ? CountryAddressHierarchyWithBoundariesViewModel.fromJS(_data["result"]) : undefined as any;
            if (Array.isArray(_data["errors"])) {
                this.errors = [] as any;
                for (let item of _data["errors"])
                    this.errors!.push(ErrorMessage.fromJS(item));
            }
            this.version = _data["version"];
            this.environment = _data["environment"];
        }
    }

    static fromJS(data: any): CountryAddressHierarchyWithBoundariesViewModelResponseResult {
        data = typeof data === 'object' ? data : {};
        let result = new CountryAddressHierarchyWithBoundariesViewModelResponseResult();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["isSuccess"] = this.isSuccess;
        data["statusCode"] = this.statusCode;
        data["result"] = this.result ? this.result.toJSON() : undefined as any;
        if (Array.isArray(this.errors)) {
            data["errors"] = [];
            for (let item of this.errors)
                data["errors"].push(item ? item.toJSON() : undefined as any);
        }
        data["version"] = this.version;
        data["environment"] = this.environment;
        return data;
    }
}


export interface ICountryAddressHierarchyWithBoundariesViewModelResponseResult {
    isSuccess: boolean;
    statusCode: number;
    result: CountryAddressHierarchyWithBoundariesViewModel;
    errors: ErrorMessage[] | undefined;
    version: string | undefined;
    environment: string | undefined;
}


export class CountryHierarchyViewModel implements ICountryHierarchyViewModel {
    countryId!: string;
    name!: string | undefined;
    states!: StateHierarchyViewModel[] | undefined;
    regions!: RegionHierarchyViewModel[] | undefined;

    constructor(data?: ICountryHierarchyViewModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.countryId = _data["countryId"];
            this.name = _data["name"];
            if (Array.isArray(_data["states"])) {
                this.states = [] as any;
                for (let item of _data["states"])
                    this.states!.push(StateHierarchyViewModel.fromJS(item));
            }
            if (Array.isArray(_data["regions"])) {
                this.regions = [] as any;
                for (let item of _data["regions"])
                    this.regions!.push(RegionHierarchyViewModel.fromJS(item));
            }
        }
    }

    static fromJS(data: any): CountryHierarchyViewModel {
        data = typeof data === 'object' ? data : {};
        let result = new CountryHierarchyViewModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["countryId"] = this.countryId;
        data["name"] = this.name;
        if (Array.isArray(this.states)) {
            data["states"] = [];
            for (let item of this.states)
                data["states"].push(item ? item.toJSON() : undefined as any);
        }
        if (Array.isArray(this.regions)) {
            data["regions"] = [];
            for (let item of this.regions)
                data["regions"].push(item ? item.toJSON() : undefined as any);
        }
        return data;
    }
}


export interface ICountryHierarchyViewModel {
    countryId: string;
    name: string | undefined;
    states: StateHierarchyViewModel[] | undefined;
    regions: RegionHierarchyViewModel[] | undefined;
}


export class CountryLookupModel implements ICountryLookupModel {
    key!: string;
    value!: string | undefined;
    codeA2!: string | undefined;
    phone!: string | undefined;
    flag!: string | undefined;

    constructor(data?: ICountryLookupModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.key = _data["key"];
            this.value = _data["value"];
            this.codeA2 = _data["codeA2"];
            this.phone = _data["phone"];
            this.flag = _data["flag"];
        }
    }

    static fromJS(data: any): CountryLookupModel {
        data = typeof data === 'object' ? data : {};
        let result = new CountryLookupModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["key"] = this.key;
        data["value"] = this.value;
        data["codeA2"] = this.codeA2;
        data["phone"] = this.phone;
        data["flag"] = this.flag;
        return data;
    }
}


export interface ICountryLookupModel {
    key: string;
    value: string | undefined;
    codeA2: string | undefined;
    phone: string | undefined;
    flag: string | undefined;
}


export class CountryLookupModelListResponseResult implements ICountryLookupModelListResponseResult {
    isSuccess!: boolean;
    statusCode!: number;
    result!: CountryLookupModel[] | undefined;
    errors!: ErrorMessage[] | undefined;
    version!: string | undefined;
    environment!: string | undefined;

    constructor(data?: ICountryLookupModelListResponseResult) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.isSuccess = _data["isSuccess"];
            this.statusCode = _data["statusCode"];
            if (Array.isArray(_data["result"])) {
                this.result = [] as any;
                for (let item of _data["result"])
                    this.result!.push(CountryLookupModel.fromJS(item));
            }
            if (Array.isArray(_data["errors"])) {
                this.errors = [] as any;
                for (let item of _data["errors"])
                    this.errors!.push(ErrorMessage.fromJS(item));
            }
            this.version = _data["version"];
            this.environment = _data["environment"];
        }
    }

    static fromJS(data: any): CountryLookupModelListResponseResult {
        data = typeof data === 'object' ? data : {};
        let result = new CountryLookupModelListResponseResult();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["isSuccess"] = this.isSuccess;
        data["statusCode"] = this.statusCode;
        if (Array.isArray(this.result)) {
            data["result"] = [];
            for (let item of this.result)
                data["result"].push(item ? item.toJSON() : undefined as any);
        }
        if (Array.isArray(this.errors)) {
            data["errors"] = [];
            for (let item of this.errors)
                data["errors"].push(item ? item.toJSON() : undefined as any);
        }
        data["version"] = this.version;
        data["environment"] = this.environment;
        return data;
    }
}


export interface ICountryLookupModelListResponseResult {
    isSuccess: boolean;
    statusCode: number;
    result: CountryLookupModel[] | undefined;
    errors: ErrorMessage[] | undefined;
    version: string | undefined;
    environment: string | undefined;
}


export class CountryViewModel implements ICountryViewModel {
    id!: string;
    name!: string | undefined;
    nativeName!: string | undefined;
    officialName!: string | undefined;
    sovereignty!: string | undefined;
    codeA2!: string | undefined;
    codeA3!: string | undefined;
    codeNumeric!: string | undefined;
    tld!: string | undefined;
    boundaries!: string | undefined;
    phoneCode!: string | undefined;
    flagEmoji!: string | undefined;
    planetTier!: number;
    sort!: number;
    phoneExample!: string | undefined;
    phoneMask!: string | undefined;

    constructor(data?: ICountryViewModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.name = _data["name"];
            this.nativeName = _data["nativeName"];
            this.officialName = _data["officialName"];
            this.sovereignty = _data["sovereignty"];
            this.codeA2 = _data["codeA2"];
            this.codeA3 = _data["codeA3"];
            this.codeNumeric = _data["codeNumeric"];
            this.tld = _data["tld"];
            this.boundaries = _data["boundaries"];
            this.phoneCode = _data["phoneCode"];
            this.flagEmoji = _data["flagEmoji"];
            this.planetTier = _data["planetTier"];
            this.sort = _data["sort"];
            this.phoneExample = _data["phoneExample"];
            this.phoneMask = _data["phoneMask"];
        }
    }

    static fromJS(data: any): CountryViewModel {
        data = typeof data === 'object' ? data : {};
        let result = new CountryViewModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["name"] = this.name;
        data["nativeName"] = this.nativeName;
        data["officialName"] = this.officialName;
        data["sovereignty"] = this.sovereignty;
        data["codeA2"] = this.codeA2;
        data["codeA3"] = this.codeA3;
        data["codeNumeric"] = this.codeNumeric;
        data["tld"] = this.tld;
        data["boundaries"] = this.boundaries;
        data["phoneCode"] = this.phoneCode;
        data["flagEmoji"] = this.flagEmoji;
        data["planetTier"] = this.planetTier;
        data["sort"] = this.sort;
        data["phoneExample"] = this.phoneExample;
        data["phoneMask"] = this.phoneMask;
        return data;
    }
}


export interface ICountryViewModel {
    id: string;
    name: string | undefined;
    nativeName: string | undefined;
    officialName: string | undefined;
    sovereignty: string | undefined;
    codeA2: string | undefined;
    codeA3: string | undefined;
    codeNumeric: string | undefined;
    tld: string | undefined;
    boundaries: string | undefined;
    phoneCode: string | undefined;
    flagEmoji: string | undefined;
    planetTier: number;
    sort: number;
    phoneExample: string | undefined;
    phoneMask: string | undefined;
}


export class CreateAccessEnterpriseCommand implements ICreateAccessEnterpriseCommand {
    enterpriseId!: string;
    countryId!: string;
    year!: number;
    cropId!: string;
    seasonId!: string;

    constructor(data?: ICreateAccessEnterpriseCommand) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.enterpriseId = _data["enterpriseId"];
            this.countryId = _data["countryId"];
            this.year = _data["year"];
            this.cropId = _data["cropId"];
            this.seasonId = _data["seasonId"];
        }
    }

    static fromJS(data: any): CreateAccessEnterpriseCommand {
        data = typeof data === 'object' ? data : {};
        let result = new CreateAccessEnterpriseCommand();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["enterpriseId"] = this.enterpriseId;
        data["countryId"] = this.countryId;
        data["year"] = this.year;
        data["cropId"] = this.cropId;
        data["seasonId"] = this.seasonId;
        return data;
    }
}


export interface ICreateAccessEnterpriseCommand {
    enterpriseId: string;
    countryId: string;
    year: number;
    cropId: string;
    seasonId: string;
}


export class CreateAccessRoleCommand implements ICreateAccessRoleCommand {
    roleId!: string;
    enterpriseId!: string;
    cropId!: string;
    seasonId!: string;
    year!: number;
    locations!: AccessRoleLocation[] | undefined;

    constructor(data?: ICreateAccessRoleCommand) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.roleId = _data["roleId"];
            this.enterpriseId = _data["enterpriseId"];
            this.cropId = _data["cropId"];
            this.seasonId = _data["seasonId"];
            this.year = _data["year"];
            if (Array.isArray(_data["locations"])) {
                this.locations = [] as any;
                for (let item of _data["locations"])
                    this.locations!.push(AccessRoleLocation.fromJS(item));
            }
        }
    }

    static fromJS(data: any): CreateAccessRoleCommand {
        data = typeof data === 'object' ? data : {};
        let result = new CreateAccessRoleCommand();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["roleId"] = this.roleId;
        data["enterpriseId"] = this.enterpriseId;
        data["cropId"] = this.cropId;
        data["seasonId"] = this.seasonId;
        data["year"] = this.year;
        if (Array.isArray(this.locations)) {
            data["locations"] = [];
            for (let item of this.locations)
                data["locations"].push(item ? item.toJSON() : undefined as any);
        }
        return data;
    }
}


export interface ICreateAccessRoleCommand {
    roleId: string;
    enterpriseId: string;
    cropId: string;
    seasonId: string;
    year: number;
    locations: AccessRoleLocation[] | undefined;
}


export class CreateCropMapUserCommand implements ICreateCropMapUserCommand {
    appId!: string;
    userTypeId!: string;
    phoneCode!: string | undefined;
    phone!: string | undefined;
    email!: string | undefined;
    password!: string | undefined;
    name!: string | undefined;
    surname!: string | undefined;
    enterpriseId!: string;
    cropMapRoleId!: string;

    constructor(data?: ICreateCropMapUserCommand) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.appId = _data["appId"];
            this.userTypeId = _data["userTypeId"];
            this.phoneCode = _data["phoneCode"];
            this.phone = _data["phone"];
            this.email = _data["email"];
            this.password = _data["password"];
            this.name = _data["name"];
            this.surname = _data["surname"];
            this.enterpriseId = _data["enterpriseId"];
            this.cropMapRoleId = _data["cropMapRoleId"];
        }
    }

    static fromJS(data: any): CreateCropMapUserCommand {
        data = typeof data === 'object' ? data : {};
        let result = new CreateCropMapUserCommand();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["appId"] = this.appId;
        data["userTypeId"] = this.userTypeId;
        data["phoneCode"] = this.phoneCode;
        data["phone"] = this.phone;
        data["email"] = this.email;
        data["password"] = this.password;
        data["name"] = this.name;
        data["surname"] = this.surname;
        data["enterpriseId"] = this.enterpriseId;
        data["cropMapRoleId"] = this.cropMapRoleId;
        return data;
    }
}


export interface ICreateCropMapUserCommand {
    appId: string;
    userTypeId: string;
    phoneCode: string | undefined;
    phone: string | undefined;
    email: string | undefined;
    password: string | undefined;
    name: string | undefined;
    surname: string | undefined;
    enterpriseId: string;
    cropMapRoleId: string;
}


export class CreateCropMapUserV2Command implements ICreateCropMapUserV2Command {
    phoneCode!: string | undefined;
    phone!: string | undefined;
    email!: string | undefined;
    password!: string | undefined;
    name!: string | undefined;
    surname!: string | undefined;
    enterpriseId!: string;
    enterpriseRoleId!: string;
    cropMapRoleIds!: string[] | undefined;

    constructor(data?: ICreateCropMapUserV2Command) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.phoneCode = _data["phoneCode"];
            this.phone = _data["phone"];
            this.email = _data["email"];
            this.password = _data["password"];
            this.name = _data["name"];
            this.surname = _data["surname"];
            this.enterpriseId = _data["enterpriseId"];
            this.enterpriseRoleId = _data["enterpriseRoleId"];
            if (Array.isArray(_data["cropMapRoleIds"])) {
                this.cropMapRoleIds = [] as any;
                for (let item of _data["cropMapRoleIds"])
                    this.cropMapRoleIds!.push(item);
            }
        }
    }

    static fromJS(data: any): CreateCropMapUserV2Command {
        data = typeof data === 'object' ? data : {};
        let result = new CreateCropMapUserV2Command();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["phoneCode"] = this.phoneCode;
        data["phone"] = this.phone;
        data["email"] = this.email;
        data["password"] = this.password;
        data["name"] = this.name;
        data["surname"] = this.surname;
        data["enterpriseId"] = this.enterpriseId;
        data["enterpriseRoleId"] = this.enterpriseRoleId;
        if (Array.isArray(this.cropMapRoleIds)) {
            data["cropMapRoleIds"] = [];
            for (let item of this.cropMapRoleIds)
                data["cropMapRoleIds"].push(item);
        }
        return data;
    }
}


export interface ICreateCropMapUserV2Command {
    phoneCode: string | undefined;
    phone: string | undefined;
    email: string | undefined;
    password: string | undefined;
    name: string | undefined;
    surname: string | undefined;
    enterpriseId: string;
    enterpriseRoleId: string;
    cropMapRoleIds: string[] | undefined;
}


export class CreateCropSeasonCommand implements ICreateCropSeasonCommand {
    cropId!: string;
    seasonId!: string;

    constructor(data?: ICreateCropSeasonCommand) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.cropId = _data["cropId"];
            this.seasonId = _data["seasonId"];
        }
    }

    static fromJS(data: any): CreateCropSeasonCommand {
        data = typeof data === 'object' ? data : {};
        let result = new CreateCropSeasonCommand();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["cropId"] = this.cropId;
        data["seasonId"] = this.seasonId;
        return data;
    }
}


export interface ICreateCropSeasonCommand {
    cropId: string;
    seasonId: string;
}


export class CreateFieldObservationCommand implements ICreateFieldObservationCommand {
    enterpriseId!: string;
    fieldRef!: number;
    year!: number;
    seasonId!: number | undefined;
    nameSurname!: string | undefined;
    phoneCode!: string | undefined;
    phone!: string | undefined;
    email!: string | undefined;
    note!: string | undefined;
    questionnaire!: Questionnaire;

    constructor(data?: ICreateFieldObservationCommand) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.enterpriseId = _data["enterpriseId"];
            this.fieldRef = _data["fieldRef"];
            this.year = _data["year"];
            this.seasonId = _data["seasonId"];
            this.nameSurname = _data["nameSurname"];
            this.phoneCode = _data["phoneCode"];
            this.phone = _data["phone"];
            this.email = _data["email"];
            this.note = _data["note"];
            this.questionnaire = _data["questionnaire"] ? Questionnaire.fromJS(_data["questionnaire"]) : undefined as any;
        }
    }

    static fromJS(data: any): CreateFieldObservationCommand {
        data = typeof data === 'object' ? data : {};
        let result = new CreateFieldObservationCommand();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["enterpriseId"] = this.enterpriseId;
        data["fieldRef"] = this.fieldRef;
        data["year"] = this.year;
        data["seasonId"] = this.seasonId;
        data["nameSurname"] = this.nameSurname;
        data["phoneCode"] = this.phoneCode;
        data["phone"] = this.phone;
        data["email"] = this.email;
        data["note"] = this.note;
        data["questionnaire"] = this.questionnaire ? this.questionnaire.toJSON() : undefined as any;
        return data;
    }
}


export interface ICreateFieldObservationCommand {
    enterpriseId: string;
    fieldRef: number;
    year: number;
    seasonId: number | undefined;
    nameSurname: string | undefined;
    phoneCode: string | undefined;
    phone: string | undefined;
    email: string | undefined;
    note: string | undefined;
    questionnaire: Questionnaire;
}


export class CreateFieldObservationQuestionnaireCommand implements ICreateFieldObservationQuestionnaireCommand {
    enterpriseId!: string;
    year!: number | undefined;
    questionnaires!: Questionnaire[] | undefined;

    constructor(data?: ICreateFieldObservationQuestionnaireCommand) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.enterpriseId = _data["enterpriseId"];
            this.year = _data["year"];
            if (Array.isArray(_data["questionnaires"])) {
                this.questionnaires = [] as any;
                for (let item of _data["questionnaires"])
                    this.questionnaires!.push(Questionnaire.fromJS(item));
            }
        }
    }

    static fromJS(data: any): CreateFieldObservationQuestionnaireCommand {
        data = typeof data === 'object' ? data : {};
        let result = new CreateFieldObservationQuestionnaireCommand();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["enterpriseId"] = this.enterpriseId;
        data["year"] = this.year;
        if (Array.isArray(this.questionnaires)) {
            data["questionnaires"] = [];
            for (let item of this.questionnaires)
                data["questionnaires"].push(item ? item.toJSON() : undefined as any);
        }
        return data;
    }
}


export interface ICreateFieldObservationQuestionnaireCommand {
    enterpriseId: string;
    year: number | undefined;
    questionnaires: Questionnaire[] | undefined;
}


export class CreateLandCommand implements ICreateLandCommand {
    coordinates!: PolygonItem[] | undefined;
    enterpriseId!: string;
    appId!: string;
    assetOwnershipId!: string;
    name!: string | undefined;
    totalArea!: number | undefined;
    displayId!: number | undefined;
    countryId!: string | undefined;
    regionId!: string | undefined;
    stateId!: string | undefined;
    cityId!: string | undefined;
    districtId!: string | undefined;
    villageId!: string | undefined;
    timeZoneId!: string | undefined;
    weatherSpotId!: string | undefined;
    kmlData!: string | undefined;
    parcelInquiryData!: ParcelInquiryDataDto;
    location!: string | undefined;
    isActive!: boolean;
    isDeleted!: boolean;
    isAnonymized!: boolean;
    note!: string | undefined;

    constructor(data?: ICreateLandCommand) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["coordinates"])) {
                this.coordinates = [] as any;
                for (let item of _data["coordinates"])
                    this.coordinates!.push(PolygonItem.fromJS(item));
            }
            this.enterpriseId = _data["enterpriseId"];
            this.appId = _data["appId"];
            this.assetOwnershipId = _data["assetOwnershipId"];
            this.name = _data["name"];
            this.totalArea = _data["totalArea"];
            this.displayId = _data["displayId"];
            this.countryId = _data["countryId"];
            this.regionId = _data["regionId"];
            this.stateId = _data["stateId"];
            this.cityId = _data["cityId"];
            this.districtId = _data["districtId"];
            this.villageId = _data["villageId"];
            this.timeZoneId = _data["timeZoneId"];
            this.weatherSpotId = _data["weatherSpotId"];
            this.kmlData = _data["kmlData"];
            this.parcelInquiryData = _data["parcelInquiryData"] ? ParcelInquiryDataDto.fromJS(_data["parcelInquiryData"]) : undefined as any;
            this.location = _data["location"];
            this.isActive = _data["isActive"];
            this.isDeleted = _data["isDeleted"];
            this.isAnonymized = _data["isAnonymized"];
            this.note = _data["note"];
        }
    }

    static fromJS(data: any): CreateLandCommand {
        data = typeof data === 'object' ? data : {};
        let result = new CreateLandCommand();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.coordinates)) {
            data["coordinates"] = [];
            for (let item of this.coordinates)
                data["coordinates"].push(item ? item.toJSON() : undefined as any);
        }
        data["enterpriseId"] = this.enterpriseId;
        data["appId"] = this.appId;
        data["assetOwnershipId"] = this.assetOwnershipId;
        data["name"] = this.name;
        data["totalArea"] = this.totalArea;
        data["displayId"] = this.displayId;
        data["countryId"] = this.countryId;
        data["regionId"] = this.regionId;
        data["stateId"] = this.stateId;
        data["cityId"] = this.cityId;
        data["districtId"] = this.districtId;
        data["villageId"] = this.villageId;
        data["timeZoneId"] = this.timeZoneId;
        data["weatherSpotId"] = this.weatherSpotId;
        data["kmlData"] = this.kmlData;
        data["parcelInquiryData"] = this.parcelInquiryData ? this.parcelInquiryData.toJSON() : undefined as any;
        data["location"] = this.location;
        data["isActive"] = this.isActive;
        data["isDeleted"] = this.isDeleted;
        data["isAnonymized"] = this.isAnonymized;
        data["note"] = this.note;
        return data;
    }
}


export interface ICreateLandCommand {
    coordinates: PolygonItem[] | undefined;
    enterpriseId: string;
    appId: string;
    assetOwnershipId: string;
    name: string | undefined;
    totalArea: number | undefined;
    displayId: number | undefined;
    countryId: string | undefined;
    regionId: string | undefined;
    stateId: string | undefined;
    cityId: string | undefined;
    districtId: string | undefined;
    villageId: string | undefined;
    timeZoneId: string | undefined;
    weatherSpotId: string | undefined;
    kmlData: string | undefined;
    parcelInquiryData: ParcelInquiryDataDto;
    location: string | undefined;
    isActive: boolean;
    isDeleted: boolean;
    isAnonymized: boolean;
    note: string | undefined;
}


export class CreateLandPlantationDto implements ICreateLandPlantationDto {
    name!: string | undefined;
    cropId!: string;
    coordinates!: PolygonItem[] | undefined;

    constructor(data?: ICreateLandPlantationDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.name = _data["name"];
            this.cropId = _data["cropId"];
            if (Array.isArray(_data["coordinates"])) {
                this.coordinates = [] as any;
                for (let item of _data["coordinates"])
                    this.coordinates!.push(PolygonItem.fromJS(item));
            }
        }
    }

    static fromJS(data: any): CreateLandPlantationDto {
        data = typeof data === 'object' ? data : {};
        let result = new CreateLandPlantationDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["name"] = this.name;
        data["cropId"] = this.cropId;
        if (Array.isArray(this.coordinates)) {
            data["coordinates"] = [];
            for (let item of this.coordinates)
                data["coordinates"].push(item ? item.toJSON() : undefined as any);
        }
        return data;
    }
}


export interface ICreateLandPlantationDto {
    name: string | undefined;
    cropId: string;
    coordinates: PolygonItem[] | undefined;
}


export class CreateLandWithPlantationCommand implements ICreateLandWithPlantationCommand {
    coordinates!: PolygonItem[] | undefined;
    enterpriseId!: string;
    assetOwnershipId!: string;
    name!: string | undefined;
    kmlData!: string | undefined;
    parcelInquiryData!: ParcelInquiryDataDto;
    regenerativePracticeIds!: string[] | undefined;
    plantation!: CreateLandPlantationDto[] | undefined;

    constructor(data?: ICreateLandWithPlantationCommand) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["coordinates"])) {
                this.coordinates = [] as any;
                for (let item of _data["coordinates"])
                    this.coordinates!.push(PolygonItem.fromJS(item));
            }
            this.enterpriseId = _data["enterpriseId"];
            this.assetOwnershipId = _data["assetOwnershipId"];
            this.name = _data["name"];
            this.kmlData = _data["kmlData"];
            this.parcelInquiryData = _data["parcelInquiryData"] ? ParcelInquiryDataDto.fromJS(_data["parcelInquiryData"]) : undefined as any;
            if (Array.isArray(_data["regenerativePracticeIds"])) {
                this.regenerativePracticeIds = [] as any;
                for (let item of _data["regenerativePracticeIds"])
                    this.regenerativePracticeIds!.push(item);
            }
            if (Array.isArray(_data["plantation"])) {
                this.plantation = [] as any;
                for (let item of _data["plantation"])
                    this.plantation!.push(CreateLandPlantationDto.fromJS(item));
            }
        }
    }

    static fromJS(data: any): CreateLandWithPlantationCommand {
        data = typeof data === 'object' ? data : {};
        let result = new CreateLandWithPlantationCommand();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.coordinates)) {
            data["coordinates"] = [];
            for (let item of this.coordinates)
                data["coordinates"].push(item ? item.toJSON() : undefined as any);
        }
        data["enterpriseId"] = this.enterpriseId;
        data["assetOwnershipId"] = this.assetOwnershipId;
        data["name"] = this.name;
        data["kmlData"] = this.kmlData;
        data["parcelInquiryData"] = this.parcelInquiryData ? this.parcelInquiryData.toJSON() : undefined as any;
        if (Array.isArray(this.regenerativePracticeIds)) {
            data["regenerativePracticeIds"] = [];
            for (let item of this.regenerativePracticeIds)
                data["regenerativePracticeIds"].push(item);
        }
        if (Array.isArray(this.plantation)) {
            data["plantation"] = [];
            for (let item of this.plantation)
                data["plantation"].push(item ? item.toJSON() : undefined as any);
        }
        return data;
    }
}


export interface ICreateLandWithPlantationCommand {
    coordinates: PolygonItem[] | undefined;
    enterpriseId: string;
    assetOwnershipId: string;
    name: string | undefined;
    kmlData: string | undefined;
    parcelInquiryData: ParcelInquiryDataDto;
    regenerativePracticeIds: string[] | undefined;
    plantation: CreateLandPlantationDto[] | undefined;
}


export class CreateLayerCommand implements ICreateLayerCommand {
    layerName!: string | undefined;
    note!: string | undefined;
    isActive!: boolean;
    countryId!: number;
    yearData!: CropMapYearDataViewModel[] | undefined;
    latitude!: CropMapCoordinatesViewModel;
    longitude!: CropMapCoordinatesViewModel;

    constructor(data?: ICreateLayerCommand) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.layerName = _data["layerName"];
            this.note = _data["note"];
            this.isActive = _data["isActive"];
            this.countryId = _data["countryId"];
            if (Array.isArray(_data["yearData"])) {
                this.yearData = [] as any;
                for (let item of _data["yearData"])
                    this.yearData!.push(CropMapYearDataViewModel.fromJS(item));
            }
            this.latitude = _data["latitude"] ? CropMapCoordinatesViewModel.fromJS(_data["latitude"]) : undefined as any;
            this.longitude = _data["longitude"] ? CropMapCoordinatesViewModel.fromJS(_data["longitude"]) : undefined as any;
        }
    }

    static fromJS(data: any): CreateLayerCommand {
        data = typeof data === 'object' ? data : {};
        let result = new CreateLayerCommand();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["layerName"] = this.layerName;
        data["note"] = this.note;
        data["isActive"] = this.isActive;
        data["countryId"] = this.countryId;
        if (Array.isArray(this.yearData)) {
            data["yearData"] = [];
            for (let item of this.yearData)
                data["yearData"].push(item ? item.toJSON() : undefined as any);
        }
        data["latitude"] = this.latitude ? this.latitude.toJSON() : undefined as any;
        data["longitude"] = this.longitude ? this.longitude.toJSON() : undefined as any;
        return data;
    }
}


export interface ICreateLayerCommand {
    layerName: string | undefined;
    note: string | undefined;
    isActive: boolean;
    countryId: number;
    yearData: CropMapYearDataViewModel[] | undefined;
    latitude: CropMapCoordinatesViewModel;
    longitude: CropMapCoordinatesViewModel;
}


export class CreateOTPResult implements ICreateOTPResult {
    otpId!: number;
    sendToType!: string | undefined;
    sendToValue!: string | undefined;
    validUntil!: DateTime;
    method!: string | undefined;
    otpRequired!: boolean;

    constructor(data?: ICreateOTPResult) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.otpId = _data["otpId"];
            this.sendToType = _data["sendToType"];
            this.sendToValue = _data["sendToValue"];
            this.validUntil = _data["validUntil"] ? DateTime.fromISO(_data["validUntil"].toString()) : undefined as any;
            this.method = _data["method"];
            this.otpRequired = _data["otpRequired"];
        }
    }

    static fromJS(data: any): CreateOTPResult {
        data = typeof data === 'object' ? data : {};
        let result = new CreateOTPResult();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["otpId"] = this.otpId;
        data["sendToType"] = this.sendToType;
        data["sendToValue"] = this.sendToValue;
        data["validUntil"] = this.validUntil ? this.validUntil.toString() : undefined as any;
        data["method"] = this.method;
        data["otpRequired"] = this.otpRequired;
        return data;
    }
}


export interface ICreateOTPResult {
    otpId: number;
    sendToType: string | undefined;
    sendToValue: string | undefined;
    validUntil: DateTime;
    method: string | undefined;
    otpRequired: boolean;
}


export class CreateOTPResultResponseResult implements ICreateOTPResultResponseResult {
    isSuccess!: boolean;
    statusCode!: number;
    result!: CreateOTPResult;
    errors!: ErrorMessage[] | undefined;
    version!: string | undefined;
    environment!: string | undefined;

    constructor(data?: ICreateOTPResultResponseResult) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.isSuccess = _data["isSuccess"];
            this.statusCode = _data["statusCode"];
            this.result = _data["result"] ? CreateOTPResult.fromJS(_data["result"]) : undefined as any;
            if (Array.isArray(_data["errors"])) {
                this.errors = [] as any;
                for (let item of _data["errors"])
                    this.errors!.push(ErrorMessage.fromJS(item));
            }
            this.version = _data["version"];
            this.environment = _data["environment"];
        }
    }

    static fromJS(data: any): CreateOTPResultResponseResult {
        data = typeof data === 'object' ? data : {};
        let result = new CreateOTPResultResponseResult();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["isSuccess"] = this.isSuccess;
        data["statusCode"] = this.statusCode;
        data["result"] = this.result ? this.result.toJSON() : undefined as any;
        if (Array.isArray(this.errors)) {
            data["errors"] = [];
            for (let item of this.errors)
                data["errors"].push(item ? item.toJSON() : undefined as any);
        }
        data["version"] = this.version;
        data["environment"] = this.environment;
        return data;
    }
}


export interface ICreateOTPResultResponseResult {
    isSuccess: boolean;
    statusCode: number;
    result: CreateOTPResult;
    errors: ErrorMessage[] | undefined;
    version: string | undefined;
    environment: string | undefined;
}


export class CreateRoleCommand implements ICreateRoleCommand {
    name!: string | undefined;
    roleKind!: string | undefined;
    description!: string | undefined;
    enterpriseId!: string | undefined;
    permissions!: string[] | undefined;

    constructor(data?: ICreateRoleCommand) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.name = _data["name"];
            this.roleKind = _data["roleKind"];
            this.description = _data["description"];
            this.enterpriseId = _data["enterpriseId"];
            if (Array.isArray(_data["permissions"])) {
                this.permissions = [] as any;
                for (let item of _data["permissions"])
                    this.permissions!.push(item);
            }
        }
    }

    static fromJS(data: any): CreateRoleCommand {
        data = typeof data === 'object' ? data : {};
        let result = new CreateRoleCommand();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["name"] = this.name;
        data["roleKind"] = this.roleKind;
        data["description"] = this.description;
        data["enterpriseId"] = this.enterpriseId;
        if (Array.isArray(this.permissions)) {
            data["permissions"] = [];
            for (let item of this.permissions)
                data["permissions"].push(item);
        }
        return data;
    }
}


export interface ICreateRoleCommand {
    name: string | undefined;
    roleKind: string | undefined;
    description: string | undefined;
    enterpriseId: string | undefined;
    permissions: string[] | undefined;
}


export class CreateUserCommand implements ICreateUserCommand {
    appId!: string;
    customerId!: string;
    userTypeId!: string;
    phoneCode!: string | undefined;
    phone!: string | undefined;
    email!: string | undefined;
    password!: string | undefined;
    name!: string | undefined;
    surname!: string | undefined;
    enterpriseId!: string | undefined;
    countryId!: string | undefined;
    timezoneId!: string | undefined;
    note!: string | undefined;

    constructor(data?: ICreateUserCommand) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.appId = _data["appId"];
            this.customerId = _data["customerId"];
            this.userTypeId = _data["userTypeId"];
            this.phoneCode = _data["phoneCode"];
            this.phone = _data["phone"];
            this.email = _data["email"];
            this.password = _data["password"];
            this.name = _data["name"];
            this.surname = _data["surname"];
            this.enterpriseId = _data["enterpriseId"];
            this.countryId = _data["countryId"];
            this.timezoneId = _data["timezoneId"];
            this.note = _data["note"];
        }
    }

    static fromJS(data: any): CreateUserCommand {
        data = typeof data === 'object' ? data : {};
        let result = new CreateUserCommand();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["appId"] = this.appId;
        data["customerId"] = this.customerId;
        data["userTypeId"] = this.userTypeId;
        data["phoneCode"] = this.phoneCode;
        data["phone"] = this.phone;
        data["email"] = this.email;
        data["password"] = this.password;
        data["name"] = this.name;
        data["surname"] = this.surname;
        data["enterpriseId"] = this.enterpriseId;
        data["countryId"] = this.countryId;
        data["timezoneId"] = this.timezoneId;
        data["note"] = this.note;
        return data;
    }
}


export interface ICreateUserCommand {
    appId: string;
    customerId: string;
    userTypeId: string;
    phoneCode: string | undefined;
    phone: string | undefined;
    email: string | undefined;
    password: string | undefined;
    name: string | undefined;
    surname: string | undefined;
    enterpriseId: string | undefined;
    countryId: string | undefined;
    timezoneId: string | undefined;
    note: string | undefined;
}


export class CrmViewModel implements ICrmViewModel {
    id!: number;
    fieldId!: string | undefined;
    lat!: number;
    lng!: number;
    year!: number;
    nameSurname!: string | undefined;
    phoneNumber!: string | undefined;
    mail!: string | undefined;
    protectionBrands!: number[] | undefined;
    protectionDecisions!: number[] | undefined;
    fertilizerBrands!: number[] | undefined;
    fertilizerDecisions!: number[] | undefined;
    seedBrands!: number[] | undefined;
    seedDecisions!: number[] | undefined;
    usingBiologicalAgents!: number | undefined;
    cropName!: string | undefined;
    cityName!: string | undefined;
    districtName!: string | undefined;
    editedBy!: string | undefined;

    constructor(data?: ICrmViewModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.fieldId = _data["fieldId"];
            this.lat = _data["lat"];
            this.lng = _data["lng"];
            this.year = _data["year"];
            this.nameSurname = _data["nameSurname"];
            this.phoneNumber = _data["phoneNumber"];
            this.mail = _data["mail"];
            if (Array.isArray(_data["protectionBrands"])) {
                this.protectionBrands = [] as any;
                for (let item of _data["protectionBrands"])
                    this.protectionBrands!.push(item);
            }
            if (Array.isArray(_data["protectionDecisions"])) {
                this.protectionDecisions = [] as any;
                for (let item of _data["protectionDecisions"])
                    this.protectionDecisions!.push(item);
            }
            if (Array.isArray(_data["fertilizerBrands"])) {
                this.fertilizerBrands = [] as any;
                for (let item of _data["fertilizerBrands"])
                    this.fertilizerBrands!.push(item);
            }
            if (Array.isArray(_data["fertilizerDecisions"])) {
                this.fertilizerDecisions = [] as any;
                for (let item of _data["fertilizerDecisions"])
                    this.fertilizerDecisions!.push(item);
            }
            if (Array.isArray(_data["seedBrands"])) {
                this.seedBrands = [] as any;
                for (let item of _data["seedBrands"])
                    this.seedBrands!.push(item);
            }
            if (Array.isArray(_data["seedDecisions"])) {
                this.seedDecisions = [] as any;
                for (let item of _data["seedDecisions"])
                    this.seedDecisions!.push(item);
            }
            this.usingBiologicalAgents = _data["usingBiologicalAgents"];
            this.cropName = _data["cropName"];
            this.cityName = _data["cityName"];
            this.districtName = _data["districtName"];
            this.editedBy = _data["editedBy"];
        }
    }

    static fromJS(data: any): CrmViewModel {
        data = typeof data === 'object' ? data : {};
        let result = new CrmViewModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["fieldId"] = this.fieldId;
        data["lat"] = this.lat;
        data["lng"] = this.lng;
        data["year"] = this.year;
        data["nameSurname"] = this.nameSurname;
        data["phoneNumber"] = this.phoneNumber;
        data["mail"] = this.mail;
        if (Array.isArray(this.protectionBrands)) {
            data["protectionBrands"] = [];
            for (let item of this.protectionBrands)
                data["protectionBrands"].push(item);
        }
        if (Array.isArray(this.protectionDecisions)) {
            data["protectionDecisions"] = [];
            for (let item of this.protectionDecisions)
                data["protectionDecisions"].push(item);
        }
        if (Array.isArray(this.fertilizerBrands)) {
            data["fertilizerBrands"] = [];
            for (let item of this.fertilizerBrands)
                data["fertilizerBrands"].push(item);
        }
        if (Array.isArray(this.fertilizerDecisions)) {
            data["fertilizerDecisions"] = [];
            for (let item of this.fertilizerDecisions)
                data["fertilizerDecisions"].push(item);
        }
        if (Array.isArray(this.seedBrands)) {
            data["seedBrands"] = [];
            for (let item of this.seedBrands)
                data["seedBrands"].push(item);
        }
        if (Array.isArray(this.seedDecisions)) {
            data["seedDecisions"] = [];
            for (let item of this.seedDecisions)
                data["seedDecisions"].push(item);
        }
        data["usingBiologicalAgents"] = this.usingBiologicalAgents;
        data["cropName"] = this.cropName;
        data["cityName"] = this.cityName;
        data["districtName"] = this.districtName;
        data["editedBy"] = this.editedBy;
        return data;
    }
}


export interface ICrmViewModel {
    id: number;
    fieldId: string | undefined;
    lat: number;
    lng: number;
    year: number;
    nameSurname: string | undefined;
    phoneNumber: string | undefined;
    mail: string | undefined;
    protectionBrands: number[] | undefined;
    protectionDecisions: number[] | undefined;
    fertilizerBrands: number[] | undefined;
    fertilizerDecisions: number[] | undefined;
    seedBrands: number[] | undefined;
    seedDecisions: number[] | undefined;
    usingBiologicalAgents: number | undefined;
    cropName: string | undefined;
    cityName: string | undefined;
    districtName: string | undefined;
    editedBy: string | undefined;
}


export class CrmViewModelListResponseResult implements ICrmViewModelListResponseResult {
    isSuccess!: boolean;
    statusCode!: number;
    result!: CrmViewModel[] | undefined;
    errors!: ErrorMessage[] | undefined;
    version!: string | undefined;
    environment!: string | undefined;

    constructor(data?: ICrmViewModelListResponseResult) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.isSuccess = _data["isSuccess"];
            this.statusCode = _data["statusCode"];
            if (Array.isArray(_data["result"])) {
                this.result = [] as any;
                for (let item of _data["result"])
                    this.result!.push(CrmViewModel.fromJS(item));
            }
            if (Array.isArray(_data["errors"])) {
                this.errors = [] as any;
                for (let item of _data["errors"])
                    this.errors!.push(ErrorMessage.fromJS(item));
            }
            this.version = _data["version"];
            this.environment = _data["environment"];
        }
    }

    static fromJS(data: any): CrmViewModelListResponseResult {
        data = typeof data === 'object' ? data : {};
        let result = new CrmViewModelListResponseResult();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["isSuccess"] = this.isSuccess;
        data["statusCode"] = this.statusCode;
        if (Array.isArray(this.result)) {
            data["result"] = [];
            for (let item of this.result)
                data["result"].push(item ? item.toJSON() : undefined as any);
        }
        if (Array.isArray(this.errors)) {
            data["errors"] = [];
            for (let item of this.errors)
                data["errors"].push(item ? item.toJSON() : undefined as any);
        }
        data["version"] = this.version;
        data["environment"] = this.environment;
        return data;
    }
}


export interface ICrmViewModelListResponseResult {
    isSuccess: boolean;
    statusCode: number;
    result: CrmViewModel[] | undefined;
    errors: ErrorMessage[] | undefined;
    version: string | undefined;
    environment: string | undefined;
}


export class CropAreaPlantationReportRowViewModel implements ICropAreaPlantationReportRowViewModel {
    year!: number;
    seasonId!: string;
    seasonName!: string | undefined;
    cropId!: string | undefined;
    cropName!: string | undefined;
    totalArea!: number | undefined;
    district!: GeoUnitSummaryViewModel;
    city!: GeoUnitSummaryViewModel;
    regionOrState!: GeoUnitSummaryViewModel;
    country!: GeoUnitSummaryViewModel;
    cityRepresentative!: GeoRepresentativeInfoViewModel;
    regionRepresentative!: GeoRepresentativeInfoViewModel;

    constructor(data?: ICropAreaPlantationReportRowViewModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
        if (!data) {
            this.district = new GeoUnitSummaryViewModel();
        }
    }

    init(_data?: any) {
        if (_data) {
            this.year = _data["year"];
            this.seasonId = _data["seasonId"];
            this.seasonName = _data["seasonName"];
            this.cropId = _data["cropId"];
            this.cropName = _data["cropName"];
            this.totalArea = _data["totalArea"];
            this.district = _data["district"] ? GeoUnitSummaryViewModel.fromJS(_data["district"]) : new GeoUnitSummaryViewModel();
            this.city = _data["city"] ? GeoUnitSummaryViewModel.fromJS(_data["city"]) : undefined as any;
            this.regionOrState = _data["regionOrState"] ? GeoUnitSummaryViewModel.fromJS(_data["regionOrState"]) : undefined as any;
            this.country = _data["country"] ? GeoUnitSummaryViewModel.fromJS(_data["country"]) : undefined as any;
            this.cityRepresentative = _data["cityRepresentative"] ? GeoRepresentativeInfoViewModel.fromJS(_data["cityRepresentative"]) : undefined as any;
            this.regionRepresentative = _data["regionRepresentative"] ? GeoRepresentativeInfoViewModel.fromJS(_data["regionRepresentative"]) : undefined as any;
        }
    }

    static fromJS(data: any): CropAreaPlantationReportRowViewModel {
        data = typeof data === 'object' ? data : {};
        let result = new CropAreaPlantationReportRowViewModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["year"] = this.year;
        data["seasonId"] = this.seasonId;
        data["seasonName"] = this.seasonName;
        data["cropId"] = this.cropId;
        data["cropName"] = this.cropName;
        data["totalArea"] = this.totalArea;
        data["district"] = this.district ? this.district.toJSON() : undefined as any;
        data["city"] = this.city ? this.city.toJSON() : undefined as any;
        data["regionOrState"] = this.regionOrState ? this.regionOrState.toJSON() : undefined as any;
        data["country"] = this.country ? this.country.toJSON() : undefined as any;
        data["cityRepresentative"] = this.cityRepresentative ? this.cityRepresentative.toJSON() : undefined as any;
        data["regionRepresentative"] = this.regionRepresentative ? this.regionRepresentative.toJSON() : undefined as any;
        return data;
    }
}


export interface ICropAreaPlantationReportRowViewModel {
    year: number;
    seasonId: string;
    seasonName: string | undefined;
    cropId: string | undefined;
    cropName: string | undefined;
    totalArea: number | undefined;
    district: GeoUnitSummaryViewModel;
    city: GeoUnitSummaryViewModel;
    regionOrState: GeoUnitSummaryViewModel;
    country: GeoUnitSummaryViewModel;
    cityRepresentative: GeoRepresentativeInfoViewModel;
    regionRepresentative: GeoRepresentativeInfoViewModel;
}


export class CropAreaPlantationReportRowViewModelListResponseResult implements ICropAreaPlantationReportRowViewModelListResponseResult {
    isSuccess!: boolean;
    statusCode!: number;
    result!: CropAreaPlantationReportRowViewModel[] | undefined;
    errors!: ErrorMessage[] | undefined;
    version!: string | undefined;
    environment!: string | undefined;

    constructor(data?: ICropAreaPlantationReportRowViewModelListResponseResult) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.isSuccess = _data["isSuccess"];
            this.statusCode = _data["statusCode"];
            if (Array.isArray(_data["result"])) {
                this.result = [] as any;
                for (let item of _data["result"])
                    this.result!.push(CropAreaPlantationReportRowViewModel.fromJS(item));
            }
            if (Array.isArray(_data["errors"])) {
                this.errors = [] as any;
                for (let item of _data["errors"])
                    this.errors!.push(ErrorMessage.fromJS(item));
            }
            this.version = _data["version"];
            this.environment = _data["environment"];
        }
    }

    static fromJS(data: any): CropAreaPlantationReportRowViewModelListResponseResult {
        data = typeof data === 'object' ? data : {};
        let result = new CropAreaPlantationReportRowViewModelListResponseResult();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["isSuccess"] = this.isSuccess;
        data["statusCode"] = this.statusCode;
        if (Array.isArray(this.result)) {
            data["result"] = [];
            for (let item of this.result)
                data["result"].push(item ? item.toJSON() : undefined as any);
        }
        if (Array.isArray(this.errors)) {
            data["errors"] = [];
            for (let item of this.errors)
                data["errors"].push(item ? item.toJSON() : undefined as any);
        }
        data["version"] = this.version;
        data["environment"] = this.environment;
        return data;
    }
}


export interface ICropAreaPlantationReportRowViewModelListResponseResult {
    isSuccess: boolean;
    statusCode: number;
    result: CropAreaPlantationReportRowViewModel[] | undefined;
    errors: ErrorMessage[] | undefined;
    version: string | undefined;
    environment: string | undefined;
}


export class CropMapAccessRoleItemViewModel implements ICropMapAccessRoleItemViewModel {
    id!: string;
    name!: string | undefined;

    constructor(data?: ICropMapAccessRoleItemViewModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.name = _data["name"];
        }
    }

    static fromJS(data: any): CropMapAccessRoleItemViewModel {
        data = typeof data === 'object' ? data : {};
        let result = new CropMapAccessRoleItemViewModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["name"] = this.name;
        return data;
    }
}


export interface ICropMapAccessRoleItemViewModel {
    id: string;
    name: string | undefined;
}


export class CropMapBoundaryLayerViewModel implements ICropMapBoundaryLayerViewModel {
    layerName!: string | undefined;
    url!: string | undefined;
    property!: string | undefined;
    layerType!: string | undefined;

    constructor(data?: ICropMapBoundaryLayerViewModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.layerName = _data["layerName"];
            this.url = _data["url"];
            this.property = _data["property"];
            this.layerType = _data["layerType"];
        }
    }

    static fromJS(data: any): CropMapBoundaryLayerViewModel {
        data = typeof data === 'object' ? data : {};
        let result = new CropMapBoundaryLayerViewModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["layerName"] = this.layerName;
        data["url"] = this.url;
        data["property"] = this.property;
        data["layerType"] = this.layerType;
        return data;
    }
}


export interface ICropMapBoundaryLayerViewModel {
    layerName: string | undefined;
    url: string | undefined;
    property: string | undefined;
    layerType: string | undefined;
}


export class CropMapCoordinatesViewModel implements ICropMapCoordinatesViewModel {
    min!: number;
    max!: number;

    constructor(data?: ICropMapCoordinatesViewModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.min = _data["min"];
            this.max = _data["max"];
        }
    }

    static fromJS(data: any): CropMapCoordinatesViewModel {
        data = typeof data === 'object' ? data : {};
        let result = new CropMapCoordinatesViewModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["min"] = this.min;
        data["max"] = this.max;
        return data;
    }
}


export interface ICropMapCoordinatesViewModel {
    min: number;
    max: number;
}


export class CropMapCropViewModel implements ICropMapCropViewModel {
    id!: number | undefined;
    name!: string | undefined;
    color!: string | undefined;
    seasonId!: number | undefined;
    dataScienceId!: number | undefined;

    constructor(data?: ICropMapCropViewModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.name = _data["name"];
            this.color = _data["color"];
            this.seasonId = _data["seasonId"];
            this.dataScienceId = _data["dataScienceId"];
        }
    }

    static fromJS(data: any): CropMapCropViewModel {
        data = typeof data === 'object' ? data : {};
        let result = new CropMapCropViewModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["name"] = this.name;
        data["color"] = this.color;
        data["seasonId"] = this.seasonId;
        data["dataScienceId"] = this.dataScienceId;
        return data;
    }
}


export interface ICropMapCropViewModel {
    id: number | undefined;
    name: string | undefined;
    color: string | undefined;
    seasonId: number | undefined;
    dataScienceId: number | undefined;
}


export class CropMapEnterpiseListViewModel implements ICropMapEnterpiseListViewModel {
    enterpriseId!: string;
    ownerId!: string;
    hasCropMapAccess!: boolean;
    name!: string | undefined;
    description!: string | undefined;
    cropMapRoleId!: string | undefined;
    cropMapPermissionId!: string | undefined;
    contactPerson!: string | undefined;
    contactEmail!: string | undefined;
    contactPhone!: string | undefined;
    address!: string | undefined;
    userRole!: string | undefined;

    constructor(data?: ICropMapEnterpiseListViewModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.enterpriseId = _data["enterpriseId"];
            this.ownerId = _data["ownerId"];
            this.hasCropMapAccess = _data["hasCropMapAccess"];
            this.name = _data["name"];
            this.description = _data["description"];
            this.cropMapRoleId = _data["cropMapRoleId"];
            this.cropMapPermissionId = _data["cropMapPermissionId"];
            this.contactPerson = _data["contactPerson"];
            this.contactEmail = _data["contactEmail"];
            this.contactPhone = _data["contactPhone"];
            this.address = _data["address"];
            this.userRole = _data["userRole"];
        }
    }

    static fromJS(data: any): CropMapEnterpiseListViewModel {
        data = typeof data === 'object' ? data : {};
        let result = new CropMapEnterpiseListViewModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["enterpriseId"] = this.enterpriseId;
        data["ownerId"] = this.ownerId;
        data["hasCropMapAccess"] = this.hasCropMapAccess;
        data["name"] = this.name;
        data["description"] = this.description;
        data["cropMapRoleId"] = this.cropMapRoleId;
        data["cropMapPermissionId"] = this.cropMapPermissionId;
        data["contactPerson"] = this.contactPerson;
        data["contactEmail"] = this.contactEmail;
        data["contactPhone"] = this.contactPhone;
        data["address"] = this.address;
        data["userRole"] = this.userRole;
        return data;
    }
}


export interface ICropMapEnterpiseListViewModel {
    enterpriseId: string;
    ownerId: string;
    hasCropMapAccess: boolean;
    name: string | undefined;
    description: string | undefined;
    cropMapRoleId: string | undefined;
    cropMapPermissionId: string | undefined;
    contactPerson: string | undefined;
    contactEmail: string | undefined;
    contactPhone: string | undefined;
    address: string | undefined;
    userRole: string | undefined;
}


export class CropMapFieldLayerDetailViewModel implements ICropMapFieldLayerDetailViewModel {
    layerName!: string | undefined;
    url!: string | undefined;
    property!: string | undefined;

    constructor(data?: ICropMapFieldLayerDetailViewModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.layerName = _data["layerName"];
            this.url = _data["url"];
            this.property = _data["property"];
        }
    }

    static fromJS(data: any): CropMapFieldLayerDetailViewModel {
        data = typeof data === 'object' ? data : {};
        let result = new CropMapFieldLayerDetailViewModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["layerName"] = this.layerName;
        data["url"] = this.url;
        data["property"] = this.property;
        return data;
    }
}


export interface ICropMapFieldLayerDetailViewModel {
    layerName: string | undefined;
    url: string | undefined;
    property: string | undefined;
}


export class CropMapFieldLayerViewModel implements ICropMapFieldLayerViewModel {
    cityProperty!: string | undefined;
    districtProperty!: string | undefined;
    fieldLayerDetails!: CropMapFieldLayerDetailViewModel[] | undefined;

    constructor(data?: ICropMapFieldLayerViewModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.cityProperty = _data["cityProperty"];
            this.districtProperty = _data["districtProperty"];
            if (Array.isArray(_data["fieldLayerDetails"])) {
                this.fieldLayerDetails = [] as any;
                for (let item of _data["fieldLayerDetails"])
                    this.fieldLayerDetails!.push(CropMapFieldLayerDetailViewModel.fromJS(item));
            }
        }
    }

    static fromJS(data: any): CropMapFieldLayerViewModel {
        data = typeof data === 'object' ? data : {};
        let result = new CropMapFieldLayerViewModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["cityProperty"] = this.cityProperty;
        data["districtProperty"] = this.districtProperty;
        if (Array.isArray(this.fieldLayerDetails)) {
            data["fieldLayerDetails"] = [];
            for (let item of this.fieldLayerDetails)
                data["fieldLayerDetails"].push(item ? item.toJSON() : undefined as any);
        }
        return data;
    }
}


export interface ICropMapFieldLayerViewModel {
    cityProperty: string | undefined;
    districtProperty: string | undefined;
    fieldLayerDetails: CropMapFieldLayerDetailViewModel[] | undefined;
}


export class CropMapGeometryTKGM implements ICropMapGeometryTKGM {
    type!: string | undefined;
    coordinates!: number[][][] | undefined;

    constructor(data?: ICropMapGeometryTKGM) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.type = _data["type"];
            if (Array.isArray(_data["coordinates"])) {
                this.coordinates = [] as any;
                for (let item of _data["coordinates"])
                    this.coordinates!.push(item);
            }
        }
    }

    static fromJS(data: any): CropMapGeometryTKGM {
        data = typeof data === 'object' ? data : {};
        let result = new CropMapGeometryTKGM();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["type"] = this.type;
        if (Array.isArray(this.coordinates)) {
            data["coordinates"] = [];
            for (let item of this.coordinates)
                data["coordinates"].push(item);
        }
        return data;
    }
}


export interface ICropMapGeometryTKGM {
    type: string | undefined;
    coordinates: number[][][] | undefined;
}


export class CropMapLayerViewModel implements ICropMapLayerViewModel {
    id!: number;
    layerName!: string | undefined;
    note!: string | undefined;
    isActive!: boolean;
    countryId!: number;
    yearData!: CropMapYearDataViewModel[] | undefined;
    latitude!: CropMapCoordinatesViewModel;
    longitude!: CropMapCoordinatesViewModel;

    constructor(data?: ICropMapLayerViewModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.layerName = _data["layerName"];
            this.note = _data["note"];
            this.isActive = _data["isActive"];
            this.countryId = _data["countryId"];
            if (Array.isArray(_data["yearData"])) {
                this.yearData = [] as any;
                for (let item of _data["yearData"])
                    this.yearData!.push(CropMapYearDataViewModel.fromJS(item));
            }
            this.latitude = _data["latitude"] ? CropMapCoordinatesViewModel.fromJS(_data["latitude"]) : undefined as any;
            this.longitude = _data["longitude"] ? CropMapCoordinatesViewModel.fromJS(_data["longitude"]) : undefined as any;
        }
    }

    static fromJS(data: any): CropMapLayerViewModel {
        data = typeof data === 'object' ? data : {};
        let result = new CropMapLayerViewModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["layerName"] = this.layerName;
        data["note"] = this.note;
        data["isActive"] = this.isActive;
        data["countryId"] = this.countryId;
        if (Array.isArray(this.yearData)) {
            data["yearData"] = [];
            for (let item of this.yearData)
                data["yearData"].push(item ? item.toJSON() : undefined as any);
        }
        data["latitude"] = this.latitude ? this.latitude.toJSON() : undefined as any;
        data["longitude"] = this.longitude ? this.longitude.toJSON() : undefined as any;
        return data;
    }
}


export interface ICropMapLayerViewModel {
    id: number;
    layerName: string | undefined;
    note: string | undefined;
    isActive: boolean;
    countryId: number;
    yearData: CropMapYearDataViewModel[] | undefined;
    latitude: CropMapCoordinatesViewModel;
    longitude: CropMapCoordinatesViewModel;
}


export class CropMapLayerViewModelListResponseResult implements ICropMapLayerViewModelListResponseResult {
    isSuccess!: boolean;
    statusCode!: number;
    result!: CropMapLayerViewModel[] | undefined;
    errors!: ErrorMessage[] | undefined;
    version!: string | undefined;
    environment!: string | undefined;

    constructor(data?: ICropMapLayerViewModelListResponseResult) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.isSuccess = _data["isSuccess"];
            this.statusCode = _data["statusCode"];
            if (Array.isArray(_data["result"])) {
                this.result = [] as any;
                for (let item of _data["result"])
                    this.result!.push(CropMapLayerViewModel.fromJS(item));
            }
            if (Array.isArray(_data["errors"])) {
                this.errors = [] as any;
                for (let item of _data["errors"])
                    this.errors!.push(ErrorMessage.fromJS(item));
            }
            this.version = _data["version"];
            this.environment = _data["environment"];
        }
    }

    static fromJS(data: any): CropMapLayerViewModelListResponseResult {
        data = typeof data === 'object' ? data : {};
        let result = new CropMapLayerViewModelListResponseResult();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["isSuccess"] = this.isSuccess;
        data["statusCode"] = this.statusCode;
        if (Array.isArray(this.result)) {
            data["result"] = [];
            for (let item of this.result)
                data["result"].push(item ? item.toJSON() : undefined as any);
        }
        if (Array.isArray(this.errors)) {
            data["errors"] = [];
            for (let item of this.errors)
                data["errors"].push(item ? item.toJSON() : undefined as any);
        }
        data["version"] = this.version;
        data["environment"] = this.environment;
        return data;
    }
}


export interface ICropMapLayerViewModelListResponseResult {
    isSuccess: boolean;
    statusCode: number;
    result: CropMapLayerViewModel[] | undefined;
    errors: ErrorMessage[] | undefined;
    version: string | undefined;
    environment: string | undefined;
}


export class CropMapLocationCityResponse implements ICropMapLocationCityResponse {
    cityId!: number;
    name!: string | undefined;
    districts!: CropMapLocationDistrictResponse[] | undefined;

    constructor(data?: ICropMapLocationCityResponse) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.cityId = _data["cityId"];
            this.name = _data["name"];
            if (Array.isArray(_data["districts"])) {
                this.districts = [] as any;
                for (let item of _data["districts"])
                    this.districts!.push(CropMapLocationDistrictResponse.fromJS(item));
            }
        }
    }

    static fromJS(data: any): CropMapLocationCityResponse {
        data = typeof data === 'object' ? data : {};
        let result = new CropMapLocationCityResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["cityId"] = this.cityId;
        data["name"] = this.name;
        if (Array.isArray(this.districts)) {
            data["districts"] = [];
            for (let item of this.districts)
                data["districts"].push(item ? item.toJSON() : undefined as any);
        }
        return data;
    }
}


export interface ICropMapLocationCityResponse {
    cityId: number;
    name: string | undefined;
    districts: CropMapLocationDistrictResponse[] | undefined;
}


export class CropMapLocationCountryResponse implements ICropMapLocationCountryResponse {
    countryId!: number;
    accessKey!: string | undefined;
    name!: string | undefined;
    states!: CropMapLocationStateResponse[] | undefined;
    regions!: CropMapLocationRegionResponse[] | undefined;

    constructor(data?: ICropMapLocationCountryResponse) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.countryId = _data["countryId"];
            this.accessKey = _data["accessKey"];
            this.name = _data["name"];
            if (Array.isArray(_data["states"])) {
                this.states = [] as any;
                for (let item of _data["states"])
                    this.states!.push(CropMapLocationStateResponse.fromJS(item));
            }
            if (Array.isArray(_data["regions"])) {
                this.regions = [] as any;
                for (let item of _data["regions"])
                    this.regions!.push(CropMapLocationRegionResponse.fromJS(item));
            }
        }
    }

    static fromJS(data: any): CropMapLocationCountryResponse {
        data = typeof data === 'object' ? data : {};
        let result = new CropMapLocationCountryResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["countryId"] = this.countryId;
        data["accessKey"] = this.accessKey;
        data["name"] = this.name;
        if (Array.isArray(this.states)) {
            data["states"] = [];
            for (let item of this.states)
                data["states"].push(item ? item.toJSON() : undefined as any);
        }
        if (Array.isArray(this.regions)) {
            data["regions"] = [];
            for (let item of this.regions)
                data["regions"].push(item ? item.toJSON() : undefined as any);
        }
        return data;
    }
}


export interface ICropMapLocationCountryResponse {
    countryId: number;
    accessKey: string | undefined;
    name: string | undefined;
    states: CropMapLocationStateResponse[] | undefined;
    regions: CropMapLocationRegionResponse[] | undefined;
}


export class CropMapLocationDistrictResponse implements ICropMapLocationDistrictResponse {
    districtId!: number;
    name!: string | undefined;
    villages!: number[] | undefined;

    constructor(data?: ICropMapLocationDistrictResponse) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.districtId = _data["districtId"];
            this.name = _data["name"];
            if (Array.isArray(_data["villages"])) {
                this.villages = [] as any;
                for (let item of _data["villages"])
                    this.villages!.push(item);
            }
        }
    }

    static fromJS(data: any): CropMapLocationDistrictResponse {
        data = typeof data === 'object' ? data : {};
        let result = new CropMapLocationDistrictResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["districtId"] = this.districtId;
        data["name"] = this.name;
        if (Array.isArray(this.villages)) {
            data["villages"] = [];
            for (let item of this.villages)
                data["villages"].push(item);
        }
        return data;
    }
}


export interface ICropMapLocationDistrictResponse {
    districtId: number;
    name: string | undefined;
    villages: number[] | undefined;
}


export class CropMapLocationRegionResponse implements ICropMapLocationRegionResponse {
    regionId!: number;
    accessKey!: string | undefined;
    name!: string | undefined;
    states!: CropMapLocationStateResponse[] | undefined;
    cities!: CropMapLocationCityResponse[] | undefined;

    constructor(data?: ICropMapLocationRegionResponse) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.regionId = _data["regionId"];
            this.accessKey = _data["accessKey"];
            this.name = _data["name"];
            if (Array.isArray(_data["states"])) {
                this.states = [] as any;
                for (let item of _data["states"])
                    this.states!.push(CropMapLocationStateResponse.fromJS(item));
            }
            if (Array.isArray(_data["cities"])) {
                this.cities = [] as any;
                for (let item of _data["cities"])
                    this.cities!.push(CropMapLocationCityResponse.fromJS(item));
            }
        }
    }

    static fromJS(data: any): CropMapLocationRegionResponse {
        data = typeof data === 'object' ? data : {};
        let result = new CropMapLocationRegionResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["regionId"] = this.regionId;
        data["accessKey"] = this.accessKey;
        data["name"] = this.name;
        if (Array.isArray(this.states)) {
            data["states"] = [];
            for (let item of this.states)
                data["states"].push(item ? item.toJSON() : undefined as any);
        }
        if (Array.isArray(this.cities)) {
            data["cities"] = [];
            for (let item of this.cities)
                data["cities"].push(item ? item.toJSON() : undefined as any);
        }
        return data;
    }
}


export interface ICropMapLocationRegionResponse {
    regionId: number;
    accessKey: string | undefined;
    name: string | undefined;
    states: CropMapLocationStateResponse[] | undefined;
    cities: CropMapLocationCityResponse[] | undefined;
}


export class CropMapLocationStateResponse implements ICropMapLocationStateResponse {
    stateId!: number;
    accessKey!: string | undefined;
    name!: string | undefined;
    cities!: CropMapLocationCityResponse[] | undefined;

    constructor(data?: ICropMapLocationStateResponse) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.stateId = _data["stateId"];
            this.accessKey = _data["accessKey"];
            this.name = _data["name"];
            if (Array.isArray(_data["cities"])) {
                this.cities = [] as any;
                for (let item of _data["cities"])
                    this.cities!.push(CropMapLocationCityResponse.fromJS(item));
            }
        }
    }

    static fromJS(data: any): CropMapLocationStateResponse {
        data = typeof data === 'object' ? data : {};
        let result = new CropMapLocationStateResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["stateId"] = this.stateId;
        data["accessKey"] = this.accessKey;
        data["name"] = this.name;
        if (Array.isArray(this.cities)) {
            data["cities"] = [];
            for (let item of this.cities)
                data["cities"].push(item ? item.toJSON() : undefined as any);
        }
        return data;
    }
}


export interface ICropMapLocationStateResponse {
    stateId: number;
    accessKey: string | undefined;
    name: string | undefined;
    cities: CropMapLocationCityResponse[] | undefined;
}


export class CropMapParcelProperties implements ICropMapParcelProperties {
    ilceAd!: string | undefined;
    parselId!: number;
    zeminId!: string | undefined;
    parselNo!: string | undefined;
    nitelik!: string | undefined;
    mahalleAd!: string | undefined;
    alan!: string | undefined;
    adaNo!: string | undefined;
    ilAd!: string | undefined;

    constructor(data?: ICropMapParcelProperties) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.ilceAd = _data["ilceAd"];
            this.parselId = _data["parselId"];
            this.zeminId = _data["zeminId"];
            this.parselNo = _data["parselNo"];
            this.nitelik = _data["nitelik"];
            this.mahalleAd = _data["mahalleAd"];
            this.alan = _data["alan"];
            this.adaNo = _data["adaNo"];
            this.ilAd = _data["ilAd"];
        }
    }

    static fromJS(data: any): CropMapParcelProperties {
        data = typeof data === 'object' ? data : {};
        let result = new CropMapParcelProperties();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["ilceAd"] = this.ilceAd;
        data["parselId"] = this.parselId;
        data["zeminId"] = this.zeminId;
        data["parselNo"] = this.parselNo;
        data["nitelik"] = this.nitelik;
        data["mahalleAd"] = this.mahalleAd;
        data["alan"] = this.alan;
        data["adaNo"] = this.adaNo;
        data["ilAd"] = this.ilAd;
        return data;
    }
}


export interface ICropMapParcelProperties {
    ilceAd: string | undefined;
    parselId: number;
    zeminId: string | undefined;
    parselNo: string | undefined;
    nitelik: string | undefined;
    mahalleAd: string | undefined;
    alan: string | undefined;
    adaNo: string | undefined;
    ilAd: string | undefined;
}


export class CropMapParcelViewModel implements ICropMapParcelViewModel {
    type!: string | undefined;
    geometry!: CropMapGeometryTKGM;
    properties!: CropMapParcelProperties;

    constructor(data?: ICropMapParcelViewModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.type = _data["type"];
            this.geometry = _data["geometry"] ? CropMapGeometryTKGM.fromJS(_data["geometry"]) : undefined as any;
            this.properties = _data["properties"] ? CropMapParcelProperties.fromJS(_data["properties"]) : undefined as any;
        }
    }

    static fromJS(data: any): CropMapParcelViewModel {
        data = typeof data === 'object' ? data : {};
        let result = new CropMapParcelViewModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["type"] = this.type;
        data["geometry"] = this.geometry ? this.geometry.toJSON() : undefined as any;
        data["properties"] = this.properties ? this.properties.toJSON() : undefined as any;
        return data;
    }
}


export interface ICropMapParcelViewModel {
    type: string | undefined;
    geometry: CropMapGeometryTKGM;
    properties: CropMapParcelProperties;
}


export class CropMapSeasonViewModel implements ICropMapSeasonViewModel {
    id!: number;
    name!: string | undefined;

    constructor(data?: ICropMapSeasonViewModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.name = _data["name"];
        }
    }

    static fromJS(data: any): CropMapSeasonViewModel {
        data = typeof data === 'object' ? data : {};
        let result = new CropMapSeasonViewModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["name"] = this.name;
        return data;
    }
}


export interface ICropMapSeasonViewModel {
    id: number;
    name: string | undefined;
}


export class CropMapUserEnterpiseListViewModel implements ICropMapUserEnterpiseListViewModel {
    userId!: string;
    userName!: string | undefined;
    userSurname!: string | undefined;
    email!: string | undefined;
    phone!: string | undefined;
    enterprises!: CropMapEnterpiseListViewModel[] | undefined;

    constructor(data?: ICropMapUserEnterpiseListViewModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.userId = _data["userId"];
            this.userName = _data["userName"];
            this.userSurname = _data["userSurname"];
            this.email = _data["email"];
            this.phone = _data["phone"];
            if (Array.isArray(_data["enterprises"])) {
                this.enterprises = [] as any;
                for (let item of _data["enterprises"])
                    this.enterprises!.push(CropMapEnterpiseListViewModel.fromJS(item));
            }
        }
    }

    static fromJS(data: any): CropMapUserEnterpiseListViewModel {
        data = typeof data === 'object' ? data : {};
        let result = new CropMapUserEnterpiseListViewModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["userId"] = this.userId;
        data["userName"] = this.userName;
        data["userSurname"] = this.userSurname;
        data["email"] = this.email;
        data["phone"] = this.phone;
        if (Array.isArray(this.enterprises)) {
            data["enterprises"] = [];
            for (let item of this.enterprises)
                data["enterprises"].push(item ? item.toJSON() : undefined as any);
        }
        return data;
    }
}


export interface ICropMapUserEnterpiseListViewModel {
    userId: string;
    userName: string | undefined;
    userSurname: string | undefined;
    email: string | undefined;
    phone: string | undefined;
    enterprises: CropMapEnterpiseListViewModel[] | undefined;
}


export class CropMapUserEnterpiseListViewModelResponseResult implements ICropMapUserEnterpiseListViewModelResponseResult {
    isSuccess!: boolean;
    statusCode!: number;
    result!: CropMapUserEnterpiseListViewModel;
    errors!: ErrorMessage[] | undefined;
    version!: string | undefined;
    environment!: string | undefined;

    constructor(data?: ICropMapUserEnterpiseListViewModelResponseResult) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.isSuccess = _data["isSuccess"];
            this.statusCode = _data["statusCode"];
            this.result = _data["result"] ? CropMapUserEnterpiseListViewModel.fromJS(_data["result"]) : undefined as any;
            if (Array.isArray(_data["errors"])) {
                this.errors = [] as any;
                for (let item of _data["errors"])
                    this.errors!.push(ErrorMessage.fromJS(item));
            }
            this.version = _data["version"];
            this.environment = _data["environment"];
        }
    }

    static fromJS(data: any): CropMapUserEnterpiseListViewModelResponseResult {
        data = typeof data === 'object' ? data : {};
        let result = new CropMapUserEnterpiseListViewModelResponseResult();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["isSuccess"] = this.isSuccess;
        data["statusCode"] = this.statusCode;
        data["result"] = this.result ? this.result.toJSON() : undefined as any;
        if (Array.isArray(this.errors)) {
            data["errors"] = [];
            for (let item of this.errors)
                data["errors"].push(item ? item.toJSON() : undefined as any);
        }
        data["version"] = this.version;
        data["environment"] = this.environment;
        return data;
    }
}


export interface ICropMapUserEnterpiseListViewModelResponseResult {
    isSuccess: boolean;
    statusCode: number;
    result: CropMapUserEnterpiseListViewModel;
    errors: ErrorMessage[] | undefined;
    version: string | undefined;
    environment: string | undefined;
}


export class CropMapUserEnterpiseViewModel implements ICropMapUserEnterpiseViewModel {
    userId!: string;
    userName!: string | undefined;
    userSurname!: string | undefined;
    enterpriseId!: string;
    ownerId!: string;
    name!: string | undefined;
    description!: string | undefined;
    contactPerson!: string | undefined;
    contactEmail!: string | undefined;
    contactPhone!: string | undefined;
    address!: string | undefined;
    userRole!: string | undefined;
    userRoleDetails!: EnterpriseRoleDto;
    cropMapRoleId!: string | undefined;
    cropMapPermissionId!: string | undefined;

    constructor(data?: ICropMapUserEnterpiseViewModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.userId = _data["userId"];
            this.userName = _data["userName"];
            this.userSurname = _data["userSurname"];
            this.enterpriseId = _data["enterpriseId"];
            this.ownerId = _data["ownerId"];
            this.name = _data["name"];
            this.description = _data["description"];
            this.contactPerson = _data["contactPerson"];
            this.contactEmail = _data["contactEmail"];
            this.contactPhone = _data["contactPhone"];
            this.address = _data["address"];
            this.userRole = _data["userRole"];
            this.userRoleDetails = _data["userRoleDetails"] ? EnterpriseRoleDto.fromJS(_data["userRoleDetails"]) : undefined as any;
            this.cropMapRoleId = _data["cropMapRoleId"];
            this.cropMapPermissionId = _data["cropMapPermissionId"];
        }
    }

    static fromJS(data: any): CropMapUserEnterpiseViewModel {
        data = typeof data === 'object' ? data : {};
        let result = new CropMapUserEnterpiseViewModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["userId"] = this.userId;
        data["userName"] = this.userName;
        data["userSurname"] = this.userSurname;
        data["enterpriseId"] = this.enterpriseId;
        data["ownerId"] = this.ownerId;
        data["name"] = this.name;
        data["description"] = this.description;
        data["contactPerson"] = this.contactPerson;
        data["contactEmail"] = this.contactEmail;
        data["contactPhone"] = this.contactPhone;
        data["address"] = this.address;
        data["userRole"] = this.userRole;
        data["userRoleDetails"] = this.userRoleDetails ? this.userRoleDetails.toJSON() : undefined as any;
        data["cropMapRoleId"] = this.cropMapRoleId;
        data["cropMapPermissionId"] = this.cropMapPermissionId;
        return data;
    }
}


export interface ICropMapUserEnterpiseViewModel {
    userId: string;
    userName: string | undefined;
    userSurname: string | undefined;
    enterpriseId: string;
    ownerId: string;
    name: string | undefined;
    description: string | undefined;
    contactPerson: string | undefined;
    contactEmail: string | undefined;
    contactPhone: string | undefined;
    address: string | undefined;
    userRole: string | undefined;
    userRoleDetails: EnterpriseRoleDto;
    cropMapRoleId: string | undefined;
    cropMapPermissionId: string | undefined;
}


export class CropMapUserEnterpiseViewModelResponseResult implements ICropMapUserEnterpiseViewModelResponseResult {
    isSuccess!: boolean;
    statusCode!: number;
    result!: CropMapUserEnterpiseViewModel;
    errors!: ErrorMessage[] | undefined;
    version!: string | undefined;
    environment!: string | undefined;

    constructor(data?: ICropMapUserEnterpiseViewModelResponseResult) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.isSuccess = _data["isSuccess"];
            this.statusCode = _data["statusCode"];
            this.result = _data["result"] ? CropMapUserEnterpiseViewModel.fromJS(_data["result"]) : undefined as any;
            if (Array.isArray(_data["errors"])) {
                this.errors = [] as any;
                for (let item of _data["errors"])
                    this.errors!.push(ErrorMessage.fromJS(item));
            }
            this.version = _data["version"];
            this.environment = _data["environment"];
        }
    }

    static fromJS(data: any): CropMapUserEnterpiseViewModelResponseResult {
        data = typeof data === 'object' ? data : {};
        let result = new CropMapUserEnterpiseViewModelResponseResult();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["isSuccess"] = this.isSuccess;
        data["statusCode"] = this.statusCode;
        data["result"] = this.result ? this.result.toJSON() : undefined as any;
        if (Array.isArray(this.errors)) {
            data["errors"] = [];
            for (let item of this.errors)
                data["errors"].push(item ? item.toJSON() : undefined as any);
        }
        data["version"] = this.version;
        data["environment"] = this.environment;
        return data;
    }
}


export interface ICropMapUserEnterpiseViewModelResponseResult {
    isSuccess: boolean;
    statusCode: number;
    result: CropMapUserEnterpiseViewModel;
    errors: ErrorMessage[] | undefined;
    version: string | undefined;
    environment: string | undefined;
}


export class CropMapUserRoleInfoV2ViewModel implements ICropMapUserRoleInfoV2ViewModel {
    userRoleId!: string;
    userRoleName!: string | undefined;
    permissionIds!: string[] | undefined;

    constructor(data?: ICropMapUserRoleInfoV2ViewModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.userRoleId = _data["userRoleId"];
            this.userRoleName = _data["userRoleName"];
            if (Array.isArray(_data["permissionIds"])) {
                this.permissionIds = [] as any;
                for (let item of _data["permissionIds"])
                    this.permissionIds!.push(item);
            }
        }
    }

    static fromJS(data: any): CropMapUserRoleInfoV2ViewModel {
        data = typeof data === 'object' ? data : {};
        let result = new CropMapUserRoleInfoV2ViewModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["userRoleId"] = this.userRoleId;
        data["userRoleName"] = this.userRoleName;
        if (Array.isArray(this.permissionIds)) {
            data["permissionIds"] = [];
            for (let item of this.permissionIds)
                data["permissionIds"].push(item);
        }
        return data;
    }
}


export interface ICropMapUserRoleInfoV2ViewModel {
    userRoleId: string;
    userRoleName: string | undefined;
    permissionIds: string[] | undefined;
}


export class CropMapUserV2ViewModel implements ICropMapUserV2ViewModel {
    userId!: string;
    authKey!: string;
    name!: string | undefined;
    surname!: string | undefined;
    nameSurname!: string | undefined;
    email!: string | undefined;
    phoneCode!: string | undefined;
    phoneNumber!: string | undefined;
    enterpriseRoleId!: string | undefined;
    enterpriseRoleName!: string | undefined;
    userRoles!: CropMapUserRoleInfoV2ViewModel[] | undefined;

    constructor(data?: ICropMapUserV2ViewModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.userId = _data["userId"];
            this.authKey = _data["authKey"];
            this.name = _data["name"];
            this.surname = _data["surname"];
            this.nameSurname = _data["nameSurname"];
            this.email = _data["email"];
            this.phoneCode = _data["phoneCode"];
            this.phoneNumber = _data["phoneNumber"];
            this.enterpriseRoleId = _data["enterpriseRoleId"];
            this.enterpriseRoleName = _data["enterpriseRoleName"];
            if (Array.isArray(_data["userRoles"])) {
                this.userRoles = [] as any;
                for (let item of _data["userRoles"])
                    this.userRoles!.push(CropMapUserRoleInfoV2ViewModel.fromJS(item));
            }
        }
    }

    static fromJS(data: any): CropMapUserV2ViewModel {
        data = typeof data === 'object' ? data : {};
        let result = new CropMapUserV2ViewModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["userId"] = this.userId;
        data["authKey"] = this.authKey;
        data["name"] = this.name;
        data["surname"] = this.surname;
        data["nameSurname"] = this.nameSurname;
        data["email"] = this.email;
        data["phoneCode"] = this.phoneCode;
        data["phoneNumber"] = this.phoneNumber;
        data["enterpriseRoleId"] = this.enterpriseRoleId;
        data["enterpriseRoleName"] = this.enterpriseRoleName;
        if (Array.isArray(this.userRoles)) {
            data["userRoles"] = [];
            for (let item of this.userRoles)
                data["userRoles"].push(item ? item.toJSON() : undefined as any);
        }
        return data;
    }
}


export interface ICropMapUserV2ViewModel {
    userId: string;
    authKey: string;
    name: string | undefined;
    surname: string | undefined;
    nameSurname: string | undefined;
    email: string | undefined;
    phoneCode: string | undefined;
    phoneNumber: string | undefined;
    enterpriseRoleId: string | undefined;
    enterpriseRoleName: string | undefined;
    userRoles: CropMapUserRoleInfoV2ViewModel[] | undefined;
}


export class CropMapUserV2ViewModelListResponseResult implements ICropMapUserV2ViewModelListResponseResult {
    isSuccess!: boolean;
    statusCode!: number;
    result!: CropMapUserV2ViewModel[] | undefined;
    errors!: ErrorMessage[] | undefined;
    version!: string | undefined;
    environment!: string | undefined;

    constructor(data?: ICropMapUserV2ViewModelListResponseResult) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.isSuccess = _data["isSuccess"];
            this.statusCode = _data["statusCode"];
            if (Array.isArray(_data["result"])) {
                this.result = [] as any;
                for (let item of _data["result"])
                    this.result!.push(CropMapUserV2ViewModel.fromJS(item));
            }
            if (Array.isArray(_data["errors"])) {
                this.errors = [] as any;
                for (let item of _data["errors"])
                    this.errors!.push(ErrorMessage.fromJS(item));
            }
            this.version = _data["version"];
            this.environment = _data["environment"];
        }
    }

    static fromJS(data: any): CropMapUserV2ViewModelListResponseResult {
        data = typeof data === 'object' ? data : {};
        let result = new CropMapUserV2ViewModelListResponseResult();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["isSuccess"] = this.isSuccess;
        data["statusCode"] = this.statusCode;
        if (Array.isArray(this.result)) {
            data["result"] = [];
            for (let item of this.result)
                data["result"].push(item ? item.toJSON() : undefined as any);
        }
        if (Array.isArray(this.errors)) {
            data["errors"] = [];
            for (let item of this.errors)
                data["errors"].push(item ? item.toJSON() : undefined as any);
        }
        data["version"] = this.version;
        data["environment"] = this.environment;
        return data;
    }
}


export interface ICropMapUserV2ViewModelListResponseResult {
    isSuccess: boolean;
    statusCode: number;
    result: CropMapUserV2ViewModel[] | undefined;
    errors: ErrorMessage[] | undefined;
    version: string | undefined;
    environment: string | undefined;
}


export class CropMapUserViewModel implements ICropMapUserViewModel {
    userId!: string;
    authKey!: string;
    name!: string | undefined;
    surname!: string | undefined;
    nameSurname!: string | undefined;
    email!: string | undefined;
    platform!: string | undefined;
    userRoleId!: string;
    socialType!: string | undefined;
    phoneCode!: string | undefined;
    phoneNumber!: string | undefined;
    cropMapRoleId!: string | undefined;
    enterpriseId!: string | undefined;
    cropMapPermissionId!: string | undefined;

    constructor(data?: ICropMapUserViewModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.userId = _data["userId"];
            this.authKey = _data["authKey"];
            this.name = _data["name"];
            this.surname = _data["surname"];
            this.nameSurname = _data["nameSurname"];
            this.email = _data["email"];
            this.platform = _data["platform"];
            this.userRoleId = _data["userRoleId"];
            this.socialType = _data["socialType"];
            this.phoneCode = _data["phoneCode"];
            this.phoneNumber = _data["phoneNumber"];
            this.cropMapRoleId = _data["cropMapRoleId"];
            this.enterpriseId = _data["enterpriseId"];
            this.cropMapPermissionId = _data["cropMapPermissionId"];
        }
    }

    static fromJS(data: any): CropMapUserViewModel {
        data = typeof data === 'object' ? data : {};
        let result = new CropMapUserViewModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["userId"] = this.userId;
        data["authKey"] = this.authKey;
        data["name"] = this.name;
        data["surname"] = this.surname;
        data["nameSurname"] = this.nameSurname;
        data["email"] = this.email;
        data["platform"] = this.platform;
        data["userRoleId"] = this.userRoleId;
        data["socialType"] = this.socialType;
        data["phoneCode"] = this.phoneCode;
        data["phoneNumber"] = this.phoneNumber;
        data["cropMapRoleId"] = this.cropMapRoleId;
        data["enterpriseId"] = this.enterpriseId;
        data["cropMapPermissionId"] = this.cropMapPermissionId;
        return data;
    }
}


export interface ICropMapUserViewModel {
    userId: string;
    authKey: string;
    name: string | undefined;
    surname: string | undefined;
    nameSurname: string | undefined;
    email: string | undefined;
    platform: string | undefined;
    userRoleId: string;
    socialType: string | undefined;
    phoneCode: string | undefined;
    phoneNumber: string | undefined;
    cropMapRoleId: string | undefined;
    enterpriseId: string | undefined;
    cropMapPermissionId: string | undefined;
}


export class CropMapUserViewModelListResponseResult implements ICropMapUserViewModelListResponseResult {
    isSuccess!: boolean;
    statusCode!: number;
    result!: CropMapUserViewModel[] | undefined;
    errors!: ErrorMessage[] | undefined;
    version!: string | undefined;
    environment!: string | undefined;

    constructor(data?: ICropMapUserViewModelListResponseResult) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.isSuccess = _data["isSuccess"];
            this.statusCode = _data["statusCode"];
            if (Array.isArray(_data["result"])) {
                this.result = [] as any;
                for (let item of _data["result"])
                    this.result!.push(CropMapUserViewModel.fromJS(item));
            }
            if (Array.isArray(_data["errors"])) {
                this.errors = [] as any;
                for (let item of _data["errors"])
                    this.errors!.push(ErrorMessage.fromJS(item));
            }
            this.version = _data["version"];
            this.environment = _data["environment"];
        }
    }

    static fromJS(data: any): CropMapUserViewModelListResponseResult {
        data = typeof data === 'object' ? data : {};
        let result = new CropMapUserViewModelListResponseResult();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["isSuccess"] = this.isSuccess;
        data["statusCode"] = this.statusCode;
        if (Array.isArray(this.result)) {
            data["result"] = [];
            for (let item of this.result)
                data["result"].push(item ? item.toJSON() : undefined as any);
        }
        if (Array.isArray(this.errors)) {
            data["errors"] = [];
            for (let item of this.errors)
                data["errors"].push(item ? item.toJSON() : undefined as any);
        }
        data["version"] = this.version;
        data["environment"] = this.environment;
        return data;
    }
}


export interface ICropMapUserViewModelListResponseResult {
    isSuccess: boolean;
    statusCode: number;
    result: CropMapUserViewModel[] | undefined;
    errors: ErrorMessage[] | undefined;
    version: string | undefined;
    environment: string | undefined;
}


export class CropMapYearDataViewModel implements ICropMapYearDataViewModel {
    year!: number;
    boundaryLayers!: CropMapBoundaryLayerViewModel[] | undefined;
    fieldLayer!: CropMapFieldLayerViewModel;
    isDeleted!: boolean | undefined;

    constructor(data?: ICropMapYearDataViewModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.year = _data["year"];
            if (Array.isArray(_data["boundaryLayers"])) {
                this.boundaryLayers = [] as any;
                for (let item of _data["boundaryLayers"])
                    this.boundaryLayers!.push(CropMapBoundaryLayerViewModel.fromJS(item));
            }
            this.fieldLayer = _data["fieldLayer"] ? CropMapFieldLayerViewModel.fromJS(_data["fieldLayer"]) : undefined as any;
            this.isDeleted = _data["isDeleted"];
        }
    }

    static fromJS(data: any): CropMapYearDataViewModel {
        data = typeof data === 'object' ? data : {};
        let result = new CropMapYearDataViewModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["year"] = this.year;
        if (Array.isArray(this.boundaryLayers)) {
            data["boundaryLayers"] = [];
            for (let item of this.boundaryLayers)
                data["boundaryLayers"].push(item ? item.toJSON() : undefined as any);
        }
        data["fieldLayer"] = this.fieldLayer ? this.fieldLayer.toJSON() : undefined as any;
        data["isDeleted"] = this.isDeleted;
        return data;
    }
}


export interface ICropMapYearDataViewModel {
    year: number;
    boundaryLayers: CropMapBoundaryLayerViewModel[] | undefined;
    fieldLayer: CropMapFieldLayerViewModel;
    isDeleted: boolean | undefined;
}


export class CropSeasonCropViewModel implements ICropSeasonCropViewModel {
    id!: string;
    name!: string | undefined;
    color!: string | undefined;

    constructor(data?: ICropSeasonCropViewModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.name = _data["name"];
            this.color = _data["color"];
        }
    }

    static fromJS(data: any): CropSeasonCropViewModel {
        data = typeof data === 'object' ? data : {};
        let result = new CropSeasonCropViewModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["name"] = this.name;
        data["color"] = this.color;
        return data;
    }
}


export interface ICropSeasonCropViewModel {
    id: string;
    name: string | undefined;
    color: string | undefined;
}


export class CropSeasonCropViewModelListResponseResult implements ICropSeasonCropViewModelListResponseResult {
    isSuccess!: boolean;
    statusCode!: number;
    result!: CropSeasonCropViewModel[] | undefined;
    errors!: ErrorMessage[] | undefined;
    version!: string | undefined;
    environment!: string | undefined;

    constructor(data?: ICropSeasonCropViewModelListResponseResult) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.isSuccess = _data["isSuccess"];
            this.statusCode = _data["statusCode"];
            if (Array.isArray(_data["result"])) {
                this.result = [] as any;
                for (let item of _data["result"])
                    this.result!.push(CropSeasonCropViewModel.fromJS(item));
            }
            if (Array.isArray(_data["errors"])) {
                this.errors = [] as any;
                for (let item of _data["errors"])
                    this.errors!.push(ErrorMessage.fromJS(item));
            }
            this.version = _data["version"];
            this.environment = _data["environment"];
        }
    }

    static fromJS(data: any): CropSeasonCropViewModelListResponseResult {
        data = typeof data === 'object' ? data : {};
        let result = new CropSeasonCropViewModelListResponseResult();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["isSuccess"] = this.isSuccess;
        data["statusCode"] = this.statusCode;
        if (Array.isArray(this.result)) {
            data["result"] = [];
            for (let item of this.result)
                data["result"].push(item ? item.toJSON() : undefined as any);
        }
        if (Array.isArray(this.errors)) {
            data["errors"] = [];
            for (let item of this.errors)
                data["errors"].push(item ? item.toJSON() : undefined as any);
        }
        data["version"] = this.version;
        data["environment"] = this.environment;
        return data;
    }
}


export interface ICropSeasonCropViewModelListResponseResult {
    isSuccess: boolean;
    statusCode: number;
    result: CropSeasonCropViewModel[] | undefined;
    errors: ErrorMessage[] | undefined;
    version: string | undefined;
    environment: string | undefined;
}


export class CropSeasonViewModel implements ICropSeasonViewModel {
    cropId!: string;
    seasonId!: string;
    cropName!: string | undefined;
    cropColor!: string | undefined;
    seasonName!: string | undefined;

    constructor(data?: ICropSeasonViewModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.cropId = _data["cropId"];
            this.seasonId = _data["seasonId"];
            this.cropName = _data["cropName"];
            this.cropColor = _data["cropColor"];
            this.seasonName = _data["seasonName"];
        }
    }

    static fromJS(data: any): CropSeasonViewModel {
        data = typeof data === 'object' ? data : {};
        let result = new CropSeasonViewModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["cropId"] = this.cropId;
        data["seasonId"] = this.seasonId;
        data["cropName"] = this.cropName;
        data["cropColor"] = this.cropColor;
        data["seasonName"] = this.seasonName;
        return data;
    }
}


export interface ICropSeasonViewModel {
    cropId: string;
    seasonId: string;
    cropName: string | undefined;
    cropColor: string | undefined;
    seasonName: string | undefined;
}


export class CropSeasonViewModelPaginatedResponse implements ICropSeasonViewModelPaginatedResponse {
    items!: CropSeasonViewModel[] | undefined;
    pageNumber!: number;
    pageSize!: number;
    totalCount!: number;
    totalPages!: number;
    hasPreviousPage!: boolean;
    hasNextPage!: boolean;
    appliedSorts!: SortCriteria[] | undefined;
    appliedFilters!: FilterCriteria[] | undefined;

    constructor(data?: ICropSeasonViewModelPaginatedResponse) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["items"])) {
                this.items = [] as any;
                for (let item of _data["items"])
                    this.items!.push(CropSeasonViewModel.fromJS(item));
            }
            this.pageNumber = _data["pageNumber"];
            this.pageSize = _data["pageSize"];
            this.totalCount = _data["totalCount"];
            this.totalPages = _data["totalPages"];
            this.hasPreviousPage = _data["hasPreviousPage"];
            this.hasNextPage = _data["hasNextPage"];
            if (Array.isArray(_data["appliedSorts"])) {
                this.appliedSorts = [] as any;
                for (let item of _data["appliedSorts"])
                    this.appliedSorts!.push(SortCriteria.fromJS(item));
            }
            if (Array.isArray(_data["appliedFilters"])) {
                this.appliedFilters = [] as any;
                for (let item of _data["appliedFilters"])
                    this.appliedFilters!.push(FilterCriteria.fromJS(item));
            }
        }
    }

    static fromJS(data: any): CropSeasonViewModelPaginatedResponse {
        data = typeof data === 'object' ? data : {};
        let result = new CropSeasonViewModelPaginatedResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.items)) {
            data["items"] = [];
            for (let item of this.items)
                data["items"].push(item ? item.toJSON() : undefined as any);
        }
        data["pageNumber"] = this.pageNumber;
        data["pageSize"] = this.pageSize;
        data["totalCount"] = this.totalCount;
        data["totalPages"] = this.totalPages;
        data["hasPreviousPage"] = this.hasPreviousPage;
        data["hasNextPage"] = this.hasNextPage;
        if (Array.isArray(this.appliedSorts)) {
            data["appliedSorts"] = [];
            for (let item of this.appliedSorts)
                data["appliedSorts"].push(item ? item.toJSON() : undefined as any);
        }
        if (Array.isArray(this.appliedFilters)) {
            data["appliedFilters"] = [];
            for (let item of this.appliedFilters)
                data["appliedFilters"].push(item ? item.toJSON() : undefined as any);
        }
        return data;
    }
}


export interface ICropSeasonViewModelPaginatedResponse {
    items: CropSeasonViewModel[] | undefined;
    pageNumber: number;
    pageSize: number;
    totalCount: number;
    totalPages: number;
    hasPreviousPage: boolean;
    hasNextPage: boolean;
    appliedSorts: SortCriteria[] | undefined;
    appliedFilters: FilterCriteria[] | undefined;
}


export class CropSeasonViewModelPaginatedResponseResponseResult implements ICropSeasonViewModelPaginatedResponseResponseResult {
    isSuccess!: boolean;
    statusCode!: number;
    result!: CropSeasonViewModelPaginatedResponse;
    errors!: ErrorMessage[] | undefined;
    version!: string | undefined;
    environment!: string | undefined;

    constructor(data?: ICropSeasonViewModelPaginatedResponseResponseResult) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.isSuccess = _data["isSuccess"];
            this.statusCode = _data["statusCode"];
            this.result = _data["result"] ? CropSeasonViewModelPaginatedResponse.fromJS(_data["result"]) : undefined as any;
            if (Array.isArray(_data["errors"])) {
                this.errors = [] as any;
                for (let item of _data["errors"])
                    this.errors!.push(ErrorMessage.fromJS(item));
            }
            this.version = _data["version"];
            this.environment = _data["environment"];
        }
    }

    static fromJS(data: any): CropSeasonViewModelPaginatedResponseResponseResult {
        data = typeof data === 'object' ? data : {};
        let result = new CropSeasonViewModelPaginatedResponseResponseResult();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["isSuccess"] = this.isSuccess;
        data["statusCode"] = this.statusCode;
        data["result"] = this.result ? this.result.toJSON() : undefined as any;
        if (Array.isArray(this.errors)) {
            data["errors"] = [];
            for (let item of this.errors)
                data["errors"].push(item ? item.toJSON() : undefined as any);
        }
        data["version"] = this.version;
        data["environment"] = this.environment;
        return data;
    }
}


export interface ICropSeasonViewModelPaginatedResponseResponseResult {
    isSuccess: boolean;
    statusCode: number;
    result: CropSeasonViewModelPaginatedResponse;
    errors: ErrorMessage[] | undefined;
    version: string | undefined;
    environment: string | undefined;
}


export class CropSeasonViewModelResponseResult implements ICropSeasonViewModelResponseResult {
    isSuccess!: boolean;
    statusCode!: number;
    result!: CropSeasonViewModel;
    errors!: ErrorMessage[] | undefined;
    version!: string | undefined;
    environment!: string | undefined;

    constructor(data?: ICropSeasonViewModelResponseResult) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.isSuccess = _data["isSuccess"];
            this.statusCode = _data["statusCode"];
            this.result = _data["result"] ? CropSeasonViewModel.fromJS(_data["result"]) : undefined as any;
            if (Array.isArray(_data["errors"])) {
                this.errors = [] as any;
                for (let item of _data["errors"])
                    this.errors!.push(ErrorMessage.fromJS(item));
            }
            this.version = _data["version"];
            this.environment = _data["environment"];
        }
    }

    static fromJS(data: any): CropSeasonViewModelResponseResult {
        data = typeof data === 'object' ? data : {};
        let result = new CropSeasonViewModelResponseResult();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["isSuccess"] = this.isSuccess;
        data["statusCode"] = this.statusCode;
        data["result"] = this.result ? this.result.toJSON() : undefined as any;
        if (Array.isArray(this.errors)) {
            data["errors"] = [];
            for (let item of this.errors)
                data["errors"].push(item ? item.toJSON() : undefined as any);
        }
        data["version"] = this.version;
        data["environment"] = this.environment;
        return data;
    }
}


export interface ICropSeasonViewModelResponseResult {
    isSuccess: boolean;
    statusCode: number;
    result: CropSeasonViewModel;
    errors: ErrorMessage[] | undefined;
    version: string | undefined;
    environment: string | undefined;
}


export class CurrencyLookupViewModel implements ICurrencyLookupViewModel {
    key!: string;
    symbol!: string | undefined;
    value!: string | undefined;

    constructor(data?: ICurrencyLookupViewModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.key = _data["key"];
            this.symbol = _data["symbol"];
            this.value = _data["value"];
        }
    }

    static fromJS(data: any): CurrencyLookupViewModel {
        data = typeof data === 'object' ? data : {};
        let result = new CurrencyLookupViewModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["key"] = this.key;
        data["symbol"] = this.symbol;
        data["value"] = this.value;
        return data;
    }
}


export interface ICurrencyLookupViewModel {
    key: string;
    symbol: string | undefined;
    value: string | undefined;
}


export class CurrencyLookupViewModelListResponseResult implements ICurrencyLookupViewModelListResponseResult {
    isSuccess!: boolean;
    statusCode!: number;
    result!: CurrencyLookupViewModel[] | undefined;
    errors!: ErrorMessage[] | undefined;
    version!: string | undefined;
    environment!: string | undefined;

    constructor(data?: ICurrencyLookupViewModelListResponseResult) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.isSuccess = _data["isSuccess"];
            this.statusCode = _data["statusCode"];
            if (Array.isArray(_data["result"])) {
                this.result = [] as any;
                for (let item of _data["result"])
                    this.result!.push(CurrencyLookupViewModel.fromJS(item));
            }
            if (Array.isArray(_data["errors"])) {
                this.errors = [] as any;
                for (let item of _data["errors"])
                    this.errors!.push(ErrorMessage.fromJS(item));
            }
            this.version = _data["version"];
            this.environment = _data["environment"];
        }
    }

    static fromJS(data: any): CurrencyLookupViewModelListResponseResult {
        data = typeof data === 'object' ? data : {};
        let result = new CurrencyLookupViewModelListResponseResult();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["isSuccess"] = this.isSuccess;
        data["statusCode"] = this.statusCode;
        if (Array.isArray(this.result)) {
            data["result"] = [];
            for (let item of this.result)
                data["result"].push(item ? item.toJSON() : undefined as any);
        }
        if (Array.isArray(this.errors)) {
            data["errors"] = [];
            for (let item of this.errors)
                data["errors"].push(item ? item.toJSON() : undefined as any);
        }
        data["version"] = this.version;
        data["environment"] = this.environment;
        return data;
    }
}


export interface ICurrencyLookupViewModelListResponseResult {
    isSuccess: boolean;
    statusCode: number;
    result: CurrencyLookupViewModel[] | undefined;
    errors: ErrorMessage[] | undefined;
    version: string | undefined;
    environment: string | undefined;
}


export class DeactivateUserCommand implements IDeactivateUserCommand {
    id!: string;
    reason!: string | undefined;
    totp!: number;

    constructor(data?: IDeactivateUserCommand) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.reason = _data["reason"];
            this.totp = _data["totp"];
        }
    }

    static fromJS(data: any): DeactivateUserCommand {
        data = typeof data === 'object' ? data : {};
        let result = new DeactivateUserCommand();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["reason"] = this.reason;
        data["totp"] = this.totp;
        return data;
    }
}


export interface IDeactivateUserCommand {
    id: string;
    reason: string | undefined;
    totp: number;
}


export class DeleteMyAccountCommand implements IDeleteMyAccountCommand {
    id!: string;
    password!: string | undefined;

    constructor(data?: IDeleteMyAccountCommand) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.password = _data["password"];
        }
    }

    static fromJS(data: any): DeleteMyAccountCommand {
        data = typeof data === 'object' ? data : {};
        let result = new DeleteMyAccountCommand();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["password"] = this.password;
        return data;
    }
}


export interface IDeleteMyAccountCommand {
    id: string;
    password: string | undefined;
}


export class DistrictBoundaryNode implements IDistrictBoundaryNode {
    key!: string;
    value!: string | undefined;
    boundaries!: CoordinateViewModel[] | undefined;

    constructor(data?: IDistrictBoundaryNode) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.key = _data["key"];
            this.value = _data["value"];
            if (Array.isArray(_data["boundaries"])) {
                this.boundaries = [] as any;
                for (let item of _data["boundaries"])
                    this.boundaries!.push(CoordinateViewModel.fromJS(item));
            }
        }
    }

    static fromJS(data: any): DistrictBoundaryNode {
        data = typeof data === 'object' ? data : {};
        let result = new DistrictBoundaryNode();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["key"] = this.key;
        data["value"] = this.value;
        if (Array.isArray(this.boundaries)) {
            data["boundaries"] = [];
            for (let item of this.boundaries)
                data["boundaries"].push(item ? item.toJSON() : undefined as any);
        }
        return data;
    }
}


export interface IDistrictBoundaryNode {
    key: string;
    value: string | undefined;
    boundaries: CoordinateViewModel[] | undefined;
}


export class DistrictHierarchyViewModel implements IDistrictHierarchyViewModel {
    districtId!: string;
    name!: string | undefined;

    constructor(data?: IDistrictHierarchyViewModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.districtId = _data["districtId"];
            this.name = _data["name"];
        }
    }

    static fromJS(data: any): DistrictHierarchyViewModel {
        data = typeof data === 'object' ? data : {};
        let result = new DistrictHierarchyViewModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["districtId"] = this.districtId;
        data["name"] = this.name;
        return data;
    }
}


export interface IDistrictHierarchyViewModel {
    districtId: string;
    name: string | undefined;
}


export class EnterpriseGroupViewModel implements IEnterpriseGroupViewModel {
    id!: string;
    name!: string | undefined;
    lands!: EnterpriseLandFlatViewModel[] | undefined;
    depth!: number;
    parent!: EnterpriseHierarchyGroupViewModel;
    topParent!: EnterpriseHierarchyGroupViewModel;

    constructor(data?: IEnterpriseGroupViewModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.name = _data["name"];
            if (Array.isArray(_data["lands"])) {
                this.lands = [] as any;
                for (let item of _data["lands"])
                    this.lands!.push(EnterpriseLandFlatViewModel.fromJS(item));
            }
            this.depth = _data["depth"];
            this.parent = _data["parent"] ? EnterpriseHierarchyGroupViewModel.fromJS(_data["parent"]) : undefined as any;
            this.topParent = _data["topParent"] ? EnterpriseHierarchyGroupViewModel.fromJS(_data["topParent"]) : undefined as any;
        }
    }

    static fromJS(data: any): EnterpriseGroupViewModel {
        data = typeof data === 'object' ? data : {};
        let result = new EnterpriseGroupViewModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["name"] = this.name;
        if (Array.isArray(this.lands)) {
            data["lands"] = [];
            for (let item of this.lands)
                data["lands"].push(item ? item.toJSON() : undefined as any);
        }
        data["depth"] = this.depth;
        data["parent"] = this.parent ? this.parent.toJSON() : undefined as any;
        data["topParent"] = this.topParent ? this.topParent.toJSON() : undefined as any;
        return data;
    }
}


export interface IEnterpriseGroupViewModel {
    id: string;
    name: string | undefined;
    lands: EnterpriseLandFlatViewModel[] | undefined;
    depth: number;
    parent: EnterpriseHierarchyGroupViewModel;
    topParent: EnterpriseHierarchyGroupViewModel;
}


export class EnterpriseGroupViewModelListResponseResult implements IEnterpriseGroupViewModelListResponseResult {
    isSuccess!: boolean;
    statusCode!: number;
    result!: EnterpriseGroupViewModel[] | undefined;
    errors!: ErrorMessage[] | undefined;
    version!: string | undefined;
    environment!: string | undefined;

    constructor(data?: IEnterpriseGroupViewModelListResponseResult) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.isSuccess = _data["isSuccess"];
            this.statusCode = _data["statusCode"];
            if (Array.isArray(_data["result"])) {
                this.result = [] as any;
                for (let item of _data["result"])
                    this.result!.push(EnterpriseGroupViewModel.fromJS(item));
            }
            if (Array.isArray(_data["errors"])) {
                this.errors = [] as any;
                for (let item of _data["errors"])
                    this.errors!.push(ErrorMessage.fromJS(item));
            }
            this.version = _data["version"];
            this.environment = _data["environment"];
        }
    }

    static fromJS(data: any): EnterpriseGroupViewModelListResponseResult {
        data = typeof data === 'object' ? data : {};
        let result = new EnterpriseGroupViewModelListResponseResult();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["isSuccess"] = this.isSuccess;
        data["statusCode"] = this.statusCode;
        if (Array.isArray(this.result)) {
            data["result"] = [];
            for (let item of this.result)
                data["result"].push(item ? item.toJSON() : undefined as any);
        }
        if (Array.isArray(this.errors)) {
            data["errors"] = [];
            for (let item of this.errors)
                data["errors"].push(item ? item.toJSON() : undefined as any);
        }
        data["version"] = this.version;
        data["environment"] = this.environment;
        return data;
    }
}


export interface IEnterpriseGroupViewModelListResponseResult {
    isSuccess: boolean;
    statusCode: number;
    result: EnterpriseGroupViewModel[] | undefined;
    errors: ErrorMessage[] | undefined;
    version: string | undefined;
    environment: string | undefined;
}


export class EnterpriseHierarchyGroupViewModel implements IEnterpriseHierarchyGroupViewModel {
    accessKey!: string;
    name!: string | undefined;

    constructor(data?: IEnterpriseHierarchyGroupViewModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.accessKey = _data["accessKey"];
            this.name = _data["name"];
        }
    }

    static fromJS(data: any): EnterpriseHierarchyGroupViewModel {
        data = typeof data === 'object' ? data : {};
        let result = new EnterpriseHierarchyGroupViewModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["accessKey"] = this.accessKey;
        data["name"] = this.name;
        return data;
    }
}


export interface IEnterpriseHierarchyGroupViewModel {
    accessKey: string;
    name: string | undefined;
}


export class EnterpriseLandFlatViewModel implements IEnterpriseLandFlatViewModel {
    id!: string;
    displayId!: number | undefined;
    name!: string | undefined;
    totalArea!: number | undefined;
    image!: string | undefined;
    plantationCount!: number;
    createdAt!: DateTime;
    readonly totalAreaDisplay!: string | undefined;
    isLandFull!: boolean;

    constructor(data?: IEnterpriseLandFlatViewModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.displayId = _data["displayId"];
            this.name = _data["name"];
            this.totalArea = _data["totalArea"];
            this.image = _data["image"];
            this.plantationCount = _data["plantationCount"];
            this.createdAt = _data["createdAt"] ? DateTime.fromISO(_data["createdAt"].toString()) : undefined as any;
            (this as any).totalAreaDisplay = _data["totalAreaDisplay"];
            this.isLandFull = _data["isLandFull"];
        }
    }

    static fromJS(data: any): EnterpriseLandFlatViewModel {
        data = typeof data === 'object' ? data : {};
        let result = new EnterpriseLandFlatViewModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["displayId"] = this.displayId;
        data["name"] = this.name;
        data["totalArea"] = this.totalArea;
        data["image"] = this.image;
        data["plantationCount"] = this.plantationCount;
        data["createdAt"] = this.createdAt ? this.createdAt.toString() : undefined as any;
        data["totalAreaDisplay"] = this.totalAreaDisplay;
        data["isLandFull"] = this.isLandFull;
        return data;
    }
}


export interface IEnterpriseLandFlatViewModel {
    id: string;
    displayId: number | undefined;
    name: string | undefined;
    totalArea: number | undefined;
    image: string | undefined;
    plantationCount: number;
    createdAt: DateTime;
    totalAreaDisplay: string | undefined;
    isLandFull: boolean;
}


export class EnterprisePermissionViewModel implements IEnterprisePermissionViewModel {
    permissions!: string[] | undefined;

    constructor(data?: IEnterprisePermissionViewModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["permissions"])) {
                this.permissions = [] as any;
                for (let item of _data["permissions"])
                    this.permissions!.push(item);
            }
        }
    }

    static fromJS(data: any): EnterprisePermissionViewModel {
        data = typeof data === 'object' ? data : {};
        let result = new EnterprisePermissionViewModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.permissions)) {
            data["permissions"] = [];
            for (let item of this.permissions)
                data["permissions"].push(item);
        }
        return data;
    }
}


export interface IEnterprisePermissionViewModel {
    permissions: string[] | undefined;
}


export class EnterprisePermissionViewModelResponseResult implements IEnterprisePermissionViewModelResponseResult {
    isSuccess!: boolean;
    statusCode!: number;
    result!: EnterprisePermissionViewModel;
    errors!: ErrorMessage[] | undefined;
    version!: string | undefined;
    environment!: string | undefined;

    constructor(data?: IEnterprisePermissionViewModelResponseResult) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.isSuccess = _data["isSuccess"];
            this.statusCode = _data["statusCode"];
            this.result = _data["result"] ? EnterprisePermissionViewModel.fromJS(_data["result"]) : undefined as any;
            if (Array.isArray(_data["errors"])) {
                this.errors = [] as any;
                for (let item of _data["errors"])
                    this.errors!.push(ErrorMessage.fromJS(item));
            }
            this.version = _data["version"];
            this.environment = _data["environment"];
        }
    }

    static fromJS(data: any): EnterprisePermissionViewModelResponseResult {
        data = typeof data === 'object' ? data : {};
        let result = new EnterprisePermissionViewModelResponseResult();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["isSuccess"] = this.isSuccess;
        data["statusCode"] = this.statusCode;
        data["result"] = this.result ? this.result.toJSON() : undefined as any;
        if (Array.isArray(this.errors)) {
            data["errors"] = [];
            for (let item of this.errors)
                data["errors"].push(item ? item.toJSON() : undefined as any);
        }
        data["version"] = this.version;
        data["environment"] = this.environment;
        return data;
    }
}


export interface IEnterprisePermissionViewModelResponseResult {
    isSuccess: boolean;
    statusCode: number;
    result: EnterprisePermissionViewModel;
    errors: ErrorMessage[] | undefined;
    version: string | undefined;
    environment: string | undefined;
}


export class EnterpriseRoleDto implements IEnterpriseRoleDto {
    roleId!: string;
    roleName!: string | undefined;
    roleDescription!: string | undefined;
    permissions!: string[] | undefined;

    constructor(data?: IEnterpriseRoleDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.roleId = _data["roleId"];
            this.roleName = _data["roleName"];
            this.roleDescription = _data["roleDescription"];
            if (Array.isArray(_data["permissions"])) {
                this.permissions = [] as any;
                for (let item of _data["permissions"])
                    this.permissions!.push(item);
            }
        }
    }

    static fromJS(data: any): EnterpriseRoleDto {
        data = typeof data === 'object' ? data : {};
        let result = new EnterpriseRoleDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["roleId"] = this.roleId;
        data["roleName"] = this.roleName;
        data["roleDescription"] = this.roleDescription;
        if (Array.isArray(this.permissions)) {
            data["permissions"] = [];
            for (let item of this.permissions)
                data["permissions"].push(item);
        }
        return data;
    }
}


export interface IEnterpriseRoleDto {
    roleId: string;
    roleName: string | undefined;
    roleDescription: string | undefined;
    permissions: string[] | undefined;
}


export class EnterpriseUserAccessViewModel implements IEnterpriseUserAccessViewModel {
    id!: string;
    name!: string | undefined;
    description!: string | undefined;
    contactPerson!: string | undefined;
    contactEmail!: string | undefined;
    contactPhone!: number | undefined;
    countryId!: string | undefined;
    isDefaultEnterprise!: boolean;
    hasCropMapAccess!: boolean;
    cropMapAccessRoles!: CropMapAccessRoleItemViewModel[] | undefined;

    constructor(data?: IEnterpriseUserAccessViewModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.name = _data["name"];
            this.description = _data["description"];
            this.contactPerson = _data["contactPerson"];
            this.contactEmail = _data["contactEmail"];
            this.contactPhone = _data["contactPhone"];
            this.countryId = _data["countryId"];
            this.isDefaultEnterprise = _data["isDefaultEnterprise"];
            this.hasCropMapAccess = _data["hasCropMapAccess"];
            if (Array.isArray(_data["cropMapAccessRoles"])) {
                this.cropMapAccessRoles = [] as any;
                for (let item of _data["cropMapAccessRoles"])
                    this.cropMapAccessRoles!.push(CropMapAccessRoleItemViewModel.fromJS(item));
            }
        }
    }

    static fromJS(data: any): EnterpriseUserAccessViewModel {
        data = typeof data === 'object' ? data : {};
        let result = new EnterpriseUserAccessViewModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["name"] = this.name;
        data["description"] = this.description;
        data["contactPerson"] = this.contactPerson;
        data["contactEmail"] = this.contactEmail;
        data["contactPhone"] = this.contactPhone;
        data["countryId"] = this.countryId;
        data["isDefaultEnterprise"] = this.isDefaultEnterprise;
        data["hasCropMapAccess"] = this.hasCropMapAccess;
        if (Array.isArray(this.cropMapAccessRoles)) {
            data["cropMapAccessRoles"] = [];
            for (let item of this.cropMapAccessRoles)
                data["cropMapAccessRoles"].push(item ? item.toJSON() : undefined as any);
        }
        return data;
    }
}


export interface IEnterpriseUserAccessViewModel {
    id: string;
    name: string | undefined;
    description: string | undefined;
    contactPerson: string | undefined;
    contactEmail: string | undefined;
    contactPhone: number | undefined;
    countryId: string | undefined;
    isDefaultEnterprise: boolean;
    hasCropMapAccess: boolean;
    cropMapAccessRoles: CropMapAccessRoleItemViewModel[] | undefined;
}


export class EnterpriseUserAccessViewModelListResponseResult implements IEnterpriseUserAccessViewModelListResponseResult {
    isSuccess!: boolean;
    statusCode!: number;
    result!: EnterpriseUserAccessViewModel[] | undefined;
    errors!: ErrorMessage[] | undefined;
    version!: string | undefined;
    environment!: string | undefined;

    constructor(data?: IEnterpriseUserAccessViewModelListResponseResult) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.isSuccess = _data["isSuccess"];
            this.statusCode = _data["statusCode"];
            if (Array.isArray(_data["result"])) {
                this.result = [] as any;
                for (let item of _data["result"])
                    this.result!.push(EnterpriseUserAccessViewModel.fromJS(item));
            }
            if (Array.isArray(_data["errors"])) {
                this.errors = [] as any;
                for (let item of _data["errors"])
                    this.errors!.push(ErrorMessage.fromJS(item));
            }
            this.version = _data["version"];
            this.environment = _data["environment"];
        }
    }

    static fromJS(data: any): EnterpriseUserAccessViewModelListResponseResult {
        data = typeof data === 'object' ? data : {};
        let result = new EnterpriseUserAccessViewModelListResponseResult();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["isSuccess"] = this.isSuccess;
        data["statusCode"] = this.statusCode;
        if (Array.isArray(this.result)) {
            data["result"] = [];
            for (let item of this.result)
                data["result"].push(item ? item.toJSON() : undefined as any);
        }
        if (Array.isArray(this.errors)) {
            data["errors"] = [];
            for (let item of this.errors)
                data["errors"].push(item ? item.toJSON() : undefined as any);
        }
        data["version"] = this.version;
        data["environment"] = this.environment;
        return data;
    }
}


export interface IEnterpriseUserAccessViewModelListResponseResult {
    isSuccess: boolean;
    statusCode: number;
    result: EnterpriseUserAccessViewModel[] | undefined;
    errors: ErrorMessage[] | undefined;
    version: string | undefined;
    environment: string | undefined;
}


export class ErrorMessage implements IErrorMessage {
    code!: string | undefined;
    message!: string | undefined;

    constructor(data?: IErrorMessage) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.code = _data["code"];
            this.message = _data["message"];
        }
    }

    static fromJS(data: any): ErrorMessage {
        data = typeof data === 'object' ? data : {};
        let result = new ErrorMessage();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["code"] = this.code;
        data["message"] = this.message;
        return data;
    }
}


export interface IErrorMessage {
    code: string | undefined;
    message: string | undefined;
}


export class ExtentedKeyValueModel implements IExtentedKeyValueModel {
    key!: string;
    value!: string | undefined;
    description!: string | undefined;

    constructor(data?: IExtentedKeyValueModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.key = _data["key"];
            this.value = _data["value"];
            this.description = _data["description"];
        }
    }

    static fromJS(data: any): ExtentedKeyValueModel {
        data = typeof data === 'object' ? data : {};
        let result = new ExtentedKeyValueModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["key"] = this.key;
        data["value"] = this.value;
        data["description"] = this.description;
        return data;
    }
}


export interface IExtentedKeyValueModel {
    key: string;
    value: string | undefined;
    description: string | undefined;
}


export class ExtentedKeyValueModelListResponseResult implements IExtentedKeyValueModelListResponseResult {
    isSuccess!: boolean;
    statusCode!: number;
    result!: ExtentedKeyValueModel[] | undefined;
    errors!: ErrorMessage[] | undefined;
    version!: string | undefined;
    environment!: string | undefined;

    constructor(data?: IExtentedKeyValueModelListResponseResult) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.isSuccess = _data["isSuccess"];
            this.statusCode = _data["statusCode"];
            if (Array.isArray(_data["result"])) {
                this.result = [] as any;
                for (let item of _data["result"])
                    this.result!.push(ExtentedKeyValueModel.fromJS(item));
            }
            if (Array.isArray(_data["errors"])) {
                this.errors = [] as any;
                for (let item of _data["errors"])
                    this.errors!.push(ErrorMessage.fromJS(item));
            }
            this.version = _data["version"];
            this.environment = _data["environment"];
        }
    }

    static fromJS(data: any): ExtentedKeyValueModelListResponseResult {
        data = typeof data === 'object' ? data : {};
        let result = new ExtentedKeyValueModelListResponseResult();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["isSuccess"] = this.isSuccess;
        data["statusCode"] = this.statusCode;
        if (Array.isArray(this.result)) {
            data["result"] = [];
            for (let item of this.result)
                data["result"].push(item ? item.toJSON() : undefined as any);
        }
        if (Array.isArray(this.errors)) {
            data["errors"] = [];
            for (let item of this.errors)
                data["errors"].push(item ? item.toJSON() : undefined as any);
        }
        data["version"] = this.version;
        data["environment"] = this.environment;
        return data;
    }
}


export interface IExtentedKeyValueModelListResponseResult {
    isSuccess: boolean;
    statusCode: number;
    result: ExtentedKeyValueModel[] | undefined;
    errors: ErrorMessage[] | undefined;
    version: string | undefined;
    environment: string | undefined;
}


export class FieldObservationQuestionnaireViewModel implements IFieldObservationQuestionnaireViewModel {
    id!: string;
    enterpriseId!: string;
    year!: number | undefined;
    questionnaire!: Questionnaire;

    constructor(data?: IFieldObservationQuestionnaireViewModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.enterpriseId = _data["enterpriseId"];
            this.year = _data["year"];
            this.questionnaire = _data["questionnaire"] ? Questionnaire.fromJS(_data["questionnaire"]) : undefined as any;
        }
    }

    static fromJS(data: any): FieldObservationQuestionnaireViewModel {
        data = typeof data === 'object' ? data : {};
        let result = new FieldObservationQuestionnaireViewModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["enterpriseId"] = this.enterpriseId;
        data["year"] = this.year;
        data["questionnaire"] = this.questionnaire ? this.questionnaire.toJSON() : undefined as any;
        return data;
    }
}


export interface IFieldObservationQuestionnaireViewModel {
    id: string;
    enterpriseId: string;
    year: number | undefined;
    questionnaire: Questionnaire;
}


export class FieldObservationQuestionnaireViewModelListResponseResult implements IFieldObservationQuestionnaireViewModelListResponseResult {
    isSuccess!: boolean;
    statusCode!: number;
    result!: FieldObservationQuestionnaireViewModel[] | undefined;
    errors!: ErrorMessage[] | undefined;
    version!: string | undefined;
    environment!: string | undefined;

    constructor(data?: IFieldObservationQuestionnaireViewModelListResponseResult) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.isSuccess = _data["isSuccess"];
            this.statusCode = _data["statusCode"];
            if (Array.isArray(_data["result"])) {
                this.result = [] as any;
                for (let item of _data["result"])
                    this.result!.push(FieldObservationQuestionnaireViewModel.fromJS(item));
            }
            if (Array.isArray(_data["errors"])) {
                this.errors = [] as any;
                for (let item of _data["errors"])
                    this.errors!.push(ErrorMessage.fromJS(item));
            }
            this.version = _data["version"];
            this.environment = _data["environment"];
        }
    }

    static fromJS(data: any): FieldObservationQuestionnaireViewModelListResponseResult {
        data = typeof data === 'object' ? data : {};
        let result = new FieldObservationQuestionnaireViewModelListResponseResult();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["isSuccess"] = this.isSuccess;
        data["statusCode"] = this.statusCode;
        if (Array.isArray(this.result)) {
            data["result"] = [];
            for (let item of this.result)
                data["result"].push(item ? item.toJSON() : undefined as any);
        }
        if (Array.isArray(this.errors)) {
            data["errors"] = [];
            for (let item of this.errors)
                data["errors"].push(item ? item.toJSON() : undefined as any);
        }
        data["version"] = this.version;
        data["environment"] = this.environment;
        return data;
    }
}


export interface IFieldObservationQuestionnaireViewModelListResponseResult {
    isSuccess: boolean;
    statusCode: number;
    result: FieldObservationQuestionnaireViewModel[] | undefined;
    errors: ErrorMessage[] | undefined;
    version: string | undefined;
    environment: string | undefined;
}


export class FieldObservationQuestionnaireViewModelResponseResult implements IFieldObservationQuestionnaireViewModelResponseResult {
    isSuccess!: boolean;
    statusCode!: number;
    result!: FieldObservationQuestionnaireViewModel;
    errors!: ErrorMessage[] | undefined;
    version!: string | undefined;
    environment!: string | undefined;

    constructor(data?: IFieldObservationQuestionnaireViewModelResponseResult) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.isSuccess = _data["isSuccess"];
            this.statusCode = _data["statusCode"];
            this.result = _data["result"] ? FieldObservationQuestionnaireViewModel.fromJS(_data["result"]) : undefined as any;
            if (Array.isArray(_data["errors"])) {
                this.errors = [] as any;
                for (let item of _data["errors"])
                    this.errors!.push(ErrorMessage.fromJS(item));
            }
            this.version = _data["version"];
            this.environment = _data["environment"];
        }
    }

    static fromJS(data: any): FieldObservationQuestionnaireViewModelResponseResult {
        data = typeof data === 'object' ? data : {};
        let result = new FieldObservationQuestionnaireViewModelResponseResult();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["isSuccess"] = this.isSuccess;
        data["statusCode"] = this.statusCode;
        data["result"] = this.result ? this.result.toJSON() : undefined as any;
        if (Array.isArray(this.errors)) {
            data["errors"] = [];
            for (let item of this.errors)
                data["errors"].push(item ? item.toJSON() : undefined as any);
        }
        data["version"] = this.version;
        data["environment"] = this.environment;
        return data;
    }
}


export interface IFieldObservationQuestionnaireViewModelResponseResult {
    isSuccess: boolean;
    statusCode: number;
    result: FieldObservationQuestionnaireViewModel;
    errors: ErrorMessage[] | undefined;
    version: string | undefined;
    environment: string | undefined;
}


export class FieldObservationViewModel implements IFieldObservationViewModel {
    id!: string;
    enterpriseId!: string;
    fieldRef!: number;
    year!: number;
    seasonId!: number | undefined;
    nameSurname!: string | undefined;
    phoneCode!: string | undefined;
    phone!: string | undefined;
    email!: string | undefined;
    note!: string | undefined;
    questionnaire!: Questionnaire;

    constructor(data?: IFieldObservationViewModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.enterpriseId = _data["enterpriseId"];
            this.fieldRef = _data["fieldRef"];
            this.year = _data["year"];
            this.seasonId = _data["seasonId"];
            this.nameSurname = _data["nameSurname"];
            this.phoneCode = _data["phoneCode"];
            this.phone = _data["phone"];
            this.email = _data["email"];
            this.note = _data["note"];
            this.questionnaire = _data["questionnaire"] ? Questionnaire.fromJS(_data["questionnaire"]) : undefined as any;
        }
    }

    static fromJS(data: any): FieldObservationViewModel {
        data = typeof data === 'object' ? data : {};
        let result = new FieldObservationViewModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["enterpriseId"] = this.enterpriseId;
        data["fieldRef"] = this.fieldRef;
        data["year"] = this.year;
        data["seasonId"] = this.seasonId;
        data["nameSurname"] = this.nameSurname;
        data["phoneCode"] = this.phoneCode;
        data["phone"] = this.phone;
        data["email"] = this.email;
        data["note"] = this.note;
        data["questionnaire"] = this.questionnaire ? this.questionnaire.toJSON() : undefined as any;
        return data;
    }
}


export interface IFieldObservationViewModel {
    id: string;
    enterpriseId: string;
    fieldRef: number;
    year: number;
    seasonId: number | undefined;
    nameSurname: string | undefined;
    phoneCode: string | undefined;
    phone: string | undefined;
    email: string | undefined;
    note: string | undefined;
    questionnaire: Questionnaire;
}


export class FieldObservationViewModelListResponseResult implements IFieldObservationViewModelListResponseResult {
    isSuccess!: boolean;
    statusCode!: number;
    result!: FieldObservationViewModel[] | undefined;
    errors!: ErrorMessage[] | undefined;
    version!: string | undefined;
    environment!: string | undefined;

    constructor(data?: IFieldObservationViewModelListResponseResult) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.isSuccess = _data["isSuccess"];
            this.statusCode = _data["statusCode"];
            if (Array.isArray(_data["result"])) {
                this.result = [] as any;
                for (let item of _data["result"])
                    this.result!.push(FieldObservationViewModel.fromJS(item));
            }
            if (Array.isArray(_data["errors"])) {
                this.errors = [] as any;
                for (let item of _data["errors"])
                    this.errors!.push(ErrorMessage.fromJS(item));
            }
            this.version = _data["version"];
            this.environment = _data["environment"];
        }
    }

    static fromJS(data: any): FieldObservationViewModelListResponseResult {
        data = typeof data === 'object' ? data : {};
        let result = new FieldObservationViewModelListResponseResult();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["isSuccess"] = this.isSuccess;
        data["statusCode"] = this.statusCode;
        if (Array.isArray(this.result)) {
            data["result"] = [];
            for (let item of this.result)
                data["result"].push(item ? item.toJSON() : undefined as any);
        }
        if (Array.isArray(this.errors)) {
            data["errors"] = [];
            for (let item of this.errors)
                data["errors"].push(item ? item.toJSON() : undefined as any);
        }
        data["version"] = this.version;
        data["environment"] = this.environment;
        return data;
    }
}


export interface IFieldObservationViewModelListResponseResult {
    isSuccess: boolean;
    statusCode: number;
    result: FieldObservationViewModel[] | undefined;
    errors: ErrorMessage[] | undefined;
    version: string | undefined;
    environment: string | undefined;
}


export class FieldObservationViewModelResponseResult implements IFieldObservationViewModelResponseResult {
    isSuccess!: boolean;
    statusCode!: number;
    result!: FieldObservationViewModel;
    errors!: ErrorMessage[] | undefined;
    version!: string | undefined;
    environment!: string | undefined;

    constructor(data?: IFieldObservationViewModelResponseResult) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.isSuccess = _data["isSuccess"];
            this.statusCode = _data["statusCode"];
            this.result = _data["result"] ? FieldObservationViewModel.fromJS(_data["result"]) : undefined as any;
            if (Array.isArray(_data["errors"])) {
                this.errors = [] as any;
                for (let item of _data["errors"])
                    this.errors!.push(ErrorMessage.fromJS(item));
            }
            this.version = _data["version"];
            this.environment = _data["environment"];
        }
    }

    static fromJS(data: any): FieldObservationViewModelResponseResult {
        data = typeof data === 'object' ? data : {};
        let result = new FieldObservationViewModelResponseResult();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["isSuccess"] = this.isSuccess;
        data["statusCode"] = this.statusCode;
        data["result"] = this.result ? this.result.toJSON() : undefined as any;
        if (Array.isArray(this.errors)) {
            data["errors"] = [];
            for (let item of this.errors)
                data["errors"].push(item ? item.toJSON() : undefined as any);
        }
        data["version"] = this.version;
        data["environment"] = this.environment;
        return data;
    }
}


export interface IFieldObservationViewModelResponseResult {
    isSuccess: boolean;
    statusCode: number;
    result: FieldObservationViewModel;
    errors: ErrorMessage[] | undefined;
    version: string | undefined;
    environment: string | undefined;
}


export class FilterCriteria implements IFilterCriteria {
    field!: string | undefined;
    matchMode!: string | undefined;
    value!: string | undefined;
    operator!: string | undefined;

    constructor(data?: IFilterCriteria) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.field = _data["field"];
            this.matchMode = _data["matchMode"];
            this.value = _data["value"];
            this.operator = _data["operator"];
        }
    }

    static fromJS(data: any): FilterCriteria {
        data = typeof data === 'object' ? data : {};
        let result = new FilterCriteria();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["field"] = this.field;
        data["matchMode"] = this.matchMode;
        data["value"] = this.value;
        data["operator"] = this.operator;
        return data;
    }
}


export interface IFilterCriteria {
    field: string | undefined;
    matchMode: string | undefined;
    value: string | undefined;
    operator: string | undefined;
}


export class GeoRepresentativeInfoViewModel implements IGeoRepresentativeInfoViewModel {
    userId!: string;
    fullName!: string | undefined;
    email!: string | undefined;
    phoneCode!: string | undefined;
    phone!: string | undefined;

    constructor(data?: IGeoRepresentativeInfoViewModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.userId = _data["userId"];
            this.fullName = _data["fullName"];
            this.email = _data["email"];
            this.phoneCode = _data["phoneCode"];
            this.phone = _data["phone"];
        }
    }

    static fromJS(data: any): GeoRepresentativeInfoViewModel {
        data = typeof data === 'object' ? data : {};
        let result = new GeoRepresentativeInfoViewModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["userId"] = this.userId;
        data["fullName"] = this.fullName;
        data["email"] = this.email;
        data["phoneCode"] = this.phoneCode;
        data["phone"] = this.phone;
        return data;
    }
}


export interface IGeoRepresentativeInfoViewModel {
    userId: string;
    fullName: string | undefined;
    email: string | undefined;
    phoneCode: string | undefined;
    phone: string | undefined;
}


export class GeoUnitSummaryViewModel implements IGeoUnitSummaryViewModel {
    accessKey!: string;
    name!: string | undefined;

    constructor(data?: IGeoUnitSummaryViewModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.accessKey = _data["accessKey"];
            this.name = _data["name"];
        }
    }

    static fromJS(data: any): GeoUnitSummaryViewModel {
        data = typeof data === 'object' ? data : {};
        let result = new GeoUnitSummaryViewModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["accessKey"] = this.accessKey;
        data["name"] = this.name;
        return data;
    }
}


export interface IGeoUnitSummaryViewModel {
    accessKey: string;
    name: string | undefined;
}


export class GetAllLandsResult implements IGetAllLandsResult {
    id!: string;
    displayId!: number | undefined;
    name!: string | undefined;

    constructor(data?: IGetAllLandsResult) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.displayId = _data["displayId"];
            this.name = _data["name"];
        }
    }

    static fromJS(data: any): GetAllLandsResult {
        data = typeof data === 'object' ? data : {};
        let result = new GetAllLandsResult();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["displayId"] = this.displayId;
        data["name"] = this.name;
        return data;
    }
}


export interface IGetAllLandsResult {
    id: string;
    displayId: number | undefined;
    name: string | undefined;
}


export class GetAllLandsResultPaginatedResponse implements IGetAllLandsResultPaginatedResponse {
    items!: GetAllLandsResult[] | undefined;
    pageNumber!: number;
    pageSize!: number;
    totalCount!: number;
    totalPages!: number;
    hasPreviousPage!: boolean;
    hasNextPage!: boolean;
    appliedSorts!: SortCriteria[] | undefined;
    appliedFilters!: FilterCriteria[] | undefined;

    constructor(data?: IGetAllLandsResultPaginatedResponse) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["items"])) {
                this.items = [] as any;
                for (let item of _data["items"])
                    this.items!.push(GetAllLandsResult.fromJS(item));
            }
            this.pageNumber = _data["pageNumber"];
            this.pageSize = _data["pageSize"];
            this.totalCount = _data["totalCount"];
            this.totalPages = _data["totalPages"];
            this.hasPreviousPage = _data["hasPreviousPage"];
            this.hasNextPage = _data["hasNextPage"];
            if (Array.isArray(_data["appliedSorts"])) {
                this.appliedSorts = [] as any;
                for (let item of _data["appliedSorts"])
                    this.appliedSorts!.push(SortCriteria.fromJS(item));
            }
            if (Array.isArray(_data["appliedFilters"])) {
                this.appliedFilters = [] as any;
                for (let item of _data["appliedFilters"])
                    this.appliedFilters!.push(FilterCriteria.fromJS(item));
            }
        }
    }

    static fromJS(data: any): GetAllLandsResultPaginatedResponse {
        data = typeof data === 'object' ? data : {};
        let result = new GetAllLandsResultPaginatedResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.items)) {
            data["items"] = [];
            for (let item of this.items)
                data["items"].push(item ? item.toJSON() : undefined as any);
        }
        data["pageNumber"] = this.pageNumber;
        data["pageSize"] = this.pageSize;
        data["totalCount"] = this.totalCount;
        data["totalPages"] = this.totalPages;
        data["hasPreviousPage"] = this.hasPreviousPage;
        data["hasNextPage"] = this.hasNextPage;
        if (Array.isArray(this.appliedSorts)) {
            data["appliedSorts"] = [];
            for (let item of this.appliedSorts)
                data["appliedSorts"].push(item ? item.toJSON() : undefined as any);
        }
        if (Array.isArray(this.appliedFilters)) {
            data["appliedFilters"] = [];
            for (let item of this.appliedFilters)
                data["appliedFilters"].push(item ? item.toJSON() : undefined as any);
        }
        return data;
    }
}


export interface IGetAllLandsResultPaginatedResponse {
    items: GetAllLandsResult[] | undefined;
    pageNumber: number;
    pageSize: number;
    totalCount: number;
    totalPages: number;
    hasPreviousPage: boolean;
    hasNextPage: boolean;
    appliedSorts: SortCriteria[] | undefined;
    appliedFilters: FilterCriteria[] | undefined;
}


export class GetAllLandsResultPaginatedResponseResponseResult implements IGetAllLandsResultPaginatedResponseResponseResult {
    isSuccess!: boolean;
    statusCode!: number;
    result!: GetAllLandsResultPaginatedResponse;
    errors!: ErrorMessage[] | undefined;
    version!: string | undefined;
    environment!: string | undefined;

    constructor(data?: IGetAllLandsResultPaginatedResponseResponseResult) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.isSuccess = _data["isSuccess"];
            this.statusCode = _data["statusCode"];
            this.result = _data["result"] ? GetAllLandsResultPaginatedResponse.fromJS(_data["result"]) : undefined as any;
            if (Array.isArray(_data["errors"])) {
                this.errors = [] as any;
                for (let item of _data["errors"])
                    this.errors!.push(ErrorMessage.fromJS(item));
            }
            this.version = _data["version"];
            this.environment = _data["environment"];
        }
    }

    static fromJS(data: any): GetAllLandsResultPaginatedResponseResponseResult {
        data = typeof data === 'object' ? data : {};
        let result = new GetAllLandsResultPaginatedResponseResponseResult();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["isSuccess"] = this.isSuccess;
        data["statusCode"] = this.statusCode;
        data["result"] = this.result ? this.result.toJSON() : undefined as any;
        if (Array.isArray(this.errors)) {
            data["errors"] = [];
            for (let item of this.errors)
                data["errors"].push(item ? item.toJSON() : undefined as any);
        }
        data["version"] = this.version;
        data["environment"] = this.environment;
        return data;
    }
}


export interface IGetAllLandsResultPaginatedResponseResponseResult {
    isSuccess: boolean;
    statusCode: number;
    result: GetAllLandsResultPaginatedResponse;
    errors: ErrorMessage[] | undefined;
    version: string | undefined;
    environment: string | undefined;
}


export class GetCropAreaPlantationReportQuery implements IGetCropAreaPlantationReportQuery {
    seasons!: string[] | undefined;
    crops!: string[] | undefined;
    years!: number[] | undefined;
    districts!: string[] | undefined;

    constructor(data?: IGetCropAreaPlantationReportQuery) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["seasons"])) {
                this.seasons = [] as any;
                for (let item of _data["seasons"])
                    this.seasons!.push(item);
            }
            if (Array.isArray(_data["crops"])) {
                this.crops = [] as any;
                for (let item of _data["crops"])
                    this.crops!.push(item);
            }
            if (Array.isArray(_data["years"])) {
                this.years = [] as any;
                for (let item of _data["years"])
                    this.years!.push(item);
            }
            if (Array.isArray(_data["districts"])) {
                this.districts = [] as any;
                for (let item of _data["districts"])
                    this.districts!.push(item);
            }
        }
    }

    static fromJS(data: any): GetCropAreaPlantationReportQuery {
        data = typeof data === 'object' ? data : {};
        let result = new GetCropAreaPlantationReportQuery();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.seasons)) {
            data["seasons"] = [];
            for (let item of this.seasons)
                data["seasons"].push(item);
        }
        if (Array.isArray(this.crops)) {
            data["crops"] = [];
            for (let item of this.crops)
                data["crops"].push(item);
        }
        if (Array.isArray(this.years)) {
            data["years"] = [];
            for (let item of this.years)
                data["years"].push(item);
        }
        if (Array.isArray(this.districts)) {
            data["districts"] = [];
            for (let item of this.districts)
                data["districts"].push(item);
        }
        return data;
    }
}


export interface IGetCropAreaPlantationReportQuery {
    seasons: string[] | undefined;
    crops: string[] | undefined;
    years: number[] | undefined;
    districts: string[] | undefined;
}


export class GetCropClassesQueryResult implements IGetCropClassesQueryResult {
    id!: string;
    idInt!: number;
    name!: string | undefined;

    constructor(data?: IGetCropClassesQueryResult) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.idInt = _data["idInt"];
            this.name = _data["name"];
        }
    }

    static fromJS(data: any): GetCropClassesQueryResult {
        data = typeof data === 'object' ? data : {};
        let result = new GetCropClassesQueryResult();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["idInt"] = this.idInt;
        data["name"] = this.name;
        return data;
    }
}


export interface IGetCropClassesQueryResult {
    id: string;
    idInt: number;
    name: string | undefined;
}


export class GetCropClassesQueryResultListResponseResult implements IGetCropClassesQueryResultListResponseResult {
    isSuccess!: boolean;
    statusCode!: number;
    result!: GetCropClassesQueryResult[] | undefined;
    errors!: ErrorMessage[] | undefined;
    version!: string | undefined;
    environment!: string | undefined;

    constructor(data?: IGetCropClassesQueryResultListResponseResult) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.isSuccess = _data["isSuccess"];
            this.statusCode = _data["statusCode"];
            if (Array.isArray(_data["result"])) {
                this.result = [] as any;
                for (let item of _data["result"])
                    this.result!.push(GetCropClassesQueryResult.fromJS(item));
            }
            if (Array.isArray(_data["errors"])) {
                this.errors = [] as any;
                for (let item of _data["errors"])
                    this.errors!.push(ErrorMessage.fromJS(item));
            }
            this.version = _data["version"];
            this.environment = _data["environment"];
        }
    }

    static fromJS(data: any): GetCropClassesQueryResultListResponseResult {
        data = typeof data === 'object' ? data : {};
        let result = new GetCropClassesQueryResultListResponseResult();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["isSuccess"] = this.isSuccess;
        data["statusCode"] = this.statusCode;
        if (Array.isArray(this.result)) {
            data["result"] = [];
            for (let item of this.result)
                data["result"].push(item ? item.toJSON() : undefined as any);
        }
        if (Array.isArray(this.errors)) {
            data["errors"] = [];
            for (let item of this.errors)
                data["errors"].push(item ? item.toJSON() : undefined as any);
        }
        data["version"] = this.version;
        data["environment"] = this.environment;
        return data;
    }
}


export interface IGetCropClassesQueryResultListResponseResult {
    isSuccess: boolean;
    statusCode: number;
    result: GetCropClassesQueryResult[] | undefined;
    errors: ErrorMessage[] | undefined;
    version: string | undefined;
    environment: string | undefined;
}


export class GetCropTypesQueryResult implements IGetCropTypesQueryResult {
    id!: string;
    idInt!: number;
    name!: string | undefined;

    constructor(data?: IGetCropTypesQueryResult) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.idInt = _data["idInt"];
            this.name = _data["name"];
        }
    }

    static fromJS(data: any): GetCropTypesQueryResult {
        data = typeof data === 'object' ? data : {};
        let result = new GetCropTypesQueryResult();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["idInt"] = this.idInt;
        data["name"] = this.name;
        return data;
    }
}


export interface IGetCropTypesQueryResult {
    id: string;
    idInt: number;
    name: string | undefined;
}


export class GetCropTypesQueryResultListResponseResult implements IGetCropTypesQueryResultListResponseResult {
    isSuccess!: boolean;
    statusCode!: number;
    result!: GetCropTypesQueryResult[] | undefined;
    errors!: ErrorMessage[] | undefined;
    version!: string | undefined;
    environment!: string | undefined;

    constructor(data?: IGetCropTypesQueryResultListResponseResult) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.isSuccess = _data["isSuccess"];
            this.statusCode = _data["statusCode"];
            if (Array.isArray(_data["result"])) {
                this.result = [] as any;
                for (let item of _data["result"])
                    this.result!.push(GetCropTypesQueryResult.fromJS(item));
            }
            if (Array.isArray(_data["errors"])) {
                this.errors = [] as any;
                for (let item of _data["errors"])
                    this.errors!.push(ErrorMessage.fromJS(item));
            }
            this.version = _data["version"];
            this.environment = _data["environment"];
        }
    }

    static fromJS(data: any): GetCropTypesQueryResultListResponseResult {
        data = typeof data === 'object' ? data : {};
        let result = new GetCropTypesQueryResultListResponseResult();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["isSuccess"] = this.isSuccess;
        data["statusCode"] = this.statusCode;
        if (Array.isArray(this.result)) {
            data["result"] = [];
            for (let item of this.result)
                data["result"].push(item ? item.toJSON() : undefined as any);
        }
        if (Array.isArray(this.errors)) {
            data["errors"] = [];
            for (let item of this.errors)
                data["errors"].push(item ? item.toJSON() : undefined as any);
        }
        data["version"] = this.version;
        data["environment"] = this.environment;
        return data;
    }
}


export interface IGetCropTypesQueryResultListResponseResult {
    isSuccess: boolean;
    statusCode: number;
    result: GetCropTypesQueryResult[] | undefined;
    errors: ErrorMessage[] | undefined;
    version: string | undefined;
    environment: string | undefined;
}


export class GetCropsQueryResult implements IGetCropsQueryResult {
    key!: string;
    value!: string | undefined;
    color!: string | undefined;
    cropLifespanClassification!: string | undefined;

    constructor(data?: IGetCropsQueryResult) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.key = _data["key"];
            this.value = _data["value"];
            this.color = _data["color"];
            this.cropLifespanClassification = _data["cropLifespanClassification"];
        }
    }

    static fromJS(data: any): GetCropsQueryResult {
        data = typeof data === 'object' ? data : {};
        let result = new GetCropsQueryResult();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["key"] = this.key;
        data["value"] = this.value;
        data["color"] = this.color;
        data["cropLifespanClassification"] = this.cropLifespanClassification;
        return data;
    }
}


export interface IGetCropsQueryResult {
    key: string;
    value: string | undefined;
    color: string | undefined;
    cropLifespanClassification: string | undefined;
}


export class GetCropsQueryResultListResponseResult implements IGetCropsQueryResultListResponseResult {
    isSuccess!: boolean;
    statusCode!: number;
    result!: GetCropsQueryResult[] | undefined;
    errors!: ErrorMessage[] | undefined;
    version!: string | undefined;
    environment!: string | undefined;

    constructor(data?: IGetCropsQueryResultListResponseResult) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.isSuccess = _data["isSuccess"];
            this.statusCode = _data["statusCode"];
            if (Array.isArray(_data["result"])) {
                this.result = [] as any;
                for (let item of _data["result"])
                    this.result!.push(GetCropsQueryResult.fromJS(item));
            }
            if (Array.isArray(_data["errors"])) {
                this.errors = [] as any;
                for (let item of _data["errors"])
                    this.errors!.push(ErrorMessage.fromJS(item));
            }
            this.version = _data["version"];
            this.environment = _data["environment"];
        }
    }

    static fromJS(data: any): GetCropsQueryResultListResponseResult {
        data = typeof data === 'object' ? data : {};
        let result = new GetCropsQueryResultListResponseResult();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["isSuccess"] = this.isSuccess;
        data["statusCode"] = this.statusCode;
        if (Array.isArray(this.result)) {
            data["result"] = [];
            for (let item of this.result)
                data["result"].push(item ? item.toJSON() : undefined as any);
        }
        if (Array.isArray(this.errors)) {
            data["errors"] = [];
            for (let item of this.errors)
                data["errors"].push(item ? item.toJSON() : undefined as any);
        }
        data["version"] = this.version;
        data["environment"] = this.environment;
        return data;
    }
}


export interface IGetCropsQueryResultListResponseResult {
    isSuccess: boolean;
    statusCode: number;
    result: GetCropsQueryResult[] | undefined;
    errors: ErrorMessage[] | undefined;
    version: string | undefined;
    environment: string | undefined;
}


export class GetUserLoginLogQuery implements IGetUserLoginLogQuery {
    id!: string;
    from!: DateTime | undefined;
    to!: DateTime | undefined;

    constructor(data?: IGetUserLoginLogQuery) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.from = _data["from"] ? DateTime.fromISO(_data["from"].toString()) : undefined as any;
            this.to = _data["to"] ? DateTime.fromISO(_data["to"].toString()) : undefined as any;
        }
    }

    static fromJS(data: any): GetUserLoginLogQuery {
        data = typeof data === 'object' ? data : {};
        let result = new GetUserLoginLogQuery();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["from"] = this.from ? this.from.toString() : undefined as any;
        data["to"] = this.to ? this.to.toString() : undefined as any;
        return data;
    }
}


export interface IGetUserLoginLogQuery {
    id: string;
    from: DateTime | undefined;
    to: DateTime | undefined;
}


export class GuidResponseResult implements IGuidResponseResult {
    isSuccess!: boolean;
    statusCode!: number;
    result!: string;
    errors!: ErrorMessage[] | undefined;
    version!: string | undefined;
    environment!: string | undefined;

    constructor(data?: IGuidResponseResult) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.isSuccess = _data["isSuccess"];
            this.statusCode = _data["statusCode"];
            this.result = _data["result"];
            if (Array.isArray(_data["errors"])) {
                this.errors = [] as any;
                for (let item of _data["errors"])
                    this.errors!.push(ErrorMessage.fromJS(item));
            }
            this.version = _data["version"];
            this.environment = _data["environment"];
        }
    }

    static fromJS(data: any): GuidResponseResult {
        data = typeof data === 'object' ? data : {};
        let result = new GuidResponseResult();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["isSuccess"] = this.isSuccess;
        data["statusCode"] = this.statusCode;
        data["result"] = this.result;
        if (Array.isArray(this.errors)) {
            data["errors"] = [];
            for (let item of this.errors)
                data["errors"].push(item ? item.toJSON() : undefined as any);
        }
        data["version"] = this.version;
        data["environment"] = this.environment;
        return data;
    }
}


export interface IGuidResponseResult {
    isSuccess: boolean;
    statusCode: number;
    result: string;
    errors: ErrorMessage[] | undefined;
    version: string | undefined;
    environment: string | undefined;
}


export class IAMPolicyPasswordComplexity implements IIAMPolicyPasswordComplexity {
    minimumCharacters!: number | undefined;
    uppercaseLetters!: number | undefined;
    lowercaseLetters!: number | undefined;
    numbers!: number | undefined;
    specialCharacters!: boolean | undefined;
    maximumLength!: number | undefined;
    enforcedPasswordHistory!: number | undefined;
    banCommonPasswords!: boolean | undefined;

    constructor(data?: IIAMPolicyPasswordComplexity) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.minimumCharacters = _data["minimumCharacters"];
            this.uppercaseLetters = _data["uppercaseLetters"];
            this.lowercaseLetters = _data["lowercaseLetters"];
            this.numbers = _data["numbers"];
            this.specialCharacters = _data["specialCharacters"];
            this.maximumLength = _data["maximumLength"];
            this.enforcedPasswordHistory = _data["enforcedPasswordHistory"];
            this.banCommonPasswords = _data["banCommonPasswords"];
        }
    }

    static fromJS(data: any): IAMPolicyPasswordComplexity {
        data = typeof data === 'object' ? data : {};
        let result = new IAMPolicyPasswordComplexity();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["minimumCharacters"] = this.minimumCharacters;
        data["uppercaseLetters"] = this.uppercaseLetters;
        data["lowercaseLetters"] = this.lowercaseLetters;
        data["numbers"] = this.numbers;
        data["specialCharacters"] = this.specialCharacters;
        data["maximumLength"] = this.maximumLength;
        data["enforcedPasswordHistory"] = this.enforcedPasswordHistory;
        data["banCommonPasswords"] = this.banCommonPasswords;
        return data;
    }
}


export interface IIAMPolicyPasswordComplexity {
    minimumCharacters: number | undefined;
    uppercaseLetters: number | undefined;
    lowercaseLetters: number | undefined;
    numbers: number | undefined;
    specialCharacters: boolean | undefined;
    maximumLength: number | undefined;
    enforcedPasswordHistory: number | undefined;
    banCommonPasswords: boolean | undefined;
}


export class IAMPolicyPasswordComplexityResponseResult implements IIAMPolicyPasswordComplexityResponseResult {
    isSuccess!: boolean;
    statusCode!: number;
    result!: IAMPolicyPasswordComplexity;
    errors!: ErrorMessage[] | undefined;
    version!: string | undefined;
    environment!: string | undefined;

    constructor(data?: IIAMPolicyPasswordComplexityResponseResult) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.isSuccess = _data["isSuccess"];
            this.statusCode = _data["statusCode"];
            this.result = _data["result"] ? IAMPolicyPasswordComplexity.fromJS(_data["result"]) : undefined as any;
            if (Array.isArray(_data["errors"])) {
                this.errors = [] as any;
                for (let item of _data["errors"])
                    this.errors!.push(ErrorMessage.fromJS(item));
            }
            this.version = _data["version"];
            this.environment = _data["environment"];
        }
    }

    static fromJS(data: any): IAMPolicyPasswordComplexityResponseResult {
        data = typeof data === 'object' ? data : {};
        let result = new IAMPolicyPasswordComplexityResponseResult();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["isSuccess"] = this.isSuccess;
        data["statusCode"] = this.statusCode;
        data["result"] = this.result ? this.result.toJSON() : undefined as any;
        if (Array.isArray(this.errors)) {
            data["errors"] = [];
            for (let item of this.errors)
                data["errors"].push(item ? item.toJSON() : undefined as any);
        }
        data["version"] = this.version;
        data["environment"] = this.environment;
        return data;
    }
}


export interface IIAMPolicyPasswordComplexityResponseResult {
    isSuccess: boolean;
    statusCode: number;
    result: IAMPolicyPasswordComplexity;
    errors: ErrorMessage[] | undefined;
    version: string | undefined;
    environment: string | undefined;
}


export class Int32ResponseResult implements IInt32ResponseResult {
    isSuccess!: boolean;
    statusCode!: number;
    result!: number;
    errors!: ErrorMessage[] | undefined;
    version!: string | undefined;
    environment!: string | undefined;

    constructor(data?: IInt32ResponseResult) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.isSuccess = _data["isSuccess"];
            this.statusCode = _data["statusCode"];
            this.result = _data["result"];
            if (Array.isArray(_data["errors"])) {
                this.errors = [] as any;
                for (let item of _data["errors"])
                    this.errors!.push(ErrorMessage.fromJS(item));
            }
            this.version = _data["version"];
            this.environment = _data["environment"];
        }
    }

    static fromJS(data: any): Int32ResponseResult {
        data = typeof data === 'object' ? data : {};
        let result = new Int32ResponseResult();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["isSuccess"] = this.isSuccess;
        data["statusCode"] = this.statusCode;
        data["result"] = this.result;
        if (Array.isArray(this.errors)) {
            data["errors"] = [];
            for (let item of this.errors)
                data["errors"].push(item ? item.toJSON() : undefined as any);
        }
        data["version"] = this.version;
        data["environment"] = this.environment;
        return data;
    }
}


export interface IInt32ResponseResult {
    isSuccess: boolean;
    statusCode: number;
    result: number;
    errors: ErrorMessage[] | undefined;
    version: string | undefined;
    environment: string | undefined;
}


export class KeyValueModel implements IKeyValueModel {
    key!: string;
    value!: string | undefined;

    constructor(data?: IKeyValueModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.key = _data["key"];
            this.value = _data["value"];
        }
    }

    static fromJS(data: any): KeyValueModel {
        data = typeof data === 'object' ? data : {};
        let result = new KeyValueModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["key"] = this.key;
        data["value"] = this.value;
        return data;
    }
}


export interface IKeyValueModel {
    key: string;
    value: string | undefined;
}


export class KeyValueModelListResponseResult implements IKeyValueModelListResponseResult {
    isSuccess!: boolean;
    statusCode!: number;
    result!: KeyValueModel[] | undefined;
    errors!: ErrorMessage[] | undefined;
    version!: string | undefined;
    environment!: string | undefined;

    constructor(data?: IKeyValueModelListResponseResult) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.isSuccess = _data["isSuccess"];
            this.statusCode = _data["statusCode"];
            if (Array.isArray(_data["result"])) {
                this.result = [] as any;
                for (let item of _data["result"])
                    this.result!.push(KeyValueModel.fromJS(item));
            }
            if (Array.isArray(_data["errors"])) {
                this.errors = [] as any;
                for (let item of _data["errors"])
                    this.errors!.push(ErrorMessage.fromJS(item));
            }
            this.version = _data["version"];
            this.environment = _data["environment"];
        }
    }

    static fromJS(data: any): KeyValueModelListResponseResult {
        data = typeof data === 'object' ? data : {};
        let result = new KeyValueModelListResponseResult();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["isSuccess"] = this.isSuccess;
        data["statusCode"] = this.statusCode;
        if (Array.isArray(this.result)) {
            data["result"] = [];
            for (let item of this.result)
                data["result"].push(item ? item.toJSON() : undefined as any);
        }
        if (Array.isArray(this.errors)) {
            data["errors"] = [];
            for (let item of this.errors)
                data["errors"].push(item ? item.toJSON() : undefined as any);
        }
        data["version"] = this.version;
        data["environment"] = this.environment;
        return data;
    }
}


export interface IKeyValueModelListResponseResult {
    isSuccess: boolean;
    statusCode: number;
    result: KeyValueModel[] | undefined;
    errors: ErrorMessage[] | undefined;
    version: string | undefined;
    environment: string | undefined;
}


export class KeyValueModelString implements IKeyValueModelString {
    key!: string | undefined;
    value!: string | undefined;

    constructor(data?: IKeyValueModelString) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.key = _data["key"];
            this.value = _data["value"];
        }
    }

    static fromJS(data: any): KeyValueModelString {
        data = typeof data === 'object' ? data : {};
        let result = new KeyValueModelString();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["key"] = this.key;
        data["value"] = this.value;
        return data;
    }
}


export interface IKeyValueModelString {
    key: string | undefined;
    value: string | undefined;
}


export class KmlValidationResult implements IKmlValidationResult {
    isValid!: boolean;
    errorMessage!: string | undefined;
    coordinates!: PolygonItem[] | undefined;
    area!: number | undefined;
    kmlImportId!: string | undefined;

    constructor(data?: IKmlValidationResult) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.isValid = _data["isValid"];
            this.errorMessage = _data["errorMessage"];
            if (Array.isArray(_data["coordinates"])) {
                this.coordinates = [] as any;
                for (let item of _data["coordinates"])
                    this.coordinates!.push(PolygonItem.fromJS(item));
            }
            this.area = _data["area"];
            this.kmlImportId = _data["kmlImportId"];
        }
    }

    static fromJS(data: any): KmlValidationResult {
        data = typeof data === 'object' ? data : {};
        let result = new KmlValidationResult();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["isValid"] = this.isValid;
        data["errorMessage"] = this.errorMessage;
        if (Array.isArray(this.coordinates)) {
            data["coordinates"] = [];
            for (let item of this.coordinates)
                data["coordinates"].push(item ? item.toJSON() : undefined as any);
        }
        data["area"] = this.area;
        data["kmlImportId"] = this.kmlImportId;
        return data;
    }
}


export interface IKmlValidationResult {
    isValid: boolean;
    errorMessage: string | undefined;
    coordinates: PolygonItem[] | undefined;
    area: number | undefined;
    kmlImportId: string | undefined;
}


export class KmlValidationResultResponseResult implements IKmlValidationResultResponseResult {
    isSuccess!: boolean;
    statusCode!: number;
    result!: KmlValidationResult;
    errors!: ErrorMessage[] | undefined;
    version!: string | undefined;
    environment!: string | undefined;

    constructor(data?: IKmlValidationResultResponseResult) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.isSuccess = _data["isSuccess"];
            this.statusCode = _data["statusCode"];
            this.result = _data["result"] ? KmlValidationResult.fromJS(_data["result"]) : undefined as any;
            if (Array.isArray(_data["errors"])) {
                this.errors = [] as any;
                for (let item of _data["errors"])
                    this.errors!.push(ErrorMessage.fromJS(item));
            }
            this.version = _data["version"];
            this.environment = _data["environment"];
        }
    }

    static fromJS(data: any): KmlValidationResultResponseResult {
        data = typeof data === 'object' ? data : {};
        let result = new KmlValidationResultResponseResult();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["isSuccess"] = this.isSuccess;
        data["statusCode"] = this.statusCode;
        data["result"] = this.result ? this.result.toJSON() : undefined as any;
        if (Array.isArray(this.errors)) {
            data["errors"] = [];
            for (let item of this.errors)
                data["errors"].push(item ? item.toJSON() : undefined as any);
        }
        data["version"] = this.version;
        data["environment"] = this.environment;
        return data;
    }
}


export interface IKmlValidationResultResponseResult {
    isSuccess: boolean;
    statusCode: number;
    result: KmlValidationResult;
    errors: ErrorMessage[] | undefined;
    version: string | undefined;
    environment: string | undefined;
}


export class LandPaginatedViewModel implements ILandPaginatedViewModel {
    id!: string;
    displayId!: number | undefined;
    name!: string | undefined;
    totalArea!: number | undefined;
    location!: string | undefined;
    kmlData!: string | undefined;
    parcelInquiryData!: string | undefined;
    createdAt!: DateTime;
    updatedAt!: DateTime;
    enterpriseId!: string;
    enterpriseName!: string | undefined;
    appId!: string;
    appName!: string | undefined;
    assetOwnershipId!: string;
    assetOwnershipName!: string | undefined;
    countryId!: string | undefined;
    countryName!: string | undefined;
    stateId!: string | undefined;
    stateName!: string | undefined;
    cityId!: string | undefined;
    cityName!: string | undefined;
    districtId!: string | undefined;
    districtName!: string | undefined;
    villageId!: string | undefined;
    villageName!: string | undefined;
    regionId!: string | undefined;
    regionName!: string | undefined;
    weatherSpotId!: string | undefined;
    timezoneId!: string | undefined;
    timezoneName!: string | undefined;
    plantationCount!: number;
    totalPlantationArea!: number | undefined;
    isActive!: boolean;
    isDeleted!: boolean;
    isAnonymized!: boolean;
    note!: string | undefined;
    createdBy!: number;
    updatedBy!: number;
    isLandFull!: boolean;

    constructor(data?: ILandPaginatedViewModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.displayId = _data["displayId"];
            this.name = _data["name"];
            this.totalArea = _data["totalArea"];
            this.location = _data["location"];
            this.kmlData = _data["kmlData"];
            this.parcelInquiryData = _data["parcelInquiryData"];
            this.createdAt = _data["createdAt"] ? DateTime.fromISO(_data["createdAt"].toString()) : undefined as any;
            this.updatedAt = _data["updatedAt"] ? DateTime.fromISO(_data["updatedAt"].toString()) : undefined as any;
            this.enterpriseId = _data["enterpriseId"];
            this.enterpriseName = _data["enterpriseName"];
            this.appId = _data["appId"];
            this.appName = _data["appName"];
            this.assetOwnershipId = _data["assetOwnershipId"];
            this.assetOwnershipName = _data["assetOwnershipName"];
            this.countryId = _data["countryId"];
            this.countryName = _data["countryName"];
            this.stateId = _data["stateId"];
            this.stateName = _data["stateName"];
            this.cityId = _data["cityId"];
            this.cityName = _data["cityName"];
            this.districtId = _data["districtId"];
            this.districtName = _data["districtName"];
            this.villageId = _data["villageId"];
            this.villageName = _data["villageName"];
            this.regionId = _data["regionId"];
            this.regionName = _data["regionName"];
            this.weatherSpotId = _data["weatherSpotId"];
            this.timezoneId = _data["timezoneId"];
            this.timezoneName = _data["timezoneName"];
            this.plantationCount = _data["plantationCount"];
            this.totalPlantationArea = _data["totalPlantationArea"];
            this.isActive = _data["isActive"];
            this.isDeleted = _data["isDeleted"];
            this.isAnonymized = _data["isAnonymized"];
            this.note = _data["note"];
            this.createdBy = _data["createdBy"];
            this.updatedBy = _data["updatedBy"];
            this.isLandFull = _data["isLandFull"];
        }
    }

    static fromJS(data: any): LandPaginatedViewModel {
        data = typeof data === 'object' ? data : {};
        let result = new LandPaginatedViewModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["displayId"] = this.displayId;
        data["name"] = this.name;
        data["totalArea"] = this.totalArea;
        data["location"] = this.location;
        data["kmlData"] = this.kmlData;
        data["parcelInquiryData"] = this.parcelInquiryData;
        data["createdAt"] = this.createdAt ? this.createdAt.toString() : undefined as any;
        data["updatedAt"] = this.updatedAt ? this.updatedAt.toString() : undefined as any;
        data["enterpriseId"] = this.enterpriseId;
        data["enterpriseName"] = this.enterpriseName;
        data["appId"] = this.appId;
        data["appName"] = this.appName;
        data["assetOwnershipId"] = this.assetOwnershipId;
        data["assetOwnershipName"] = this.assetOwnershipName;
        data["countryId"] = this.countryId;
        data["countryName"] = this.countryName;
        data["stateId"] = this.stateId;
        data["stateName"] = this.stateName;
        data["cityId"] = this.cityId;
        data["cityName"] = this.cityName;
        data["districtId"] = this.districtId;
        data["districtName"] = this.districtName;
        data["villageId"] = this.villageId;
        data["villageName"] = this.villageName;
        data["regionId"] = this.regionId;
        data["regionName"] = this.regionName;
        data["weatherSpotId"] = this.weatherSpotId;
        data["timezoneId"] = this.timezoneId;
        data["timezoneName"] = this.timezoneName;
        data["plantationCount"] = this.plantationCount;
        data["totalPlantationArea"] = this.totalPlantationArea;
        data["isActive"] = this.isActive;
        data["isDeleted"] = this.isDeleted;
        data["isAnonymized"] = this.isAnonymized;
        data["note"] = this.note;
        data["createdBy"] = this.createdBy;
        data["updatedBy"] = this.updatedBy;
        data["isLandFull"] = this.isLandFull;
        return data;
    }
}


export interface ILandPaginatedViewModel {
    id: string;
    displayId: number | undefined;
    name: string | undefined;
    totalArea: number | undefined;
    location: string | undefined;
    kmlData: string | undefined;
    parcelInquiryData: string | undefined;
    createdAt: DateTime;
    updatedAt: DateTime;
    enterpriseId: string;
    enterpriseName: string | undefined;
    appId: string;
    appName: string | undefined;
    assetOwnershipId: string;
    assetOwnershipName: string | undefined;
    countryId: string | undefined;
    countryName: string | undefined;
    stateId: string | undefined;
    stateName: string | undefined;
    cityId: string | undefined;
    cityName: string | undefined;
    districtId: string | undefined;
    districtName: string | undefined;
    villageId: string | undefined;
    villageName: string | undefined;
    regionId: string | undefined;
    regionName: string | undefined;
    weatherSpotId: string | undefined;
    timezoneId: string | undefined;
    timezoneName: string | undefined;
    plantationCount: number;
    totalPlantationArea: number | undefined;
    isActive: boolean;
    isDeleted: boolean;
    isAnonymized: boolean;
    note: string | undefined;
    createdBy: number;
    updatedBy: number;
    isLandFull: boolean;
}


export class LandPaginatedViewModelPaginatedResponse implements ILandPaginatedViewModelPaginatedResponse {
    items!: LandPaginatedViewModel[] | undefined;
    pageNumber!: number;
    pageSize!: number;
    totalCount!: number;
    totalPages!: number;
    hasPreviousPage!: boolean;
    hasNextPage!: boolean;
    appliedSorts!: SortCriteria[] | undefined;
    appliedFilters!: FilterCriteria[] | undefined;

    constructor(data?: ILandPaginatedViewModelPaginatedResponse) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["items"])) {
                this.items = [] as any;
                for (let item of _data["items"])
                    this.items!.push(LandPaginatedViewModel.fromJS(item));
            }
            this.pageNumber = _data["pageNumber"];
            this.pageSize = _data["pageSize"];
            this.totalCount = _data["totalCount"];
            this.totalPages = _data["totalPages"];
            this.hasPreviousPage = _data["hasPreviousPage"];
            this.hasNextPage = _data["hasNextPage"];
            if (Array.isArray(_data["appliedSorts"])) {
                this.appliedSorts = [] as any;
                for (let item of _data["appliedSorts"])
                    this.appliedSorts!.push(SortCriteria.fromJS(item));
            }
            if (Array.isArray(_data["appliedFilters"])) {
                this.appliedFilters = [] as any;
                for (let item of _data["appliedFilters"])
                    this.appliedFilters!.push(FilterCriteria.fromJS(item));
            }
        }
    }

    static fromJS(data: any): LandPaginatedViewModelPaginatedResponse {
        data = typeof data === 'object' ? data : {};
        let result = new LandPaginatedViewModelPaginatedResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.items)) {
            data["items"] = [];
            for (let item of this.items)
                data["items"].push(item ? item.toJSON() : undefined as any);
        }
        data["pageNumber"] = this.pageNumber;
        data["pageSize"] = this.pageSize;
        data["totalCount"] = this.totalCount;
        data["totalPages"] = this.totalPages;
        data["hasPreviousPage"] = this.hasPreviousPage;
        data["hasNextPage"] = this.hasNextPage;
        if (Array.isArray(this.appliedSorts)) {
            data["appliedSorts"] = [];
            for (let item of this.appliedSorts)
                data["appliedSorts"].push(item ? item.toJSON() : undefined as any);
        }
        if (Array.isArray(this.appliedFilters)) {
            data["appliedFilters"] = [];
            for (let item of this.appliedFilters)
                data["appliedFilters"].push(item ? item.toJSON() : undefined as any);
        }
        return data;
    }
}


export interface ILandPaginatedViewModelPaginatedResponse {
    items: LandPaginatedViewModel[] | undefined;
    pageNumber: number;
    pageSize: number;
    totalCount: number;
    totalPages: number;
    hasPreviousPage: boolean;
    hasNextPage: boolean;
    appliedSorts: SortCriteria[] | undefined;
    appliedFilters: FilterCriteria[] | undefined;
}


export class LandPaginatedViewModelPaginatedResponseResponseResult implements ILandPaginatedViewModelPaginatedResponseResponseResult {
    isSuccess!: boolean;
    statusCode!: number;
    result!: LandPaginatedViewModelPaginatedResponse;
    errors!: ErrorMessage[] | undefined;
    version!: string | undefined;
    environment!: string | undefined;

    constructor(data?: ILandPaginatedViewModelPaginatedResponseResponseResult) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.isSuccess = _data["isSuccess"];
            this.statusCode = _data["statusCode"];
            this.result = _data["result"] ? LandPaginatedViewModelPaginatedResponse.fromJS(_data["result"]) : undefined as any;
            if (Array.isArray(_data["errors"])) {
                this.errors = [] as any;
                for (let item of _data["errors"])
                    this.errors!.push(ErrorMessage.fromJS(item));
            }
            this.version = _data["version"];
            this.environment = _data["environment"];
        }
    }

    static fromJS(data: any): LandPaginatedViewModelPaginatedResponseResponseResult {
        data = typeof data === 'object' ? data : {};
        let result = new LandPaginatedViewModelPaginatedResponseResponseResult();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["isSuccess"] = this.isSuccess;
        data["statusCode"] = this.statusCode;
        data["result"] = this.result ? this.result.toJSON() : undefined as any;
        if (Array.isArray(this.errors)) {
            data["errors"] = [];
            for (let item of this.errors)
                data["errors"].push(item ? item.toJSON() : undefined as any);
        }
        data["version"] = this.version;
        data["environment"] = this.environment;
        return data;
    }
}


export interface ILandPaginatedViewModelPaginatedResponseResponseResult {
    isSuccess: boolean;
    statusCode: number;
    result: LandPaginatedViewModelPaginatedResponse;
    errors: ErrorMessage[] | undefined;
    version: string | undefined;
    environment: string | undefined;
}


export class LandPlantationViewModel implements ILandPlantationViewModel {
    id!: string;
    displayId!: number | undefined;
    name!: string | undefined;
    totalArea!: number | undefined;
    readonly totalAreaDisplay!: string | undefined;
    activeCropColor!: string | undefined;
    image!: string | undefined;
    boundaries!: CoordinateViewModel[] | undefined;
    rotations!: RotationViewModel[] | undefined;

    constructor(data?: ILandPlantationViewModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.displayId = _data["displayId"];
            this.name = _data["name"];
            this.totalArea = _data["totalArea"];
            (this as any).totalAreaDisplay = _data["totalAreaDisplay"];
            this.activeCropColor = _data["activeCropColor"];
            this.image = _data["image"];
            if (Array.isArray(_data["boundaries"])) {
                this.boundaries = [] as any;
                for (let item of _data["boundaries"])
                    this.boundaries!.push(CoordinateViewModel.fromJS(item));
            }
            if (Array.isArray(_data["rotations"])) {
                this.rotations = [] as any;
                for (let item of _data["rotations"])
                    this.rotations!.push(RotationViewModel.fromJS(item));
            }
        }
    }

    static fromJS(data: any): LandPlantationViewModel {
        data = typeof data === 'object' ? data : {};
        let result = new LandPlantationViewModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["displayId"] = this.displayId;
        data["name"] = this.name;
        data["totalArea"] = this.totalArea;
        data["totalAreaDisplay"] = this.totalAreaDisplay;
        data["activeCropColor"] = this.activeCropColor;
        data["image"] = this.image;
        if (Array.isArray(this.boundaries)) {
            data["boundaries"] = [];
            for (let item of this.boundaries)
                data["boundaries"].push(item ? item.toJSON() : undefined as any);
        }
        if (Array.isArray(this.rotations)) {
            data["rotations"] = [];
            for (let item of this.rotations)
                data["rotations"].push(item ? item.toJSON() : undefined as any);
        }
        return data;
    }
}


export interface ILandPlantationViewModel {
    id: string;
    displayId: number | undefined;
    name: string | undefined;
    totalArea: number | undefined;
    totalAreaDisplay: string | undefined;
    activeCropColor: string | undefined;
    image: string | undefined;
    boundaries: CoordinateViewModel[] | undefined;
    rotations: RotationViewModel[] | undefined;
}


export class LandRegenerativePracticeItemViewModel implements ILandRegenerativePracticeItemViewModel {
    accessKey!: string;
    code!: string | undefined;
    name!: string | undefined;

    constructor(data?: ILandRegenerativePracticeItemViewModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.accessKey = _data["accessKey"];
            this.code = _data["code"];
            this.name = _data["name"];
        }
    }

    static fromJS(data: any): LandRegenerativePracticeItemViewModel {
        data = typeof data === 'object' ? data : {};
        let result = new LandRegenerativePracticeItemViewModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["accessKey"] = this.accessKey;
        data["code"] = this.code;
        data["name"] = this.name;
        return data;
    }
}


export interface ILandRegenerativePracticeItemViewModel {
    accessKey: string;
    code: string | undefined;
    name: string | undefined;
}


export class LandViewModel implements ILandViewModel {
    id!: string;
    displayId!: number | undefined;
    enterpriseId!: string;
    appId!: string;
    assetOwnershipId!: string;
    name!: string | undefined;
    readonly coordinatesWkt!: string | undefined;
    totalArea!: number | undefined;
    readonly totalAreaDisplay!: string | undefined;
    ownershipStatus!: KeyValueModel;
    plantationCount!: number | undefined;
    countryName!: string | undefined;
    stateName!: string | undefined;
    cityName!: string | undefined;
    districtName!: string | undefined;
    villageName!: string | undefined;
    countryId!: string | undefined;
    regionId!: string | undefined;
    stateId!: string | undefined;
    cityId!: string | undefined;
    districtId!: string | undefined;
    villageId!: string | undefined;
    timeZoneId!: string | undefined;
    weatherSpotId!: string | undefined;
    kmlData!: string | undefined;
    parcelInquiryData!: string | undefined;
    boundaries!: CoordinateViewModel[] | undefined;
    createdAt!: DateTime;
    enterpriseName!: string | undefined;
    isActive!: boolean;
    isDeleted!: boolean;
    plantations!: LandPlantationViewModel[] | undefined;
    readonly image!: string | undefined;
    readonly location!: string | undefined;
    activeCrops!: ActiveCropModel[] | undefined;
    note!: string | undefined;
    appName!: string | undefined;
    timezoneName!: string | undefined;
    updatedAt!: DateTime;
    createdBy!: number;
    updatedBy!: number;
    assetOwnershipName!: string | undefined;
    isLandFull!: boolean;
    readOnly!: boolean;
    regenerativePractices!: LandRegenerativePracticeItemViewModel[] | undefined;

    constructor(data?: ILandViewModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.displayId = _data["displayId"];
            this.enterpriseId = _data["enterpriseId"];
            this.appId = _data["appId"];
            this.assetOwnershipId = _data["assetOwnershipId"];
            this.name = _data["name"];
            (this as any).coordinatesWkt = _data["coordinatesWkt"];
            this.totalArea = _data["totalArea"];
            (this as any).totalAreaDisplay = _data["totalAreaDisplay"];
            this.ownershipStatus = _data["ownershipStatus"] ? KeyValueModel.fromJS(_data["ownershipStatus"]) : undefined as any;
            this.plantationCount = _data["plantationCount"];
            this.countryName = _data["countryName"];
            this.stateName = _data["stateName"];
            this.cityName = _data["cityName"];
            this.districtName = _data["districtName"];
            this.villageName = _data["villageName"];
            this.countryId = _data["countryId"];
            this.regionId = _data["regionId"];
            this.stateId = _data["stateId"];
            this.cityId = _data["cityId"];
            this.districtId = _data["districtId"];
            this.villageId = _data["villageId"];
            this.timeZoneId = _data["timeZoneId"];
            this.weatherSpotId = _data["weatherSpotId"];
            this.kmlData = _data["kmlData"];
            this.parcelInquiryData = _data["parcelInquiryData"];
            if (Array.isArray(_data["boundaries"])) {
                this.boundaries = [] as any;
                for (let item of _data["boundaries"])
                    this.boundaries!.push(CoordinateViewModel.fromJS(item));
            }
            this.createdAt = _data["createdAt"] ? DateTime.fromISO(_data["createdAt"].toString()) : undefined as any;
            this.enterpriseName = _data["enterpriseName"];
            this.isActive = _data["isActive"];
            this.isDeleted = _data["isDeleted"];
            if (Array.isArray(_data["plantations"])) {
                this.plantations = [] as any;
                for (let item of _data["plantations"])
                    this.plantations!.push(LandPlantationViewModel.fromJS(item));
            }
            (this as any).image = _data["image"];
            (this as any).location = _data["location"];
            if (Array.isArray(_data["activeCrops"])) {
                this.activeCrops = [] as any;
                for (let item of _data["activeCrops"])
                    this.activeCrops!.push(ActiveCropModel.fromJS(item));
            }
            this.note = _data["note"];
            this.appName = _data["appName"];
            this.timezoneName = _data["timezoneName"];
            this.updatedAt = _data["updatedAt"] ? DateTime.fromISO(_data["updatedAt"].toString()) : undefined as any;
            this.createdBy = _data["createdBy"];
            this.updatedBy = _data["updatedBy"];
            this.assetOwnershipName = _data["assetOwnershipName"];
            this.isLandFull = _data["isLandFull"];
            this.readOnly = _data["readOnly"];
            if (Array.isArray(_data["regenerativePractices"])) {
                this.regenerativePractices = [] as any;
                for (let item of _data["regenerativePractices"])
                    this.regenerativePractices!.push(LandRegenerativePracticeItemViewModel.fromJS(item));
            }
        }
    }

    static fromJS(data: any): LandViewModel {
        data = typeof data === 'object' ? data : {};
        let result = new LandViewModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["displayId"] = this.displayId;
        data["enterpriseId"] = this.enterpriseId;
        data["appId"] = this.appId;
        data["assetOwnershipId"] = this.assetOwnershipId;
        data["name"] = this.name;
        data["coordinatesWkt"] = this.coordinatesWkt;
        data["totalArea"] = this.totalArea;
        data["totalAreaDisplay"] = this.totalAreaDisplay;
        data["ownershipStatus"] = this.ownershipStatus ? this.ownershipStatus.toJSON() : undefined as any;
        data["plantationCount"] = this.plantationCount;
        data["countryName"] = this.countryName;
        data["stateName"] = this.stateName;
        data["cityName"] = this.cityName;
        data["districtName"] = this.districtName;
        data["villageName"] = this.villageName;
        data["countryId"] = this.countryId;
        data["regionId"] = this.regionId;
        data["stateId"] = this.stateId;
        data["cityId"] = this.cityId;
        data["districtId"] = this.districtId;
        data["villageId"] = this.villageId;
        data["timeZoneId"] = this.timeZoneId;
        data["weatherSpotId"] = this.weatherSpotId;
        data["kmlData"] = this.kmlData;
        data["parcelInquiryData"] = this.parcelInquiryData;
        if (Array.isArray(this.boundaries)) {
            data["boundaries"] = [];
            for (let item of this.boundaries)
                data["boundaries"].push(item ? item.toJSON() : undefined as any);
        }
        data["createdAt"] = this.createdAt ? this.createdAt.toString() : undefined as any;
        data["enterpriseName"] = this.enterpriseName;
        data["isActive"] = this.isActive;
        data["isDeleted"] = this.isDeleted;
        if (Array.isArray(this.plantations)) {
            data["plantations"] = [];
            for (let item of this.plantations)
                data["plantations"].push(item ? item.toJSON() : undefined as any);
        }
        data["image"] = this.image;
        data["location"] = this.location;
        if (Array.isArray(this.activeCrops)) {
            data["activeCrops"] = [];
            for (let item of this.activeCrops)
                data["activeCrops"].push(item ? item.toJSON() : undefined as any);
        }
        data["note"] = this.note;
        data["appName"] = this.appName;
        data["timezoneName"] = this.timezoneName;
        data["updatedAt"] = this.updatedAt ? this.updatedAt.toString() : undefined as any;
        data["createdBy"] = this.createdBy;
        data["updatedBy"] = this.updatedBy;
        data["assetOwnershipName"] = this.assetOwnershipName;
        data["isLandFull"] = this.isLandFull;
        data["readOnly"] = this.readOnly;
        if (Array.isArray(this.regenerativePractices)) {
            data["regenerativePractices"] = [];
            for (let item of this.regenerativePractices)
                data["regenerativePractices"].push(item ? item.toJSON() : undefined as any);
        }
        return data;
    }
}


export interface ILandViewModel {
    id: string;
    displayId: number | undefined;
    enterpriseId: string;
    appId: string;
    assetOwnershipId: string;
    name: string | undefined;
    coordinatesWkt: string | undefined;
    totalArea: number | undefined;
    totalAreaDisplay: string | undefined;
    ownershipStatus: KeyValueModel;
    plantationCount: number | undefined;
    countryName: string | undefined;
    stateName: string | undefined;
    cityName: string | undefined;
    districtName: string | undefined;
    villageName: string | undefined;
    countryId: string | undefined;
    regionId: string | undefined;
    stateId: string | undefined;
    cityId: string | undefined;
    districtId: string | undefined;
    villageId: string | undefined;
    timeZoneId: string | undefined;
    weatherSpotId: string | undefined;
    kmlData: string | undefined;
    parcelInquiryData: string | undefined;
    boundaries: CoordinateViewModel[] | undefined;
    createdAt: DateTime;
    enterpriseName: string | undefined;
    isActive: boolean;
    isDeleted: boolean;
    plantations: LandPlantationViewModel[] | undefined;
    image: string | undefined;
    location: string | undefined;
    activeCrops: ActiveCropModel[] | undefined;
    note: string | undefined;
    appName: string | undefined;
    timezoneName: string | undefined;
    updatedAt: DateTime;
    createdBy: number;
    updatedBy: number;
    assetOwnershipName: string | undefined;
    isLandFull: boolean;
    readOnly: boolean;
    regenerativePractices: LandRegenerativePracticeItemViewModel[] | undefined;
}


export class LandViewModelResponseResult implements ILandViewModelResponseResult {
    isSuccess!: boolean;
    statusCode!: number;
    result!: LandViewModel;
    errors!: ErrorMessage[] | undefined;
    version!: string | undefined;
    environment!: string | undefined;

    constructor(data?: ILandViewModelResponseResult) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.isSuccess = _data["isSuccess"];
            this.statusCode = _data["statusCode"];
            this.result = _data["result"] ? LandViewModel.fromJS(_data["result"]) : undefined as any;
            if (Array.isArray(_data["errors"])) {
                this.errors = [] as any;
                for (let item of _data["errors"])
                    this.errors!.push(ErrorMessage.fromJS(item));
            }
            this.version = _data["version"];
            this.environment = _data["environment"];
        }
    }

    static fromJS(data: any): LandViewModelResponseResult {
        data = typeof data === 'object' ? data : {};
        let result = new LandViewModelResponseResult();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["isSuccess"] = this.isSuccess;
        data["statusCode"] = this.statusCode;
        data["result"] = this.result ? this.result.toJSON() : undefined as any;
        if (Array.isArray(this.errors)) {
            data["errors"] = [];
            for (let item of this.errors)
                data["errors"].push(item ? item.toJSON() : undefined as any);
        }
        data["version"] = this.version;
        data["environment"] = this.environment;
        return data;
    }
}


export interface ILandViewModelResponseResult {
    isSuccess: boolean;
    statusCode: number;
    result: LandViewModel;
    errors: ErrorMessage[] | undefined;
    version: string | undefined;
    environment: string | undefined;
}


export class LanguageViewModel implements ILanguageViewModel {
    id!: string;
    language!: string | undefined;
    nativeName!: string | undefined;
    isO1!: string | undefined;

    constructor(data?: ILanguageViewModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.language = _data["language"];
            this.nativeName = _data["nativeName"];
            this.isO1 = _data["isO1"];
        }
    }

    static fromJS(data: any): LanguageViewModel {
        data = typeof data === 'object' ? data : {};
        let result = new LanguageViewModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["language"] = this.language;
        data["nativeName"] = this.nativeName;
        data["isO1"] = this.isO1;
        return data;
    }
}


export interface ILanguageViewModel {
    id: string;
    language: string | undefined;
    nativeName: string | undefined;
    isO1: string | undefined;
}


export class LanguageViewModelListResponseResult implements ILanguageViewModelListResponseResult {
    isSuccess!: boolean;
    statusCode!: number;
    result!: LanguageViewModel[] | undefined;
    errors!: ErrorMessage[] | undefined;
    version!: string | undefined;
    environment!: string | undefined;

    constructor(data?: ILanguageViewModelListResponseResult) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.isSuccess = _data["isSuccess"];
            this.statusCode = _data["statusCode"];
            if (Array.isArray(_data["result"])) {
                this.result = [] as any;
                for (let item of _data["result"])
                    this.result!.push(LanguageViewModel.fromJS(item));
            }
            if (Array.isArray(_data["errors"])) {
                this.errors = [] as any;
                for (let item of _data["errors"])
                    this.errors!.push(ErrorMessage.fromJS(item));
            }
            this.version = _data["version"];
            this.environment = _data["environment"];
        }
    }

    static fromJS(data: any): LanguageViewModelListResponseResult {
        data = typeof data === 'object' ? data : {};
        let result = new LanguageViewModelListResponseResult();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["isSuccess"] = this.isSuccess;
        data["statusCode"] = this.statusCode;
        if (Array.isArray(this.result)) {
            data["result"] = [];
            for (let item of this.result)
                data["result"].push(item ? item.toJSON() : undefined as any);
        }
        if (Array.isArray(this.errors)) {
            data["errors"] = [];
            for (let item of this.errors)
                data["errors"].push(item ? item.toJSON() : undefined as any);
        }
        data["version"] = this.version;
        data["environment"] = this.environment;
        return data;
    }
}


export interface ILanguageViewModelListResponseResult {
    isSuccess: boolean;
    statusCode: number;
    result: LanguageViewModel[] | undefined;
    errors: ErrorMessage[] | undefined;
    version: string | undefined;
    environment: string | undefined;
}


export class LockUserCommand implements ILockUserCommand {
    id!: string;
    reason!: string | undefined;
    totp!: number;
    lockUntil!: DateTime | undefined;

    constructor(data?: ILockUserCommand) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.reason = _data["reason"];
            this.totp = _data["totp"];
            this.lockUntil = _data["lockUntil"] ? DateTime.fromISO(_data["lockUntil"].toString()) : undefined as any;
        }
    }

    static fromJS(data: any): LockUserCommand {
        data = typeof data === 'object' ? data : {};
        let result = new LockUserCommand();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["reason"] = this.reason;
        data["totp"] = this.totp;
        data["lockUntil"] = this.lockUntil ? this.lockUntil.toString() : undefined as any;
        return data;
    }
}


export interface ILockUserCommand {
    id: string;
    reason: string | undefined;
    totp: number;
    lockUntil: DateTime | undefined;
}


export class MobileAppVersionViewModel implements IMobileAppVersionViewModel {
    android!: PlatformVersion;
    ios!: PlatformVersion;

    constructor(data?: IMobileAppVersionViewModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.android = _data["android"] ? PlatformVersion.fromJS(_data["android"]) : undefined as any;
            this.ios = _data["ios"] ? PlatformVersion.fromJS(_data["ios"]) : undefined as any;
        }
    }

    static fromJS(data: any): MobileAppVersionViewModel {
        data = typeof data === 'object' ? data : {};
        let result = new MobileAppVersionViewModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["android"] = this.android ? this.android.toJSON() : undefined as any;
        data["ios"] = this.ios ? this.ios.toJSON() : undefined as any;
        return data;
    }
}


export interface IMobileAppVersionViewModel {
    android: PlatformVersion;
    ios: PlatformVersion;
}


export class MyPermissionViewModel implements IMyPermissionViewModel {
    code!: string | undefined;
    name!: string | undefined;

    constructor(data?: IMyPermissionViewModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.code = _data["code"];
            this.name = _data["name"];
        }
    }

    static fromJS(data: any): MyPermissionViewModel {
        data = typeof data === 'object' ? data : {};
        let result = new MyPermissionViewModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["code"] = this.code;
        data["name"] = this.name;
        return data;
    }
}


export interface IMyPermissionViewModel {
    code: string | undefined;
    name: string | undefined;
}


export class MyPermissionViewModelListResponseResult implements IMyPermissionViewModelListResponseResult {
    isSuccess!: boolean;
    statusCode!: number;
    result!: MyPermissionViewModel[] | undefined;
    errors!: ErrorMessage[] | undefined;
    version!: string | undefined;
    environment!: string | undefined;

    constructor(data?: IMyPermissionViewModelListResponseResult) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.isSuccess = _data["isSuccess"];
            this.statusCode = _data["statusCode"];
            if (Array.isArray(_data["result"])) {
                this.result = [] as any;
                for (let item of _data["result"])
                    this.result!.push(MyPermissionViewModel.fromJS(item));
            }
            if (Array.isArray(_data["errors"])) {
                this.errors = [] as any;
                for (let item of _data["errors"])
                    this.errors!.push(ErrorMessage.fromJS(item));
            }
            this.version = _data["version"];
            this.environment = _data["environment"];
        }
    }

    static fromJS(data: any): MyPermissionViewModelListResponseResult {
        data = typeof data === 'object' ? data : {};
        let result = new MyPermissionViewModelListResponseResult();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["isSuccess"] = this.isSuccess;
        data["statusCode"] = this.statusCode;
        if (Array.isArray(this.result)) {
            data["result"] = [];
            for (let item of this.result)
                data["result"].push(item ? item.toJSON() : undefined as any);
        }
        if (Array.isArray(this.errors)) {
            data["errors"] = [];
            for (let item of this.errors)
                data["errors"].push(item ? item.toJSON() : undefined as any);
        }
        data["version"] = this.version;
        data["environment"] = this.environment;
        return data;
    }
}


export interface IMyPermissionViewModelListResponseResult {
    isSuccess: boolean;
    statusCode: number;
    result: MyPermissionViewModel[] | undefined;
    errors: ErrorMessage[] | undefined;
    version: string | undefined;
    environment: string | undefined;
}


export class NoteTagsLookupModel implements INoteTagsLookupModel {
    key!: string;
    value!: string | undefined;
    icon!: string | undefined;

    constructor(data?: INoteTagsLookupModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.key = _data["key"];
            this.value = _data["value"];
            this.icon = _data["icon"];
        }
    }

    static fromJS(data: any): NoteTagsLookupModel {
        data = typeof data === 'object' ? data : {};
        let result = new NoteTagsLookupModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["key"] = this.key;
        data["value"] = this.value;
        data["icon"] = this.icon;
        return data;
    }
}


export interface INoteTagsLookupModel {
    key: string;
    value: string | undefined;
    icon: string | undefined;
}


export class NoteTagsLookupModelListResponseResult implements INoteTagsLookupModelListResponseResult {
    isSuccess!: boolean;
    statusCode!: number;
    result!: NoteTagsLookupModel[] | undefined;
    errors!: ErrorMessage[] | undefined;
    version!: string | undefined;
    environment!: string | undefined;

    constructor(data?: INoteTagsLookupModelListResponseResult) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.isSuccess = _data["isSuccess"];
            this.statusCode = _data["statusCode"];
            if (Array.isArray(_data["result"])) {
                this.result = [] as any;
                for (let item of _data["result"])
                    this.result!.push(NoteTagsLookupModel.fromJS(item));
            }
            if (Array.isArray(_data["errors"])) {
                this.errors = [] as any;
                for (let item of _data["errors"])
                    this.errors!.push(ErrorMessage.fromJS(item));
            }
            this.version = _data["version"];
            this.environment = _data["environment"];
        }
    }

    static fromJS(data: any): NoteTagsLookupModelListResponseResult {
        data = typeof data === 'object' ? data : {};
        let result = new NoteTagsLookupModelListResponseResult();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["isSuccess"] = this.isSuccess;
        data["statusCode"] = this.statusCode;
        if (Array.isArray(this.result)) {
            data["result"] = [];
            for (let item of this.result)
                data["result"].push(item ? item.toJSON() : undefined as any);
        }
        if (Array.isArray(this.errors)) {
            data["errors"] = [];
            for (let item of this.errors)
                data["errors"].push(item ? item.toJSON() : undefined as any);
        }
        data["version"] = this.version;
        data["environment"] = this.environment;
        return data;
    }
}


export interface INoteTagsLookupModelListResponseResult {
    isSuccess: boolean;
    statusCode: number;
    result: NoteTagsLookupModel[] | undefined;
    errors: ErrorMessage[] | undefined;
    version: string | undefined;
    environment: string | undefined;
}


export enum OtpReasons {
    _0 = 0,
    _1 = 1,
    _2 = 2,
    _3 = 3,
    _4 = 4,
    _5 = 5,
    _6 = 6,
}


export class PaginatedRequest implements IPaginatedRequest {
    sortArray!: SortCriteria[] | undefined;
    paging!: PagingInfo;
    filters!: FilterCriteria[] | undefined;

    constructor(data?: IPaginatedRequest) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["sortArray"])) {
                this.sortArray = [] as any;
                for (let item of _data["sortArray"])
                    this.sortArray!.push(SortCriteria.fromJS(item));
            }
            this.paging = _data["paging"] ? PagingInfo.fromJS(_data["paging"]) : undefined as any;
            if (Array.isArray(_data["filters"])) {
                this.filters = [] as any;
                for (let item of _data["filters"])
                    this.filters!.push(FilterCriteria.fromJS(item));
            }
        }
    }

    static fromJS(data: any): PaginatedRequest {
        data = typeof data === 'object' ? data : {};
        let result = new PaginatedRequest();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.sortArray)) {
            data["sortArray"] = [];
            for (let item of this.sortArray)
                data["sortArray"].push(item ? item.toJSON() : undefined as any);
        }
        data["paging"] = this.paging ? this.paging.toJSON() : undefined as any;
        if (Array.isArray(this.filters)) {
            data["filters"] = [];
            for (let item of this.filters)
                data["filters"].push(item ? item.toJSON() : undefined as any);
        }
        return data;
    }
}


export interface IPaginatedRequest {
    sortArray: SortCriteria[] | undefined;
    paging: PagingInfo;
    filters: FilterCriteria[] | undefined;
}


export class PagingInfo implements IPagingInfo {
    pageNumber!: string | undefined;
    pageSize!: string | undefined;
    readonly pageNumberInt!: number;
    readonly pageSizeInt!: number;

    constructor(data?: IPagingInfo) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.pageNumber = _data["pageNumber"];
            this.pageSize = _data["pageSize"];
            (this as any).pageNumberInt = _data["pageNumberInt"];
            (this as any).pageSizeInt = _data["pageSizeInt"];
        }
    }

    static fromJS(data: any): PagingInfo {
        data = typeof data === 'object' ? data : {};
        let result = new PagingInfo();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["pageNumber"] = this.pageNumber;
        data["pageSize"] = this.pageSize;
        data["pageNumberInt"] = this.pageNumberInt;
        data["pageSizeInt"] = this.pageSizeInt;
        return data;
    }
}


export interface IPagingInfo {
    pageNumber: string | undefined;
    pageSize: string | undefined;
    pageNumberInt: number;
    pageSizeInt: number;
}


export class ParcelInquiryCommand implements IParcelInquiryCommand {
    villageId!: number;
    block!: number;
    parcel!: number;

    constructor(data?: IParcelInquiryCommand) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.villageId = _data["villageId"];
            this.block = _data["block"];
            this.parcel = _data["parcel"];
        }
    }

    static fromJS(data: any): ParcelInquiryCommand {
        data = typeof data === 'object' ? data : {};
        let result = new ParcelInquiryCommand();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["villageId"] = this.villageId;
        data["block"] = this.block;
        data["parcel"] = this.parcel;
        return data;
    }
}


export interface IParcelInquiryCommand {
    villageId: number;
    block: number;
    parcel: number;
}


export class ParcelInquiryConfigurationCommand implements IParcelInquiryConfigurationCommand {
    villageId!: number;
    block!: number;
    parcel!: number;

    constructor(data?: IParcelInquiryConfigurationCommand) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.villageId = _data["villageId"];
            this.block = _data["block"];
            this.parcel = _data["parcel"];
        }
    }

    static fromJS(data: any): ParcelInquiryConfigurationCommand {
        data = typeof data === 'object' ? data : {};
        let result = new ParcelInquiryConfigurationCommand();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["villageId"] = this.villageId;
        data["block"] = this.block;
        data["parcel"] = this.parcel;
        return data;
    }
}


export interface IParcelInquiryConfigurationCommand {
    villageId: number;
    block: number;
    parcel: number;
}


export class ParcelInquiryConfigurationResponse implements IParcelInquiryConfigurationResponse {
    urlTemplate!: string | undefined;
    coordinatesPath!: string | undefined;

    constructor(data?: IParcelInquiryConfigurationResponse) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.urlTemplate = _data["urlTemplate"];
            this.coordinatesPath = _data["coordinatesPath"];
        }
    }

    static fromJS(data: any): ParcelInquiryConfigurationResponse {
        data = typeof data === 'object' ? data : {};
        let result = new ParcelInquiryConfigurationResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["urlTemplate"] = this.urlTemplate;
        data["coordinatesPath"] = this.coordinatesPath;
        return data;
    }
}


export interface IParcelInquiryConfigurationResponse {
    urlTemplate: string | undefined;
    coordinatesPath: string | undefined;
}


export class ParcelInquiryConfigurationResponseResponseResult implements IParcelInquiryConfigurationResponseResponseResult {
    isSuccess!: boolean;
    statusCode!: number;
    result!: ParcelInquiryConfigurationResponse;
    errors!: ErrorMessage[] | undefined;
    version!: string | undefined;
    environment!: string | undefined;

    constructor(data?: IParcelInquiryConfigurationResponseResponseResult) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.isSuccess = _data["isSuccess"];
            this.statusCode = _data["statusCode"];
            this.result = _data["result"] ? ParcelInquiryConfigurationResponse.fromJS(_data["result"]) : undefined as any;
            if (Array.isArray(_data["errors"])) {
                this.errors = [] as any;
                for (let item of _data["errors"])
                    this.errors!.push(ErrorMessage.fromJS(item));
            }
            this.version = _data["version"];
            this.environment = _data["environment"];
        }
    }

    static fromJS(data: any): ParcelInquiryConfigurationResponseResponseResult {
        data = typeof data === 'object' ? data : {};
        let result = new ParcelInquiryConfigurationResponseResponseResult();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["isSuccess"] = this.isSuccess;
        data["statusCode"] = this.statusCode;
        data["result"] = this.result ? this.result.toJSON() : undefined as any;
        if (Array.isArray(this.errors)) {
            data["errors"] = [];
            for (let item of this.errors)
                data["errors"].push(item ? item.toJSON() : undefined as any);
        }
        data["version"] = this.version;
        data["environment"] = this.environment;
        return data;
    }
}


export interface IParcelInquiryConfigurationResponseResponseResult {
    isSuccess: boolean;
    statusCode: number;
    result: ParcelInquiryConfigurationResponse;
    errors: ErrorMessage[] | undefined;
    version: string | undefined;
    environment: string | undefined;
}


export class ParcelInquiryDataDto implements IParcelInquiryDataDto {
    cityId!: number;
    city!: string | undefined;
    districtId!: number;
    district!: string | undefined;
    villageId!: number;
    village!: string | undefined;
    block!: number;
    parcel!: number;

    constructor(data?: IParcelInquiryDataDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.cityId = _data["cityId"];
            this.city = _data["city"];
            this.districtId = _data["districtId"];
            this.district = _data["district"];
            this.villageId = _data["villageId"];
            this.village = _data["village"];
            this.block = _data["block"];
            this.parcel = _data["parcel"];
        }
    }

    static fromJS(data: any): ParcelInquiryDataDto {
        data = typeof data === 'object' ? data : {};
        let result = new ParcelInquiryDataDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["cityId"] = this.cityId;
        data["city"] = this.city;
        data["districtId"] = this.districtId;
        data["district"] = this.district;
        data["villageId"] = this.villageId;
        data["village"] = this.village;
        data["block"] = this.block;
        data["parcel"] = this.parcel;
        return data;
    }
}


export interface IParcelInquiryDataDto {
    cityId: number;
    city: string | undefined;
    districtId: number;
    district: string | undefined;
    villageId: number;
    village: string | undefined;
    block: number;
    parcel: number;
}


export class PlatformVersion implements IPlatformVersion {
    latestVersion!: string | undefined;
    minSupportedVersion!: string | undefined;

    constructor(data?: IPlatformVersion) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.latestVersion = _data["latestVersion"];
            this.minSupportedVersion = _data["minSupportedVersion"];
        }
    }

    static fromJS(data: any): PlatformVersion {
        data = typeof data === 'object' ? data : {};
        let result = new PlatformVersion();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["latestVersion"] = this.latestVersion;
        data["minSupportedVersion"] = this.minSupportedVersion;
        return data;
    }
}


export interface IPlatformVersion {
    latestVersion: string | undefined;
    minSupportedVersion: string | undefined;
}


export class PolygonItem implements IPolygonItem {
    latitude!: number;
    longitude!: number;

    constructor(data?: IPolygonItem) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.latitude = _data["latitude"];
            this.longitude = _data["longitude"];
        }
    }

    static fromJS(data: any): PolygonItem {
        data = typeof data === 'object' ? data : {};
        let result = new PolygonItem();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["latitude"] = this.latitude;
        data["longitude"] = this.longitude;
        return data;
    }
}


export interface IPolygonItem {
    latitude: number;
    longitude: number;
}


export class ProblemDetails implements IProblemDetails {
    type!: string | undefined;
    title!: string | undefined;
    status!: number | undefined;
    detail!: string | undefined;
    instance!: string | undefined;

    [key: string]: any;

    constructor(data?: IProblemDetails) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            for (var property in _data) {
                if (_data.hasOwnProperty(property))
                    this[property] = _data[property];
            }
            this.type = _data["type"];
            this.title = _data["title"];
            this.status = _data["status"];
            this.detail = _data["detail"];
            this.instance = _data["instance"];
        }
    }

    static fromJS(data: any): ProblemDetails {
        data = typeof data === 'object' ? data : {};
        let result = new ProblemDetails();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        for (var property in this) {
            if (this.hasOwnProperty(property))
                data[property] = this[property];
        }
        data["type"] = this.type;
        data["title"] = this.title;
        data["status"] = this.status;
        data["detail"] = this.detail;
        data["instance"] = this.instance;
        return data;
    }
}


export interface IProblemDetails {
    type: string | undefined;
    title: string | undefined;
    status: number | undefined;
    detail: string | undefined;
    instance: string | undefined;

    [key: string]: any;
}


export class ProfessionLookupViewModel implements IProfessionLookupViewModel {
    key!: string;
    value!: string | undefined;
    icon!: string | undefined;

    constructor(data?: IProfessionLookupViewModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.key = _data["key"];
            this.value = _data["value"];
            this.icon = _data["icon"];
        }
    }

    static fromJS(data: any): ProfessionLookupViewModel {
        data = typeof data === 'object' ? data : {};
        let result = new ProfessionLookupViewModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["key"] = this.key;
        data["value"] = this.value;
        data["icon"] = this.icon;
        return data;
    }
}


export interface IProfessionLookupViewModel {
    key: string;
    value: string | undefined;
    icon: string | undefined;
}


export class ProfessionLookupViewModelListResponseResult implements IProfessionLookupViewModelListResponseResult {
    isSuccess!: boolean;
    statusCode!: number;
    result!: ProfessionLookupViewModel[] | undefined;
    errors!: ErrorMessage[] | undefined;
    version!: string | undefined;
    environment!: string | undefined;

    constructor(data?: IProfessionLookupViewModelListResponseResult) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.isSuccess = _data["isSuccess"];
            this.statusCode = _data["statusCode"];
            if (Array.isArray(_data["result"])) {
                this.result = [] as any;
                for (let item of _data["result"])
                    this.result!.push(ProfessionLookupViewModel.fromJS(item));
            }
            if (Array.isArray(_data["errors"])) {
                this.errors = [] as any;
                for (let item of _data["errors"])
                    this.errors!.push(ErrorMessage.fromJS(item));
            }
            this.version = _data["version"];
            this.environment = _data["environment"];
        }
    }

    static fromJS(data: any): ProfessionLookupViewModelListResponseResult {
        data = typeof data === 'object' ? data : {};
        let result = new ProfessionLookupViewModelListResponseResult();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["isSuccess"] = this.isSuccess;
        data["statusCode"] = this.statusCode;
        if (Array.isArray(this.result)) {
            data["result"] = [];
            for (let item of this.result)
                data["result"].push(item ? item.toJSON() : undefined as any);
        }
        if (Array.isArray(this.errors)) {
            data["errors"] = [];
            for (let item of this.errors)
                data["errors"].push(item ? item.toJSON() : undefined as any);
        }
        data["version"] = this.version;
        data["environment"] = this.environment;
        return data;
    }
}


export interface IProfessionLookupViewModelListResponseResult {
    isSuccess: boolean;
    statusCode: number;
    result: ProfessionLookupViewModel[] | undefined;
    errors: ErrorMessage[] | undefined;
    version: string | undefined;
    environment: string | undefined;
}


export class Question implements IQuestion {
    id!: string;
    text!: string | undefined;
    type!: QuestionType;
    isRequired!: boolean;
    order!: number;
    options!: QuestionOption[] | undefined;
    answer!: QuestionAnswer;

    constructor(data?: IQuestion) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.text = _data["text"];
            this.type = _data["type"];
            this.isRequired = _data["isRequired"];
            this.order = _data["order"];
            if (Array.isArray(_data["options"])) {
                this.options = [] as any;
                for (let item of _data["options"])
                    this.options!.push(QuestionOption.fromJS(item));
            }
            this.answer = _data["answer"] ? QuestionAnswer.fromJS(_data["answer"]) : undefined as any;
        }
    }

    static fromJS(data: any): Question {
        data = typeof data === 'object' ? data : {};
        let result = new Question();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["text"] = this.text;
        data["type"] = this.type;
        data["isRequired"] = this.isRequired;
        data["order"] = this.order;
        if (Array.isArray(this.options)) {
            data["options"] = [];
            for (let item of this.options)
                data["options"].push(item ? item.toJSON() : undefined as any);
        }
        data["answer"] = this.answer ? this.answer.toJSON() : undefined as any;
        return data;
    }
}


export interface IQuestion {
    id: string;
    text: string | undefined;
    type: QuestionType;
    isRequired: boolean;
    order: number;
    options: QuestionOption[] | undefined;
    answer: QuestionAnswer;
}


export class QuestionAnswer implements IQuestionAnswer {
    textAnswer!: string | undefined;
    booleanAnswer!: boolean | undefined;
    selectedOptionIds!: string[] | undefined;

    constructor(data?: IQuestionAnswer) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.textAnswer = _data["textAnswer"];
            this.booleanAnswer = _data["booleanAnswer"];
            if (Array.isArray(_data["selectedOptionIds"])) {
                this.selectedOptionIds = [] as any;
                for (let item of _data["selectedOptionIds"])
                    this.selectedOptionIds!.push(item);
            }
        }
    }

    static fromJS(data: any): QuestionAnswer {
        data = typeof data === 'object' ? data : {};
        let result = new QuestionAnswer();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["textAnswer"] = this.textAnswer;
        data["booleanAnswer"] = this.booleanAnswer;
        if (Array.isArray(this.selectedOptionIds)) {
            data["selectedOptionIds"] = [];
            for (let item of this.selectedOptionIds)
                data["selectedOptionIds"].push(item);
        }
        return data;
    }
}


export interface IQuestionAnswer {
    textAnswer: string | undefined;
    booleanAnswer: boolean | undefined;
    selectedOptionIds: string[] | undefined;
}


export class QuestionLanguage implements IQuestionLanguage {
    id!: string;
    languageCode!: string | undefined;
    name!: string | undefined;

    constructor(data?: IQuestionLanguage) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.languageCode = _data["languageCode"];
            this.name = _data["name"];
        }
    }

    static fromJS(data: any): QuestionLanguage {
        data = typeof data === 'object' ? data : {};
        let result = new QuestionLanguage();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["languageCode"] = this.languageCode;
        data["name"] = this.name;
        return data;
    }
}


export interface IQuestionLanguage {
    id: string;
    languageCode: string | undefined;
    name: string | undefined;
}


export class QuestionOption implements IQuestionOption {
    id!: string;
    questionId!: string;
    text!: string | undefined;
    order!: number;

    constructor(data?: IQuestionOption) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.questionId = _data["questionId"];
            this.text = _data["text"];
            this.order = _data["order"];
        }
    }

    static fromJS(data: any): QuestionOption {
        data = typeof data === 'object' ? data : {};
        let result = new QuestionOption();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["questionId"] = this.questionId;
        data["text"] = this.text;
        data["order"] = this.order;
        return data;
    }
}


export interface IQuestionOption {
    id: string;
    questionId: string;
    text: string | undefined;
    order: number;
}


export enum QuestionType {
    _0 = 0,
    _1 = 1,
    _2 = 2,
    _3 = 3,
}


export class Questionnaire implements IQuestionnaire {
    id!: string;
    title!: string | undefined;
    description!: string | undefined;
    createdAt!: DateTime;
    isActive!: boolean;
    questions!: Question[] | undefined;
    language!: QuestionLanguage;

    constructor(data?: IQuestionnaire) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.title = _data["title"];
            this.description = _data["description"];
            this.createdAt = _data["createdAt"] ? DateTime.fromISO(_data["createdAt"].toString()) : undefined as any;
            this.isActive = _data["isActive"];
            if (Array.isArray(_data["questions"])) {
                this.questions = [] as any;
                for (let item of _data["questions"])
                    this.questions!.push(Question.fromJS(item));
            }
            this.language = _data["language"] ? QuestionLanguage.fromJS(_data["language"]) : undefined as any;
        }
    }

    static fromJS(data: any): Questionnaire {
        data = typeof data === 'object' ? data : {};
        let result = new Questionnaire();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["title"] = this.title;
        data["description"] = this.description;
        data["createdAt"] = this.createdAt ? this.createdAt.toString() : undefined as any;
        data["isActive"] = this.isActive;
        if (Array.isArray(this.questions)) {
            data["questions"] = [];
            for (let item of this.questions)
                data["questions"].push(item ? item.toJSON() : undefined as any);
        }
        data["language"] = this.language ? this.language.toJSON() : undefined as any;
        return data;
    }
}


export interface IQuestionnaire {
    id: string;
    title: string | undefined;
    description: string | undefined;
    createdAt: DateTime;
    isActive: boolean;
    questions: Question[] | undefined;
    language: QuestionLanguage;
}


export class RegionHierarchyViewModel implements IRegionHierarchyViewModel {
    regionId!: string;
    name!: string | undefined;
    cities!: CityHierarchyViewModel[] | undefined;

    constructor(data?: IRegionHierarchyViewModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.regionId = _data["regionId"];
            this.name = _data["name"];
            if (Array.isArray(_data["cities"])) {
                this.cities = [] as any;
                for (let item of _data["cities"])
                    this.cities!.push(CityHierarchyViewModel.fromJS(item));
            }
        }
    }

    static fromJS(data: any): RegionHierarchyViewModel {
        data = typeof data === 'object' ? data : {};
        let result = new RegionHierarchyViewModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["regionId"] = this.regionId;
        data["name"] = this.name;
        if (Array.isArray(this.cities)) {
            data["cities"] = [];
            for (let item of this.cities)
                data["cities"].push(item ? item.toJSON() : undefined as any);
        }
        return data;
    }
}


export interface IRegionHierarchyViewModel {
    regionId: string;
    name: string | undefined;
    cities: CityHierarchyViewModel[] | undefined;
}


export class RegisterUserCommand implements IRegisterUserCommand {
    name!: string | undefined;
    surname!: string | undefined;
    phoneCode!: string | undefined;
    phone!: string | undefined;
    email!: string | undefined;
    password!: string | undefined;

    constructor(data?: IRegisterUserCommand) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.name = _data["name"];
            this.surname = _data["surname"];
            this.phoneCode = _data["phoneCode"];
            this.phone = _data["phone"];
            this.email = _data["email"];
            this.password = _data["password"];
        }
    }

    static fromJS(data: any): RegisterUserCommand {
        data = typeof data === 'object' ? data : {};
        let result = new RegisterUserCommand();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["name"] = this.name;
        data["surname"] = this.surname;
        data["phoneCode"] = this.phoneCode;
        data["phone"] = this.phone;
        data["email"] = this.email;
        data["password"] = this.password;
        return data;
    }
}


export interface IRegisterUserCommand {
    name: string | undefined;
    surname: string | undefined;
    phoneCode: string | undefined;
    phone: string | undefined;
    email: string | undefined;
    password: string | undefined;
}


export class RegisterUserCompleteCommand implements IRegisterUserCompleteCommand {
    name!: string | undefined;
    surname!: string | undefined;
    email!: string | undefined;
    phoneCode!: string | undefined;
    phone!: string | undefined;
    password!: string | undefined;
    emailOtp!: number | undefined;
    phoneOtp!: number | undefined;

    constructor(data?: IRegisterUserCompleteCommand) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.name = _data["name"];
            this.surname = _data["surname"];
            this.email = _data["email"];
            this.phoneCode = _data["phoneCode"];
            this.phone = _data["phone"];
            this.password = _data["password"];
            this.emailOtp = _data["emailOtp"];
            this.phoneOtp = _data["phoneOtp"];
        }
    }

    static fromJS(data: any): RegisterUserCompleteCommand {
        data = typeof data === 'object' ? data : {};
        let result = new RegisterUserCompleteCommand();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["name"] = this.name;
        data["surname"] = this.surname;
        data["email"] = this.email;
        data["phoneCode"] = this.phoneCode;
        data["phone"] = this.phone;
        data["password"] = this.password;
        data["emailOtp"] = this.emailOtp;
        data["phoneOtp"] = this.phoneOtp;
        return data;
    }
}


export interface IRegisterUserCompleteCommand {
    name: string | undefined;
    surname: string | undefined;
    email: string | undefined;
    phoneCode: string | undefined;
    phone: string | undefined;
    password: string | undefined;
    emailOtp: number | undefined;
    phoneOtp: number | undefined;
}


export class RegisterUserResponse implements IRegisterUserResponse {
    id!: string;
    isSuccess!: boolean;
    requestOTPResult!: RequestUserOTPResult;

    constructor(data?: IRegisterUserResponse) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.isSuccess = _data["isSuccess"];
            this.requestOTPResult = _data["requestOTPResult"] ? RequestUserOTPResult.fromJS(_data["requestOTPResult"]) : undefined as any;
        }
    }

    static fromJS(data: any): RegisterUserResponse {
        data = typeof data === 'object' ? data : {};
        let result = new RegisterUserResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["isSuccess"] = this.isSuccess;
        data["requestOTPResult"] = this.requestOTPResult ? this.requestOTPResult.toJSON() : undefined as any;
        return data;
    }
}


export interface IRegisterUserResponse {
    id: string;
    isSuccess: boolean;
    requestOTPResult: RequestUserOTPResult;
}


export class RegisterUserResponseResponseResult implements IRegisterUserResponseResponseResult {
    isSuccess!: boolean;
    statusCode!: number;
    result!: RegisterUserResponse;
    errors!: ErrorMessage[] | undefined;
    version!: string | undefined;
    environment!: string | undefined;

    constructor(data?: IRegisterUserResponseResponseResult) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.isSuccess = _data["isSuccess"];
            this.statusCode = _data["statusCode"];
            this.result = _data["result"] ? RegisterUserResponse.fromJS(_data["result"]) : undefined as any;
            if (Array.isArray(_data["errors"])) {
                this.errors = [] as any;
                for (let item of _data["errors"])
                    this.errors!.push(ErrorMessage.fromJS(item));
            }
            this.version = _data["version"];
            this.environment = _data["environment"];
        }
    }

    static fromJS(data: any): RegisterUserResponseResponseResult {
        data = typeof data === 'object' ? data : {};
        let result = new RegisterUserResponseResponseResult();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["isSuccess"] = this.isSuccess;
        data["statusCode"] = this.statusCode;
        data["result"] = this.result ? this.result.toJSON() : undefined as any;
        if (Array.isArray(this.errors)) {
            data["errors"] = [];
            for (let item of this.errors)
                data["errors"].push(item ? item.toJSON() : undefined as any);
        }
        data["version"] = this.version;
        data["environment"] = this.environment;
        return data;
    }
}


export interface IRegisterUserResponseResponseResult {
    isSuccess: boolean;
    statusCode: number;
    result: RegisterUserResponse;
    errors: ErrorMessage[] | undefined;
    version: string | undefined;
    environment: string | undefined;
}


export class RemoveCropMapUserV2Command implements IRemoveCropMapUserV2Command {
    enterpriseId!: string;
    userId!: string;

    constructor(data?: IRemoveCropMapUserV2Command) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.enterpriseId = _data["enterpriseId"];
            this.userId = _data["userId"];
        }
    }

    static fromJS(data: any): RemoveCropMapUserV2Command {
        data = typeof data === 'object' ? data : {};
        let result = new RemoveCropMapUserV2Command();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["enterpriseId"] = this.enterpriseId;
        data["userId"] = this.userId;
        return data;
    }
}


export interface IRemoveCropMapUserV2Command {
    enterpriseId: string;
    userId: string;
}


export class RequestEmailOtpModel implements IRequestEmailOtpModel {
    email!: string | undefined;

    constructor(data?: IRequestEmailOtpModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.email = _data["email"];
        }
    }

    static fromJS(data: any): RequestEmailOtpModel {
        data = typeof data === 'object' ? data : {};
        let result = new RequestEmailOtpModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["email"] = this.email;
        return data;
    }
}


export interface IRequestEmailOtpModel {
    email: string | undefined;
}


export class RequestOtpModel implements IRequestOtpModel {
    reason!: string | undefined;
    method!: string | undefined;
    email!: string | undefined;
    phoneCode!: string | undefined;
    phone!: string | undefined;
    userId!: string | undefined;

    constructor(data?: IRequestOtpModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.reason = _data["reason"];
            this.method = _data["method"];
            this.email = _data["email"];
            this.phoneCode = _data["phoneCode"];
            this.phone = _data["phone"];
            this.userId = _data["userId"];
        }
    }

    static fromJS(data: any): RequestOtpModel {
        data = typeof data === 'object' ? data : {};
        let result = new RequestOtpModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["reason"] = this.reason;
        data["method"] = this.method;
        data["email"] = this.email;
        data["phoneCode"] = this.phoneCode;
        data["phone"] = this.phone;
        data["userId"] = this.userId;
        return data;
    }
}


export interface IRequestOtpModel {
    reason: string | undefined;
    method: string | undefined;
    email: string | undefined;
    phoneCode: string | undefined;
    phone: string | undefined;
    userId: string | undefined;
}


export class RequestPasswordResetCodeCommand implements IRequestPasswordResetCodeCommand {
    phoneCode!: string | undefined;
    phone!: string | undefined;
    email!: string | undefined;

    constructor(data?: IRequestPasswordResetCodeCommand) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.phoneCode = _data["phoneCode"];
            this.phone = _data["phone"];
            this.email = _data["email"];
        }
    }

    static fromJS(data: any): RequestPasswordResetCodeCommand {
        data = typeof data === 'object' ? data : {};
        let result = new RequestPasswordResetCodeCommand();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["phoneCode"] = this.phoneCode;
        data["phone"] = this.phone;
        data["email"] = this.email;
        return data;
    }
}


export interface IRequestPasswordResetCodeCommand {
    phoneCode: string | undefined;
    phone: string | undefined;
    email: string | undefined;
}


export class RequestPhoneOtpModel implements IRequestPhoneOtpModel {
    phoneCode!: string | undefined;
    phone!: string | undefined;

    constructor(data?: IRequestPhoneOtpModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.phoneCode = _data["phoneCode"];
            this.phone = _data["phone"];
        }
    }

    static fromJS(data: any): RequestPhoneOtpModel {
        data = typeof data === 'object' ? data : {};
        let result = new RequestPhoneOtpModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["phoneCode"] = this.phoneCode;
        data["phone"] = this.phone;
        return data;
    }
}


export interface IRequestPhoneOtpModel {
    phoneCode: string | undefined;
    phone: string | undefined;
}


export class RequestUserOTPCommand implements IRequestUserOTPCommand {
    id!: string | undefined;
    otpReason!: OtpReasons;
    isNewPhoneOrEmail!: boolean;
    phoneCode!: string | undefined;
    phone!: string | undefined;
    email!: string | undefined;

    constructor(data?: IRequestUserOTPCommand) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.otpReason = _data["otpReason"];
            this.isNewPhoneOrEmail = _data["isNewPhoneOrEmail"];
            this.phoneCode = _data["phoneCode"];
            this.phone = _data["phone"];
            this.email = _data["email"];
        }
    }

    static fromJS(data: any): RequestUserOTPCommand {
        data = typeof data === 'object' ? data : {};
        let result = new RequestUserOTPCommand();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["otpReason"] = this.otpReason;
        data["isNewPhoneOrEmail"] = this.isNewPhoneOrEmail;
        data["phoneCode"] = this.phoneCode;
        data["phone"] = this.phone;
        data["email"] = this.email;
        return data;
    }
}


export interface IRequestUserOTPCommand {
    id: string | undefined;
    otpReason: OtpReasons;
    isNewPhoneOrEmail: boolean;
    phoneCode: string | undefined;
    phone: string | undefined;
    email: string | undefined;
}


export class RequestUserOTPResult implements IRequestUserOTPResult {
    sendToType!: string | undefined;
    sendToValue!: string | undefined;
    notes!: string | undefined;

    constructor(data?: IRequestUserOTPResult) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.sendToType = _data["sendToType"];
            this.sendToValue = _data["sendToValue"];
            this.notes = _data["notes"];
        }
    }

    static fromJS(data: any): RequestUserOTPResult {
        data = typeof data === 'object' ? data : {};
        let result = new RequestUserOTPResult();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["sendToType"] = this.sendToType;
        data["sendToValue"] = this.sendToValue;
        data["notes"] = this.notes;
        return data;
    }
}


export interface IRequestUserOTPResult {
    sendToType: string | undefined;
    sendToValue: string | undefined;
    notes: string | undefined;
}


export class RequestUserOTPResultResponseResult implements IRequestUserOTPResultResponseResult {
    isSuccess!: boolean;
    statusCode!: number;
    result!: RequestUserOTPResult;
    errors!: ErrorMessage[] | undefined;
    version!: string | undefined;
    environment!: string | undefined;

    constructor(data?: IRequestUserOTPResultResponseResult) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.isSuccess = _data["isSuccess"];
            this.statusCode = _data["statusCode"];
            this.result = _data["result"] ? RequestUserOTPResult.fromJS(_data["result"]) : undefined as any;
            if (Array.isArray(_data["errors"])) {
                this.errors = [] as any;
                for (let item of _data["errors"])
                    this.errors!.push(ErrorMessage.fromJS(item));
            }
            this.version = _data["version"];
            this.environment = _data["environment"];
        }
    }

    static fromJS(data: any): RequestUserOTPResultResponseResult {
        data = typeof data === 'object' ? data : {};
        let result = new RequestUserOTPResultResponseResult();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["isSuccess"] = this.isSuccess;
        data["statusCode"] = this.statusCode;
        data["result"] = this.result ? this.result.toJSON() : undefined as any;
        if (Array.isArray(this.errors)) {
            data["errors"] = [];
            for (let item of this.errors)
                data["errors"].push(item ? item.toJSON() : undefined as any);
        }
        data["version"] = this.version;
        data["environment"] = this.environment;
        return data;
    }
}


export interface IRequestUserOTPResultResponseResult {
    isSuccess: boolean;
    statusCode: number;
    result: RequestUserOTPResult;
    errors: ErrorMessage[] | undefined;
    version: string | undefined;
    environment: string | undefined;
}


export class ResetPasswordCommand implements IResetPasswordCommand {
    id!: string | undefined;
    emailOrPhone!: string | undefined;
    otp!: number;
    newPassword!: string | undefined;

    constructor(data?: IResetPasswordCommand) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.emailOrPhone = _data["emailOrPhone"];
            this.otp = _data["otp"];
            this.newPassword = _data["newPassword"];
        }
    }

    static fromJS(data: any): ResetPasswordCommand {
        data = typeof data === 'object' ? data : {};
        let result = new ResetPasswordCommand();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["emailOrPhone"] = this.emailOrPhone;
        data["otp"] = this.otp;
        data["newPassword"] = this.newPassword;
        return data;
    }
}


export interface IResetPasswordCommand {
    id: string | undefined;
    emailOrPhone: string | undefined;
    otp: number;
    newPassword: string | undefined;
}


export class ResetPasswordCommandV2 implements IResetPasswordCommandV2 {
    email!: string | undefined;
    phoneCode!: string | undefined;
    phone!: string | undefined;
    otp!: number;
    newPassword!: string | undefined;
    userId!: string | undefined;

    constructor(data?: IResetPasswordCommandV2) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.email = _data["email"];
            this.phoneCode = _data["phoneCode"];
            this.phone = _data["phone"];
            this.otp = _data["otp"];
            this.newPassword = _data["newPassword"];
            this.userId = _data["userId"];
        }
    }

    static fromJS(data: any): ResetPasswordCommandV2 {
        data = typeof data === 'object' ? data : {};
        let result = new ResetPasswordCommandV2();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["email"] = this.email;
        data["phoneCode"] = this.phoneCode;
        data["phone"] = this.phone;
        data["otp"] = this.otp;
        data["newPassword"] = this.newPassword;
        data["userId"] = this.userId;
        return data;
    }
}


export interface IResetPasswordCommandV2 {
    email: string | undefined;
    phoneCode: string | undefined;
    phone: string | undefined;
    otp: number;
    newPassword: string | undefined;
    userId: string | undefined;
}


export class ResetUserPINCommand implements IResetUserPINCommand {
    userId!: string;
    newPin!: number;

    constructor(data?: IResetUserPINCommand) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.userId = _data["userId"];
            this.newPin = _data["newPin"];
        }
    }

    static fromJS(data: any): ResetUserPINCommand {
        data = typeof data === 'object' ? data : {};
        let result = new ResetUserPINCommand();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["userId"] = this.userId;
        data["newPin"] = this.newPin;
        return data;
    }
}


export interface IResetUserPINCommand {
    userId: string;
    newPin: number;
}


export class RoleDto implements IRoleDto {
    id!: string;
    name!: string | undefined;
    enterpriseId!: string | undefined;
    enterpriseName!: string | undefined;
    roleKind!: string | undefined;
    description!: string | undefined;
    isActive!: boolean;
    permissions!: RolePermissionDto[] | undefined;

    constructor(data?: IRoleDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.name = _data["name"];
            this.enterpriseId = _data["enterpriseId"];
            this.enterpriseName = _data["enterpriseName"];
            this.roleKind = _data["roleKind"];
            this.description = _data["description"];
            this.isActive = _data["isActive"];
            if (Array.isArray(_data["permissions"])) {
                this.permissions = [] as any;
                for (let item of _data["permissions"])
                    this.permissions!.push(RolePermissionDto.fromJS(item));
            }
        }
    }

    static fromJS(data: any): RoleDto {
        data = typeof data === 'object' ? data : {};
        let result = new RoleDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["name"] = this.name;
        data["enterpriseId"] = this.enterpriseId;
        data["enterpriseName"] = this.enterpriseName;
        data["roleKind"] = this.roleKind;
        data["description"] = this.description;
        data["isActive"] = this.isActive;
        if (Array.isArray(this.permissions)) {
            data["permissions"] = [];
            for (let item of this.permissions)
                data["permissions"].push(item ? item.toJSON() : undefined as any);
        }
        return data;
    }
}


export interface IRoleDto {
    id: string;
    name: string | undefined;
    enterpriseId: string | undefined;
    enterpriseName: string | undefined;
    roleKind: string | undefined;
    description: string | undefined;
    isActive: boolean;
    permissions: RolePermissionDto[] | undefined;
}


export class RoleDtoListResponseResult implements IRoleDtoListResponseResult {
    isSuccess!: boolean;
    statusCode!: number;
    result!: RoleDto[] | undefined;
    errors!: ErrorMessage[] | undefined;
    version!: string | undefined;
    environment!: string | undefined;

    constructor(data?: IRoleDtoListResponseResult) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.isSuccess = _data["isSuccess"];
            this.statusCode = _data["statusCode"];
            if (Array.isArray(_data["result"])) {
                this.result = [] as any;
                for (let item of _data["result"])
                    this.result!.push(RoleDto.fromJS(item));
            }
            if (Array.isArray(_data["errors"])) {
                this.errors = [] as any;
                for (let item of _data["errors"])
                    this.errors!.push(ErrorMessage.fromJS(item));
            }
            this.version = _data["version"];
            this.environment = _data["environment"];
        }
    }

    static fromJS(data: any): RoleDtoListResponseResult {
        data = typeof data === 'object' ? data : {};
        let result = new RoleDtoListResponseResult();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["isSuccess"] = this.isSuccess;
        data["statusCode"] = this.statusCode;
        if (Array.isArray(this.result)) {
            data["result"] = [];
            for (let item of this.result)
                data["result"].push(item ? item.toJSON() : undefined as any);
        }
        if (Array.isArray(this.errors)) {
            data["errors"] = [];
            for (let item of this.errors)
                data["errors"].push(item ? item.toJSON() : undefined as any);
        }
        data["version"] = this.version;
        data["environment"] = this.environment;
        return data;
    }
}


export interface IRoleDtoListResponseResult {
    isSuccess: boolean;
    statusCode: number;
    result: RoleDto[] | undefined;
    errors: ErrorMessage[] | undefined;
    version: string | undefined;
    environment: string | undefined;
}


export class RoleDtoResponseResult implements IRoleDtoResponseResult {
    isSuccess!: boolean;
    statusCode!: number;
    result!: RoleDto;
    errors!: ErrorMessage[] | undefined;
    version!: string | undefined;
    environment!: string | undefined;

    constructor(data?: IRoleDtoResponseResult) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.isSuccess = _data["isSuccess"];
            this.statusCode = _data["statusCode"];
            this.result = _data["result"] ? RoleDto.fromJS(_data["result"]) : undefined as any;
            if (Array.isArray(_data["errors"])) {
                this.errors = [] as any;
                for (let item of _data["errors"])
                    this.errors!.push(ErrorMessage.fromJS(item));
            }
            this.version = _data["version"];
            this.environment = _data["environment"];
        }
    }

    static fromJS(data: any): RoleDtoResponseResult {
        data = typeof data === 'object' ? data : {};
        let result = new RoleDtoResponseResult();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["isSuccess"] = this.isSuccess;
        data["statusCode"] = this.statusCode;
        data["result"] = this.result ? this.result.toJSON() : undefined as any;
        if (Array.isArray(this.errors)) {
            data["errors"] = [];
            for (let item of this.errors)
                data["errors"].push(item ? item.toJSON() : undefined as any);
        }
        data["version"] = this.version;
        data["environment"] = this.environment;
        return data;
    }
}


export interface IRoleDtoResponseResult {
    isSuccess: boolean;
    statusCode: number;
    result: RoleDto;
    errors: ErrorMessage[] | undefined;
    version: string | undefined;
    environment: string | undefined;
}


export class RolePermissionDto implements IRolePermissionDto {
    id!: string;
    name!: string | undefined;
    description!: string | undefined;

    constructor(data?: IRolePermissionDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.name = _data["name"];
            this.description = _data["description"];
        }
    }

    static fromJS(data: any): RolePermissionDto {
        data = typeof data === 'object' ? data : {};
        let result = new RolePermissionDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["name"] = this.name;
        data["description"] = this.description;
        return data;
    }
}


export interface IRolePermissionDto {
    id: string;
    name: string | undefined;
    description: string | undefined;
}


export class RotationViewModel implements IRotationViewModel {
    id!: string;
    displayId!: number | undefined;
    cropId!: string;
    cropName!: string | undefined;
    cropColor!: string | undefined;
    cropVarietyId!: string | undefined;
    cropVariety!: string | undefined;
    sowingStartDate!: DateTime | undefined;
    harvestEndDate!: DateTime | undefined;
    readonly harvestEndDateDisplay!: string | undefined;
    readonly sowingStartDateDisplay!: string | undefined;
    isHarvested!: boolean;

    constructor(data?: IRotationViewModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.displayId = _data["displayId"];
            this.cropId = _data["cropId"];
            this.cropName = _data["cropName"];
            this.cropColor = _data["cropColor"];
            this.cropVarietyId = _data["cropVarietyId"];
            this.cropVariety = _data["cropVariety"];
            this.sowingStartDate = _data["sowingStartDate"] ? DateTime.fromISO(_data["sowingStartDate"].toString()) : undefined as any;
            this.harvestEndDate = _data["harvestEndDate"] ? DateTime.fromISO(_data["harvestEndDate"].toString()) : undefined as any;
            (this as any).harvestEndDateDisplay = _data["harvestEndDateDisplay"];
            (this as any).sowingStartDateDisplay = _data["sowingStartDateDisplay"];
            this.isHarvested = _data["isHarvested"];
        }
    }

    static fromJS(data: any): RotationViewModel {
        data = typeof data === 'object' ? data : {};
        let result = new RotationViewModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["displayId"] = this.displayId;
        data["cropId"] = this.cropId;
        data["cropName"] = this.cropName;
        data["cropColor"] = this.cropColor;
        data["cropVarietyId"] = this.cropVarietyId;
        data["cropVariety"] = this.cropVariety;
        data["sowingStartDate"] = this.sowingStartDate ? this.sowingStartDate.toString() : undefined as any;
        data["harvestEndDate"] = this.harvestEndDate ? this.harvestEndDate.toString() : undefined as any;
        data["harvestEndDateDisplay"] = this.harvestEndDateDisplay;
        data["sowingStartDateDisplay"] = this.sowingStartDateDisplay;
        data["isHarvested"] = this.isHarvested;
        return data;
    }
}


export interface IRotationViewModel {
    id: string;
    displayId: number | undefined;
    cropId: string;
    cropName: string | undefined;
    cropColor: string | undefined;
    cropVarietyId: string | undefined;
    cropVariety: string | undefined;
    sowingStartDate: DateTime | undefined;
    harvestEndDate: DateTime | undefined;
    harvestEndDateDisplay: string | undefined;
    sowingStartDateDisplay: string | undefined;
    isHarvested: boolean;
}


export class SaveCrmCommand implements ISaveCrmCommand {
    id!: number;
    fieldId!: string | undefined;
    lat!: number;
    lng!: number;
    year!: number;
    nameSurname!: string | undefined;
    phoneNumber!: string | undefined;
    mail!: string | undefined;
    protectionBrands!: number[] | undefined;
    protectionDecisions!: number[] | undefined;
    fertilizerBrands!: number[] | undefined;
    fertilizerDecisions!: number[] | undefined;
    seedBrands!: number[] | undefined;
    seedDecisions!: number[] | undefined;
    usingBiologicalAgents!: number | undefined;
    cropName!: string | undefined;
    cityName!: string | undefined;
    districtName!: string | undefined;
    enterpriseId!: string | undefined;

    constructor(data?: ISaveCrmCommand) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.fieldId = _data["fieldId"];
            this.lat = _data["lat"];
            this.lng = _data["lng"];
            this.year = _data["year"];
            this.nameSurname = _data["nameSurname"];
            this.phoneNumber = _data["phoneNumber"];
            this.mail = _data["mail"];
            if (Array.isArray(_data["protectionBrands"])) {
                this.protectionBrands = [] as any;
                for (let item of _data["protectionBrands"])
                    this.protectionBrands!.push(item);
            }
            if (Array.isArray(_data["protectionDecisions"])) {
                this.protectionDecisions = [] as any;
                for (let item of _data["protectionDecisions"])
                    this.protectionDecisions!.push(item);
            }
            if (Array.isArray(_data["fertilizerBrands"])) {
                this.fertilizerBrands = [] as any;
                for (let item of _data["fertilizerBrands"])
                    this.fertilizerBrands!.push(item);
            }
            if (Array.isArray(_data["fertilizerDecisions"])) {
                this.fertilizerDecisions = [] as any;
                for (let item of _data["fertilizerDecisions"])
                    this.fertilizerDecisions!.push(item);
            }
            if (Array.isArray(_data["seedBrands"])) {
                this.seedBrands = [] as any;
                for (let item of _data["seedBrands"])
                    this.seedBrands!.push(item);
            }
            if (Array.isArray(_data["seedDecisions"])) {
                this.seedDecisions = [] as any;
                for (let item of _data["seedDecisions"])
                    this.seedDecisions!.push(item);
            }
            this.usingBiologicalAgents = _data["usingBiologicalAgents"];
            this.cropName = _data["cropName"];
            this.cityName = _data["cityName"];
            this.districtName = _data["districtName"];
            this.enterpriseId = _data["enterpriseId"];
        }
    }

    static fromJS(data: any): SaveCrmCommand {
        data = typeof data === 'object' ? data : {};
        let result = new SaveCrmCommand();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["fieldId"] = this.fieldId;
        data["lat"] = this.lat;
        data["lng"] = this.lng;
        data["year"] = this.year;
        data["nameSurname"] = this.nameSurname;
        data["phoneNumber"] = this.phoneNumber;
        data["mail"] = this.mail;
        if (Array.isArray(this.protectionBrands)) {
            data["protectionBrands"] = [];
            for (let item of this.protectionBrands)
                data["protectionBrands"].push(item);
        }
        if (Array.isArray(this.protectionDecisions)) {
            data["protectionDecisions"] = [];
            for (let item of this.protectionDecisions)
                data["protectionDecisions"].push(item);
        }
        if (Array.isArray(this.fertilizerBrands)) {
            data["fertilizerBrands"] = [];
            for (let item of this.fertilizerBrands)
                data["fertilizerBrands"].push(item);
        }
        if (Array.isArray(this.fertilizerDecisions)) {
            data["fertilizerDecisions"] = [];
            for (let item of this.fertilizerDecisions)
                data["fertilizerDecisions"].push(item);
        }
        if (Array.isArray(this.seedBrands)) {
            data["seedBrands"] = [];
            for (let item of this.seedBrands)
                data["seedBrands"].push(item);
        }
        if (Array.isArray(this.seedDecisions)) {
            data["seedDecisions"] = [];
            for (let item of this.seedDecisions)
                data["seedDecisions"].push(item);
        }
        data["usingBiologicalAgents"] = this.usingBiologicalAgents;
        data["cropName"] = this.cropName;
        data["cityName"] = this.cityName;
        data["districtName"] = this.districtName;
        data["enterpriseId"] = this.enterpriseId;
        return data;
    }
}


export interface ISaveCrmCommand {
    id: number;
    fieldId: string | undefined;
    lat: number;
    lng: number;
    year: number;
    nameSurname: string | undefined;
    phoneNumber: string | undefined;
    mail: string | undefined;
    protectionBrands: number[] | undefined;
    protectionDecisions: number[] | undefined;
    fertilizerBrands: number[] | undefined;
    fertilizerDecisions: number[] | undefined;
    seedBrands: number[] | undefined;
    seedDecisions: number[] | undefined;
    usingBiologicalAgents: number | undefined;
    cropName: string | undefined;
    cityName: string | undefined;
    districtName: string | undefined;
    enterpriseId: string | undefined;
}


export class SaveCrmVisitingUserCommand implements ISaveCrmVisitingUserCommand {

    constructor(data?: ISaveCrmVisitingUserCommand) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
    }

    static fromJS(data: any): SaveCrmVisitingUserCommand {
        data = typeof data === 'object' ? data : {};
        let result = new SaveCrmVisitingUserCommand();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        return data;
    }
}


export interface ISaveCrmVisitingUserCommand {
}


export class SeasonViewModel implements ISeasonViewModel {
    id!: string;
    code!: string | undefined;
    name!: string | undefined;
    description!: string | undefined;
    sort!: number;
    isActive!: boolean;
    note!: string | undefined;

    constructor(data?: ISeasonViewModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.code = _data["code"];
            this.name = _data["name"];
            this.description = _data["description"];
            this.sort = _data["sort"];
            this.isActive = _data["isActive"];
            this.note = _data["note"];
        }
    }

    static fromJS(data: any): SeasonViewModel {
        data = typeof data === 'object' ? data : {};
        let result = new SeasonViewModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["code"] = this.code;
        data["name"] = this.name;
        data["description"] = this.description;
        data["sort"] = this.sort;
        data["isActive"] = this.isActive;
        data["note"] = this.note;
        return data;
    }
}


export interface ISeasonViewModel {
    id: string;
    code: string | undefined;
    name: string | undefined;
    description: string | undefined;
    sort: number;
    isActive: boolean;
    note: string | undefined;
}


export class SeasonViewModelListResponseResult implements ISeasonViewModelListResponseResult {
    isSuccess!: boolean;
    statusCode!: number;
    result!: SeasonViewModel[] | undefined;
    errors!: ErrorMessage[] | undefined;
    version!: string | undefined;
    environment!: string | undefined;

    constructor(data?: ISeasonViewModelListResponseResult) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.isSuccess = _data["isSuccess"];
            this.statusCode = _data["statusCode"];
            if (Array.isArray(_data["result"])) {
                this.result = [] as any;
                for (let item of _data["result"])
                    this.result!.push(SeasonViewModel.fromJS(item));
            }
            if (Array.isArray(_data["errors"])) {
                this.errors = [] as any;
                for (let item of _data["errors"])
                    this.errors!.push(ErrorMessage.fromJS(item));
            }
            this.version = _data["version"];
            this.environment = _data["environment"];
        }
    }

    static fromJS(data: any): SeasonViewModelListResponseResult {
        data = typeof data === 'object' ? data : {};
        let result = new SeasonViewModelListResponseResult();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["isSuccess"] = this.isSuccess;
        data["statusCode"] = this.statusCode;
        if (Array.isArray(this.result)) {
            data["result"] = [];
            for (let item of this.result)
                data["result"].push(item ? item.toJSON() : undefined as any);
        }
        if (Array.isArray(this.errors)) {
            data["errors"] = [];
            for (let item of this.errors)
                data["errors"].push(item ? item.toJSON() : undefined as any);
        }
        data["version"] = this.version;
        data["environment"] = this.environment;
        return data;
    }
}


export interface ISeasonViewModelListResponseResult {
    isSuccess: boolean;
    statusCode: number;
    result: SeasonViewModel[] | undefined;
    errors: ErrorMessage[] | undefined;
    version: string | undefined;
    environment: string | undefined;
}


export class SigninUserCommand implements ISigninUserCommand {
    email!: string | undefined;
    phoneCode!: string | undefined;
    phone!: string | undefined;
    password!: string | undefined;
    newPassword!: string | undefined;
    externalProviderType!: string | undefined;
    externalProviderToken!: string | undefined;
    captchaToken!: string | undefined;

    constructor(data?: ISigninUserCommand) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.email = _data["email"];
            this.phoneCode = _data["phoneCode"];
            this.phone = _data["phone"];
            this.password = _data["password"];
            this.newPassword = _data["newPassword"];
            this.externalProviderType = _data["externalProviderType"];
            this.externalProviderToken = _data["externalProviderToken"];
            this.captchaToken = _data["captchaToken"];
        }
    }

    static fromJS(data: any): SigninUserCommand {
        data = typeof data === 'object' ? data : {};
        let result = new SigninUserCommand();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["email"] = this.email;
        data["phoneCode"] = this.phoneCode;
        data["phone"] = this.phone;
        data["password"] = this.password;
        data["newPassword"] = this.newPassword;
        data["externalProviderType"] = this.externalProviderType;
        data["externalProviderToken"] = this.externalProviderToken;
        data["captchaToken"] = this.captchaToken;
        return data;
    }
}


export interface ISigninUserCommand {
    email: string | undefined;
    phoneCode: string | undefined;
    phone: string | undefined;
    password: string | undefined;
    newPassword: string | undefined;
    externalProviderType: string | undefined;
    externalProviderToken: string | undefined;
    captchaToken: string | undefined;
}


export class SigninUserResponse implements ISigninUserResponse {
    id!: string;
    token!: string | undefined;
    validUntil!: DateTime | undefined;

    constructor(data?: ISigninUserResponse) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.token = _data["token"];
            this.validUntil = _data["validUntil"] ? DateTime.fromISO(_data["validUntil"].toString()) : undefined as any;
        }
    }

    static fromJS(data: any): SigninUserResponse {
        data = typeof data === 'object' ? data : {};
        let result = new SigninUserResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["token"] = this.token;
        data["validUntil"] = this.validUntil ? this.validUntil.toString() : undefined as any;
        return data;
    }
}


export interface ISigninUserResponse {
    id: string;
    token: string | undefined;
    validUntil: DateTime | undefined;
}


export class SigninUserResponseResponseResult implements ISigninUserResponseResponseResult {
    isSuccess!: boolean;
    statusCode!: number;
    result!: SigninUserResponse;
    errors!: ErrorMessage[] | undefined;
    version!: string | undefined;
    environment!: string | undefined;

    constructor(data?: ISigninUserResponseResponseResult) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.isSuccess = _data["isSuccess"];
            this.statusCode = _data["statusCode"];
            this.result = _data["result"] ? SigninUserResponse.fromJS(_data["result"]) : undefined as any;
            if (Array.isArray(_data["errors"])) {
                this.errors = [] as any;
                for (let item of _data["errors"])
                    this.errors!.push(ErrorMessage.fromJS(item));
            }
            this.version = _data["version"];
            this.environment = _data["environment"];
        }
    }

    static fromJS(data: any): SigninUserResponseResponseResult {
        data = typeof data === 'object' ? data : {};
        let result = new SigninUserResponseResponseResult();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["isSuccess"] = this.isSuccess;
        data["statusCode"] = this.statusCode;
        data["result"] = this.result ? this.result.toJSON() : undefined as any;
        if (Array.isArray(this.errors)) {
            data["errors"] = [];
            for (let item of this.errors)
                data["errors"].push(item ? item.toJSON() : undefined as any);
        }
        data["version"] = this.version;
        data["environment"] = this.environment;
        return data;
    }
}


export interface ISigninUserResponseResponseResult {
    isSuccess: boolean;
    statusCode: number;
    result: SigninUserResponse;
    errors: ErrorMessage[] | undefined;
    version: string | undefined;
    environment: string | undefined;
}


export class SignoutUserCommand implements ISignoutUserCommand {
    id!: string;
    note!: string | undefined;

    constructor(data?: ISignoutUserCommand) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.note = _data["note"];
        }
    }

    static fromJS(data: any): SignoutUserCommand {
        data = typeof data === 'object' ? data : {};
        let result = new SignoutUserCommand();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["note"] = this.note;
        return data;
    }
}


export interface ISignoutUserCommand {
    id: string;
    note: string | undefined;
}


export class SortCriteria implements ISortCriteria {
    fieldName!: string | undefined;
    sortType!: string | undefined;

    constructor(data?: ISortCriteria) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.fieldName = _data["fieldName"];
            this.sortType = _data["sortType"];
        }
    }

    static fromJS(data: any): SortCriteria {
        data = typeof data === 'object' ? data : {};
        let result = new SortCriteria();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["fieldName"] = this.fieldName;
        data["sortType"] = this.sortType;
        return data;
    }
}


export interface ISortCriteria {
    fieldName: string | undefined;
    sortType: string | undefined;
}


export class StateHierarchyViewModel implements IStateHierarchyViewModel {
    stateId!: string;
    name!: string | undefined;
    cities!: CityHierarchyViewModel[] | undefined;

    constructor(data?: IStateHierarchyViewModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.stateId = _data["stateId"];
            this.name = _data["name"];
            if (Array.isArray(_data["cities"])) {
                this.cities = [] as any;
                for (let item of _data["cities"])
                    this.cities!.push(CityHierarchyViewModel.fromJS(item));
            }
        }
    }

    static fromJS(data: any): StateHierarchyViewModel {
        data = typeof data === 'object' ? data : {};
        let result = new StateHierarchyViewModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["stateId"] = this.stateId;
        data["name"] = this.name;
        if (Array.isArray(this.cities)) {
            data["cities"] = [];
            for (let item of this.cities)
                data["cities"].push(item ? item.toJSON() : undefined as any);
        }
        return data;
    }
}


export interface IStateHierarchyViewModel {
    stateId: string;
    name: string | undefined;
    cities: CityHierarchyViewModel[] | undefined;
}


export class StateOrRegionBoundaryNode implements IStateOrRegionBoundaryNode {
    key!: string;
    value!: string | undefined;
    boundaries!: CoordinateViewModel[] | undefined;
    cities!: CityBoundaryNode[] | undefined;

    constructor(data?: IStateOrRegionBoundaryNode) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.key = _data["key"];
            this.value = _data["value"];
            if (Array.isArray(_data["boundaries"])) {
                this.boundaries = [] as any;
                for (let item of _data["boundaries"])
                    this.boundaries!.push(CoordinateViewModel.fromJS(item));
            }
            if (Array.isArray(_data["cities"])) {
                this.cities = [] as any;
                for (let item of _data["cities"])
                    this.cities!.push(CityBoundaryNode.fromJS(item));
            }
        }
    }

    static fromJS(data: any): StateOrRegionBoundaryNode {
        data = typeof data === 'object' ? data : {};
        let result = new StateOrRegionBoundaryNode();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["key"] = this.key;
        data["value"] = this.value;
        if (Array.isArray(this.boundaries)) {
            data["boundaries"] = [];
            for (let item of this.boundaries)
                data["boundaries"].push(item ? item.toJSON() : undefined as any);
        }
        if (Array.isArray(this.cities)) {
            data["cities"] = [];
            for (let item of this.cities)
                data["cities"].push(item ? item.toJSON() : undefined as any);
        }
        return data;
    }
}


export interface IStateOrRegionBoundaryNode {
    key: string;
    value: string | undefined;
    boundaries: CoordinateViewModel[] | undefined;
    cities: CityBoundaryNode[] | undefined;
}


export class StateOrRegionNode implements IStateOrRegionNode {
    key!: string;
    value!: string | undefined;
    cities!: CityDistrictNode[] | undefined;

    constructor(data?: IStateOrRegionNode) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.key = _data["key"];
            this.value = _data["value"];
            if (Array.isArray(_data["cities"])) {
                this.cities = [] as any;
                for (let item of _data["cities"])
                    this.cities!.push(CityDistrictNode.fromJS(item));
            }
        }
    }

    static fromJS(data: any): StateOrRegionNode {
        data = typeof data === 'object' ? data : {};
        let result = new StateOrRegionNode();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["key"] = this.key;
        data["value"] = this.value;
        if (Array.isArray(this.cities)) {
            data["cities"] = [];
            for (let item of this.cities)
                data["cities"].push(item ? item.toJSON() : undefined as any);
        }
        return data;
    }
}


export interface IStateOrRegionNode {
    key: string;
    value: string | undefined;
    cities: CityDistrictNode[] | undefined;
}


export class StringDoubleDictionaryListResponseResult implements IStringDoubleDictionaryListResponseResult {
    isSuccess!: boolean;
    statusCode!: number;
    result!: { [key: string]: number; }[] | undefined;
    errors!: ErrorMessage[] | undefined;
    version!: string | undefined;
    environment!: string | undefined;

    constructor(data?: IStringDoubleDictionaryListResponseResult) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.isSuccess = _data["isSuccess"];
            this.statusCode = _data["statusCode"];
            if (Array.isArray(_data["result"])) {
                this.result = [] as any;
                for (let item of _data["result"])
                    this.result!.push(item);
            }
            if (Array.isArray(_data["errors"])) {
                this.errors = [] as any;
                for (let item of _data["errors"])
                    this.errors!.push(ErrorMessage.fromJS(item));
            }
            this.version = _data["version"];
            this.environment = _data["environment"];
        }
    }

    static fromJS(data: any): StringDoubleDictionaryListResponseResult {
        data = typeof data === 'object' ? data : {};
        let result = new StringDoubleDictionaryListResponseResult();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["isSuccess"] = this.isSuccess;
        data["statusCode"] = this.statusCode;
        if (Array.isArray(this.result)) {
            data["result"] = [];
            for (let item of this.result)
                data["result"].push(item);
        }
        if (Array.isArray(this.errors)) {
            data["errors"] = [];
            for (let item of this.errors)
                data["errors"].push(item ? item.toJSON() : undefined as any);
        }
        data["version"] = this.version;
        data["environment"] = this.environment;
        return data;
    }
}


export interface IStringDoubleDictionaryListResponseResult {
    isSuccess: boolean;
    statusCode: number;
    result: { [key: string]: number; }[] | undefined;
    errors: ErrorMessage[] | undefined;
    version: string | undefined;
    environment: string | undefined;
}


export class SubcontractPracticeKeyValueModel implements ISubcontractPracticeKeyValueModel {
    key!: string;
    value!: string | undefined;
    code!: string | undefined;

    constructor(data?: ISubcontractPracticeKeyValueModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.key = _data["key"];
            this.value = _data["value"];
            this.code = _data["code"];
        }
    }

    static fromJS(data: any): SubcontractPracticeKeyValueModel {
        data = typeof data === 'object' ? data : {};
        let result = new SubcontractPracticeKeyValueModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["key"] = this.key;
        data["value"] = this.value;
        data["code"] = this.code;
        return data;
    }
}


export interface ISubcontractPracticeKeyValueModel {
    key: string;
    value: string | undefined;
    code: string | undefined;
}


export class SubcontractPracticeKeyValueModelListResponseResult implements ISubcontractPracticeKeyValueModelListResponseResult {
    isSuccess!: boolean;
    statusCode!: number;
    result!: SubcontractPracticeKeyValueModel[] | undefined;
    errors!: ErrorMessage[] | undefined;
    version!: string | undefined;
    environment!: string | undefined;

    constructor(data?: ISubcontractPracticeKeyValueModelListResponseResult) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.isSuccess = _data["isSuccess"];
            this.statusCode = _data["statusCode"];
            if (Array.isArray(_data["result"])) {
                this.result = [] as any;
                for (let item of _data["result"])
                    this.result!.push(SubcontractPracticeKeyValueModel.fromJS(item));
            }
            if (Array.isArray(_data["errors"])) {
                this.errors = [] as any;
                for (let item of _data["errors"])
                    this.errors!.push(ErrorMessage.fromJS(item));
            }
            this.version = _data["version"];
            this.environment = _data["environment"];
        }
    }

    static fromJS(data: any): SubcontractPracticeKeyValueModelListResponseResult {
        data = typeof data === 'object' ? data : {};
        let result = new SubcontractPracticeKeyValueModelListResponseResult();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["isSuccess"] = this.isSuccess;
        data["statusCode"] = this.statusCode;
        if (Array.isArray(this.result)) {
            data["result"] = [];
            for (let item of this.result)
                data["result"].push(item ? item.toJSON() : undefined as any);
        }
        if (Array.isArray(this.errors)) {
            data["errors"] = [];
            for (let item of this.errors)
                data["errors"].push(item ? item.toJSON() : undefined as any);
        }
        data["version"] = this.version;
        data["environment"] = this.environment;
        return data;
    }
}


export interface ISubcontractPracticeKeyValueModelListResponseResult {
    isSuccess: boolean;
    statusCode: number;
    result: SubcontractPracticeKeyValueModel[] | undefined;
    errors: ErrorMessage[] | undefined;
    version: string | undefined;
    environment: string | undefined;
}


export class TerminateUserTokenCommand implements ITerminateUserTokenCommand {
    userAccessKey!: string;
    appId!: string;
    otp!: number;
    notes!: string | undefined;

    constructor(data?: ITerminateUserTokenCommand) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.userAccessKey = _data["userAccessKey"];
            this.appId = _data["appId"];
            this.otp = _data["otp"];
            this.notes = _data["notes"];
        }
    }

    static fromJS(data: any): TerminateUserTokenCommand {
        data = typeof data === 'object' ? data : {};
        let result = new TerminateUserTokenCommand();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["userAccessKey"] = this.userAccessKey;
        data["appId"] = this.appId;
        data["otp"] = this.otp;
        data["notes"] = this.notes;
        return data;
    }
}


export interface ITerminateUserTokenCommand {
    userAccessKey: string;
    appId: string;
    otp: number;
    notes: string | undefined;
}


export class UnitLookupViewModel implements IUnitLookupViewModel {
    id!: string;
    name!: string | undefined;
    abbreviation!: string | undefined;

    constructor(data?: IUnitLookupViewModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.name = _data["name"];
            this.abbreviation = _data["abbreviation"];
        }
    }

    static fromJS(data: any): UnitLookupViewModel {
        data = typeof data === 'object' ? data : {};
        let result = new UnitLookupViewModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["name"] = this.name;
        data["abbreviation"] = this.abbreviation;
        return data;
    }
}


export interface IUnitLookupViewModel {
    id: string;
    name: string | undefined;
    abbreviation: string | undefined;
}


export class UnitTypeLookupViewModel implements IUnitTypeLookupViewModel {
    id!: string;
    name!: string | undefined;
    units!: UnitLookupViewModel[] | undefined;

    constructor(data?: IUnitTypeLookupViewModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.name = _data["name"];
            if (Array.isArray(_data["units"])) {
                this.units = [] as any;
                for (let item of _data["units"])
                    this.units!.push(UnitLookupViewModel.fromJS(item));
            }
        }
    }

    static fromJS(data: any): UnitTypeLookupViewModel {
        data = typeof data === 'object' ? data : {};
        let result = new UnitTypeLookupViewModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["name"] = this.name;
        if (Array.isArray(this.units)) {
            data["units"] = [];
            for (let item of this.units)
                data["units"].push(item ? item.toJSON() : undefined as any);
        }
        return data;
    }
}


export interface IUnitTypeLookupViewModel {
    id: string;
    name: string | undefined;
    units: UnitLookupViewModel[] | undefined;
}


export class UnitTypeLookupViewModelListResponseResult implements IUnitTypeLookupViewModelListResponseResult {
    isSuccess!: boolean;
    statusCode!: number;
    result!: UnitTypeLookupViewModel[] | undefined;
    errors!: ErrorMessage[] | undefined;
    version!: string | undefined;
    environment!: string | undefined;

    constructor(data?: IUnitTypeLookupViewModelListResponseResult) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.isSuccess = _data["isSuccess"];
            this.statusCode = _data["statusCode"];
            if (Array.isArray(_data["result"])) {
                this.result = [] as any;
                for (let item of _data["result"])
                    this.result!.push(UnitTypeLookupViewModel.fromJS(item));
            }
            if (Array.isArray(_data["errors"])) {
                this.errors = [] as any;
                for (let item of _data["errors"])
                    this.errors!.push(ErrorMessage.fromJS(item));
            }
            this.version = _data["version"];
            this.environment = _data["environment"];
        }
    }

    static fromJS(data: any): UnitTypeLookupViewModelListResponseResult {
        data = typeof data === 'object' ? data : {};
        let result = new UnitTypeLookupViewModelListResponseResult();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["isSuccess"] = this.isSuccess;
        data["statusCode"] = this.statusCode;
        if (Array.isArray(this.result)) {
            data["result"] = [];
            for (let item of this.result)
                data["result"].push(item ? item.toJSON() : undefined as any);
        }
        if (Array.isArray(this.errors)) {
            data["errors"] = [];
            for (let item of this.errors)
                data["errors"].push(item ? item.toJSON() : undefined as any);
        }
        data["version"] = this.version;
        data["environment"] = this.environment;
        return data;
    }
}


export interface IUnitTypeLookupViewModelListResponseResult {
    isSuccess: boolean;
    statusCode: number;
    result: UnitTypeLookupViewModel[] | undefined;
    errors: ErrorMessage[] | undefined;
    version: string | undefined;
    environment: string | undefined;
}


export class UpdateAccessEnterpriseCommand implements IUpdateAccessEnterpriseCommand {
    id!: string;
    enterpriseId!: string;
    countryId!: string;
    year!: number;
    cropId!: string;
    seasonId!: string;

    constructor(data?: IUpdateAccessEnterpriseCommand) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.enterpriseId = _data["enterpriseId"];
            this.countryId = _data["countryId"];
            this.year = _data["year"];
            this.cropId = _data["cropId"];
            this.seasonId = _data["seasonId"];
        }
    }

    static fromJS(data: any): UpdateAccessEnterpriseCommand {
        data = typeof data === 'object' ? data : {};
        let result = new UpdateAccessEnterpriseCommand();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["enterpriseId"] = this.enterpriseId;
        data["countryId"] = this.countryId;
        data["year"] = this.year;
        data["cropId"] = this.cropId;
        data["seasonId"] = this.seasonId;
        return data;
    }
}


export interface IUpdateAccessEnterpriseCommand {
    id: string;
    enterpriseId: string;
    countryId: string;
    year: number;
    cropId: string;
    seasonId: string;
}


export class UpdateAccessRoleCommand implements IUpdateAccessRoleCommand {
    roleId!: string;
    enterpriseId!: string;
    cropId!: string;
    seasonId!: string;
    year!: number;
    locations!: AccessRoleLocation[] | undefined;

    constructor(data?: IUpdateAccessRoleCommand) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.roleId = _data["roleId"];
            this.enterpriseId = _data["enterpriseId"];
            this.cropId = _data["cropId"];
            this.seasonId = _data["seasonId"];
            this.year = _data["year"];
            if (Array.isArray(_data["locations"])) {
                this.locations = [] as any;
                for (let item of _data["locations"])
                    this.locations!.push(AccessRoleLocation.fromJS(item));
            }
        }
    }

    static fromJS(data: any): UpdateAccessRoleCommand {
        data = typeof data === 'object' ? data : {};
        let result = new UpdateAccessRoleCommand();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["roleId"] = this.roleId;
        data["enterpriseId"] = this.enterpriseId;
        data["cropId"] = this.cropId;
        data["seasonId"] = this.seasonId;
        data["year"] = this.year;
        if (Array.isArray(this.locations)) {
            data["locations"] = [];
            for (let item of this.locations)
                data["locations"].push(item ? item.toJSON() : undefined as any);
        }
        return data;
    }
}


export interface IUpdateAccessRoleCommand {
    roleId: string;
    enterpriseId: string;
    cropId: string;
    seasonId: string;
    year: number;
    locations: AccessRoleLocation[] | undefined;
}


export class UpdateCropMapUserCommand implements IUpdateCropMapUserCommand {
    userId!: string;
    name!: string | undefined;
    surname!: string | undefined;
    cropMapRoleId!: string;

    constructor(data?: IUpdateCropMapUserCommand) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.userId = _data["userId"];
            this.name = _data["name"];
            this.surname = _data["surname"];
            this.cropMapRoleId = _data["cropMapRoleId"];
        }
    }

    static fromJS(data: any): UpdateCropMapUserCommand {
        data = typeof data === 'object' ? data : {};
        let result = new UpdateCropMapUserCommand();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["userId"] = this.userId;
        data["name"] = this.name;
        data["surname"] = this.surname;
        data["cropMapRoleId"] = this.cropMapRoleId;
        return data;
    }
}


export interface IUpdateCropMapUserCommand {
    userId: string;
    name: string | undefined;
    surname: string | undefined;
    cropMapRoleId: string;
}


export class UpdateCropMapUserV2Command implements IUpdateCropMapUserV2Command {
    userId!: string;
    enterpriseId!: string;
    name!: string | undefined;
    surname!: string | undefined;
    roleIds!: string[] | undefined;

    constructor(data?: IUpdateCropMapUserV2Command) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.userId = _data["userId"];
            this.enterpriseId = _data["enterpriseId"];
            this.name = _data["name"];
            this.surname = _data["surname"];
            if (Array.isArray(_data["roleIds"])) {
                this.roleIds = [] as any;
                for (let item of _data["roleIds"])
                    this.roleIds!.push(item);
            }
        }
    }

    static fromJS(data: any): UpdateCropMapUserV2Command {
        data = typeof data === 'object' ? data : {};
        let result = new UpdateCropMapUserV2Command();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["userId"] = this.userId;
        data["enterpriseId"] = this.enterpriseId;
        data["name"] = this.name;
        data["surname"] = this.surname;
        if (Array.isArray(this.roleIds)) {
            data["roleIds"] = [];
            for (let item of this.roleIds)
                data["roleIds"].push(item);
        }
        return data;
    }
}


export interface IUpdateCropMapUserV2Command {
    userId: string;
    enterpriseId: string;
    name: string | undefined;
    surname: string | undefined;
    roleIds: string[] | undefined;
}


export class UpdateFieldObservationCommand implements IUpdateFieldObservationCommand {
    id!: string;
    enterpriseId!: string;
    fieldRef!: number;
    year!: number;
    seasonId!: number | undefined;
    nameSurname!: string | undefined;
    phoneCode!: string | undefined;
    phone!: string | undefined;
    email!: string | undefined;
    note!: string | undefined;
    questionnaire!: Questionnaire;

    constructor(data?: IUpdateFieldObservationCommand) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.enterpriseId = _data["enterpriseId"];
            this.fieldRef = _data["fieldRef"];
            this.year = _data["year"];
            this.seasonId = _data["seasonId"];
            this.nameSurname = _data["nameSurname"];
            this.phoneCode = _data["phoneCode"];
            this.phone = _data["phone"];
            this.email = _data["email"];
            this.note = _data["note"];
            this.questionnaire = _data["questionnaire"] ? Questionnaire.fromJS(_data["questionnaire"]) : undefined as any;
        }
    }

    static fromJS(data: any): UpdateFieldObservationCommand {
        data = typeof data === 'object' ? data : {};
        let result = new UpdateFieldObservationCommand();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["enterpriseId"] = this.enterpriseId;
        data["fieldRef"] = this.fieldRef;
        data["year"] = this.year;
        data["seasonId"] = this.seasonId;
        data["nameSurname"] = this.nameSurname;
        data["phoneCode"] = this.phoneCode;
        data["phone"] = this.phone;
        data["email"] = this.email;
        data["note"] = this.note;
        data["questionnaire"] = this.questionnaire ? this.questionnaire.toJSON() : undefined as any;
        return data;
    }
}


export interface IUpdateFieldObservationCommand {
    id: string;
    enterpriseId: string;
    fieldRef: number;
    year: number;
    seasonId: number | undefined;
    nameSurname: string | undefined;
    phoneCode: string | undefined;
    phone: string | undefined;
    email: string | undefined;
    note: string | undefined;
    questionnaire: Questionnaire;
}


export class UpdateFieldObservationQuestionnaireCommand implements IUpdateFieldObservationQuestionnaireCommand {
    id!: string;
    questionnaireList!: Questionnaire[] | undefined;

    constructor(data?: IUpdateFieldObservationQuestionnaireCommand) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            if (Array.isArray(_data["questionnaireList"])) {
                this.questionnaireList = [] as any;
                for (let item of _data["questionnaireList"])
                    this.questionnaireList!.push(Questionnaire.fromJS(item));
            }
        }
    }

    static fromJS(data: any): UpdateFieldObservationQuestionnaireCommand {
        data = typeof data === 'object' ? data : {};
        let result = new UpdateFieldObservationQuestionnaireCommand();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        if (Array.isArray(this.questionnaireList)) {
            data["questionnaireList"] = [];
            for (let item of this.questionnaireList)
                data["questionnaireList"].push(item ? item.toJSON() : undefined as any);
        }
        return data;
    }
}


export interface IUpdateFieldObservationQuestionnaireCommand {
    id: string;
    questionnaireList: Questionnaire[] | undefined;
}


export class UpdateLandCommand implements IUpdateLandCommand {
    id!: string;
    coordinates!: PolygonItem[] | undefined;
    enterpriseId!: string;
    appId!: string;
    assetOwnershipId!: string;
    name!: string | undefined;
    totalArea!: number | undefined;
    displayId!: number | undefined;
    countryId!: string | undefined;
    regionId!: string | undefined;
    stateId!: string | undefined;
    cityId!: string | undefined;
    districtId!: string | undefined;
    villageId!: string | undefined;
    timeZoneId!: string | undefined;
    weatherSpotId!: string | undefined;
    kmlData!: string | undefined;
    parcelInquiryData!: ParcelInquiryDataDto;
    location!: string | undefined;
    isActive!: boolean;
    isDeleted!: boolean;
    isAnonymized!: boolean;
    note!: string | undefined;

    constructor(data?: IUpdateLandCommand) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            if (Array.isArray(_data["coordinates"])) {
                this.coordinates = [] as any;
                for (let item of _data["coordinates"])
                    this.coordinates!.push(PolygonItem.fromJS(item));
            }
            this.enterpriseId = _data["enterpriseId"];
            this.appId = _data["appId"];
            this.assetOwnershipId = _data["assetOwnershipId"];
            this.name = _data["name"];
            this.totalArea = _data["totalArea"];
            this.displayId = _data["displayId"];
            this.countryId = _data["countryId"];
            this.regionId = _data["regionId"];
            this.stateId = _data["stateId"];
            this.cityId = _data["cityId"];
            this.districtId = _data["districtId"];
            this.villageId = _data["villageId"];
            this.timeZoneId = _data["timeZoneId"];
            this.weatherSpotId = _data["weatherSpotId"];
            this.kmlData = _data["kmlData"];
            this.parcelInquiryData = _data["parcelInquiryData"] ? ParcelInquiryDataDto.fromJS(_data["parcelInquiryData"]) : undefined as any;
            this.location = _data["location"];
            this.isActive = _data["isActive"];
            this.isDeleted = _data["isDeleted"];
            this.isAnonymized = _data["isAnonymized"];
            this.note = _data["note"];
        }
    }

    static fromJS(data: any): UpdateLandCommand {
        data = typeof data === 'object' ? data : {};
        let result = new UpdateLandCommand();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        if (Array.isArray(this.coordinates)) {
            data["coordinates"] = [];
            for (let item of this.coordinates)
                data["coordinates"].push(item ? item.toJSON() : undefined as any);
        }
        data["enterpriseId"] = this.enterpriseId;
        data["appId"] = this.appId;
        data["assetOwnershipId"] = this.assetOwnershipId;
        data["name"] = this.name;
        data["totalArea"] = this.totalArea;
        data["displayId"] = this.displayId;
        data["countryId"] = this.countryId;
        data["regionId"] = this.regionId;
        data["stateId"] = this.stateId;
        data["cityId"] = this.cityId;
        data["districtId"] = this.districtId;
        data["villageId"] = this.villageId;
        data["timeZoneId"] = this.timeZoneId;
        data["weatherSpotId"] = this.weatherSpotId;
        data["kmlData"] = this.kmlData;
        data["parcelInquiryData"] = this.parcelInquiryData ? this.parcelInquiryData.toJSON() : undefined as any;
        data["location"] = this.location;
        data["isActive"] = this.isActive;
        data["isDeleted"] = this.isDeleted;
        data["isAnonymized"] = this.isAnonymized;
        data["note"] = this.note;
        return data;
    }
}


export interface IUpdateLandCommand {
    id: string;
    coordinates: PolygonItem[] | undefined;
    enterpriseId: string;
    appId: string;
    assetOwnershipId: string;
    name: string | undefined;
    totalArea: number | undefined;
    displayId: number | undefined;
    countryId: string | undefined;
    regionId: string | undefined;
    stateId: string | undefined;
    cityId: string | undefined;
    districtId: string | undefined;
    villageId: string | undefined;
    timeZoneId: string | undefined;
    weatherSpotId: string | undefined;
    kmlData: string | undefined;
    parcelInquiryData: ParcelInquiryDataDto;
    location: string | undefined;
    isActive: boolean;
    isDeleted: boolean;
    isAnonymized: boolean;
    note: string | undefined;
}


export class UpdateLandWithPlantationCommand implements IUpdateLandWithPlantationCommand {
    id!: string;
    assetOwnershipId!: string;
    name!: string | undefined;
    regenerativePracticeIds!: string[] | undefined;

    constructor(data?: IUpdateLandWithPlantationCommand) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.assetOwnershipId = _data["assetOwnershipId"];
            this.name = _data["name"];
            if (Array.isArray(_data["regenerativePracticeIds"])) {
                this.regenerativePracticeIds = [] as any;
                for (let item of _data["regenerativePracticeIds"])
                    this.regenerativePracticeIds!.push(item);
            }
        }
    }

    static fromJS(data: any): UpdateLandWithPlantationCommand {
        data = typeof data === 'object' ? data : {};
        let result = new UpdateLandWithPlantationCommand();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["assetOwnershipId"] = this.assetOwnershipId;
        data["name"] = this.name;
        if (Array.isArray(this.regenerativePracticeIds)) {
            data["regenerativePracticeIds"] = [];
            for (let item of this.regenerativePracticeIds)
                data["regenerativePracticeIds"].push(item);
        }
        return data;
    }
}


export interface IUpdateLandWithPlantationCommand {
    id: string;
    assetOwnershipId: string;
    name: string | undefined;
    regenerativePracticeIds: string[] | undefined;
}


export class UpdateLayerCommand implements IUpdateLayerCommand {
    id!: number;
    layerName!: string | undefined;
    note!: string | undefined;
    isActive!: boolean;
    countryId!: number;
    yearData!: CropMapYearDataViewModel[] | undefined;
    latitude!: CropMapCoordinatesViewModel;
    longitude!: CropMapCoordinatesViewModel;

    constructor(data?: IUpdateLayerCommand) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.layerName = _data["layerName"];
            this.note = _data["note"];
            this.isActive = _data["isActive"];
            this.countryId = _data["countryId"];
            if (Array.isArray(_data["yearData"])) {
                this.yearData = [] as any;
                for (let item of _data["yearData"])
                    this.yearData!.push(CropMapYearDataViewModel.fromJS(item));
            }
            this.latitude = _data["latitude"] ? CropMapCoordinatesViewModel.fromJS(_data["latitude"]) : undefined as any;
            this.longitude = _data["longitude"] ? CropMapCoordinatesViewModel.fromJS(_data["longitude"]) : undefined as any;
        }
    }

    static fromJS(data: any): UpdateLayerCommand {
        data = typeof data === 'object' ? data : {};
        let result = new UpdateLayerCommand();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["layerName"] = this.layerName;
        data["note"] = this.note;
        data["isActive"] = this.isActive;
        data["countryId"] = this.countryId;
        if (Array.isArray(this.yearData)) {
            data["yearData"] = [];
            for (let item of this.yearData)
                data["yearData"].push(item ? item.toJSON() : undefined as any);
        }
        data["latitude"] = this.latitude ? this.latitude.toJSON() : undefined as any;
        data["longitude"] = this.longitude ? this.longitude.toJSON() : undefined as any;
        return data;
    }
}


export interface IUpdateLayerCommand {
    id: number;
    layerName: string | undefined;
    note: string | undefined;
    isActive: boolean;
    countryId: number;
    yearData: CropMapYearDataViewModel[] | undefined;
    latitude: CropMapCoordinatesViewModel;
    longitude: CropMapCoordinatesViewModel;
}


export class UpdateRoleCommand implements IUpdateRoleCommand {
    id!: string;
    name!: string | undefined;
    roleKind!: string | undefined;
    description!: string | undefined;
    enterpriseId!: string | undefined;
    permissions!: string[] | undefined;

    constructor(data?: IUpdateRoleCommand) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.name = _data["name"];
            this.roleKind = _data["roleKind"];
            this.description = _data["description"];
            this.enterpriseId = _data["enterpriseId"];
            if (Array.isArray(_data["permissions"])) {
                this.permissions = [] as any;
                for (let item of _data["permissions"])
                    this.permissions!.push(item);
            }
        }
    }

    static fromJS(data: any): UpdateRoleCommand {
        data = typeof data === 'object' ? data : {};
        let result = new UpdateRoleCommand();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["name"] = this.name;
        data["roleKind"] = this.roleKind;
        data["description"] = this.description;
        data["enterpriseId"] = this.enterpriseId;
        if (Array.isArray(this.permissions)) {
            data["permissions"] = [];
            for (let item of this.permissions)
                data["permissions"].push(item);
        }
        return data;
    }
}


export interface IUpdateRoleCommand {
    id: string;
    name: string | undefined;
    roleKind: string | undefined;
    description: string | undefined;
    enterpriseId: string | undefined;
    permissions: string[] | undefined;
}


export class UpdateUserEmailCommand implements IUpdateUserEmailCommand {
    id!: string;
    email!: string | undefined;
    otp!: number;

    constructor(data?: IUpdateUserEmailCommand) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.email = _data["email"];
            this.otp = _data["otp"];
        }
    }

    static fromJS(data: any): UpdateUserEmailCommand {
        data = typeof data === 'object' ? data : {};
        let result = new UpdateUserEmailCommand();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["email"] = this.email;
        data["otp"] = this.otp;
        return data;
    }
}


export interface IUpdateUserEmailCommand {
    id: string;
    email: string | undefined;
    otp: number;
}


export class UpdateUserEmailCommandV2 implements IUpdateUserEmailCommandV2 {
    newEmail!: string | undefined;
    otp!: number;
    userId!: string | undefined;

    constructor(data?: IUpdateUserEmailCommandV2) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.newEmail = _data["newEmail"];
            this.otp = _data["otp"];
            this.userId = _data["userId"];
        }
    }

    static fromJS(data: any): UpdateUserEmailCommandV2 {
        data = typeof data === 'object' ? data : {};
        let result = new UpdateUserEmailCommandV2();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["newEmail"] = this.newEmail;
        data["otp"] = this.otp;
        data["userId"] = this.userId;
        return data;
    }
}


export interface IUpdateUserEmailCommandV2 {
    newEmail: string | undefined;
    otp: number;
    userId: string | undefined;
}


export class UpdateUserPhoneCommand implements IUpdateUserPhoneCommand {
    id!: string;
    phoneCode!: string | undefined;
    phone!: string | undefined;
    otp!: number;

    constructor(data?: IUpdateUserPhoneCommand) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.phoneCode = _data["phoneCode"];
            this.phone = _data["phone"];
            this.otp = _data["otp"];
        }
    }

    static fromJS(data: any): UpdateUserPhoneCommand {
        data = typeof data === 'object' ? data : {};
        let result = new UpdateUserPhoneCommand();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["phoneCode"] = this.phoneCode;
        data["phone"] = this.phone;
        data["otp"] = this.otp;
        return data;
    }
}


export interface IUpdateUserPhoneCommand {
    id: string;
    phoneCode: string | undefined;
    phone: string | undefined;
    otp: number;
}


export class UpdateUserPhoneCommandV2 implements IUpdateUserPhoneCommandV2 {
    phoneCode!: string | undefined;
    phone!: string | undefined;
    otp!: number;
    userId!: string | undefined;

    constructor(data?: IUpdateUserPhoneCommandV2) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.phoneCode = _data["phoneCode"];
            this.phone = _data["phone"];
            this.otp = _data["otp"];
            this.userId = _data["userId"];
        }
    }

    static fromJS(data: any): UpdateUserPhoneCommandV2 {
        data = typeof data === 'object' ? data : {};
        let result = new UpdateUserPhoneCommandV2();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["phoneCode"] = this.phoneCode;
        data["phone"] = this.phone;
        data["otp"] = this.otp;
        data["userId"] = this.userId;
        return data;
    }
}


export interface IUpdateUserPhoneCommandV2 {
    phoneCode: string | undefined;
    phone: string | undefined;
    otp: number;
    userId: string | undefined;
}


export class UpdateUserProfileCommand implements IUpdateUserProfileCommand {
    name!: string | undefined;
    surname!: string | undefined;
    appId!: string | undefined;
    customerId!: string | undefined;
    countryId!: string | undefined;
    defaultEnterpriseId!: string | undefined;
    professionId!: string | undefined;
    localeId!: string | undefined;
    timeZoneId!: string | undefined;
    units!: string[] | undefined;
    notificationPreferences!: string[] | undefined;
    engagementPreferences!: string[] | undefined;
    roles!: string[] | undefined;
    allCommunicationsAllowed!: boolean | undefined;
    isMFAActive!: boolean | undefined;
    forcePasswordChange!: boolean | undefined;
    note!: string | undefined;

    constructor(data?: IUpdateUserProfileCommand) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.name = _data["name"];
            this.surname = _data["surname"];
            this.appId = _data["appId"];
            this.customerId = _data["customerId"];
            this.countryId = _data["countryId"];
            this.defaultEnterpriseId = _data["defaultEnterpriseId"];
            this.professionId = _data["professionId"];
            this.localeId = _data["localeId"];
            this.timeZoneId = _data["timeZoneId"];
            if (Array.isArray(_data["units"])) {
                this.units = [] as any;
                for (let item of _data["units"])
                    this.units!.push(item);
            }
            if (Array.isArray(_data["notificationPreferences"])) {
                this.notificationPreferences = [] as any;
                for (let item of _data["notificationPreferences"])
                    this.notificationPreferences!.push(item);
            }
            if (Array.isArray(_data["engagementPreferences"])) {
                this.engagementPreferences = [] as any;
                for (let item of _data["engagementPreferences"])
                    this.engagementPreferences!.push(item);
            }
            if (Array.isArray(_data["roles"])) {
                this.roles = [] as any;
                for (let item of _data["roles"])
                    this.roles!.push(item);
            }
            this.allCommunicationsAllowed = _data["allCommunicationsAllowed"];
            this.isMFAActive = _data["isMFAActive"];
            this.forcePasswordChange = _data["forcePasswordChange"];
            this.note = _data["note"];
        }
    }

    static fromJS(data: any): UpdateUserProfileCommand {
        data = typeof data === 'object' ? data : {};
        let result = new UpdateUserProfileCommand();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["name"] = this.name;
        data["surname"] = this.surname;
        data["appId"] = this.appId;
        data["customerId"] = this.customerId;
        data["countryId"] = this.countryId;
        data["defaultEnterpriseId"] = this.defaultEnterpriseId;
        data["professionId"] = this.professionId;
        data["localeId"] = this.localeId;
        data["timeZoneId"] = this.timeZoneId;
        if (Array.isArray(this.units)) {
            data["units"] = [];
            for (let item of this.units)
                data["units"].push(item);
        }
        if (Array.isArray(this.notificationPreferences)) {
            data["notificationPreferences"] = [];
            for (let item of this.notificationPreferences)
                data["notificationPreferences"].push(item);
        }
        if (Array.isArray(this.engagementPreferences)) {
            data["engagementPreferences"] = [];
            for (let item of this.engagementPreferences)
                data["engagementPreferences"].push(item);
        }
        if (Array.isArray(this.roles)) {
            data["roles"] = [];
            for (let item of this.roles)
                data["roles"].push(item);
        }
        data["allCommunicationsAllowed"] = this.allCommunicationsAllowed;
        data["isMFAActive"] = this.isMFAActive;
        data["forcePasswordChange"] = this.forcePasswordChange;
        data["note"] = this.note;
        return data;
    }
}


export interface IUpdateUserProfileCommand {
    name: string | undefined;
    surname: string | undefined;
    appId: string | undefined;
    customerId: string | undefined;
    countryId: string | undefined;
    defaultEnterpriseId: string | undefined;
    professionId: string | undefined;
    localeId: string | undefined;
    timeZoneId: string | undefined;
    units: string[] | undefined;
    notificationPreferences: string[] | undefined;
    engagementPreferences: string[] | undefined;
    roles: string[] | undefined;
    allCommunicationsAllowed: boolean | undefined;
    isMFAActive: boolean | undefined;
    forcePasswordChange: boolean | undefined;
    note: string | undefined;
}


export class UpdateUserSensitiveCommand implements IUpdateUserSensitiveCommand {
    id!: string;
    userTypeId!: string;
    email!: string | undefined;
    isEmailVerified!: boolean;
    phoneCode!: string | undefined;
    phone!: string | undefined;
    isPhoneVerified!: boolean;
    isLocked!: boolean | undefined;
    lockedUntil!: DateTime | undefined;
    isActive!: boolean;
    isDeleted!: boolean;
    totp!: number;
    reason!: string | undefined;

    constructor(data?: IUpdateUserSensitiveCommand) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.userTypeId = _data["userTypeId"];
            this.email = _data["email"];
            this.isEmailVerified = _data["isEmailVerified"];
            this.phoneCode = _data["phoneCode"];
            this.phone = _data["phone"];
            this.isPhoneVerified = _data["isPhoneVerified"];
            this.isLocked = _data["isLocked"];
            this.lockedUntil = _data["lockedUntil"] ? DateTime.fromISO(_data["lockedUntil"].toString()) : undefined as any;
            this.isActive = _data["isActive"];
            this.isDeleted = _data["isDeleted"];
            this.totp = _data["totp"];
            this.reason = _data["reason"];
        }
    }

    static fromJS(data: any): UpdateUserSensitiveCommand {
        data = typeof data === 'object' ? data : {};
        let result = new UpdateUserSensitiveCommand();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["userTypeId"] = this.userTypeId;
        data["email"] = this.email;
        data["isEmailVerified"] = this.isEmailVerified;
        data["phoneCode"] = this.phoneCode;
        data["phone"] = this.phone;
        data["isPhoneVerified"] = this.isPhoneVerified;
        data["isLocked"] = this.isLocked;
        data["lockedUntil"] = this.lockedUntil ? this.lockedUntil.toString() : undefined as any;
        data["isActive"] = this.isActive;
        data["isDeleted"] = this.isDeleted;
        data["totp"] = this.totp;
        data["reason"] = this.reason;
        return data;
    }
}


export interface IUpdateUserSensitiveCommand {
    id: string;
    userTypeId: string;
    email: string | undefined;
    isEmailVerified: boolean;
    phoneCode: string | undefined;
    phone: string | undefined;
    isPhoneVerified: boolean;
    isLocked: boolean | undefined;
    lockedUntil: DateTime | undefined;
    isActive: boolean;
    isDeleted: boolean;
    totp: number;
    reason: string | undefined;
}


export class UserEnterpriseViewModel implements IUserEnterpriseViewModel {
    id!: string;
    name!: string | undefined;
    owner!: string | undefined;
    depth!: number;
    parent!: string | undefined;
    topParent!: string | undefined;
    isActive!: boolean;
    isDefaultEnterprise!: boolean;

    constructor(data?: IUserEnterpriseViewModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.name = _data["name"];
            this.owner = _data["owner"];
            this.depth = _data["depth"];
            this.parent = _data["parent"];
            this.topParent = _data["topParent"];
            this.isActive = _data["isActive"];
            this.isDefaultEnterprise = _data["isDefaultEnterprise"];
        }
    }

    static fromJS(data: any): UserEnterpriseViewModel {
        data = typeof data === 'object' ? data : {};
        let result = new UserEnterpriseViewModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["name"] = this.name;
        data["owner"] = this.owner;
        data["depth"] = this.depth;
        data["parent"] = this.parent;
        data["topParent"] = this.topParent;
        data["isActive"] = this.isActive;
        data["isDefaultEnterprise"] = this.isDefaultEnterprise;
        return data;
    }
}


export interface IUserEnterpriseViewModel {
    id: string;
    name: string | undefined;
    owner: string | undefined;
    depth: number;
    parent: string | undefined;
    topParent: string | undefined;
    isActive: boolean;
    isDefaultEnterprise: boolean;
}


export class UserInquiryViewModel implements IUserInquiryViewModel {
    id!: string;
    subject!: string | undefined;
    plantation!: string | undefined;
    enterprise!: string | undefined;
    inventory!: string | undefined;
    activeUntil!: DateTime | undefined;
    expectedResponseEmail!: string | undefined;
    expectedResponsePhone!: string | undefined;

    constructor(data?: IUserInquiryViewModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.subject = _data["subject"];
            this.plantation = _data["plantation"];
            this.enterprise = _data["enterprise"];
            this.inventory = _data["inventory"];
            this.activeUntil = _data["activeUntil"] ? DateTime.fromISO(_data["activeUntil"].toString()) : undefined as any;
            this.expectedResponseEmail = _data["expectedResponseEmail"];
            this.expectedResponsePhone = _data["expectedResponsePhone"];
        }
    }

    static fromJS(data: any): UserInquiryViewModel {
        data = typeof data === 'object' ? data : {};
        let result = new UserInquiryViewModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["subject"] = this.subject;
        data["plantation"] = this.plantation;
        data["enterprise"] = this.enterprise;
        data["inventory"] = this.inventory;
        data["activeUntil"] = this.activeUntil ? this.activeUntil.toString() : undefined as any;
        data["expectedResponseEmail"] = this.expectedResponseEmail;
        data["expectedResponsePhone"] = this.expectedResponsePhone;
        return data;
    }
}


export interface IUserInquiryViewModel {
    id: string;
    subject: string | undefined;
    plantation: string | undefined;
    enterprise: string | undefined;
    inventory: string | undefined;
    activeUntil: DateTime | undefined;
    expectedResponseEmail: string | undefined;
    expectedResponsePhone: string | undefined;
}


export class UserInviteViewModel implements IUserInviteViewModel {
    id!: string;
    inviteeId!: string | undefined;
    inviteeName!: string | undefined;
    inviteePhone!: string | undefined;
    inviteeEmail!: string | undefined;
    validUntil!: DateTime | undefined;
    acceptanceDate!: DateTime | undefined;
    createdAt!: DateTime;
    createdBy!: number;
    isActive!: boolean;
    isAnonymized!: boolean;

    constructor(data?: IUserInviteViewModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.inviteeId = _data["inviteeId"];
            this.inviteeName = _data["inviteeName"];
            this.inviteePhone = _data["inviteePhone"];
            this.inviteeEmail = _data["inviteeEmail"];
            this.validUntil = _data["validUntil"] ? DateTime.fromISO(_data["validUntil"].toString()) : undefined as any;
            this.acceptanceDate = _data["acceptanceDate"] ? DateTime.fromISO(_data["acceptanceDate"].toString()) : undefined as any;
            this.createdAt = _data["createdAt"] ? DateTime.fromISO(_data["createdAt"].toString()) : undefined as any;
            this.createdBy = _data["createdBy"];
            this.isActive = _data["isActive"];
            this.isAnonymized = _data["isAnonymized"];
        }
    }

    static fromJS(data: any): UserInviteViewModel {
        data = typeof data === 'object' ? data : {};
        let result = new UserInviteViewModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["inviteeId"] = this.inviteeId;
        data["inviteeName"] = this.inviteeName;
        data["inviteePhone"] = this.inviteePhone;
        data["inviteeEmail"] = this.inviteeEmail;
        data["validUntil"] = this.validUntil ? this.validUntil.toString() : undefined as any;
        data["acceptanceDate"] = this.acceptanceDate ? this.acceptanceDate.toString() : undefined as any;
        data["createdAt"] = this.createdAt ? this.createdAt.toString() : undefined as any;
        data["createdBy"] = this.createdBy;
        data["isActive"] = this.isActive;
        data["isAnonymized"] = this.isAnonymized;
        return data;
    }
}


export interface IUserInviteViewModel {
    id: string;
    inviteeId: string | undefined;
    inviteeName: string | undefined;
    inviteePhone: string | undefined;
    inviteeEmail: string | undefined;
    validUntil: DateTime | undefined;
    acceptanceDate: DateTime | undefined;
    createdAt: DateTime;
    createdBy: number;
    isActive: boolean;
    isAnonymized: boolean;
}


export class UserProfileViewModel implements IUserProfileViewModel {
    id!: string;
    name!: string | undefined;
    surname!: string | undefined;
    email!: string | undefined;
    phone!: string | undefined;
    phoneCode!: string | undefined;
    note!: string | undefined;
    professionId!: string | undefined;
    localeId!: string | undefined;
    timeZoneId!: string | undefined;
    readonly isEmailVerified!: boolean;
    readonly isPhoneVerified!: boolean;
    readonly isHasLand!: boolean;
    readonly isHasPlantation!: boolean;
    permissions!: string[] | undefined;
    unitPreferences!: KeyValueModel[] | undefined;
    notificationChannels!: KeyValueModel[] | undefined;
    engagementCategories!: KeyValueModel[] | undefined;
    roles!: KeyValueModel[] | undefined;
    userSSOMap!: KeyValueModelString[] | undefined;
    enterprises!: UserEnterpriseViewModel[] | undefined;
    invitations!: UserInviteViewModel[] | undefined;
    inquiries!: UserInquiryViewModel[] | undefined;

    constructor(data?: IUserProfileViewModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.name = _data["name"];
            this.surname = _data["surname"];
            this.email = _data["email"];
            this.phone = _data["phone"];
            this.phoneCode = _data["phoneCode"];
            this.note = _data["note"];
            this.professionId = _data["professionId"];
            this.localeId = _data["localeId"];
            this.timeZoneId = _data["timeZoneId"];
            (this as any).isEmailVerified = _data["isEmailVerified"];
            (this as any).isPhoneVerified = _data["isPhoneVerified"];
            (this as any).isHasLand = _data["isHasLand"];
            (this as any).isHasPlantation = _data["isHasPlantation"];
            if (Array.isArray(_data["permissions"])) {
                this.permissions = [] as any;
                for (let item of _data["permissions"])
                    this.permissions!.push(item);
            }
            if (Array.isArray(_data["unitPreferences"])) {
                this.unitPreferences = [] as any;
                for (let item of _data["unitPreferences"])
                    this.unitPreferences!.push(KeyValueModel.fromJS(item));
            }
            if (Array.isArray(_data["notificationChannels"])) {
                this.notificationChannels = [] as any;
                for (let item of _data["notificationChannels"])
                    this.notificationChannels!.push(KeyValueModel.fromJS(item));
            }
            if (Array.isArray(_data["engagementCategories"])) {
                this.engagementCategories = [] as any;
                for (let item of _data["engagementCategories"])
                    this.engagementCategories!.push(KeyValueModel.fromJS(item));
            }
            if (Array.isArray(_data["roles"])) {
                this.roles = [] as any;
                for (let item of _data["roles"])
                    this.roles!.push(KeyValueModel.fromJS(item));
            }
            if (Array.isArray(_data["userSSOMap"])) {
                this.userSSOMap = [] as any;
                for (let item of _data["userSSOMap"])
                    this.userSSOMap!.push(KeyValueModelString.fromJS(item));
            }
            if (Array.isArray(_data["enterprises"])) {
                this.enterprises = [] as any;
                for (let item of _data["enterprises"])
                    this.enterprises!.push(UserEnterpriseViewModel.fromJS(item));
            }
            if (Array.isArray(_data["invitations"])) {
                this.invitations = [] as any;
                for (let item of _data["invitations"])
                    this.invitations!.push(UserInviteViewModel.fromJS(item));
            }
            if (Array.isArray(_data["inquiries"])) {
                this.inquiries = [] as any;
                for (let item of _data["inquiries"])
                    this.inquiries!.push(UserInquiryViewModel.fromJS(item));
            }
        }
    }

    static fromJS(data: any): UserProfileViewModel {
        data = typeof data === 'object' ? data : {};
        let result = new UserProfileViewModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["name"] = this.name;
        data["surname"] = this.surname;
        data["email"] = this.email;
        data["phone"] = this.phone;
        data["phoneCode"] = this.phoneCode;
        data["note"] = this.note;
        data["professionId"] = this.professionId;
        data["localeId"] = this.localeId;
        data["timeZoneId"] = this.timeZoneId;
        data["isEmailVerified"] = this.isEmailVerified;
        data["isPhoneVerified"] = this.isPhoneVerified;
        data["isHasLand"] = this.isHasLand;
        data["isHasPlantation"] = this.isHasPlantation;
        if (Array.isArray(this.permissions)) {
            data["permissions"] = [];
            for (let item of this.permissions)
                data["permissions"].push(item);
        }
        if (Array.isArray(this.unitPreferences)) {
            data["unitPreferences"] = [];
            for (let item of this.unitPreferences)
                data["unitPreferences"].push(item ? item.toJSON() : undefined as any);
        }
        if (Array.isArray(this.notificationChannels)) {
            data["notificationChannels"] = [];
            for (let item of this.notificationChannels)
                data["notificationChannels"].push(item ? item.toJSON() : undefined as any);
        }
        if (Array.isArray(this.engagementCategories)) {
            data["engagementCategories"] = [];
            for (let item of this.engagementCategories)
                data["engagementCategories"].push(item ? item.toJSON() : undefined as any);
        }
        if (Array.isArray(this.roles)) {
            data["roles"] = [];
            for (let item of this.roles)
                data["roles"].push(item ? item.toJSON() : undefined as any);
        }
        if (Array.isArray(this.userSSOMap)) {
            data["userSSOMap"] = [];
            for (let item of this.userSSOMap)
                data["userSSOMap"].push(item ? item.toJSON() : undefined as any);
        }
        if (Array.isArray(this.enterprises)) {
            data["enterprises"] = [];
            for (let item of this.enterprises)
                data["enterprises"].push(item ? item.toJSON() : undefined as any);
        }
        if (Array.isArray(this.invitations)) {
            data["invitations"] = [];
            for (let item of this.invitations)
                data["invitations"].push(item ? item.toJSON() : undefined as any);
        }
        if (Array.isArray(this.inquiries)) {
            data["inquiries"] = [];
            for (let item of this.inquiries)
                data["inquiries"].push(item ? item.toJSON() : undefined as any);
        }
        return data;
    }
}


export interface IUserProfileViewModel {
    id: string;
    name: string | undefined;
    surname: string | undefined;
    email: string | undefined;
    phone: string | undefined;
    phoneCode: string | undefined;
    note: string | undefined;
    professionId: string | undefined;
    localeId: string | undefined;
    timeZoneId: string | undefined;
    isEmailVerified: boolean;
    isPhoneVerified: boolean;
    isHasLand: boolean;
    isHasPlantation: boolean;
    permissions: string[] | undefined;
    unitPreferences: KeyValueModel[] | undefined;
    notificationChannels: KeyValueModel[] | undefined;
    engagementCategories: KeyValueModel[] | undefined;
    roles: KeyValueModel[] | undefined;
    userSSOMap: KeyValueModelString[] | undefined;
    enterprises: UserEnterpriseViewModel[] | undefined;
    invitations: UserInviteViewModel[] | undefined;
    inquiries: UserInquiryViewModel[] | undefined;
}


export class UserProfileViewModelResponseResult implements IUserProfileViewModelResponseResult {
    isSuccess!: boolean;
    statusCode!: number;
    result!: UserProfileViewModel;
    errors!: ErrorMessage[] | undefined;
    version!: string | undefined;
    environment!: string | undefined;

    constructor(data?: IUserProfileViewModelResponseResult) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.isSuccess = _data["isSuccess"];
            this.statusCode = _data["statusCode"];
            this.result = _data["result"] ? UserProfileViewModel.fromJS(_data["result"]) : undefined as any;
            if (Array.isArray(_data["errors"])) {
                this.errors = [] as any;
                for (let item of _data["errors"])
                    this.errors!.push(ErrorMessage.fromJS(item));
            }
            this.version = _data["version"];
            this.environment = _data["environment"];
        }
    }

    static fromJS(data: any): UserProfileViewModelResponseResult {
        data = typeof data === 'object' ? data : {};
        let result = new UserProfileViewModelResponseResult();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["isSuccess"] = this.isSuccess;
        data["statusCode"] = this.statusCode;
        data["result"] = this.result ? this.result.toJSON() : undefined as any;
        if (Array.isArray(this.errors)) {
            data["errors"] = [];
            for (let item of this.errors)
                data["errors"].push(item ? item.toJSON() : undefined as any);
        }
        data["version"] = this.version;
        data["environment"] = this.environment;
        return data;
    }
}


export interface IUserProfileViewModelResponseResult {
    isSuccess: boolean;
    statusCode: number;
    result: UserProfileViewModel;
    errors: ErrorMessage[] | undefined;
    version: string | undefined;
    environment: string | undefined;
}


export class UserViewModel implements IUserViewModel {
    id!: string;
    authKey!: string;
    userTypeId!: string;
    userTypeName!: string | undefined;
    defaultEnterpriseId!: string | undefined;
    defaultEnterpriseName!: string | undefined;
    name!: string | undefined;
    surname!: string | undefined;
    email!: string | undefined;
    phone!: string | undefined;
    phoneCode!: string | undefined;
    appId!: string | undefined;
    appName!: string | undefined;
    customerId!: string | undefined;
    customerName!: string | undefined;
    countryId!: string | undefined;
    countryName!: string | undefined;
    timezoneId!: string | undefined;
    timezoneName!: string | undefined;
    localeId!: string | undefined;
    localeName!: string | undefined;
    professionId!: string | undefined;
    professionName!: string | undefined;
    totalLandArea!: number | undefined;
    totalPlantationArea!: number | undefined;
    lastSigninDate!: DateTime | undefined;
    lastActivityDate!: DateTime | undefined;
    passwordChangeDate!: DateTime | undefined;
    passwordResetDate!: DateTime | undefined;
    isMFAActive!: boolean;
    forcePasswordChange!: boolean;
    lockedUntil!: DateTime | undefined;
    allCommunicationsAllowed!: boolean | undefined;
    isLocked!: boolean | undefined;
    isActive!: boolean;
    isDeleted!: boolean;
    isAnonymized!: boolean;
    isEmailVerified!: boolean;
    isPhoneVerified!: boolean;
    createdAt!: DateTime | undefined;
    createdBy!: string | undefined;
    updatedAt!: DateTime | undefined;
    updatedBy!: string | undefined;
    note!: string | undefined;

    constructor(data?: IUserViewModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.authKey = _data["authKey"];
            this.userTypeId = _data["userTypeId"];
            this.userTypeName = _data["userTypeName"];
            this.defaultEnterpriseId = _data["defaultEnterpriseId"];
            this.defaultEnterpriseName = _data["defaultEnterpriseName"];
            this.name = _data["name"];
            this.surname = _data["surname"];
            this.email = _data["email"];
            this.phone = _data["phone"];
            this.phoneCode = _data["phoneCode"];
            this.appId = _data["appId"];
            this.appName = _data["appName"];
            this.customerId = _data["customerId"];
            this.customerName = _data["customerName"];
            this.countryId = _data["countryId"];
            this.countryName = _data["countryName"];
            this.timezoneId = _data["timezoneId"];
            this.timezoneName = _data["timezoneName"];
            this.localeId = _data["localeId"];
            this.localeName = _data["localeName"];
            this.professionId = _data["professionId"];
            this.professionName = _data["professionName"];
            this.totalLandArea = _data["totalLandArea"];
            this.totalPlantationArea = _data["totalPlantationArea"];
            this.lastSigninDate = _data["lastSigninDate"] ? DateTime.fromISO(_data["lastSigninDate"].toString()) : undefined as any;
            this.lastActivityDate = _data["lastActivityDate"] ? DateTime.fromISO(_data["lastActivityDate"].toString()) : undefined as any;
            this.passwordChangeDate = _data["passwordChangeDate"] ? DateTime.fromISO(_data["passwordChangeDate"].toString()) : undefined as any;
            this.passwordResetDate = _data["passwordResetDate"] ? DateTime.fromISO(_data["passwordResetDate"].toString()) : undefined as any;
            this.isMFAActive = _data["isMFAActive"];
            this.forcePasswordChange = _data["forcePasswordChange"];
            this.lockedUntil = _data["lockedUntil"] ? DateTime.fromISO(_data["lockedUntil"].toString()) : undefined as any;
            this.allCommunicationsAllowed = _data["allCommunicationsAllowed"];
            this.isLocked = _data["isLocked"];
            this.isActive = _data["isActive"];
            this.isDeleted = _data["isDeleted"];
            this.isAnonymized = _data["isAnonymized"];
            this.isEmailVerified = _data["isEmailVerified"];
            this.isPhoneVerified = _data["isPhoneVerified"];
            this.createdAt = _data["createdAt"] ? DateTime.fromISO(_data["createdAt"].toString()) : undefined as any;
            this.createdBy = _data["createdBy"];
            this.updatedAt = _data["updatedAt"] ? DateTime.fromISO(_data["updatedAt"].toString()) : undefined as any;
            this.updatedBy = _data["updatedBy"];
            this.note = _data["note"];
        }
    }

    static fromJS(data: any): UserViewModel {
        data = typeof data === 'object' ? data : {};
        let result = new UserViewModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["authKey"] = this.authKey;
        data["userTypeId"] = this.userTypeId;
        data["userTypeName"] = this.userTypeName;
        data["defaultEnterpriseId"] = this.defaultEnterpriseId;
        data["defaultEnterpriseName"] = this.defaultEnterpriseName;
        data["name"] = this.name;
        data["surname"] = this.surname;
        data["email"] = this.email;
        data["phone"] = this.phone;
        data["phoneCode"] = this.phoneCode;
        data["appId"] = this.appId;
        data["appName"] = this.appName;
        data["customerId"] = this.customerId;
        data["customerName"] = this.customerName;
        data["countryId"] = this.countryId;
        data["countryName"] = this.countryName;
        data["timezoneId"] = this.timezoneId;
        data["timezoneName"] = this.timezoneName;
        data["localeId"] = this.localeId;
        data["localeName"] = this.localeName;
        data["professionId"] = this.professionId;
        data["professionName"] = this.professionName;
        data["totalLandArea"] = this.totalLandArea;
        data["totalPlantationArea"] = this.totalPlantationArea;
        data["lastSigninDate"] = this.lastSigninDate ? this.lastSigninDate.toString() : undefined as any;
        data["lastActivityDate"] = this.lastActivityDate ? this.lastActivityDate.toString() : undefined as any;
        data["passwordChangeDate"] = this.passwordChangeDate ? this.passwordChangeDate.toString() : undefined as any;
        data["passwordResetDate"] = this.passwordResetDate ? this.passwordResetDate.toString() : undefined as any;
        data["isMFAActive"] = this.isMFAActive;
        data["forcePasswordChange"] = this.forcePasswordChange;
        data["lockedUntil"] = this.lockedUntil ? this.lockedUntil.toString() : undefined as any;
        data["allCommunicationsAllowed"] = this.allCommunicationsAllowed;
        data["isLocked"] = this.isLocked;
        data["isActive"] = this.isActive;
        data["isDeleted"] = this.isDeleted;
        data["isAnonymized"] = this.isAnonymized;
        data["isEmailVerified"] = this.isEmailVerified;
        data["isPhoneVerified"] = this.isPhoneVerified;
        data["createdAt"] = this.createdAt ? this.createdAt.toString() : undefined as any;
        data["createdBy"] = this.createdBy;
        data["updatedAt"] = this.updatedAt ? this.updatedAt.toString() : undefined as any;
        data["updatedBy"] = this.updatedBy;
        data["note"] = this.note;
        return data;
    }
}


export interface IUserViewModel {
    id: string;
    authKey: string;
    userTypeId: string;
    userTypeName: string | undefined;
    defaultEnterpriseId: string | undefined;
    defaultEnterpriseName: string | undefined;
    name: string | undefined;
    surname: string | undefined;
    email: string | undefined;
    phone: string | undefined;
    phoneCode: string | undefined;
    appId: string | undefined;
    appName: string | undefined;
    customerId: string | undefined;
    customerName: string | undefined;
    countryId: string | undefined;
    countryName: string | undefined;
    timezoneId: string | undefined;
    timezoneName: string | undefined;
    localeId: string | undefined;
    localeName: string | undefined;
    professionId: string | undefined;
    professionName: string | undefined;
    totalLandArea: number | undefined;
    totalPlantationArea: number | undefined;
    lastSigninDate: DateTime | undefined;
    lastActivityDate: DateTime | undefined;
    passwordChangeDate: DateTime | undefined;
    passwordResetDate: DateTime | undefined;
    isMFAActive: boolean;
    forcePasswordChange: boolean;
    lockedUntil: DateTime | undefined;
    allCommunicationsAllowed: boolean | undefined;
    isLocked: boolean | undefined;
    isActive: boolean;
    isDeleted: boolean;
    isAnonymized: boolean;
    isEmailVerified: boolean;
    isPhoneVerified: boolean;
    createdAt: DateTime | undefined;
    createdBy: string | undefined;
    updatedAt: DateTime | undefined;
    updatedBy: string | undefined;
    note: string | undefined;
}


export class UserViewModelListResponseResult implements IUserViewModelListResponseResult {
    isSuccess!: boolean;
    statusCode!: number;
    result!: UserViewModel[] | undefined;
    errors!: ErrorMessage[] | undefined;
    version!: string | undefined;
    environment!: string | undefined;

    constructor(data?: IUserViewModelListResponseResult) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.isSuccess = _data["isSuccess"];
            this.statusCode = _data["statusCode"];
            if (Array.isArray(_data["result"])) {
                this.result = [] as any;
                for (let item of _data["result"])
                    this.result!.push(UserViewModel.fromJS(item));
            }
            if (Array.isArray(_data["errors"])) {
                this.errors = [] as any;
                for (let item of _data["errors"])
                    this.errors!.push(ErrorMessage.fromJS(item));
            }
            this.version = _data["version"];
            this.environment = _data["environment"];
        }
    }

    static fromJS(data: any): UserViewModelListResponseResult {
        data = typeof data === 'object' ? data : {};
        let result = new UserViewModelListResponseResult();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["isSuccess"] = this.isSuccess;
        data["statusCode"] = this.statusCode;
        if (Array.isArray(this.result)) {
            data["result"] = [];
            for (let item of this.result)
                data["result"].push(item ? item.toJSON() : undefined as any);
        }
        if (Array.isArray(this.errors)) {
            data["errors"] = [];
            for (let item of this.errors)
                data["errors"].push(item ? item.toJSON() : undefined as any);
        }
        data["version"] = this.version;
        data["environment"] = this.environment;
        return data;
    }
}


export interface IUserViewModelListResponseResult {
    isSuccess: boolean;
    statusCode: number;
    result: UserViewModel[] | undefined;
    errors: ErrorMessage[] | undefined;
    version: string | undefined;
    environment: string | undefined;
}


export class UserViewModelPaginatedResponse implements IUserViewModelPaginatedResponse {
    items!: UserViewModel[] | undefined;
    pageNumber!: number;
    pageSize!: number;
    totalCount!: number;
    totalPages!: number;
    hasPreviousPage!: boolean;
    hasNextPage!: boolean;
    appliedSorts!: SortCriteria[] | undefined;
    appliedFilters!: FilterCriteria[] | undefined;

    constructor(data?: IUserViewModelPaginatedResponse) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["items"])) {
                this.items = [] as any;
                for (let item of _data["items"])
                    this.items!.push(UserViewModel.fromJS(item));
            }
            this.pageNumber = _data["pageNumber"];
            this.pageSize = _data["pageSize"];
            this.totalCount = _data["totalCount"];
            this.totalPages = _data["totalPages"];
            this.hasPreviousPage = _data["hasPreviousPage"];
            this.hasNextPage = _data["hasNextPage"];
            if (Array.isArray(_data["appliedSorts"])) {
                this.appliedSorts = [] as any;
                for (let item of _data["appliedSorts"])
                    this.appliedSorts!.push(SortCriteria.fromJS(item));
            }
            if (Array.isArray(_data["appliedFilters"])) {
                this.appliedFilters = [] as any;
                for (let item of _data["appliedFilters"])
                    this.appliedFilters!.push(FilterCriteria.fromJS(item));
            }
        }
    }

    static fromJS(data: any): UserViewModelPaginatedResponse {
        data = typeof data === 'object' ? data : {};
        let result = new UserViewModelPaginatedResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.items)) {
            data["items"] = [];
            for (let item of this.items)
                data["items"].push(item ? item.toJSON() : undefined as any);
        }
        data["pageNumber"] = this.pageNumber;
        data["pageSize"] = this.pageSize;
        data["totalCount"] = this.totalCount;
        data["totalPages"] = this.totalPages;
        data["hasPreviousPage"] = this.hasPreviousPage;
        data["hasNextPage"] = this.hasNextPage;
        if (Array.isArray(this.appliedSorts)) {
            data["appliedSorts"] = [];
            for (let item of this.appliedSorts)
                data["appliedSorts"].push(item ? item.toJSON() : undefined as any);
        }
        if (Array.isArray(this.appliedFilters)) {
            data["appliedFilters"] = [];
            for (let item of this.appliedFilters)
                data["appliedFilters"].push(item ? item.toJSON() : undefined as any);
        }
        return data;
    }
}


export interface IUserViewModelPaginatedResponse {
    items: UserViewModel[] | undefined;
    pageNumber: number;
    pageSize: number;
    totalCount: number;
    totalPages: number;
    hasPreviousPage: boolean;
    hasNextPage: boolean;
    appliedSorts: SortCriteria[] | undefined;
    appliedFilters: FilterCriteria[] | undefined;
}


export class UserViewModelPaginatedResponseResponseResult implements IUserViewModelPaginatedResponseResponseResult {
    isSuccess!: boolean;
    statusCode!: number;
    result!: UserViewModelPaginatedResponse;
    errors!: ErrorMessage[] | undefined;
    version!: string | undefined;
    environment!: string | undefined;

    constructor(data?: IUserViewModelPaginatedResponseResponseResult) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.isSuccess = _data["isSuccess"];
            this.statusCode = _data["statusCode"];
            this.result = _data["result"] ? UserViewModelPaginatedResponse.fromJS(_data["result"]) : undefined as any;
            if (Array.isArray(_data["errors"])) {
                this.errors = [] as any;
                for (let item of _data["errors"])
                    this.errors!.push(ErrorMessage.fromJS(item));
            }
            this.version = _data["version"];
            this.environment = _data["environment"];
        }
    }

    static fromJS(data: any): UserViewModelPaginatedResponseResponseResult {
        data = typeof data === 'object' ? data : {};
        let result = new UserViewModelPaginatedResponseResponseResult();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["isSuccess"] = this.isSuccess;
        data["statusCode"] = this.statusCode;
        data["result"] = this.result ? this.result.toJSON() : undefined as any;
        if (Array.isArray(this.errors)) {
            data["errors"] = [];
            for (let item of this.errors)
                data["errors"].push(item ? item.toJSON() : undefined as any);
        }
        data["version"] = this.version;
        data["environment"] = this.environment;
        return data;
    }
}


export interface IUserViewModelPaginatedResponseResponseResult {
    isSuccess: boolean;
    statusCode: number;
    result: UserViewModelPaginatedResponse;
    errors: ErrorMessage[] | undefined;
    version: string | undefined;
    environment: string | undefined;
}


export class ValidateEmailModel implements IValidateEmailModel {
    email!: string | undefined;
    otp!: number;

    constructor(data?: IValidateEmailModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.email = _data["email"];
            this.otp = _data["otp"];
        }
    }

    static fromJS(data: any): ValidateEmailModel {
        data = typeof data === 'object' ? data : {};
        let result = new ValidateEmailModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["email"] = this.email;
        data["otp"] = this.otp;
        return data;
    }
}


export interface IValidateEmailModel {
    email: string | undefined;
    otp: number;
}


export class ValidatePhoneModel implements IValidatePhoneModel {
    phoneCode!: string | undefined;
    phone!: string | undefined;
    otp!: number;

    constructor(data?: IValidatePhoneModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.phoneCode = _data["phoneCode"];
            this.phone = _data["phone"];
            this.otp = _data["otp"];
        }
    }

    static fromJS(data: any): ValidatePhoneModel {
        data = typeof data === 'object' ? data : {};
        let result = new ValidatePhoneModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["phoneCode"] = this.phoneCode;
        data["phone"] = this.phone;
        data["otp"] = this.otp;
        return data;
    }
}


export interface IValidatePhoneModel {
    phoneCode: string | undefined;
    phone: string | undefined;
    otp: number;
}


export class ValidatePrincipalOTPCommand implements IValidatePrincipalOTPCommand {
    principalId!: string;
    totp!: number;

    constructor(data?: IValidatePrincipalOTPCommand) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.principalId = _data["principalId"];
            this.totp = _data["totp"];
        }
    }

    static fromJS(data: any): ValidatePrincipalOTPCommand {
        data = typeof data === 'object' ? data : {};
        let result = new ValidatePrincipalOTPCommand();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["principalId"] = this.principalId;
        data["totp"] = this.totp;
        return data;
    }
}


export interface IValidatePrincipalOTPCommand {
    principalId: string;
    totp: number;
}


export class ValidateUserOTPCommand implements IValidateUserOTPCommand {
    id!: string | undefined;
    email!: string | undefined;
    phoneCode!: string | undefined;
    phone!: string | undefined;
    otp!: number;
    otpReason!: OtpReasons;

    constructor(data?: IValidateUserOTPCommand) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.email = _data["email"];
            this.phoneCode = _data["phoneCode"];
            this.phone = _data["phone"];
            this.otp = _data["otp"];
            this.otpReason = _data["otpReason"];
        }
    }

    static fromJS(data: any): ValidateUserOTPCommand {
        data = typeof data === 'object' ? data : {};
        let result = new ValidateUserOTPCommand();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["email"] = this.email;
        data["phoneCode"] = this.phoneCode;
        data["phone"] = this.phone;
        data["otp"] = this.otp;
        data["otpReason"] = this.otpReason;
        return data;
    }
}


export interface IValidateUserOTPCommand {
    id: string | undefined;
    email: string | undefined;
    phoneCode: string | undefined;
    phone: string | undefined;
    otp: number;
    otpReason: OtpReasons;
}


export class VerifyPasswordCommand implements IVerifyPasswordCommand {
    userAccessKey!: string;
    password!: string | undefined;

    constructor(data?: IVerifyPasswordCommand) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.userAccessKey = _data["userAccessKey"];
            this.password = _data["password"];
        }
    }

    static fromJS(data: any): VerifyPasswordCommand {
        data = typeof data === 'object' ? data : {};
        let result = new VerifyPasswordCommand();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["userAccessKey"] = this.userAccessKey;
        data["password"] = this.password;
        return data;
    }
}


export interface IVerifyPasswordCommand {
    userAccessKey: string;
    password: string | undefined;
}


export class VillageLookupViewModel implements IVillageLookupViewModel {
    key!: string;
    value!: string | undefined;
    tkgmId!: number | undefined;

    constructor(data?: IVillageLookupViewModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.key = _data["key"];
            this.value = _data["value"];
            this.tkgmId = _data["tkgmId"];
        }
    }

    static fromJS(data: any): VillageLookupViewModel {
        data = typeof data === 'object' ? data : {};
        let result = new VillageLookupViewModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["key"] = this.key;
        data["value"] = this.value;
        data["tkgmId"] = this.tkgmId;
        return data;
    }
}


export interface IVillageLookupViewModel {
    key: string;
    value: string | undefined;
    tkgmId: number | undefined;
}


export class VillageLookupViewModelListResponseResult implements IVillageLookupViewModelListResponseResult {
    isSuccess!: boolean;
    statusCode!: number;
    result!: VillageLookupViewModel[] | undefined;
    errors!: ErrorMessage[] | undefined;
    version!: string | undefined;
    environment!: string | undefined;

    constructor(data?: IVillageLookupViewModelListResponseResult) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.isSuccess = _data["isSuccess"];
            this.statusCode = _data["statusCode"];
            if (Array.isArray(_data["result"])) {
                this.result = [] as any;
                for (let item of _data["result"])
                    this.result!.push(VillageLookupViewModel.fromJS(item));
            }
            if (Array.isArray(_data["errors"])) {
                this.errors = [] as any;
                for (let item of _data["errors"])
                    this.errors!.push(ErrorMessage.fromJS(item));
            }
            this.version = _data["version"];
            this.environment = _data["environment"];
        }
    }

    static fromJS(data: any): VillageLookupViewModelListResponseResult {
        data = typeof data === 'object' ? data : {};
        let result = new VillageLookupViewModelListResponseResult();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["isSuccess"] = this.isSuccess;
        data["statusCode"] = this.statusCode;
        if (Array.isArray(this.result)) {
            data["result"] = [];
            for (let item of this.result)
                data["result"].push(item ? item.toJSON() : undefined as any);
        }
        if (Array.isArray(this.errors)) {
            data["errors"] = [];
            for (let item of this.errors)
                data["errors"].push(item ? item.toJSON() : undefined as any);
        }
        data["version"] = this.version;
        data["environment"] = this.environment;
        return data;
    }
}


export interface IVillageLookupViewModelListResponseResult {
    isSuccess: boolean;
    statusCode: number;
    result: VillageLookupViewModel[] | undefined;
    errors: ErrorMessage[] | undefined;
    version: string | undefined;
    environment: string | undefined;
}


export interface FileParameter {
    data: any;
    fileName: string;
}


export class ApiException extends Error {
    override message: string;
    status: number;
    response: string;
    headers: { [key: string]: any; };
    result: any;

    constructor(message: string, status: number, response: string, headers: { [key: string]: any; }, result: any) {
        super();

        this.message = message;
        this.status = status;
        this.response = response;
        this.headers = headers;
        this.result = result;
    }

    protected isApiException = true;

    static isApiException(obj: any): obj is ApiException {
        return obj.isApiException === true;
    }
}


function throwException(message: string, status: number, response: string, headers: { [key: string]: any; }, result?: any): Observable<any> {
    if (result !== null && result !== undefined)
        return _observableThrow(result);
    else
        return _observableThrow(new ApiException(message, status, response, headers, null));
}


function blobToText(blob: any): Observable<string> {
    return new Observable<string>((observer: any) => {
        if (!blob) {
            observer.next("");
            observer.complete();
        } else {
            let reader = new FileReader();
            reader.onload = event => {
                observer.next((event.target as any).result);
                observer.complete();
            };
            reader.readAsText(blob);
        }
    });
}